/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */

/* 该文件由 yapi-to-typescript 自动生成，请勿直接修改！！！ */

// @ts-ignore
// prettier-ignore
// @ts-ignore
// prettier-ignore
import type { RequestConfig,RequestFunctionRestArgs } from 'yapi-to-typescript';
import {
  FileData,
  Method,
  prepare,
  QueryStringArrayFormat,
  RequestBodyType,
  ResponseBodyType,
} from 'yapi-to-typescript';
// @ts-ignore
import request from '../ajax/index';

type UserRequestRestArgs = RequestFunctionRestArgs<typeof request>;

// Request: 目前 React Hooks 功能有用到
export type Request<
  TRequestData,
  TRequestConfig extends RequestConfig,
  TRequestResult,
> = (TRequestConfig['requestDataOptional'] extends true
  ? (requestData?: TRequestData, ...args: RequestFunctionRestArgs<typeof request>) => TRequestResult
  : (
      requestData: TRequestData,
      ...args: RequestFunctionRestArgs<typeof request>
    ) => TRequestResult) & {
  requestConfig: TRequestConfig;
};

const mockUrl_0_4_0_0 = 'http://yapi.cai-inc.com/mock/2991' as any;
const devUrl_0_4_0_0 = '' as any;
const prodUrl_0_4_0_0 = '' as any;
const dataKey_0_4_0_0 = 'data' as any;

/**
 * 接口 [删除收入管理计划单↗](http://yapi.cai-inc.com/project/2991/interface/api/314682) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [收入管理-申请单接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_48864)
 * @请求头 `POST /zlb/budget/api/income/apply-form/delete`
 * @更新时间 `2024-05-14 11:44:37`
 * @项目ID 2991
 */
export interface ZlbBudgetApiIncomeApplyFormDeletePostRequest {
  applyFormCode: string;
}

/**
 * 接口 [删除收入管理计划单↗](http://yapi.cai-inc.com/project/2991/interface/api/314682) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [收入管理-申请单接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_48864)
 * @请求头 `POST /zlb/budget/api/income/apply-form/delete`
 * @更新时间 `2024-05-14 11:44:37`
 * @项目ID 2991
 */
export interface ZlbBudgetApiIncomeApplyFormDeletePostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [删除收入管理计划单↗](http://yapi.cai-inc.com/project/2991/interface/api/314682) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [收入管理-申请单接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_48864)
 * @请求头 `POST /zlb/budget/api/income/apply-form/delete`
 * @更新时间 `2024-05-14 11:44:37`
 * @项目ID 2991
 */
type ZlbBudgetApiIncomeApplyFormDeletePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/api/income/apply-form/delete',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [删除收入管理计划单↗](http://yapi.cai-inc.com/project/2991/interface/api/314682) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [收入管理-申请单接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_48864)
 * @请求头 `POST /zlb/budget/api/income/apply-form/delete`
 * @更新时间 `2024-05-14 11:44:37`
 * @项目ID 2991
 */
const zlbBudgetApiIncomeApplyFormDeletePostRequestConfig: ZlbBudgetApiIncomeApplyFormDeletePostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_0,
    devUrl: devUrl_0_4_0_0,
    prodUrl: prodUrl_0_4_0_0,
    path: '/zlb/budget/api/income/apply-form/delete',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbBudgetApiIncomeApplyFormDeletePost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [删除收入管理计划单↗](http://yapi.cai-inc.com/project/2991/interface/api/314682) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [收入管理-申请单接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_48864)
 * @请求头 `POST /zlb/budget/api/income/apply-form/delete`
 * @更新时间 `2024-05-14 11:44:37`
 * @项目ID 2991
 */
export const zlbBudgetApiIncomeApplyFormDeletePost = /*#__PURE__*/ (
  requestData: ZlbBudgetApiIncomeApplyFormDeletePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetApiIncomeApplyFormDeletePostResponse>(
    prepare(zlbBudgetApiIncomeApplyFormDeletePostRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetApiIncomeApplyFormDeletePost.requestConfig =
  zlbBudgetApiIncomeApplyFormDeletePostRequestConfig;

/**
 * 接口 [申请单转交↗](http://yapi.cai-inc.com/project/2991/interface/api/314690) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [收入管理-申请单接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_48864)
 * @请求头 `POST /zlb/budget/api/income/apply-form/forward`
 * @更新时间 `2024-05-14 11:44:37`
 * @项目ID 2991
 */
export interface ZlbBudgetApiIncomeApplyFormForwardPostRequest {
  applyFormCode: string;
  receiverPOS: {
    /**
     * 操作员ID
     */
    operatorId: number;
    /**
     * 姓名
     */
    userName: string;
  }[];
}

/**
 * 接口 [申请单转交↗](http://yapi.cai-inc.com/project/2991/interface/api/314690) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [收入管理-申请单接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_48864)
 * @请求头 `POST /zlb/budget/api/income/apply-form/forward`
 * @更新时间 `2024-05-14 11:44:37`
 * @项目ID 2991
 */
export interface ZlbBudgetApiIncomeApplyFormForwardPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [申请单转交↗](http://yapi.cai-inc.com/project/2991/interface/api/314690) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [收入管理-申请单接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_48864)
 * @请求头 `POST /zlb/budget/api/income/apply-form/forward`
 * @更新时间 `2024-05-14 11:44:37`
 * @项目ID 2991
 */
type ZlbBudgetApiIncomeApplyFormForwardPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/api/income/apply-form/forward',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [申请单转交↗](http://yapi.cai-inc.com/project/2991/interface/api/314690) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [收入管理-申请单接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_48864)
 * @请求头 `POST /zlb/budget/api/income/apply-form/forward`
 * @更新时间 `2024-05-14 11:44:37`
 * @项目ID 2991
 */
const zlbBudgetApiIncomeApplyFormForwardPostRequestConfig: ZlbBudgetApiIncomeApplyFormForwardPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_0,
    devUrl: devUrl_0_4_0_0,
    prodUrl: prodUrl_0_4_0_0,
    path: '/zlb/budget/api/income/apply-form/forward',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbBudgetApiIncomeApplyFormForwardPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [申请单转交↗](http://yapi.cai-inc.com/project/2991/interface/api/314690) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [收入管理-申请单接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_48864)
 * @请求头 `POST /zlb/budget/api/income/apply-form/forward`
 * @更新时间 `2024-05-14 11:44:37`
 * @项目ID 2991
 */
export const zlbBudgetApiIncomeApplyFormForwardPost = /*#__PURE__*/ (
  requestData: ZlbBudgetApiIncomeApplyFormForwardPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetApiIncomeApplyFormForwardPostResponse>(
    prepare(zlbBudgetApiIncomeApplyFormForwardPostRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetApiIncomeApplyFormForwardPost.requestConfig =
  zlbBudgetApiIncomeApplyFormForwardPostRequestConfig;

/**
 * 接口 [申请单作废↗](http://yapi.cai-inc.com/project/2991/interface/api/314698) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [收入管理-申请单接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_48864)
 * @请求头 `POST /zlb/budget/api/income/apply-form/nullify`
 * @更新时间 `2024-05-14 11:44:38`
 * @项目ID 2991
 */
export interface ZlbBudgetApiIncomeApplyFormNullifyPostRequest {
  applyFormCode: string;
}

/**
 * 接口 [申请单作废↗](http://yapi.cai-inc.com/project/2991/interface/api/314698) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [收入管理-申请单接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_48864)
 * @请求头 `POST /zlb/budget/api/income/apply-form/nullify`
 * @更新时间 `2024-05-14 11:44:38`
 * @项目ID 2991
 */
export interface ZlbBudgetApiIncomeApplyFormNullifyPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [申请单作废↗](http://yapi.cai-inc.com/project/2991/interface/api/314698) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [收入管理-申请单接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_48864)
 * @请求头 `POST /zlb/budget/api/income/apply-form/nullify`
 * @更新时间 `2024-05-14 11:44:38`
 * @项目ID 2991
 */
type ZlbBudgetApiIncomeApplyFormNullifyPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/api/income/apply-form/nullify',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [申请单作废↗](http://yapi.cai-inc.com/project/2991/interface/api/314698) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [收入管理-申请单接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_48864)
 * @请求头 `POST /zlb/budget/api/income/apply-form/nullify`
 * @更新时间 `2024-05-14 11:44:38`
 * @项目ID 2991
 */
const zlbBudgetApiIncomeApplyFormNullifyPostRequestConfig: ZlbBudgetApiIncomeApplyFormNullifyPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_0,
    devUrl: devUrl_0_4_0_0,
    prodUrl: prodUrl_0_4_0_0,
    path: '/zlb/budget/api/income/apply-form/nullify',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbBudgetApiIncomeApplyFormNullifyPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [申请单作废↗](http://yapi.cai-inc.com/project/2991/interface/api/314698) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [收入管理-申请单接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_48864)
 * @请求头 `POST /zlb/budget/api/income/apply-form/nullify`
 * @更新时间 `2024-05-14 11:44:38`
 * @项目ID 2991
 */
export const zlbBudgetApiIncomeApplyFormNullifyPost = /*#__PURE__*/ (
  requestData: ZlbBudgetApiIncomeApplyFormNullifyPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetApiIncomeApplyFormNullifyPostResponse>(
    prepare(zlbBudgetApiIncomeApplyFormNullifyPostRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetApiIncomeApplyFormNullifyPost.requestConfig =
  zlbBudgetApiIncomeApplyFormNullifyPostRequestConfig;

/**
 * 接口 [获取申请单默认信息↗](http://yapi.cai-inc.com/project/2991/interface/api/314706) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [收入管理-申请单接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_48864)
 * @请求头 `GET /zlb/budget/api/income/apply-form/default-info/{formBizType}`
 * @更新时间 `2024-05-14 11:44:38`
 * @项目ID 2991
 */
export interface ZlbBudgetApiIncomeApplyFormDefaultInfoFormBizTypeGetRequest {
  formBizType: string;
}

/**
 * 接口 [获取申请单默认信息↗](http://yapi.cai-inc.com/project/2991/interface/api/314706) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [收入管理-申请单接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_48864)
 * @请求头 `GET /zlb/budget/api/income/apply-form/default-info/{formBizType}`
 * @更新时间 `2024-05-14 11:44:38`
 * @项目ID 2991
 */
export interface ZlbBudgetApiIncomeApplyFormDefaultInfoFormBizTypeGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 工作单位id
     */
    orgId?: number;
    /**
     * 工作单位名称
     */
    orgName?: string;
    /**
     * 所在部门列表
     */
    departmentList?: {
      /**
       * 部门ID
       */
      deptId?: number;
      /**
       * 部门名称
       */
      deptName?: string;
    }[];
    /**
     * 单位所在省地址编码
     */
    provinceCode?: string;
    /**
     * 单位所在省地址名称
     */
    provinceName?: string;
    /**
     * 单位所在市地址编码
     */
    cityCode?: string;
    /**
     * 单位所在市地址名称
     */
    cityName?: string;
    /**
     * 单位所在区地址编码
     */
    regionCode?: string;
    /**
     * 单位所在区地址名称
     */
    regionName?: string;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [获取申请单默认信息↗](http://yapi.cai-inc.com/project/2991/interface/api/314706) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [收入管理-申请单接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_48864)
 * @请求头 `GET /zlb/budget/api/income/apply-form/default-info/{formBizType}`
 * @更新时间 `2024-05-14 11:44:38`
 * @项目ID 2991
 */
type ZlbBudgetApiIncomeApplyFormDefaultInfoFormBizTypeGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/api/income/apply-form/default-info/{formBizType}',
    'data',
    'formBizType',
    string,
    false
  >
>;

/**
 * 接口 [获取申请单默认信息↗](http://yapi.cai-inc.com/project/2991/interface/api/314706) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [收入管理-申请单接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_48864)
 * @请求头 `GET /zlb/budget/api/income/apply-form/default-info/{formBizType}`
 * @更新时间 `2024-05-14 11:44:38`
 * @项目ID 2991
 */
const zlbBudgetApiIncomeApplyFormDefaultInfoFormBizTypeGetRequestConfig: ZlbBudgetApiIncomeApplyFormDefaultInfoFormBizTypeGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_0,
    devUrl: devUrl_0_4_0_0,
    prodUrl: prodUrl_0_4_0_0,
    path: '/zlb/budget/api/income/apply-form/default-info/{formBizType}',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_0,
    paramNames: ['formBizType'],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbBudgetApiIncomeApplyFormDefaultInfoFormBizTypeGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [获取申请单默认信息↗](http://yapi.cai-inc.com/project/2991/interface/api/314706) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [收入管理-申请单接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_48864)
 * @请求头 `GET /zlb/budget/api/income/apply-form/default-info/{formBizType}`
 * @更新时间 `2024-05-14 11:44:38`
 * @项目ID 2991
 */
export const zlbBudgetApiIncomeApplyFormDefaultInfoFormBizTypeGet = /*#__PURE__*/ (
  requestData: ZlbBudgetApiIncomeApplyFormDefaultInfoFormBizTypeGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetApiIncomeApplyFormDefaultInfoFormBizTypeGetResponse>(
    prepare(zlbBudgetApiIncomeApplyFormDefaultInfoFormBizTypeGetRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetApiIncomeApplyFormDefaultInfoFormBizTypeGet.requestConfig =
  zlbBudgetApiIncomeApplyFormDefaultInfoFormBizTypeGetRequestConfig;

/**
 * 接口 [根据表code和type 来过滤已有的用户↗](http://yapi.cai-inc.com/project/2991/interface/api/314714) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [收入管理-申请单接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_48864)
 * @请求头 `POST /zlb/budget/api/income/apply-form/form-operator/list`
 * @更新时间 `2024-05-14 11:44:38`
 * @项目ID 2991
 */
export interface ZlbBudgetApiIncomeApplyFormFormOperatorListPostRequest {
  /**
   * 当前用户操作人列表
   */
  operatorIds?: number[];
  /**
   * 单号
   */
  formCode?: string;
  /**
   * 单据类型
   */
  formType?: number;
}

/**
 * 接口 [根据表code和type 来过滤已有的用户↗](http://yapi.cai-inc.com/project/2991/interface/api/314714) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [收入管理-申请单接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_48864)
 * @请求头 `POST /zlb/budget/api/income/apply-form/form-operator/list`
 * @更新时间 `2024-05-14 11:44:38`
 * @项目ID 2991
 */
export interface ZlbBudgetApiIncomeApplyFormFormOperatorListPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: number;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [根据表code和type 来过滤已有的用户↗](http://yapi.cai-inc.com/project/2991/interface/api/314714) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [收入管理-申请单接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_48864)
 * @请求头 `POST /zlb/budget/api/income/apply-form/form-operator/list`
 * @更新时间 `2024-05-14 11:44:38`
 * @项目ID 2991
 */
type ZlbBudgetApiIncomeApplyFormFormOperatorListPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/api/income/apply-form/form-operator/list',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [根据表code和type 来过滤已有的用户↗](http://yapi.cai-inc.com/project/2991/interface/api/314714) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [收入管理-申请单接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_48864)
 * @请求头 `POST /zlb/budget/api/income/apply-form/form-operator/list`
 * @更新时间 `2024-05-14 11:44:38`
 * @项目ID 2991
 */
const zlbBudgetApiIncomeApplyFormFormOperatorListPostRequestConfig: ZlbBudgetApiIncomeApplyFormFormOperatorListPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_0,
    devUrl: devUrl_0_4_0_0,
    prodUrl: prodUrl_0_4_0_0,
    path: '/zlb/budget/api/income/apply-form/form-operator/list',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbBudgetApiIncomeApplyFormFormOperatorListPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [根据表code和type 来过滤已有的用户↗](http://yapi.cai-inc.com/project/2991/interface/api/314714) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [收入管理-申请单接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_48864)
 * @请求头 `POST /zlb/budget/api/income/apply-form/form-operator/list`
 * @更新时间 `2024-05-14 11:44:38`
 * @项目ID 2991
 */
export const zlbBudgetApiIncomeApplyFormFormOperatorListPost = /*#__PURE__*/ (
  requestData: ZlbBudgetApiIncomeApplyFormFormOperatorListPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetApiIncomeApplyFormFormOperatorListPostResponse>(
    prepare(zlbBudgetApiIncomeApplyFormFormOperatorListPostRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetApiIncomeApplyFormFormOperatorListPost.requestConfig =
  zlbBudgetApiIncomeApplyFormFormOperatorListPostRequestConfig;

/**
 * 接口 [获取打印文件详情↗](http://yapi.cai-inc.com/project/2991/interface/api/314722) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [收入管理-申请单接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_48864)
 * @请求头 `GET /zlb/budget/api/income/apply-form/print-info/{formCode}`
 * @更新时间 `2024-05-14 11:44:38`
 * @项目ID 2991
 */
export interface ZlbBudgetApiIncomeApplyFormPrintInfoFormCodeGetRequest {
  /**
   * 单据code
   */
  formCode: string;
}

/**
 * 接口 [获取打印文件详情↗](http://yapi.cai-inc.com/project/2991/interface/api/314722) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [收入管理-申请单接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_48864)
 * @请求头 `GET /zlb/budget/api/income/apply-form/print-info/{formCode}`
 * @更新时间 `2024-05-14 11:44:38`
 * @项目ID 2991
 */
export interface ZlbBudgetApiIncomeApplyFormPrintInfoFormCodeGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 申请单打印信息
     */
    applyPrintInfo?: {
      /**
       * 文件信息
       */
      attachmentDTO?: {
        /**
         * 附件OssId
         */
        fileId: string;
        /**
         * 附件类型
         */
        type?: string;
        /**
         * 附件名称
         */
        name?: string;
        /**
         * 附件大小
         */
        size?: number;
        /**
         * 桶的key
         */
        bizCode?: string;
        /**
         * 下载文件的url
         */
        url?: string;
        /**
         * 文件大小描述
         */
        sizeDesc?: string;
      };
      /**
       * 单据编号
       */
      businessCode?: string;
      /**
       * 表单名称
       */
      formName?: string;
    }[];
    /**
     * 附件打印信息
     */
    attachmentPrintInfo?: {
      /**
       * 附件OssId
       */
      fileId: string;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 附件名称
       */
      name?: string;
      /**
       * 附件大小
       */
      size?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      url?: string;
      /**
       * 文件大小描述
       */
      sizeDesc?: string;
    }[];
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [获取打印文件详情↗](http://yapi.cai-inc.com/project/2991/interface/api/314722) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [收入管理-申请单接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_48864)
 * @请求头 `GET /zlb/budget/api/income/apply-form/print-info/{formCode}`
 * @更新时间 `2024-05-14 11:44:38`
 * @项目ID 2991
 */
type ZlbBudgetApiIncomeApplyFormPrintInfoFormCodeGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/api/income/apply-form/print-info/{formCode}',
    'data',
    'formCode',
    string,
    false
  >
>;

/**
 * 接口 [获取打印文件详情↗](http://yapi.cai-inc.com/project/2991/interface/api/314722) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [收入管理-申请单接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_48864)
 * @请求头 `GET /zlb/budget/api/income/apply-form/print-info/{formCode}`
 * @更新时间 `2024-05-14 11:44:38`
 * @项目ID 2991
 */
const zlbBudgetApiIncomeApplyFormPrintInfoFormCodeGetRequestConfig: ZlbBudgetApiIncomeApplyFormPrintInfoFormCodeGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_0,
    devUrl: devUrl_0_4_0_0,
    prodUrl: prodUrl_0_4_0_0,
    path: '/zlb/budget/api/income/apply-form/print-info/{formCode}',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_0,
    paramNames: ['formCode'],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbBudgetApiIncomeApplyFormPrintInfoFormCodeGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [获取打印文件详情↗](http://yapi.cai-inc.com/project/2991/interface/api/314722) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [收入管理-申请单接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_48864)
 * @请求头 `GET /zlb/budget/api/income/apply-form/print-info/{formCode}`
 * @更新时间 `2024-05-14 11:44:38`
 * @项目ID 2991
 */
export const zlbBudgetApiIncomeApplyFormPrintInfoFormCodeGet = /*#__PURE__*/ (
  requestData: ZlbBudgetApiIncomeApplyFormPrintInfoFormCodeGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetApiIncomeApplyFormPrintInfoFormCodeGetResponse>(
    prepare(zlbBudgetApiIncomeApplyFormPrintInfoFormCodeGetRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetApiIncomeApplyFormPrintInfoFormCodeGet.requestConfig =
  zlbBudgetApiIncomeApplyFormPrintInfoFormCodeGetRequestConfig;

/**
 * 接口 [列表查询↗](http://yapi.cai-inc.com/project/2991/interface/api/314850) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [收入管理-申请单接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_48864)
 * @请求头 `POST /zlb/budget/api/income/apply-form/paging`
 * @更新时间 `2024-05-14 11:44:38`
 * @项目ID 2991
 */
export interface ZlbBudgetApiIncomeApplyFormPagingPostRequest {
  /**
   * 页面大小
   */
  pageSize?: number;
  /**
   * 页码
   */
  pageNo?: number;
  /**
   * 排序字段
   */
  sortField?: string;
  /**
   * 排序规则：DESC || ASC
   */
  sortBy?: string;
  /**
   * 类目代码
   */
  categoryCode?: string;
  /**
   * 收入事由
   */
  applyReason?: string;
  /**
   * 事项起始时间
   */
  itemBeginDate?: string;
  /**
   * 事项结束时间
   */
  itemEndDate?: string;
  /**
   * 收款状态
   */
  payStatus?: number;
  /**
   * 单据状态
   */
  formStatus?: number;
  /**
   * 部门ID
   */
  deptId?: number;
  /**
   * table页，0：全部 1：待审批 2:已完成
   */
  tableStatus?: number;
  /**
   * 发起人名字
   */
  applyUserName?: string;
  /**
   * 业务单号
   */
  businessFormCode?: string;
  /**
   * 关联机构id
   */
  orgId?: number;
  source?: number;
}

/**
 * 接口 [列表查询↗](http://yapi.cai-inc.com/project/2991/interface/api/314850) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [收入管理-申请单接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_48864)
 * @请求头 `POST /zlb/budget/api/income/apply-form/paging`
 * @更新时间 `2024-05-14 11:44:38`
 * @项目ID 2991
 */
export interface ZlbBudgetApiIncomeApplyFormPagingPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 总记录数
     */
    total?: number;
    /**
     * 结果集
     */
    data?: {
      /**
       * 收入类型
       */
      categoryName?: string;
      /**
       * 申请单号
       */
      applyFormCode?: string;
      /**
       * 业务单号
       */
      businessFormCode?: string;
      /**
       * 申请事由
       */
      applyReason?: string;
      operatorName?: string;
      /**
       * 部门ID
       */
      deptId?: number;
      /**
       * 部门名字
       */
      deptName?: string;
      /**
       * 金额
       */
      applyAmount?: number;
      /**
       * 收款状态 0：未收款 1：已收款
       */
      payStatus?: number;
      /**
       * 收款状态描述
       */
      payStatusDesc?: string;
      /**
       * 单据状态
       */
      formStatus?: number;
      /**
       * 单据状态描述
       */
      formStatusDesc?: string;
      /**
       * 申请日期
       */
      applyDate?: number;
      /**
       * 唯一ID
       */
      uniqueId?: string;
      /**
       * 0：当前用户 1：审批 2：审核
       */
      userRole?: number;
      /**
       * 机构名称
       */
      orgName?: string;
      /**
       * 单据按钮控制RO
       */
      operateButton?: {
        /**
         * 是否可编辑
         */
        edit?: boolean;
        /**
         * 是否可查看
         */
        detail?: boolean;
        /**
         * 是否可删除
         */
        remove?: boolean;
        /**
         * 是否可审核/审批
         */
        audit?: boolean;
        /**
         * 是否可编辑收款人信息
         */
        editReceiver?: boolean;
        /**
         * 是否可打印
         */
        print?: boolean;
      };
      /**
       * 打印状态
       */
      printStatus?: number;
      /**
       * 打印状态描述
       */
      printStatusName?: string;
      /**
       * 是否是测试单据：1-是，2-否
       */
      isTestForm?: number;
    }[];
    pageNum?: number;
    pageSize?: number;
    /**
     * 总页数
     */
    pages?: number;
    /**
     * 第几页
     */
    size?: number;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [列表查询↗](http://yapi.cai-inc.com/project/2991/interface/api/314850) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [收入管理-申请单接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_48864)
 * @请求头 `POST /zlb/budget/api/income/apply-form/paging`
 * @更新时间 `2024-05-14 11:44:38`
 * @项目ID 2991
 */
type ZlbBudgetApiIncomeApplyFormPagingPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/api/income/apply-form/paging',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [列表查询↗](http://yapi.cai-inc.com/project/2991/interface/api/314850) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [收入管理-申请单接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_48864)
 * @请求头 `POST /zlb/budget/api/income/apply-form/paging`
 * @更新时间 `2024-05-14 11:44:38`
 * @项目ID 2991
 */
const zlbBudgetApiIncomeApplyFormPagingPostRequestConfig: ZlbBudgetApiIncomeApplyFormPagingPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_0,
    devUrl: devUrl_0_4_0_0,
    prodUrl: prodUrl_0_4_0_0,
    path: '/zlb/budget/api/income/apply-form/paging',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbBudgetApiIncomeApplyFormPagingPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [列表查询↗](http://yapi.cai-inc.com/project/2991/interface/api/314850) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [收入管理-申请单接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_48864)
 * @请求头 `POST /zlb/budget/api/income/apply-form/paging`
 * @更新时间 `2024-05-14 11:44:38`
 * @项目ID 2991
 */
export const zlbBudgetApiIncomeApplyFormPagingPost = /*#__PURE__*/ (
  requestData: ZlbBudgetApiIncomeApplyFormPagingPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetApiIncomeApplyFormPagingPostResponse>(
    prepare(zlbBudgetApiIncomeApplyFormPagingPostRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetApiIncomeApplyFormPagingPost.requestConfig =
  zlbBudgetApiIncomeApplyFormPagingPostRequestConfig;

/**
 * 接口 [审核列表查询↗](http://yapi.cai-inc.com/project/2991/interface/api/315938) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [收入管理-申请单接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_48864)
 * @请求头 `POST /zlb/budget/api/income/apply-form/audit-list`
 * @更新时间 `2024-05-14 11:44:39`
 * @项目ID 2991
 */
export interface ZlbBudgetApiIncomeApplyFormAuditListPostRequest {
  /**
   * 页面大小
   */
  pageSize?: number;
  /**
   * 页码
   */
  pageNo?: number;
  /**
   * 排序字段
   */
  sortField?: string;
  /**
   * 排序规则：DESC || ASC
   */
  sortBy?: string;
  /**
   * 类目代码
   */
  categoryCode?: string;
  /**
   * 收入事由
   */
  applyReason?: string;
  /**
   * 事项起始时间
   */
  itemBeginDate?: string;
  /**
   * 事项结束时间
   */
  itemEndDate?: string;
  /**
   * 收款状态
   */
  payStatus?: number;
  /**
   * 单据状态
   */
  formStatus?: number;
  /**
   * 部门ID
   */
  deptId?: number;
  /**
   * table页，0：全部 1：待审批 2:已完成
   */
  tableStatus?: number;
  /**
   * 发起人名字
   */
  applyUserName?: string;
  /**
   * 事由/申请人名字/单号
   */
  reason?: string;
  /**
   * 业务单号
   */
  businessFormCode?: string;
}

/**
 * 接口 [审核列表查询↗](http://yapi.cai-inc.com/project/2991/interface/api/315938) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [收入管理-申请单接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_48864)
 * @请求头 `POST /zlb/budget/api/income/apply-form/audit-list`
 * @更新时间 `2024-05-14 11:44:39`
 * @项目ID 2991
 */
export interface ZlbBudgetApiIncomeApplyFormAuditListPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 总记录数
     */
    total?: number;
    /**
     * 结果集
     */
    data?: {
      /**
       * 收入类型
       */
      categoryName?: string;
      /**
       * 申请单号
       */
      applyFormCode?: string;
      /**
       * 业务单号
       */
      businessFormCode?: string;
      /**
       * 申请事由
       */
      applyReason?: string;
      operatorName?: string;
      /**
       * 部门ID
       */
      deptId?: number;
      /**
       * 部门名字
       */
      deptName?: string;
      /**
       * 金额
       */
      applyAmount?: number;
      /**
       * 收款状态 0：未收款 1：已收款
       */
      payStatus?: number;
      /**
       * 收款状态描述
       */
      payStatusDesc?: string;
      /**
       * 单据状态
       */
      formStatus?: number;
      /**
       * 单据状态描述
       */
      formStatusDesc?: string;
      /**
       * 申请日期
       */
      applyDate?: number;
      /**
       * 唯一ID
       */
      uniqueId?: string;
      /**
       * 0：当前用户 1：审批 2：审核
       */
      userRole?: number;
      /**
       * 机构名称
       */
      orgName?: string;
      /**
       * 单据按钮控制RO
       */
      operateButton?: {
        /**
         * 是否可审核/审批
         */
        audit?: boolean;
        /**
         * 是否可查看
         */
        detail?: boolean;
        /**
         * 是否可编辑收款人信息
         */
        editReceiveInfo?: boolean;
        /**
         * 是否可编辑票据信息
         */
        editInvoiceInfo?: boolean;
      };
      /**
       * 单据审核状态 0.待审批 1：待审核 2：通过 3：驳回
       */
      auditStatus?: number;
      auditStatusDesc?: string;
      submitTime?: number;
      /**
       * 节点类型
       * 0-审批，1-审核
       */
      nodeType?: number;
      /**
       * 节点类型描述
       */
      nodeTypeDesc?: string;
    }[];
    pageNum?: number;
    pageSize?: number;
    /**
     * 总页数
     */
    pages?: number;
    /**
     * 第几页
     */
    size?: number;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [审核列表查询↗](http://yapi.cai-inc.com/project/2991/interface/api/315938) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [收入管理-申请单接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_48864)
 * @请求头 `POST /zlb/budget/api/income/apply-form/audit-list`
 * @更新时间 `2024-05-14 11:44:39`
 * @项目ID 2991
 */
type ZlbBudgetApiIncomeApplyFormAuditListPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/api/income/apply-form/audit-list',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [审核列表查询↗](http://yapi.cai-inc.com/project/2991/interface/api/315938) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [收入管理-申请单接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_48864)
 * @请求头 `POST /zlb/budget/api/income/apply-form/audit-list`
 * @更新时间 `2024-05-14 11:44:39`
 * @项目ID 2991
 */
const zlbBudgetApiIncomeApplyFormAuditListPostRequestConfig: ZlbBudgetApiIncomeApplyFormAuditListPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_0,
    devUrl: devUrl_0_4_0_0,
    prodUrl: prodUrl_0_4_0_0,
    path: '/zlb/budget/api/income/apply-form/audit-list',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbBudgetApiIncomeApplyFormAuditListPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [审核列表查询↗](http://yapi.cai-inc.com/project/2991/interface/api/315938) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [收入管理-申请单接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_48864)
 * @请求头 `POST /zlb/budget/api/income/apply-form/audit-list`
 * @更新时间 `2024-05-14 11:44:39`
 * @项目ID 2991
 */
export const zlbBudgetApiIncomeApplyFormAuditListPost = /*#__PURE__*/ (
  requestData: ZlbBudgetApiIncomeApplyFormAuditListPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetApiIncomeApplyFormAuditListPostResponse>(
    prepare(zlbBudgetApiIncomeApplyFormAuditListPostRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetApiIncomeApplyFormAuditListPost.requestConfig =
  zlbBudgetApiIncomeApplyFormAuditListPostRequestConfig;

/**
 * 接口 [查询单据详情↗](http://yapi.cai-inc.com/project/2991/interface/api/316146) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [收入管理-申请单接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_48864)
 * @请求头 `GET /zlb/budget/api/income/apply-form/info`
 * @更新时间 `2024-05-14 11:44:39`
 * @项目ID 2991
 */
export interface ZlbBudgetApiIncomeApplyFormInfoGetRequest {
  applyFormCode: string;
  source: string;
}

/**
 * 接口 [查询单据详情↗](http://yapi.cai-inc.com/project/2991/interface/api/316146) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [收入管理-申请单接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_48864)
 * @请求头 `GET /zlb/budget/api/income/apply-form/info`
 * @更新时间 `2024-05-14 11:44:39`
 * @项目ID 2991
 */
export interface ZlbBudgetApiIncomeApplyFormInfoGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 收入类型
     */
    categoryName?: string;
    /**
     * 收入类型唯一代码
     */
    categoryCode?: string;
    /**
     * 收入类型
     */
    applyFormCode?: string;
    /**
     * 资金来源
     */
    capitalSource?: string;
    /**
     * 申请单号
     */
    businessFormCode?: string;
    /**
     * 申请事由
     */
    applyReason?: string;
    /**
     * 经办人
     */
    operatorName?: string;
    /**
     * 经办人ID
     */
    operatorId?: number;
    /**
     * 负责人姓名
     */
    principalName?: string;
    /**
     * 负责人operatorId
     */
    principalOperatorId?: number;
    /**
     * 部门ID
     */
    deptId?: number;
    /**
     * 部门名字
     */
    deptName?: string;
    /**
     * 金额
     */
    applyAmount?: number;
    /**
     * 本次报销金额
     */
    currentAmount?: number;
    /**
     * 收款状态 0：未收款 1：已收款
     */
    payStatus?: number;
    /**
     * 收款状态描述
     */
    payStatusDesc?: string;
    /**
     * 单据状态
     */
    formStatus?: number;
    /**
     * 单据状态描述
     */
    formStatusDesc?: string;
    /**
     * 事项起始时间
     */
    itemBeginDate?: number;
    /**
     * 事项截止时间
     */
    itemEndDate?: number;
    /**
     * 收入描述
     */
    incomeDesc?: string;
    /**
     * 是否需要收款
     */
    needIssue?: boolean;
    /**
     * 开票信息
     */
    issueInfoDTO?: {
      /**
       * 开票信息code
       */
      issueCode?: string;
      /**
       * 发票类型
       */
      invoiceType?: number;
      /**
       * 票据类型描述
       */
      invoiceTypeDesc?: string;
      /**
       * 开票金额
       */
      issueAmount?: number;
      /**
       * 购买方名称
       */
      buyerName?: string;
      /**
       * 购买方税号
       */
      buyerTaxNo?: string;
      /**
       * 地址
       */
      address?: string;
      /**
       * 电话
       */
      telephoneNo?: string;
      /**
       * 开户银行
       */
      bankName?: string;
      /**
       * 账号
       */
      receiveAccountNo?: string;
      /**
       * 收款人邮箱
       */
      receiverTelephoneNo?: string;
      /**
       * 收款人邮箱
       */
      receiverEmail?: string;
    };
    /**
     * 合同信息集合
     */
    contractROS?: {
      /**
       * 合同唯一编号
       */
      uniqueCode?: string;
      currentPrice: number;
      /**
       * 合同编号
       */
      contractCode: string;
      /**
       * 合同名称
       */
      contractName: string;
      /**
       * 合同金额（分）
       */
      amount: number;
      /**
       * 甲方名称
       */
      firstPartyName: string;
      /**
       * 甲方联系人姓名
       */
      firstPartyContact: string;
      /**
       * 甲方联系人电话
       */
      firstPartyPhone: string;
      /**
       * 乙方名称
       */
      secondPartyName: string;
      /**
       * 乙方联系人姓名
       */
      secondPartyContact: string;
      /**
       * 乙方联系人电话
       */
      secondPartyPhone: string;
      /**
       * 合同内容明细
       */
      detail?: string;
      /**
       * 备注
       */
      remark?: string;
      attachmentList: {
        /**
         * 附件OssId
         */
        fileId: string;
        /**
         * 附件类型
         */
        type?: string;
        /**
         * 附件名称
         */
        name?: string;
        /**
         * 附件大小
         */
        size?: number;
        /**
         * 桶的key
         */
        bizCode?: string;
        /**
         * 下载文件的url
         */
        url?: string;
        /**
         * 文件大小描述
         */
        sizeDesc?: string;
        /**
         * 是否是合同文档
         * 1-是
         */
        contractType?: number;
      }[];
      /**
       * 分期类型  1 一次性付款 2分期付款
       */
      stagingType: number;
      /**
       * 来源
       */
      dataSource: 0 | 1 | 2 | 3 | 4 | 5;
      stagingContractList: {
        /**
         * 支付期数
         */
        stagingCount: number;
        /**
         * 金额
         */
        amount: number;
        /**
         * 支付时间
         */
        payTime?: string;
        /**
         * 备注
         */
        remark?: string;
        /**
         * 支付比例
         */
        payProportion?: string;
      }[];
      /**
       * 付款方式描述
       */
      payModeDesc?: string;
      /**
       * 是否可编辑
       */
      canEdit?: boolean;
      /**
       * 是否可删除
       */
      canDelete?: boolean;
      /**
       * 是否可查看
       */
      canRead?: boolean;
      /**
       * 本次金额
       */
      currentAmount?: number;
    }[];
    /**
     * 是否已收款 0：未收款 1：已收款
     */
    isPay?: boolean;
    /**
     * 收款人信息
     */
    receiverROS?: {
      receiveCode?: string;
      /**
       * 收款户名
       */
      receiveName?: string;
      /**
       * 收款账号
       */
      receiveAccountNo?: string;
      /**
       * 收款金额
       */
      amount?: number;
      /**
       * 账号code
       */
      accountCode?: string;
      /**
       * 银行名字
       */
      bankName?: string;
    }[];
    /**
     * 银行回单文件
     */
    bankReceiptFiles?: {
      /**
       * 附件OssId
       */
      fileId: string;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 附件名称
       */
      name?: string;
      /**
       * 附件大小
       */
      size?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      url?: string;
      /**
       * 文件大小描述
       */
      sizeDesc?: string;
      /**
       * 银行回单唯一编码
       */
      voucherId?: string;
    }[];
    /**
     * 附件信息集合
     */
    attachmentDTOS?: {
      /**
       * 附件OssId
       */
      fileId: string;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 附件名称
       */
      name?: string;
      /**
       * 附件大小
       */
      size?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      url?: string;
      /**
       * 文件大小描述
       */
      sizeDesc?: string;
    }[];
    /**
     * 转交人员列表
     */
    forwardReceivers?: {
      /**
       * 用户ID
       */
      userId?: number;
      /**
       * 操作员ID
       */
      operatorId: number;
      /**
       * 姓名
       */
      userName: string;
    }[];
    /**
     * 按钮控制
     */
    operateButton?: {
      /**
       * 是否可撤销
       */
      withdraw?: boolean;
      /**
       * 是否可转交
       */
      transfer?: boolean;
      /**
       * 是否可打印
       */
      print?: boolean;
      /**
       * 是否可重新发起
       */
      restart?: boolean;
      /**
       * 是否可作废
       */
      discard?: boolean;
      /**
       * 是否可通过
       */
      pass?: boolean;
      /**
       * 是否可驳回
       */
      reject?: boolean;
      /**
       * 是否可加签
       */
      signature?: boolean;
    };
    /**
     * 0：当前用户 1：审批 2：审核
     */
    userRole?: number;
    /**
     * 提交时间
     */
    submitTime?: number;
    /**
     * 发票附件数据
     */
    invoiceAttachments?: {
      /**
       * 附件OssId
       */
      fileId: string;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 附件名称
       */
      name?: string;
      /**
       * 附件大小
       */
      size?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      url?: string;
      /**
       * 文件大小描述
       */
      sizeDesc?: string;
    }[];
    /**
     * 预算填报记录
     */
    budgetProjectRecordList?: {
      depId?: number;
      depName?: string;
      projectUk?: string;
      projectName?: string;
      subjectUk?: string;
      subjectName?: string;
      budgetProjectRecordUk?: string;
      amount?: number;
      totalAmount?: number;
      availableAmount?: number;
      operatorId?: number;
    }[];
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [查询单据详情↗](http://yapi.cai-inc.com/project/2991/interface/api/316146) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [收入管理-申请单接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_48864)
 * @请求头 `GET /zlb/budget/api/income/apply-form/info`
 * @更新时间 `2024-05-14 11:44:39`
 * @项目ID 2991
 */
type ZlbBudgetApiIncomeApplyFormInfoGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/api/income/apply-form/info',
    'data',
    string,
    'applyFormCode' | 'source',
    false
  >
>;

/**
 * 接口 [查询单据详情↗](http://yapi.cai-inc.com/project/2991/interface/api/316146) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [收入管理-申请单接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_48864)
 * @请求头 `GET /zlb/budget/api/income/apply-form/info`
 * @更新时间 `2024-05-14 11:44:39`
 * @项目ID 2991
 */
const zlbBudgetApiIncomeApplyFormInfoGetRequestConfig: ZlbBudgetApiIncomeApplyFormInfoGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_0,
    devUrl: devUrl_0_4_0_0,
    prodUrl: prodUrl_0_4_0_0,
    path: '/zlb/budget/api/income/apply-form/info',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_0,
    paramNames: [],
    queryNames: ['applyFormCode', 'source'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbBudgetApiIncomeApplyFormInfoGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [查询单据详情↗](http://yapi.cai-inc.com/project/2991/interface/api/316146) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [收入管理-申请单接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_48864)
 * @请求头 `GET /zlb/budget/api/income/apply-form/info`
 * @更新时间 `2024-05-14 11:44:39`
 * @项目ID 2991
 */
export const zlbBudgetApiIncomeApplyFormInfoGet = /*#__PURE__*/ (
  requestData: ZlbBudgetApiIncomeApplyFormInfoGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetApiIncomeApplyFormInfoGetResponse>(
    prepare(zlbBudgetApiIncomeApplyFormInfoGetRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetApiIncomeApplyFormInfoGet.requestConfig = zlbBudgetApiIncomeApplyFormInfoGetRequestConfig;

/**
 * 接口 [保存申请单↗](http://yapi.cai-inc.com/project/2991/interface/api/316154) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [收入管理-申请单接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_48864)
 * @请求头 `POST /zlb/budget/api/income/apply-form/save`
 * @更新时间 `2024-05-14 11:44:40`
 * @项目ID 2991
 */
export interface ZlbBudgetApiIncomeApplyFormSavePostRequest {
  /**
   * 业务单号
   */
  applyFormCode?: string;
  /**
   * 部门ID
   */
  deptId?: number;
  /**
   * 申请事由
   */
  applyReason: string;
  /**
   * 收入类型
   */
  categoryCode: string;
  /**
   * 资金来源
   */
  capitalSource: string;
  /**
   * 收入总金额
   */
  applyAmount: number;
  /**
   * 事项起始时间
   */
  itemBeginDate: string;
  /**
   * 事项截止时间
   */
  itemEndDate: string;
  /**
   * 收入描述
   */
  incomeDesc?: string;
  /**
   * 部门名字
   */
  deptName?: string;
  /**
   * 负责人姓名
   */
  principalName: string;
  /**
   * 是否需要开票 true需要 fasle不需要
   */
  needIssue: boolean;
  /**
   * 银行回单文件
   */
  bankReceiptFiles?: {
    /**
     * 附件OssId
     */
    fileId: string;
    /**
     * 附件类型
     */
    type?: string;
    /**
     * 附件名称
     */
    name?: string;
    /**
     * 附件大小
     */
    size?: number;
    /**
     * 桶的key
     */
    bizCode?: string;
    /**
     * 下载文件的url
     */
    url?: string;
    /**
     * 文件大小描述
     */
    sizeDesc?: string;
    /**
     * 银行回单唯一编码
     */
    voucherId?: string;
  }[];
  /**
   * 附件信息集合
   */
  attachmentDTOS?: {
    /**
     * 附件OssId
     */
    fileId: string;
    /**
     * 附件类型
     */
    type?: string;
    /**
     * 附件名称
     */
    name?: string;
    /**
     * 附件大小
     */
    size?: number;
    /**
     * 桶的key
     */
    bizCode?: string;
    /**
     * 下载文件的url
     */
    url?: string;
    /**
     * 文件大小描述
     */
    sizeDesc?: string;
  }[];
  /**
   * 收款状态 0：未收款 1：已收款
   */
  payStatus: number;
  /**
   * 收款人信息
   */
  receiverPOS?: {
    /**
     * 支付代码
     */
    accountCode?: string;
    /**
     * 收款金额
     */
    amount: number;
  }[];
  /**
   * 合同信息
   */
  contractPOS?: {
    /**
     * 合同唯一编号
     */
    uniqueCode?: string;
    currentPrice: number;
    /**
     * 合同编号
     */
    contractCode: string;
    /**
     * 合同名称
     */
    contractName: string;
    /**
     * 合同金额（分）
     */
    amount: number;
    /**
     * 甲方名称
     */
    firstPartyName: string;
    /**
     * 甲方联系人姓名
     */
    firstPartyContact: string;
    /**
     * 甲方联系人电话
     */
    firstPartyPhone: string;
    /**
     * 乙方名称
     */
    secondPartyName: string;
    /**
     * 乙方联系人姓名
     */
    secondPartyContact: string;
    /**
     * 乙方联系人电话
     */
    secondPartyPhone: string;
    /**
     * 合同内容明细
     */
    detail?: string;
    /**
     * 备注
     */
    remark?: string;
    attachmentList: {
      /**
       * 附件OssId
       */
      fileId: string;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 附件名称
       */
      name?: string;
      /**
       * 附件大小
       */
      size?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      url?: string;
      /**
       * 文件大小描述
       */
      sizeDesc?: string;
      /**
       * 是否是合同文档
       * 1-是
       */
      contractType?: number;
    }[];
    /**
     * 分期类型  1 一次性付款 2分期付款
     */
    stagingType: number;
    /**
     * 来源
     */
    dataSource: 0 | 1 | 2 | 3 | 4 | 5;
    stagingContractList: {
      /**
       * 支付期数
       */
      stagingCount: number;
      /**
       * 金额
       */
      amount: number;
      /**
       * 支付时间
       */
      payTime?: string;
      /**
       * 备注
       */
      remark?: string;
      /**
       * 支付比例
       */
      payProportion?: string;
    }[];
  }[];
  /**
   * 开票信息
   */
  issueInfoDTO?: {
    /**
     * 开票信息code
     */
    issueCode?: string;
    /**
     * 发票类型
     */
    invoiceType?: number;
    /**
     * 票据类型描述
     */
    invoiceTypeDesc?: string;
    /**
     * 开票金额
     */
    issueAmount?: number;
    /**
     * 购买方名称
     */
    buyerName?: string;
    /**
     * 购买方税号
     */
    buyerTaxNo?: string;
    /**
     * 地址
     */
    address?: string;
    /**
     * 电话
     */
    telephoneNo?: string;
    /**
     * 开户银行
     */
    bankName?: string;
    /**
     * 账号
     */
    receiveAccountNo?: string;
    /**
     * 收款人邮箱
     */
    receiverTelephoneNo?: string;
    /**
     * 收款人邮箱
     */
    receiverEmail?: string;
  };
  /**
   * 发票附件数据
   */
  invoiceAttachments?: {
    /**
     * 附件OssId
     */
    fileId: string;
    /**
     * 附件类型
     */
    type?: string;
    /**
     * 附件名称
     */
    name?: string;
    /**
     * 附件大小
     */
    size?: number;
    /**
     * 桶的key
     */
    bizCode?: string;
    /**
     * 下载文件的url
     */
    url?: string;
    /**
     * 文件大小描述
     */
    sizeDesc?: string;
  }[];
  /**
   * 预算填报记录
   */
  budgetProjectRecordList?: {
    depId?: number;
    depName?: string;
    projectUk?: string;
    projectName?: string;
    subjectUk?: string;
    subjectName?: string;
    budgetProjectRecordUk?: string;
    amount?: number;
    totalAmount?: number;
    availableAmount?: number;
    operatorId?: number;
  }[];
  /**
   * 工作流提交
   */
  workflowInfo: {
    bizId?: string;
    bizType?: string;
    businessCode?: string;
    subType?: string;
    processDefineKey?: string;
    processModelId?: number;
    version?: number;
    auditInfos?: {
      taskDefineKey?: string;
      nodeName?: string;
      operatorIds?: number[];
      nodeType?: number;
      eventType?: number;
      auditType?: number;
      departmentId?: number;
      bizProperty?: string;
      auditStatus?: number;
    }[];
    extConditions?: {
      key?: {};
    };
    context?: string;
    operatorId?: number;
    remark?: string;
  };
}

/**
 * 接口 [保存申请单↗](http://yapi.cai-inc.com/project/2991/interface/api/316154) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [收入管理-申请单接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_48864)
 * @请求头 `POST /zlb/budget/api/income/apply-form/save`
 * @更新时间 `2024-05-14 11:44:40`
 * @项目ID 2991
 */
export interface ZlbBudgetApiIncomeApplyFormSavePostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [保存申请单↗](http://yapi.cai-inc.com/project/2991/interface/api/316154) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [收入管理-申请单接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_48864)
 * @请求头 `POST /zlb/budget/api/income/apply-form/save`
 * @更新时间 `2024-05-14 11:44:40`
 * @项目ID 2991
 */
type ZlbBudgetApiIncomeApplyFormSavePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/api/income/apply-form/save',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [保存申请单↗](http://yapi.cai-inc.com/project/2991/interface/api/316154) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [收入管理-申请单接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_48864)
 * @请求头 `POST /zlb/budget/api/income/apply-form/save`
 * @更新时间 `2024-05-14 11:44:40`
 * @项目ID 2991
 */
const zlbBudgetApiIncomeApplyFormSavePostRequestConfig: ZlbBudgetApiIncomeApplyFormSavePostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_0,
    devUrl: devUrl_0_4_0_0,
    prodUrl: prodUrl_0_4_0_0,
    path: '/zlb/budget/api/income/apply-form/save',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbBudgetApiIncomeApplyFormSavePost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [保存申请单↗](http://yapi.cai-inc.com/project/2991/interface/api/316154) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [收入管理-申请单接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_48864)
 * @请求头 `POST /zlb/budget/api/income/apply-form/save`
 * @更新时间 `2024-05-14 11:44:40`
 * @项目ID 2991
 */
export const zlbBudgetApiIncomeApplyFormSavePost = /*#__PURE__*/ (
  requestData: ZlbBudgetApiIncomeApplyFormSavePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetApiIncomeApplyFormSavePostResponse>(
    prepare(zlbBudgetApiIncomeApplyFormSavePostRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetApiIncomeApplyFormSavePost.requestConfig =
  zlbBudgetApiIncomeApplyFormSavePostRequestConfig;

/**
 * 接口 [更新申请单↗](http://yapi.cai-inc.com/project/2991/interface/api/316210) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [收入管理-申请单接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_48864)
 * @请求头 `POST /zlb/budget/api/income/apply-form/update`
 * @更新时间 `2024-05-14 11:44:40`
 * @项目ID 2991
 */
export interface ZlbBudgetApiIncomeApplyFormUpdatePostRequest {
  /**
   * 申请单号
   */
  applyFormCode: string;
  /**
   * 收款人信息
   */
  applyReceiverPOList?: {
    /**
     * 支付代码
     */
    accountCode?: string;
    /**
     * 收款金额
     */
    amount: number;
  }[];
  /**
   * 银行回单信息
   */
  bankReceiptFiles?: {
    /**
     * 附件OssId
     */
    fileId: string;
    /**
     * 附件类型
     */
    type?: string;
    /**
     * 附件名称
     */
    name?: string;
    /**
     * 附件大小
     */
    size?: number;
    /**
     * 桶的key
     */
    bizCode?: string;
    /**
     * 下载文件的url
     */
    url?: string;
    /**
     * 文件大小描述
     */
    sizeDesc?: string;
    /**
     * 银行回单唯一编码
     */
    voucherId?: string;
  }[];
  /**
   * 发票信息
   */
  invoiceAttachments?: {
    /**
     * 附件OssId
     */
    fileId: string;
    /**
     * 附件类型
     */
    type?: string;
    /**
     * 附件名称
     */
    name?: string;
    /**
     * 附件大小
     */
    size?: number;
    /**
     * 桶的key
     */
    bizCode?: string;
    /**
     * 下载文件的url
     */
    url?: string;
    /**
     * 文件大小描述
     */
    sizeDesc?: string;
  }[];
  /**
   * 0：未收款 1：已收款
   */
  payStatus?: number;
  /**
   * ：0-审批，1-审核，2-出纳
   */
  nodeEvent?: number;
  /**
   * 预算填报记录
   */
  budgetProjectRecordList?: {
    depId?: number;
    depName?: string;
    projectUk?: string;
    projectName?: string;
    subjectUk?: string;
    subjectName?: string;
    budgetProjectRecordUk?: string;
    amount?: number;
    totalAmount?: number;
    availableAmount?: number;
    operatorId?: number;
  }[];
}

/**
 * 接口 [更新申请单↗](http://yapi.cai-inc.com/project/2991/interface/api/316210) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [收入管理-申请单接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_48864)
 * @请求头 `POST /zlb/budget/api/income/apply-form/update`
 * @更新时间 `2024-05-14 11:44:40`
 * @项目ID 2991
 */
export interface ZlbBudgetApiIncomeApplyFormUpdatePostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [更新申请单↗](http://yapi.cai-inc.com/project/2991/interface/api/316210) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [收入管理-申请单接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_48864)
 * @请求头 `POST /zlb/budget/api/income/apply-form/update`
 * @更新时间 `2024-05-14 11:44:40`
 * @项目ID 2991
 */
type ZlbBudgetApiIncomeApplyFormUpdatePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/api/income/apply-form/update',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [更新申请单↗](http://yapi.cai-inc.com/project/2991/interface/api/316210) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [收入管理-申请单接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_48864)
 * @请求头 `POST /zlb/budget/api/income/apply-form/update`
 * @更新时间 `2024-05-14 11:44:40`
 * @项目ID 2991
 */
const zlbBudgetApiIncomeApplyFormUpdatePostRequestConfig: ZlbBudgetApiIncomeApplyFormUpdatePostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_0,
    devUrl: devUrl_0_4_0_0,
    prodUrl: prodUrl_0_4_0_0,
    path: '/zlb/budget/api/income/apply-form/update',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbBudgetApiIncomeApplyFormUpdatePost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [更新申请单↗](http://yapi.cai-inc.com/project/2991/interface/api/316210) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [收入管理-申请单接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_48864)
 * @请求头 `POST /zlb/budget/api/income/apply-form/update`
 * @更新时间 `2024-05-14 11:44:40`
 * @项目ID 2991
 */
export const zlbBudgetApiIncomeApplyFormUpdatePost = /*#__PURE__*/ (
  requestData: ZlbBudgetApiIncomeApplyFormUpdatePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetApiIncomeApplyFormUpdatePostResponse>(
    prepare(zlbBudgetApiIncomeApplyFormUpdatePostRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetApiIncomeApplyFormUpdatePost.requestConfig =
  zlbBudgetApiIncomeApplyFormUpdatePostRequestConfig;

/**
 * 接口 [获取合同详情信息↗](http://yapi.cai-inc.com/project/2991/interface/api/316714) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [收入管理-申请单接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_48864)
 * @请求头 `GET /zlb/budget/api/income/apply-form/contract/info`
 * @更新时间 `2024-05-14 11:44:41`
 * @项目ID 2991
 */
export interface ZlbBudgetApiIncomeApplyFormContractInfoGetRequest {
  uniqueCode: string;
  source: string;
}

/**
 * 接口 [获取合同详情信息↗](http://yapi.cai-inc.com/project/2991/interface/api/316714) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [收入管理-申请单接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_48864)
 * @请求头 `GET /zlb/budget/api/income/apply-form/contract/info`
 * @更新时间 `2024-05-14 11:44:41`
 * @项目ID 2991
 */
export interface ZlbBudgetApiIncomeApplyFormContractInfoGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 合同唯一编号
     */
    uniqueCode?: string;
    /**
     * 外部唯一编号
     */
    externalUniqueCode?: string;
    /**
     * 合同编号
     */
    contractCode?: string;
    /**
     * 合同名称
     */
    contractName?: string;
    /**
     * 报销单编号（报销单合同）
     */
    expenseFormCode?: string;
    /**
     * 合同金额（分）
     */
    amount?: number;
    /**
     * 甲方名称(采购单位)
     */
    firstPartyName?: string;
    /**
     * 甲方联系人姓名
     */
    firstPartyContact?: string;
    /**
     * 甲方联系人电话
     */
    firstPartyPhone?: string;
    /**
     * 乙方姓名(供应商)
     */
    secondPartyName?: string;
    /**
     * 乙方联系人姓名
     */
    secondPartyContact?: string;
    /**
     * 乙方联系人电话
     */
    secondPartyPhone?: string;
    /**
     * 合同内容明细
     */
    detail?: string;
    /**
     * 备注
     */
    remark?: string;
    /**
     * 合同状态：0草稿 1被驳回 2用印申请中 3签订完成 4已作废
     */
    status?: number;
    /**
     * 合同状态名称
     */
    statusDesc?: string;
    /**
     * 数据源来源：0手动添加 1政采云 3报销单
     */
    dataSource?: number;
    /**
     * 附件信息
     */
    attachmentList?: {
      /**
       * 附件OssId
       */
      fileId: string;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 附件名称
       */
      name?: string;
      /**
       * 附件大小
       */
      size?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      url?: string;
      /**
       * 文件大小描述
       */
      sizeDesc?: string;
      /**
       * 是否是合同文档
       * 1-是
       */
      contractType?: number;
    }[];
    /**
     * 分期类型  1 一次性付款 2分期付款
     */
    stagingType?: number;
    /**
     * 支付期数
     */
    stagingContractList?: {
      /**
       * 支付期数
       */
      stagingCount: number;
      /**
       * 金额
       */
      amount: number;
      /**
       * 支付时间
       */
      payTime?: string;
      /**
       * 备注
       */
      remark?: string;
      /**
       * 支付比例
       */
      payProportion?: string;
    }[];
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [获取合同详情信息↗](http://yapi.cai-inc.com/project/2991/interface/api/316714) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [收入管理-申请单接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_48864)
 * @请求头 `GET /zlb/budget/api/income/apply-form/contract/info`
 * @更新时间 `2024-05-14 11:44:41`
 * @项目ID 2991
 */
type ZlbBudgetApiIncomeApplyFormContractInfoGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/api/income/apply-form/contract/info',
    'data',
    string,
    'uniqueCode' | 'source',
    false
  >
>;

/**
 * 接口 [获取合同详情信息↗](http://yapi.cai-inc.com/project/2991/interface/api/316714) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [收入管理-申请单接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_48864)
 * @请求头 `GET /zlb/budget/api/income/apply-form/contract/info`
 * @更新时间 `2024-05-14 11:44:41`
 * @项目ID 2991
 */
const zlbBudgetApiIncomeApplyFormContractInfoGetRequestConfig: ZlbBudgetApiIncomeApplyFormContractInfoGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_0,
    devUrl: devUrl_0_4_0_0,
    prodUrl: prodUrl_0_4_0_0,
    path: '/zlb/budget/api/income/apply-form/contract/info',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_0,
    paramNames: [],
    queryNames: ['uniqueCode', 'source'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbBudgetApiIncomeApplyFormContractInfoGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [获取合同详情信息↗](http://yapi.cai-inc.com/project/2991/interface/api/316714) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [收入管理-申请单接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_48864)
 * @请求头 `GET /zlb/budget/api/income/apply-form/contract/info`
 * @更新时间 `2024-05-14 11:44:41`
 * @项目ID 2991
 */
export const zlbBudgetApiIncomeApplyFormContractInfoGet = /*#__PURE__*/ (
  requestData: ZlbBudgetApiIncomeApplyFormContractInfoGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetApiIncomeApplyFormContractInfoGetResponse>(
    prepare(zlbBudgetApiIncomeApplyFormContractInfoGetRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetApiIncomeApplyFormContractInfoGet.requestConfig =
  zlbBudgetApiIncomeApplyFormContractInfoGetRequestConfig;

/**
 * 接口 [单据查询↗](http://yapi.cai-inc.com/project/2991/interface/api/322114) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [收入管理-申请单接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_48864)
 * @请求头 `POST /zlb/budget/api/income/apply-form/query-form`
 * @更新时间 `2024-05-14 11:44:38`
 * @项目ID 2991
 */
export interface ZlbBudgetApiIncomeApplyFormQueryFormPostRequest {
  /**
   * 页面大小
   */
  pageSize?: number;
  /**
   * 页码
   */
  pageNo?: number;
  /**
   * 排序字段
   */
  sortField?: string;
  /**
   * 排序规则：DESC || ASC
   */
  sortBy?: string;
  /**
   * 类目代码
   */
  categoryCode?: string;
  /**
   * 收入事由
   */
  applyReason?: string;
  /**
   * 事项起始时间
   */
  itemBeginDate?: string;
  /**
   * 事项结束时间
   */
  itemEndDate?: string;
  /**
   * 收款状态
   */
  payStatus?: number;
  /**
   * 单据状态
   */
  formStatus?: number;
  /**
   * 部门ID
   */
  deptId?: number;
  /**
   * table页，0：全部 1：待审批 2:已完成
   */
  tableStatus?: number;
  /**
   * 发起人名字
   */
  applyUserName?: string;
  /**
   * 机构ID
   */
  orgId?: number;
  /**
   * 是否已打印 0：未打印 1：已打印
   */
  printStatus?: number;
  /**
   * 统一社会信用代码
   */
  creditCode?: string;
  /**
   * 是否是测试单据：1-是，2-否
   */
  isTestForm?: number;
  /**
   * 1.财务管理列表查询 2：历史数据查询
   */
  source?: number;
}

/**
 * 接口 [单据查询↗](http://yapi.cai-inc.com/project/2991/interface/api/322114) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [收入管理-申请单接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_48864)
 * @请求头 `POST /zlb/budget/api/income/apply-form/query-form`
 * @更新时间 `2024-05-14 11:44:38`
 * @项目ID 2991
 */
export interface ZlbBudgetApiIncomeApplyFormQueryFormPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 总记录数
     */
    total?: number;
    /**
     * 结果集
     */
    data?: {
      /**
       * 收入类型
       */
      categoryName?: string;
      /**
       * 申请单号
       */
      applyFormCode?: string;
      /**
       * 业务单号
       */
      businessFormCode?: string;
      /**
       * 申请事由
       */
      applyReason?: string;
      operatorName?: string;
      /**
       * 部门ID
       */
      deptId?: number;
      /**
       * 部门名字
       */
      deptName?: string;
      /**
       * 金额
       */
      applyAmount?: number;
      /**
       * 收款状态 0：未收款 1：已收款
       */
      payStatus?: number;
      /**
       * 收款状态描述
       */
      payStatusDesc?: string;
      /**
       * 单据状态
       */
      formStatus?: number;
      /**
       * 单据状态描述
       */
      formStatusDesc?: string;
      /**
       * 申请日期
       */
      applyDate?: number;
      /**
       * 唯一ID
       */
      uniqueId?: string;
      /**
       * 0：当前用户 1：审批 2：审核
       */
      userRole?: number;
      /**
       * 机构名称
       */
      orgName?: string;
      /**
       * 单据按钮控制RO
       */
      operateButton?: {
        /**
         * 是否可编辑
         */
        edit?: boolean;
        /**
         * 是否可查看
         */
        detail?: boolean;
        /**
         * 是否可删除
         */
        remove?: boolean;
        /**
         * 是否可审核/审批
         */
        audit?: boolean;
        /**
         * 是否可编辑收款人信息
         */
        editReceiver?: boolean;
        /**
         * 是否可打印
         */
        print?: boolean;
      };
      /**
       * 打印状态
       */
      printStatus?: number;
      /**
       * 打印状态描述
       */
      printStatusName?: string;
      /**
       * 是否是测试单据：1-是，2-否
       */
      isTestForm?: number;
    }[];
    pageNum?: number;
    pageSize?: number;
    /**
     * 总页数
     */
    pages?: number;
    /**
     * 第几页
     */
    size?: number;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [单据查询↗](http://yapi.cai-inc.com/project/2991/interface/api/322114) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [收入管理-申请单接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_48864)
 * @请求头 `POST /zlb/budget/api/income/apply-form/query-form`
 * @更新时间 `2024-05-14 11:44:38`
 * @项目ID 2991
 */
type ZlbBudgetApiIncomeApplyFormQueryFormPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/api/income/apply-form/query-form',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [单据查询↗](http://yapi.cai-inc.com/project/2991/interface/api/322114) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [收入管理-申请单接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_48864)
 * @请求头 `POST /zlb/budget/api/income/apply-form/query-form`
 * @更新时间 `2024-05-14 11:44:38`
 * @项目ID 2991
 */
const zlbBudgetApiIncomeApplyFormQueryFormPostRequestConfig: ZlbBudgetApiIncomeApplyFormQueryFormPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_0,
    devUrl: devUrl_0_4_0_0,
    prodUrl: prodUrl_0_4_0_0,
    path: '/zlb/budget/api/income/apply-form/query-form',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbBudgetApiIncomeApplyFormQueryFormPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [单据查询↗](http://yapi.cai-inc.com/project/2991/interface/api/322114) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [收入管理-申请单接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_48864)
 * @请求头 `POST /zlb/budget/api/income/apply-form/query-form`
 * @更新时间 `2024-05-14 11:44:38`
 * @项目ID 2991
 */
export const zlbBudgetApiIncomeApplyFormQueryFormPost = /*#__PURE__*/ (
  requestData: ZlbBudgetApiIncomeApplyFormQueryFormPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetApiIncomeApplyFormQueryFormPostResponse>(
    prepare(zlbBudgetApiIncomeApplyFormQueryFormPostRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetApiIncomeApplyFormQueryFormPost.requestConfig =
  zlbBudgetApiIncomeApplyFormQueryFormPostRequestConfig;

/**
 * 接口 [查询单据详情↗](http://yapi.cai-inc.com/project/2991/interface/api/322650) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [收入管理-申请单接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_48864)
 * @请求头 `GET /zlb/budget/api/income/apply-form/info-on-audit`
 * @更新时间 `2024-05-14 11:44:39`
 * @项目ID 2991
 */
export interface ZlbBudgetApiIncomeApplyFormInfoOnAuditGetRequest {
  applyFormCode: string;
}

/**
 * 接口 [查询单据详情↗](http://yapi.cai-inc.com/project/2991/interface/api/322650) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [收入管理-申请单接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_48864)
 * @请求头 `GET /zlb/budget/api/income/apply-form/info-on-audit`
 * @更新时间 `2024-05-14 11:44:39`
 * @项目ID 2991
 */
export interface ZlbBudgetApiIncomeApplyFormInfoOnAuditGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 收入类型
     */
    categoryName?: string;
    /**
     * 收入类型唯一代码
     */
    categoryCode?: string;
    /**
     * 收入类型
     */
    applyFormCode?: string;
    /**
     * 资金来源
     */
    capitalSource?: string;
    /**
     * 申请单号
     */
    businessFormCode?: string;
    /**
     * 申请事由
     */
    applyReason?: string;
    /**
     * 经办人
     */
    operatorName?: string;
    /**
     * 经办人ID
     */
    operatorId?: number;
    /**
     * 负责人姓名
     */
    principalName?: string;
    /**
     * 负责人operatorId
     */
    principalOperatorId?: number;
    /**
     * 部门ID
     */
    deptId?: number;
    /**
     * 部门名字
     */
    deptName?: string;
    /**
     * 金额
     */
    applyAmount?: number;
    /**
     * 本次报销金额
     */
    currentAmount?: number;
    /**
     * 收款状态 0：未收款 1：已收款
     */
    payStatus?: number;
    /**
     * 收款状态描述
     */
    payStatusDesc?: string;
    /**
     * 单据状态
     */
    formStatus?: number;
    /**
     * 单据状态描述
     */
    formStatusDesc?: string;
    /**
     * 事项起始时间
     */
    itemBeginDate?: number;
    /**
     * 事项截止时间
     */
    itemEndDate?: number;
    /**
     * 收入描述
     */
    incomeDesc?: string;
    /**
     * 是否需要收款
     */
    needIssue?: boolean;
    /**
     * 开票信息
     */
    issueInfoDTO?: {
      /**
       * 开票信息code
       */
      issueCode?: string;
      /**
       * 发票类型
       */
      invoiceType?: number;
      /**
       * 票据类型描述
       */
      invoiceTypeDesc?: string;
      /**
       * 开票金额
       */
      issueAmount?: number;
      /**
       * 购买方名称
       */
      buyerName?: string;
      /**
       * 购买方税号
       */
      buyerTaxNo?: string;
      /**
       * 地址
       */
      address?: string;
      /**
       * 电话
       */
      telephoneNo?: string;
      /**
       * 开户银行
       */
      bankName?: string;
      /**
       * 账号
       */
      receiveAccountNo?: string;
      /**
       * 收款人邮箱
       */
      receiverTelephoneNo?: string;
      /**
       * 收款人邮箱
       */
      receiverEmail?: string;
    };
    /**
     * 合同信息集合
     */
    contractROS?: {
      /**
       * 合同唯一编号
       */
      uniqueCode?: string;
      currentPrice: number;
      /**
       * 合同编号
       */
      contractCode: string;
      /**
       * 合同名称
       */
      contractName: string;
      /**
       * 合同金额（分）
       */
      amount: number;
      /**
       * 甲方名称
       */
      firstPartyName: string;
      /**
       * 甲方联系人姓名
       */
      firstPartyContact: string;
      /**
       * 甲方联系人电话
       */
      firstPartyPhone: string;
      /**
       * 乙方名称
       */
      secondPartyName: string;
      /**
       * 乙方联系人姓名
       */
      secondPartyContact: string;
      /**
       * 乙方联系人电话
       */
      secondPartyPhone: string;
      /**
       * 合同内容明细
       */
      detail?: string;
      /**
       * 备注
       */
      remark?: string;
      attachmentList: {
        /**
         * 附件OssId
         */
        fileId: string;
        /**
         * 附件类型
         */
        type?: string;
        /**
         * 附件名称
         */
        name?: string;
        /**
         * 附件大小
         */
        size?: number;
        /**
         * 桶的key
         */
        bizCode?: string;
        /**
         * 下载文件的url
         */
        url?: string;
        /**
         * 文件大小描述
         */
        sizeDesc?: string;
        /**
         * 是否是合同文档
         * 1-是
         */
        contractType?: number;
      }[];
      /**
       * 分期类型  1 一次性付款 2分期付款
       */
      stagingType: number;
      /**
       * 来源
       */
      dataSource: 0 | 1 | 2 | 3 | 4 | 5;
      stagingContractList: {
        /**
         * 支付期数
         */
        stagingCount: number;
        /**
         * 金额
         */
        amount: number;
        /**
         * 支付时间
         */
        payTime?: string;
        /**
         * 备注
         */
        remark?: string;
        /**
         * 支付比例
         */
        payProportion?: string;
      }[];
      /**
       * 付款方式描述
       */
      payModeDesc?: string;
      /**
       * 是否可编辑
       */
      canEdit?: boolean;
      /**
       * 是否可删除
       */
      canDelete?: boolean;
      /**
       * 是否可查看
       */
      canRead?: boolean;
      /**
       * 本次金额
       */
      currentAmount?: number;
    }[];
    /**
     * 是否已收款 0：未收款 1：已收款
     */
    isPay?: boolean;
    /**
     * 收款人信息
     */
    receiverROS?: {
      receiveCode?: string;
      /**
       * 收款户名
       */
      receiveName?: string;
      /**
       * 收款账号
       */
      receiveAccountNo?: string;
      /**
       * 收款金额
       */
      amount?: number;
      /**
       * 账号code
       */
      accountCode?: string;
      /**
       * 银行名字
       */
      bankName?: string;
    }[];
    /**
     * 银行回单文件
     */
    bankReceiptFiles?: {
      /**
       * 附件OssId
       */
      fileId: string;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 附件名称
       */
      name?: string;
      /**
       * 附件大小
       */
      size?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      url?: string;
      /**
       * 文件大小描述
       */
      sizeDesc?: string;
      /**
       * 银行回单唯一编码
       */
      voucherId?: string;
    }[];
    /**
     * 附件信息集合
     */
    attachmentDTOS?: {
      /**
       * 附件OssId
       */
      fileId: string;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 附件名称
       */
      name?: string;
      /**
       * 附件大小
       */
      size?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      url?: string;
      /**
       * 文件大小描述
       */
      sizeDesc?: string;
    }[];
    /**
     * 转交人员列表
     */
    forwardReceivers?: {
      /**
       * 用户ID
       */
      userId?: number;
      /**
       * 操作员ID
       */
      operatorId: number;
      /**
       * 姓名
       */
      userName: string;
    }[];
    /**
     * 按钮控制
     */
    operateButton?: {
      /**
       * 是否可撤销
       */
      withdraw?: boolean;
      /**
       * 是否可转交
       */
      transfer?: boolean;
      /**
       * 是否可打印
       */
      print?: boolean;
      /**
       * 是否可重新发起
       */
      restart?: boolean;
      /**
       * 是否可作废
       */
      discard?: boolean;
      /**
       * 是否可通过
       */
      pass?: boolean;
      /**
       * 是否可驳回
       */
      reject?: boolean;
      /**
       * 是否可加签
       */
      signature?: boolean;
    };
    /**
     * 0：当前用户 1：审批 2：审核
     */
    userRole?: number;
    /**
     * 提交时间
     */
    submitTime?: number;
    /**
     * 发票附件数据
     */
    invoiceAttachments?: {
      /**
       * 附件OssId
       */
      fileId: string;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 附件名称
       */
      name?: string;
      /**
       * 附件大小
       */
      size?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      url?: string;
      /**
       * 文件大小描述
       */
      sizeDesc?: string;
    }[];
    /**
     * 预算填报记录
     */
    budgetProjectRecordList?: {
      depId?: number;
      depName?: string;
      projectUk?: string;
      projectName?: string;
      subjectUk?: string;
      subjectName?: string;
      budgetProjectRecordUk?: string;
      amount?: number;
      totalAmount?: number;
      availableAmount?: number;
      operatorId?: number;
    }[];
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [查询单据详情↗](http://yapi.cai-inc.com/project/2991/interface/api/322650) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [收入管理-申请单接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_48864)
 * @请求头 `GET /zlb/budget/api/income/apply-form/info-on-audit`
 * @更新时间 `2024-05-14 11:44:39`
 * @项目ID 2991
 */
type ZlbBudgetApiIncomeApplyFormInfoOnAuditGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/api/income/apply-form/info-on-audit',
    'data',
    string,
    'applyFormCode',
    false
  >
>;

/**
 * 接口 [查询单据详情↗](http://yapi.cai-inc.com/project/2991/interface/api/322650) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [收入管理-申请单接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_48864)
 * @请求头 `GET /zlb/budget/api/income/apply-form/info-on-audit`
 * @更新时间 `2024-05-14 11:44:39`
 * @项目ID 2991
 */
const zlbBudgetApiIncomeApplyFormInfoOnAuditGetRequestConfig: ZlbBudgetApiIncomeApplyFormInfoOnAuditGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_0,
    devUrl: devUrl_0_4_0_0,
    prodUrl: prodUrl_0_4_0_0,
    path: '/zlb/budget/api/income/apply-form/info-on-audit',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_0,
    paramNames: [],
    queryNames: ['applyFormCode'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbBudgetApiIncomeApplyFormInfoOnAuditGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [查询单据详情↗](http://yapi.cai-inc.com/project/2991/interface/api/322650) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [收入管理-申请单接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_48864)
 * @请求头 `GET /zlb/budget/api/income/apply-form/info-on-audit`
 * @更新时间 `2024-05-14 11:44:39`
 * @项目ID 2991
 */
export const zlbBudgetApiIncomeApplyFormInfoOnAuditGet = /*#__PURE__*/ (
  requestData: ZlbBudgetApiIncomeApplyFormInfoOnAuditGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetApiIncomeApplyFormInfoOnAuditGetResponse>(
    prepare(zlbBudgetApiIncomeApplyFormInfoOnAuditGetRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetApiIncomeApplyFormInfoOnAuditGet.requestConfig =
  zlbBudgetApiIncomeApplyFormInfoOnAuditGetRequestConfig;

/**
 * 接口 [删除收入管理计划单↗](http://yapi.cai-inc.com/project/2991/interface/api/340874) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [收入管理-申请单接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_48864)
 * @请求头 `POST /cn.gov.zlb.income.web.controller.IncomeApplyFormController/delete/cn.gov.zlb.income.domain.po.ApplyFormDeletePO/`
 * @更新时间 `2022-11-24 15:12:08`
 * @项目ID 2991
 */
export interface CnGovZlbIncomeWebControllerIncomeApplyFormControllerDeleteCnGovZlbIncomeDomainPoApplyFormDeletePoPostRequest {
  formDeletePO?: {
    applyFormCode: string;
  };
}

/**
 * 接口 [删除收入管理计划单↗](http://yapi.cai-inc.com/project/2991/interface/api/340874) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [收入管理-申请单接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_48864)
 * @请求头 `POST /cn.gov.zlb.income.web.controller.IncomeApplyFormController/delete/cn.gov.zlb.income.domain.po.ApplyFormDeletePO/`
 * @更新时间 `2022-11-24 15:12:08`
 * @项目ID 2991
 */
export interface CnGovZlbIncomeWebControllerIncomeApplyFormControllerDeleteCnGovZlbIncomeDomainPoApplyFormDeletePoPostResponse {
  success?: boolean;
  result?: boolean;
  code?: string;
  message?: string;
}

/**
 * 接口 [删除收入管理计划单↗](http://yapi.cai-inc.com/project/2991/interface/api/340874) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [收入管理-申请单接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_48864)
 * @请求头 `POST /cn.gov.zlb.income.web.controller.IncomeApplyFormController/delete/cn.gov.zlb.income.domain.po.ApplyFormDeletePO/`
 * @更新时间 `2022-11-24 15:12:08`
 * @项目ID 2991
 */
type CnGovZlbIncomeWebControllerIncomeApplyFormControllerDeleteCnGovZlbIncomeDomainPoApplyFormDeletePoPostRequestConfig =
  Readonly<
    RequestConfig<
      'http://yapi.cai-inc.com/mock/2991',
      '',
      '',
      '/cn.gov.zlb.income.web.controller.IncomeApplyFormController/delete/cn.gov.zlb.income.domain.po.ApplyFormDeletePO/',
      'data',
      string,
      string,
      false
    >
  >;

/**
 * 接口 [删除收入管理计划单↗](http://yapi.cai-inc.com/project/2991/interface/api/340874) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [收入管理-申请单接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_48864)
 * @请求头 `POST /cn.gov.zlb.income.web.controller.IncomeApplyFormController/delete/cn.gov.zlb.income.domain.po.ApplyFormDeletePO/`
 * @更新时间 `2022-11-24 15:12:08`
 * @项目ID 2991
 */
const cnGovZlbIncomeWebControllerIncomeApplyFormControllerDeleteCnGovZlbIncomeDomainPoApplyFormDeletePoPostRequestConfig: CnGovZlbIncomeWebControllerIncomeApplyFormControllerDeleteCnGovZlbIncomeDomainPoApplyFormDeletePoPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_0,
    devUrl: devUrl_0_4_0_0,
    prodUrl: prodUrl_0_4_0_0,
    path: '/cn.gov.zlb.income.web.controller.IncomeApplyFormController/delete/cn.gov.zlb.income.domain.po.ApplyFormDeletePO/',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName:
      'cnGovZlbIncomeWebControllerIncomeApplyFormControllerDeleteCnGovZlbIncomeDomainPoApplyFormDeletePoPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [删除收入管理计划单↗](http://yapi.cai-inc.com/project/2991/interface/api/340874) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [收入管理-申请单接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_48864)
 * @请求头 `POST /cn.gov.zlb.income.web.controller.IncomeApplyFormController/delete/cn.gov.zlb.income.domain.po.ApplyFormDeletePO/`
 * @更新时间 `2022-11-24 15:12:08`
 * @项目ID 2991
 */
export const cnGovZlbIncomeWebControllerIncomeApplyFormControllerDeleteCnGovZlbIncomeDomainPoApplyFormDeletePoPost =
  /*#__PURE__*/ (
    requestData: CnGovZlbIncomeWebControllerIncomeApplyFormControllerDeleteCnGovZlbIncomeDomainPoApplyFormDeletePoPostRequest,
    ...args: UserRequestRestArgs
  ) => {
    return request<CnGovZlbIncomeWebControllerIncomeApplyFormControllerDeleteCnGovZlbIncomeDomainPoApplyFormDeletePoPostResponse>(
      prepare(
        cnGovZlbIncomeWebControllerIncomeApplyFormControllerDeleteCnGovZlbIncomeDomainPoApplyFormDeletePoPostRequestConfig,
        requestData,
      ),
      ...args,
    );
  };

cnGovZlbIncomeWebControllerIncomeApplyFormControllerDeleteCnGovZlbIncomeDomainPoApplyFormDeletePoPost.requestConfig =
  cnGovZlbIncomeWebControllerIncomeApplyFormControllerDeleteCnGovZlbIncomeDomainPoApplyFormDeletePoPostRequestConfig;

/**
 * 接口 [确认打印↗](http://yapi.cai-inc.com/project/2991/interface/api/341298) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [收入管理-申请单接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_48864)
 * @请求头 `POST /zlb/budget/api/income/apply-form/confirm-print`
 * @更新时间 `2024-05-14 11:44:41`
 * @项目ID 2991
 */
export interface ZlbBudgetApiIncomeApplyFormConfirmPrintPostRequest {
  formCode: string;
}

/**
 * 接口 [确认打印↗](http://yapi.cai-inc.com/project/2991/interface/api/341298) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [收入管理-申请单接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_48864)
 * @请求头 `POST /zlb/budget/api/income/apply-form/confirm-print`
 * @更新时间 `2024-05-14 11:44:41`
 * @项目ID 2991
 */
export interface ZlbBudgetApiIncomeApplyFormConfirmPrintPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [确认打印↗](http://yapi.cai-inc.com/project/2991/interface/api/341298) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [收入管理-申请单接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_48864)
 * @请求头 `POST /zlb/budget/api/income/apply-form/confirm-print`
 * @更新时间 `2024-05-14 11:44:41`
 * @项目ID 2991
 */
type ZlbBudgetApiIncomeApplyFormConfirmPrintPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/api/income/apply-form/confirm-print',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [确认打印↗](http://yapi.cai-inc.com/project/2991/interface/api/341298) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [收入管理-申请单接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_48864)
 * @请求头 `POST /zlb/budget/api/income/apply-form/confirm-print`
 * @更新时间 `2024-05-14 11:44:41`
 * @项目ID 2991
 */
const zlbBudgetApiIncomeApplyFormConfirmPrintPostRequestConfig: ZlbBudgetApiIncomeApplyFormConfirmPrintPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_0,
    devUrl: devUrl_0_4_0_0,
    prodUrl: prodUrl_0_4_0_0,
    path: '/zlb/budget/api/income/apply-form/confirm-print',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbBudgetApiIncomeApplyFormConfirmPrintPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [确认打印↗](http://yapi.cai-inc.com/project/2991/interface/api/341298) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [收入管理-申请单接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_48864)
 * @请求头 `POST /zlb/budget/api/income/apply-form/confirm-print`
 * @更新时间 `2024-05-14 11:44:41`
 * @项目ID 2991
 */
export const zlbBudgetApiIncomeApplyFormConfirmPrintPost = /*#__PURE__*/ (
  requestData: ZlbBudgetApiIncomeApplyFormConfirmPrintPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetApiIncomeApplyFormConfirmPrintPostResponse>(
    prepare(zlbBudgetApiIncomeApplyFormConfirmPrintPostRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetApiIncomeApplyFormConfirmPrintPost.requestConfig =
  zlbBudgetApiIncomeApplyFormConfirmPrintPostRequestConfig;

/**
 * 接口 [列表数据导出↗](http://yapi.cai-inc.com/project/2991/interface/api/341306) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [收入管理-申请单接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_48864)
 * @请求头 `POST /zlb/budget/api/income/apply-form/export-query-form-list`
 * @更新时间 `2024-05-14 11:44:41`
 * @项目ID 2991
 */
export interface ZlbBudgetApiIncomeApplyFormExportQueryFormListPostRequest {
  /**
   * 页面大小
   */
  pageSize?: number;
  /**
   * 页码
   */
  pageNo?: number;
  /**
   * 排序字段
   */
  sortField?: string;
  /**
   * 排序规则：DESC || ASC
   */
  sortBy?: string;
  /**
   * 类目代码
   */
  categoryCode?: string;
  /**
   * 收入事由
   */
  applyReason?: string;
  /**
   * 事项起始时间
   */
  itemBeginDate?: string;
  /**
   * 事项结束时间
   */
  itemEndDate?: string;
  /**
   * 收款状态
   */
  payStatus?: number;
  /**
   * 单据状态
   */
  formStatus?: number;
  /**
   * 部门ID
   */
  deptId?: number;
  /**
   * table页，0：全部 1：待审批 2:已完成
   */
  tableStatus?: number;
  /**
   * 发起人名字
   */
  applyUserName?: string;
  /**
   * 机构ID
   */
  orgId?: number[];
  /**
   * 是否已打印 0：未打印 1：已打印
   */
  printStatus?: number;
  /**
   * 统一社会信用代码
   */
  creditCode?: string;
  /**
   * 是否是测试单据：1-是，2-否
   */
  isTestForm?: number;
  /**
   * 业务单号
   */
  businessCode?: string;
}

/**
 * 接口 [列表数据导出↗](http://yapi.cai-inc.com/project/2991/interface/api/341306) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [收入管理-申请单接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_48864)
 * @请求头 `POST /zlb/budget/api/income/apply-form/export-query-form-list`
 * @更新时间 `2024-05-14 11:44:41`
 * @项目ID 2991
 */
export interface ZlbBudgetApiIncomeApplyFormExportQueryFormListPostResponse {}

/**
 * 接口 [列表数据导出↗](http://yapi.cai-inc.com/project/2991/interface/api/341306) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [收入管理-申请单接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_48864)
 * @请求头 `POST /zlb/budget/api/income/apply-form/export-query-form-list`
 * @更新时间 `2024-05-14 11:44:41`
 * @项目ID 2991
 */
type ZlbBudgetApiIncomeApplyFormExportQueryFormListPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/api/income/apply-form/export-query-form-list',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [列表数据导出↗](http://yapi.cai-inc.com/project/2991/interface/api/341306) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [收入管理-申请单接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_48864)
 * @请求头 `POST /zlb/budget/api/income/apply-form/export-query-form-list`
 * @更新时间 `2024-05-14 11:44:41`
 * @项目ID 2991
 */
const zlbBudgetApiIncomeApplyFormExportQueryFormListPostRequestConfig: ZlbBudgetApiIncomeApplyFormExportQueryFormListPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_0,
    devUrl: devUrl_0_4_0_0,
    prodUrl: prodUrl_0_4_0_0,
    path: '/zlb/budget/api/income/apply-form/export-query-form-list',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbBudgetApiIncomeApplyFormExportQueryFormListPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [列表数据导出↗](http://yapi.cai-inc.com/project/2991/interface/api/341306) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [收入管理-申请单接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_48864)
 * @请求头 `POST /zlb/budget/api/income/apply-form/export-query-form-list`
 * @更新时间 `2024-05-14 11:44:41`
 * @项目ID 2991
 */
export const zlbBudgetApiIncomeApplyFormExportQueryFormListPost = /*#__PURE__*/ (
  requestData: ZlbBudgetApiIncomeApplyFormExportQueryFormListPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetApiIncomeApplyFormExportQueryFormListPostResponse>(
    prepare(zlbBudgetApiIncomeApplyFormExportQueryFormListPostRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetApiIncomeApplyFormExportQueryFormListPost.requestConfig =
  zlbBudgetApiIncomeApplyFormExportQueryFormListPostRequestConfig;

/**
 * 接口 [运营平台测-查询单据列表↗](http://yapi.cai-inc.com/project/2991/interface/api/358690) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [收入管理-申请单接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_48864)
 * @请求头 `POST /zlb/budget/api/income/apply-form/manager/query-list`
 * @更新时间 `2022-12-14 16:48:59`
 * @项目ID 2991
 */
export interface ZlbBudgetApiIncomeApplyFormManagerQueryListPostRequest {
  /**
   * 业务单号
   */
  businessFormCode?: string;
  /**
   * 类目代码
   */
  categoryCode?: string;
  /**
   * 收入事由
   */
  applyReason?: string;
  /**
   * 事项起始时间
   */
  itemBeginDate?: string;
  /**
   * 事项结束时间
   */
  itemEndDate?: string;
  /**
   * 收款状态
   */
  payStatus?: number;
  /**
   * 单据状态
   */
  formStatus?: number;
  /**
   * 部门ID
   */
  deptId?: number;
  /**
   * table页，0：全部 1：待审批 2:已完成
   */
  tableStatus?: number;
  /**
   * 是否已打印 0：未打印 1：已打印
   */
  printStatus?: number;
  /**
   * 机构ID
   */
  orgId?: number[];
  /**
   * 发起人名字
   */
  applyUserName?: string;
  /**
   * 页面大小
   */
  pageSize?: number;
  /**
   * 页码
   */
  pageNo?: number;
  /**
   * 排序字段
   */
  sortField?: string;
  /**
   * 排序规则：DESC || ASC
   */
  sortBy?: string;
}

/**
 * 接口 [运营平台测-查询单据列表↗](http://yapi.cai-inc.com/project/2991/interface/api/358690) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [收入管理-申请单接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_48864)
 * @请求头 `POST /zlb/budget/api/income/apply-form/manager/query-list`
 * @更新时间 `2022-12-14 16:48:59`
 * @项目ID 2991
 */
export interface ZlbBudgetApiIncomeApplyFormManagerQueryListPostResponse {
  success?: boolean;
  result?: {
    /**
     * 总记录数
     */
    total?: number;
    /**
     * 结果集
     */
    data?: {
      /**
       * 单据按钮控制RO
       */
      buttonControlRO?: {
        /**
         * 是否可编辑
         */
        canEdit?: boolean;
        /**
         * 是否可查看
         */
        canRead?: boolean;
        /**
         * 是否可删除
         */
        canDelete?: boolean;
        /**
         * 是否可审核/审批
         */
        canAudit?: boolean;
        /**
         * 是否可编辑收款人信息
         */
        canEditReceiver?: boolean;
        /**
         * 是否可打印
         */
        canPrint?: boolean;
      };
      /**
       * 打印状态
       */
      printStatus?: number;
      /**
       * 打印状态描述
       */
      printStatusName?: string;
      /**
       * 收入类型
       */
      categoryName?: string;
      /**
       * 申请单号
       */
      applyFormCode?: string;
      /**
       * 业务单号
       */
      businessFormCode?: string;
      /**
       * 申请事由
       */
      applyReason?: string;
      operatorName?: string;
      /**
       * 部门ID
       */
      deptId?: number;
      /**
       * 部门名字
       */
      deptName?: string;
      /**
       * 金额
       */
      applyAmount?: number;
      /**
       * 收款状态 0：未收款 1：已收款
       */
      payStatus?: number;
      /**
       * 收款状态描述
       */
      payStatusDesc?: string;
      /**
       * 单据状态
       */
      formStatus?: number;
      /**
       * 单据状态描述
       */
      formStatusDesc?: string;
      /**
       * 申请日期
       */
      applyDate?: number;
      /**
       * 唯一ID
       */
      uniqueId?: string;
      /**
       * 0：当前用户 1：审批 2：审核
       */
      userRole?: number;
      /**
       * 机构名称
       */
      orgName?: string;
    }[];
    pageNum?: number;
    pageSize?: number;
    /**
     * 总页数
     */
    pages?: number;
    /**
     * 第几页
     */
    size?: number;
  };
  code?: string;
  message?: string;
}

/**
 * 接口 [运营平台测-查询单据列表↗](http://yapi.cai-inc.com/project/2991/interface/api/358690) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [收入管理-申请单接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_48864)
 * @请求头 `POST /zlb/budget/api/income/apply-form/manager/query-list`
 * @更新时间 `2022-12-14 16:48:59`
 * @项目ID 2991
 */
type ZlbBudgetApiIncomeApplyFormManagerQueryListPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/api/income/apply-form/manager/query-list',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [运营平台测-查询单据列表↗](http://yapi.cai-inc.com/project/2991/interface/api/358690) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [收入管理-申请单接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_48864)
 * @请求头 `POST /zlb/budget/api/income/apply-form/manager/query-list`
 * @更新时间 `2022-12-14 16:48:59`
 * @项目ID 2991
 */
const zlbBudgetApiIncomeApplyFormManagerQueryListPostRequestConfig: ZlbBudgetApiIncomeApplyFormManagerQueryListPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_0,
    devUrl: devUrl_0_4_0_0,
    prodUrl: prodUrl_0_4_0_0,
    path: '/zlb/budget/api/income/apply-form/manager/query-list',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbBudgetApiIncomeApplyFormManagerQueryListPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [运营平台测-查询单据列表↗](http://yapi.cai-inc.com/project/2991/interface/api/358690) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [收入管理-申请单接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_48864)
 * @请求头 `POST /zlb/budget/api/income/apply-form/manager/query-list`
 * @更新时间 `2022-12-14 16:48:59`
 * @项目ID 2991
 */
export const zlbBudgetApiIncomeApplyFormManagerQueryListPost = /*#__PURE__*/ (
  requestData: ZlbBudgetApiIncomeApplyFormManagerQueryListPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetApiIncomeApplyFormManagerQueryListPostResponse>(
    prepare(zlbBudgetApiIncomeApplyFormManagerQueryListPostRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetApiIncomeApplyFormManagerQueryListPost.requestConfig =
  zlbBudgetApiIncomeApplyFormManagerQueryListPostRequestConfig;

/**
 * 接口 [运营平台测-查询单据列表↗](http://yapi.cai-inc.com/project/2991/interface/api/360066) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [收入管理-申请单接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_48864)
 * @请求头 `POST /zlb/budget/api/income/apply-form/operation/query-list`
 * @更新时间 `2024-05-14 11:44:39`
 * @项目ID 2991
 */
export interface ZlbBudgetApiIncomeApplyFormOperationQueryListPostRequest {
  /**
   * 页面大小
   */
  pageSize?: number;
  /**
   * 页码
   */
  pageNo?: number;
  /**
   * 排序字段
   */
  sortField?: string;
  /**
   * 排序规则：DESC || ASC
   */
  sortBy?: string;
  /**
   * 单据状态列表
   */
  formStatus?: number[];
  /**
   * 业务单号
   */
  businessCode?: string;
  /**
   * 机构ID
   */
  orgId?: number[];
  /**
   * 是否已打印 0：未打印 1：已打印
   */
  printStatus?: number;
  /**
   * 统一社会信用代码
   */
  creditCode?: string;
  /**
   * 是否是测试单据：1-是，2-否
   */
  isTestForm?: number;
  /**
   * 类目代码
   */
  categoryCode?: string;
  /**
   * 收入事由
   */
  applyReason?: string;
  /**
   * 事项起始时间
   */
  itemBeginDate?: string;
  /**
   * 事项结束时间
   */
  itemEndDate?: string;
  /**
   * 收款状态
   */
  payStatus?: number;
  /**
   * 部门ID
   */
  deptId?: number;
  /**
   * table页，0：全部 1：待审批 2:已完成
   */
  tableStatus?: number;
  /**
   * 发起人名字
   */
  applyUserName?: string;
}

/**
 * 接口 [运营平台测-查询单据列表↗](http://yapi.cai-inc.com/project/2991/interface/api/360066) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [收入管理-申请单接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_48864)
 * @请求头 `POST /zlb/budget/api/income/apply-form/operation/query-list`
 * @更新时间 `2024-05-14 11:44:39`
 * @项目ID 2991
 */
export interface ZlbBudgetApiIncomeApplyFormOperationQueryListPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 总记录数
     */
    total?: number;
    /**
     * 结果集
     */
    data?: {
      /**
       * 收入类型
       */
      categoryName?: string;
      /**
       * 申请单号
       */
      applyFormCode?: string;
      /**
       * 业务单号
       */
      businessFormCode?: string;
      /**
       * 申请事由
       */
      applyReason?: string;
      operatorName?: string;
      /**
       * 部门ID
       */
      deptId?: number;
      /**
       * 部门名字
       */
      deptName?: string;
      /**
       * 金额
       */
      applyAmount?: number;
      /**
       * 收款状态 0：未收款 1：已收款
       */
      payStatus?: number;
      /**
       * 收款状态描述
       */
      payStatusDesc?: string;
      /**
       * 单据状态
       */
      formStatus?: number;
      /**
       * 单据状态描述
       */
      formStatusDesc?: string;
      /**
       * 申请日期
       */
      applyDate?: number;
      /**
       * 唯一ID
       */
      uniqueId?: string;
      /**
       * 0：当前用户 1：审批 2：审核
       */
      userRole?: number;
      /**
       * 机构名称
       */
      orgName?: string;
      /**
       * 单据按钮控制RO
       */
      operateButton?: {
        /**
         * 是否可编辑
         */
        edit?: boolean;
        /**
         * 是否可查看
         */
        detail?: boolean;
        /**
         * 是否可删除
         */
        remove?: boolean;
        /**
         * 是否可审核/审批
         */
        audit?: boolean;
        /**
         * 是否可编辑收款人信息
         */
        editReceiver?: boolean;
        /**
         * 是否可打印
         */
        print?: boolean;
      };
      /**
       * 打印状态
       */
      printStatus?: number;
      /**
       * 打印状态描述
       */
      printStatusName?: string;
      /**
       * 是否是测试单据：1-是，2-否
       */
      isTestForm?: number;
    }[];
    pageNum?: number;
    pageSize?: number;
    /**
     * 总页数
     */
    pages?: number;
    /**
     * 第几页
     */
    size?: number;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [运营平台测-查询单据列表↗](http://yapi.cai-inc.com/project/2991/interface/api/360066) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [收入管理-申请单接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_48864)
 * @请求头 `POST /zlb/budget/api/income/apply-form/operation/query-list`
 * @更新时间 `2024-05-14 11:44:39`
 * @项目ID 2991
 */
type ZlbBudgetApiIncomeApplyFormOperationQueryListPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/api/income/apply-form/operation/query-list',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [运营平台测-查询单据列表↗](http://yapi.cai-inc.com/project/2991/interface/api/360066) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [收入管理-申请单接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_48864)
 * @请求头 `POST /zlb/budget/api/income/apply-form/operation/query-list`
 * @更新时间 `2024-05-14 11:44:39`
 * @项目ID 2991
 */
const zlbBudgetApiIncomeApplyFormOperationQueryListPostRequestConfig: ZlbBudgetApiIncomeApplyFormOperationQueryListPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_0,
    devUrl: devUrl_0_4_0_0,
    prodUrl: prodUrl_0_4_0_0,
    path: '/zlb/budget/api/income/apply-form/operation/query-list',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbBudgetApiIncomeApplyFormOperationQueryListPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [运营平台测-查询单据列表↗](http://yapi.cai-inc.com/project/2991/interface/api/360066) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [收入管理-申请单接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_48864)
 * @请求头 `POST /zlb/budget/api/income/apply-form/operation/query-list`
 * @更新时间 `2024-05-14 11:44:39`
 * @项目ID 2991
 */
export const zlbBudgetApiIncomeApplyFormOperationQueryListPost = /*#__PURE__*/ (
  requestData: ZlbBudgetApiIncomeApplyFormOperationQueryListPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetApiIncomeApplyFormOperationQueryListPostResponse>(
    prepare(zlbBudgetApiIncomeApplyFormOperationQueryListPostRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetApiIncomeApplyFormOperationQueryListPost.requestConfig =
  zlbBudgetApiIncomeApplyFormOperationQueryListPostRequestConfig;

/**
 * 接口 [删除测试单据↗](http://yapi.cai-inc.com/project/2991/interface/api/360554) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [收入管理-申请单接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_48864)
 * @请求头 `POST /zlb/budget/api/income/apply-form/delete-test-form`
 * @更新时间 `2024-05-14 11:44:37`
 * @项目ID 2991
 */
export interface ZlbBudgetApiIncomeApplyFormDeleteTestFormPostRequest {
  /**
   * 申请单据号集合
   */
  applyCodeList: string[];
}

/**
 * 接口 [删除测试单据↗](http://yapi.cai-inc.com/project/2991/interface/api/360554) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [收入管理-申请单接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_48864)
 * @请求头 `POST /zlb/budget/api/income/apply-form/delete-test-form`
 * @更新时间 `2024-05-14 11:44:37`
 * @项目ID 2991
 */
export interface ZlbBudgetApiIncomeApplyFormDeleteTestFormPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [删除测试单据↗](http://yapi.cai-inc.com/project/2991/interface/api/360554) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [收入管理-申请单接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_48864)
 * @请求头 `POST /zlb/budget/api/income/apply-form/delete-test-form`
 * @更新时间 `2024-05-14 11:44:37`
 * @项目ID 2991
 */
type ZlbBudgetApiIncomeApplyFormDeleteTestFormPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/api/income/apply-form/delete-test-form',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [删除测试单据↗](http://yapi.cai-inc.com/project/2991/interface/api/360554) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [收入管理-申请单接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_48864)
 * @请求头 `POST /zlb/budget/api/income/apply-form/delete-test-form`
 * @更新时间 `2024-05-14 11:44:37`
 * @项目ID 2991
 */
const zlbBudgetApiIncomeApplyFormDeleteTestFormPostRequestConfig: ZlbBudgetApiIncomeApplyFormDeleteTestFormPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_0,
    devUrl: devUrl_0_4_0_0,
    prodUrl: prodUrl_0_4_0_0,
    path: '/zlb/budget/api/income/apply-form/delete-test-form',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbBudgetApiIncomeApplyFormDeleteTestFormPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [删除测试单据↗](http://yapi.cai-inc.com/project/2991/interface/api/360554) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [收入管理-申请单接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_48864)
 * @请求头 `POST /zlb/budget/api/income/apply-form/delete-test-form`
 * @更新时间 `2024-05-14 11:44:37`
 * @项目ID 2991
 */
export const zlbBudgetApiIncomeApplyFormDeleteTestFormPost = /*#__PURE__*/ (
  requestData: ZlbBudgetApiIncomeApplyFormDeleteTestFormPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetApiIncomeApplyFormDeleteTestFormPostResponse>(
    prepare(zlbBudgetApiIncomeApplyFormDeleteTestFormPostRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetApiIncomeApplyFormDeleteTestFormPost.requestConfig =
  zlbBudgetApiIncomeApplyFormDeleteTestFormPostRequestConfig;

/**
 * 接口 [银行回单查询↗](http://yapi.cai-inc.com/project/2991/interface/api/629698) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [收入管理-申请单接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_48864)
 * @请求头 `POST /zlb/budget/api/income/apply-form/bank-receipt/page`
 * @更新时间 `2024-05-14 11:44:40`
 * @项目ID 2991
 */
export interface ZlbBudgetApiIncomeApplyFormBankReceiptPagePostRequest {
  /**
   * 页面大小
   */
  pageSize?: number;
  /**
   * 页码
   */
  pageNo?: number;
  /**
   * 排序字段
   */
  sortField?: string;
  /**
   * 排序规则：DESC || ASC
   */
  sortBy?: string;
  /**
   * 银行回单编号
   */
  bankReceiptCode?: string;
  /**
   * 起始时间
   */
  createStartTime?: number;
  /**
   * 截止时间
   */
  createEndTime?: number;
  /**
   * 户名
   */
  accountNameLike?: string;
  /**
   * 单据编码，编辑时传递
   */
  formCode?: string;
}

/**
 * 接口 [银行回单查询↗](http://yapi.cai-inc.com/project/2991/interface/api/629698) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [收入管理-申请单接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_48864)
 * @请求头 `POST /zlb/budget/api/income/apply-form/bank-receipt/page`
 * @更新时间 `2024-05-14 11:44:40`
 * @项目ID 2991
 */
export interface ZlbBudgetApiIncomeApplyFormBankReceiptPagePostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 总记录数
     */
    total?: number;
    /**
     * 结果集
     */
    data?: {
      /**
       * 银行回单凭证UK
       */
      voucherId?: string;
      /**
       * 银行回单编号
       */
      bankReceiptCode?: string;
      /**
       * 创建时间
       */
      createTime?: number;
      /**
       * 金额
       */
      amount?: number;
      /**
       * 付款人户名
       */
      payerAccountName?: string;
      /**
       * 付款人账户
       */
      payerAccountNo?: string;
      /**
       * 付款人开户行
       */
      payerBankName?: string;
      /**
       * 银行回单file
       */
      attachment?: {
        /**
         * 附件OssId
         */
        fileId: string;
        /**
         * 附件类型
         */
        type?: string;
        /**
         * 附件名称
         */
        name?: string;
        /**
         * 附件大小
         */
        size?: number;
        /**
         * 桶的key
         */
        bizCode?: string;
        /**
         * 下载文件的url
         */
        url?: string;
        /**
         * 文件大小描述
         */
        sizeDesc?: string;
      };
      /**
       * 收款人户名
       */
      payeeAccountName?: string;
      /**
       * 收款人账户
       */
      payeeAccountNo?: string;
      /**
       * 收款人开户行
       */
      payeeBankName?: string;
      /**
       * 已使用，0-未使用，1-已使用
       */
      usedStatus?: number;
    }[];
    pageNum?: number;
    pageSize?: number;
    /**
     * 总页数
     */
    pages?: number;
    /**
     * 第几页
     */
    size?: number;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [银行回单查询↗](http://yapi.cai-inc.com/project/2991/interface/api/629698) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [收入管理-申请单接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_48864)
 * @请求头 `POST /zlb/budget/api/income/apply-form/bank-receipt/page`
 * @更新时间 `2024-05-14 11:44:40`
 * @项目ID 2991
 */
type ZlbBudgetApiIncomeApplyFormBankReceiptPagePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/api/income/apply-form/bank-receipt/page',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [银行回单查询↗](http://yapi.cai-inc.com/project/2991/interface/api/629698) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [收入管理-申请单接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_48864)
 * @请求头 `POST /zlb/budget/api/income/apply-form/bank-receipt/page`
 * @更新时间 `2024-05-14 11:44:40`
 * @项目ID 2991
 */
const zlbBudgetApiIncomeApplyFormBankReceiptPagePostRequestConfig: ZlbBudgetApiIncomeApplyFormBankReceiptPagePostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_0,
    devUrl: devUrl_0_4_0_0,
    prodUrl: prodUrl_0_4_0_0,
    path: '/zlb/budget/api/income/apply-form/bank-receipt/page',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbBudgetApiIncomeApplyFormBankReceiptPagePost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [银行回单查询↗](http://yapi.cai-inc.com/project/2991/interface/api/629698) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [收入管理-申请单接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_48864)
 * @请求头 `POST /zlb/budget/api/income/apply-form/bank-receipt/page`
 * @更新时间 `2024-05-14 11:44:40`
 * @项目ID 2991
 */
export const zlbBudgetApiIncomeApplyFormBankReceiptPagePost = /*#__PURE__*/ (
  requestData: ZlbBudgetApiIncomeApplyFormBankReceiptPagePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetApiIncomeApplyFormBankReceiptPagePostResponse>(
    prepare(zlbBudgetApiIncomeApplyFormBankReceiptPagePostRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetApiIncomeApplyFormBankReceiptPagePost.requestConfig =
  zlbBudgetApiIncomeApplyFormBankReceiptPagePostRequestConfig;

/**
 * 接口 [提交↗](http://yapi.cai-inc.com/project/2991/interface/api/653738) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [收入管理-申请单接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_48864)
 * @请求头 `POST /zlb/budget/api/income/apply-form/submit`
 * @更新时间 `2024-05-14 11:44:40`
 * @项目ID 2991
 */
export interface ZlbBudgetApiIncomeApplyFormSubmitPostRequest {
  /**
   * 业务单号
   */
  applyFormCode?: string;
  /**
   * 部门ID
   */
  deptId?: number;
  /**
   * 申请事由
   */
  applyReason: string;
  /**
   * 收入类型
   */
  categoryCode: string;
  /**
   * 资金来源
   */
  capitalSource: string;
  /**
   * 收入总金额
   */
  applyAmount: number;
  /**
   * 事项起始时间
   */
  itemBeginDate: string;
  /**
   * 事项截止时间
   */
  itemEndDate: string;
  /**
   * 收入描述
   */
  incomeDesc?: string;
  /**
   * 部门名字
   */
  deptName?: string;
  /**
   * 负责人姓名
   */
  principalName: string;
  /**
   * 是否需要开票 true需要 fasle不需要
   */
  needIssue: boolean;
  /**
   * 银行回单文件
   */
  bankReceiptFiles?: {
    /**
     * 附件OssId
     */
    fileId: string;
    /**
     * 附件类型
     */
    type?: string;
    /**
     * 附件名称
     */
    name?: string;
    /**
     * 附件大小
     */
    size?: number;
    /**
     * 桶的key
     */
    bizCode?: string;
    /**
     * 下载文件的url
     */
    url?: string;
    /**
     * 文件大小描述
     */
    sizeDesc?: string;
    /**
     * 银行回单唯一编码
     */
    voucherId?: string;
  }[];
  /**
   * 附件信息集合
   */
  attachmentDTOS?: {
    /**
     * 附件OssId
     */
    fileId: string;
    /**
     * 附件类型
     */
    type?: string;
    /**
     * 附件名称
     */
    name?: string;
    /**
     * 附件大小
     */
    size?: number;
    /**
     * 桶的key
     */
    bizCode?: string;
    /**
     * 下载文件的url
     */
    url?: string;
    /**
     * 文件大小描述
     */
    sizeDesc?: string;
  }[];
  /**
   * 收款状态 0：未收款 1：已收款
   */
  payStatus: number;
  /**
   * 收款人信息
   */
  receiverPOS?: {
    /**
     * 支付代码
     */
    accountCode?: string;
    /**
     * 收款金额
     */
    amount: number;
  }[];
  /**
   * 合同信息
   */
  contractPOS?: {
    /**
     * 合同唯一编号
     */
    uniqueCode?: string;
    currentPrice: number;
    /**
     * 合同编号
     */
    contractCode: string;
    /**
     * 合同名称
     */
    contractName: string;
    /**
     * 合同金额（分）
     */
    amount: number;
    /**
     * 甲方名称
     */
    firstPartyName: string;
    /**
     * 甲方联系人姓名
     */
    firstPartyContact: string;
    /**
     * 甲方联系人电话
     */
    firstPartyPhone: string;
    /**
     * 乙方名称
     */
    secondPartyName: string;
    /**
     * 乙方联系人姓名
     */
    secondPartyContact: string;
    /**
     * 乙方联系人电话
     */
    secondPartyPhone: string;
    /**
     * 合同内容明细
     */
    detail?: string;
    /**
     * 备注
     */
    remark?: string;
    attachmentList: {
      /**
       * 附件OssId
       */
      fileId: string;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 附件名称
       */
      name?: string;
      /**
       * 附件大小
       */
      size?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      url?: string;
      /**
       * 文件大小描述
       */
      sizeDesc?: string;
      /**
       * 是否是合同文档
       * 1-是
       */
      contractType?: number;
    }[];
    /**
     * 分期类型  1 一次性付款 2分期付款
     */
    stagingType: number;
    /**
     * 来源
     */
    dataSource: 0 | 1 | 2 | 3 | 4 | 5;
    stagingContractList: {
      /**
       * 支付期数
       */
      stagingCount: number;
      /**
       * 金额
       */
      amount: number;
      /**
       * 支付时间
       */
      payTime?: string;
      /**
       * 备注
       */
      remark?: string;
      /**
       * 支付比例
       */
      payProportion?: string;
    }[];
  }[];
  /**
   * 开票信息
   */
  issueInfoDTO?: {
    /**
     * 开票信息code
     */
    issueCode?: string;
    /**
     * 发票类型
     */
    invoiceType?: number;
    /**
     * 票据类型描述
     */
    invoiceTypeDesc?: string;
    /**
     * 开票金额
     */
    issueAmount?: number;
    /**
     * 购买方名称
     */
    buyerName?: string;
    /**
     * 购买方税号
     */
    buyerTaxNo?: string;
    /**
     * 地址
     */
    address?: string;
    /**
     * 电话
     */
    telephoneNo?: string;
    /**
     * 开户银行
     */
    bankName?: string;
    /**
     * 账号
     */
    receiveAccountNo?: string;
    /**
     * 收款人邮箱
     */
    receiverTelephoneNo?: string;
    /**
     * 收款人邮箱
     */
    receiverEmail?: string;
  };
  /**
   * 发票附件数据
   */
  invoiceAttachments?: {
    /**
     * 附件OssId
     */
    fileId: string;
    /**
     * 附件类型
     */
    type?: string;
    /**
     * 附件名称
     */
    name?: string;
    /**
     * 附件大小
     */
    size?: number;
    /**
     * 桶的key
     */
    bizCode?: string;
    /**
     * 下载文件的url
     */
    url?: string;
    /**
     * 文件大小描述
     */
    sizeDesc?: string;
  }[];
  /**
   * 预算填报记录
   */
  budgetProjectRecordList?: {
    depId?: number;
    depName?: string;
    projectUk?: string;
    projectName?: string;
    subjectUk?: string;
    subjectName?: string;
    budgetProjectRecordUk?: string;
    amount?: number;
    totalAmount?: number;
    availableAmount?: number;
    operatorId?: number;
  }[];
  /**
   * 工作流提交
   */
  workflowInfo: {
    bizId?: string;
    bizType?: string;
    businessCode?: string;
    subType?: string;
    processDefineKey?: string;
    processModelId?: number;
    version?: number;
    auditInfos?: {
      taskDefineKey?: string;
      nodeName?: string;
      operatorIds?: number[];
      nodeType?: number;
      eventType?: number;
      auditType?: number;
      departmentId?: number;
      bizProperty?: string;
      auditStatus?: number;
    }[];
    extConditions?: {
      key?: {};
    };
    context?: string;
    operatorId?: number;
    remark?: string;
  };
}

/**
 * 接口 [提交↗](http://yapi.cai-inc.com/project/2991/interface/api/653738) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [收入管理-申请单接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_48864)
 * @请求头 `POST /zlb/budget/api/income/apply-form/submit`
 * @更新时间 `2024-05-14 11:44:40`
 * @项目ID 2991
 */
export interface ZlbBudgetApiIncomeApplyFormSubmitPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 单据编码
     */
    formCode?: string;
    /**
     * 整体校验
     */
    isSuccess?: boolean;
    /**
     * 预算校验结果
     */
    budgetProjectCheckResultRO?: {
      checkStatus?: number;
      checkResultInfoROS?: {
        budgetProjectRecordUk?: string;
        availableAmount?: number;
        projectCheckStatus?: number;
        subjectCheckStatus?: number;
        amountCheckStatus?: number;
      }[];
    };
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [提交↗](http://yapi.cai-inc.com/project/2991/interface/api/653738) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [收入管理-申请单接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_48864)
 * @请求头 `POST /zlb/budget/api/income/apply-form/submit`
 * @更新时间 `2024-05-14 11:44:40`
 * @项目ID 2991
 */
type ZlbBudgetApiIncomeApplyFormSubmitPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/api/income/apply-form/submit',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [提交↗](http://yapi.cai-inc.com/project/2991/interface/api/653738) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [收入管理-申请单接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_48864)
 * @请求头 `POST /zlb/budget/api/income/apply-form/submit`
 * @更新时间 `2024-05-14 11:44:40`
 * @项目ID 2991
 */
const zlbBudgetApiIncomeApplyFormSubmitPostRequestConfig: ZlbBudgetApiIncomeApplyFormSubmitPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_0,
    devUrl: devUrl_0_4_0_0,
    prodUrl: prodUrl_0_4_0_0,
    path: '/zlb/budget/api/income/apply-form/submit',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbBudgetApiIncomeApplyFormSubmitPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [提交↗](http://yapi.cai-inc.com/project/2991/interface/api/653738) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [收入管理-申请单接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_48864)
 * @请求头 `POST /zlb/budget/api/income/apply-form/submit`
 * @更新时间 `2024-05-14 11:44:40`
 * @项目ID 2991
 */
export const zlbBudgetApiIncomeApplyFormSubmitPost = /*#__PURE__*/ (
  requestData: ZlbBudgetApiIncomeApplyFormSubmitPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetApiIncomeApplyFormSubmitPostResponse>(
    prepare(zlbBudgetApiIncomeApplyFormSubmitPostRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetApiIncomeApplyFormSubmitPost.requestConfig =
  zlbBudgetApiIncomeApplyFormSubmitPostRequestConfig;

/**
 * 接口 [更新申请单↗](http://yapi.cai-inc.com/project/2991/interface/api/653922) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [收入管理-申请单接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_48864)
 * @请求头 `POST /zlb/budget/api/income/apply-form/audit`
 * @更新时间 `2024-05-14 11:44:40`
 * @项目ID 2991
 */
export interface ZlbBudgetApiIncomeApplyFormAuditPostRequest {
  /**
   * 参数
   */
  updatePO: {
    /**
     * 申请单号
     */
    applyFormCode: string;
    /**
     * 收款人信息
     */
    applyReceiverPOList?: {
      /**
       * 支付代码
       */
      accountCode?: string;
      /**
       * 收款金额
       */
      amount: number;
    }[];
    /**
     * 银行回单信息
     */
    bankReceiptFiles?: {
      /**
       * 附件OssId
       */
      fileId: string;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 附件名称
       */
      name?: string;
      /**
       * 附件大小
       */
      size?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      url?: string;
      /**
       * 文件大小描述
       */
      sizeDesc?: string;
      /**
       * 银行回单唯一编码
       */
      voucherId?: string;
    }[];
    /**
     * 发票信息
     */
    invoiceAttachments?: {
      /**
       * 附件OssId
       */
      fileId: string;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 附件名称
       */
      name?: string;
      /**
       * 附件大小
       */
      size?: number;
      /**
       * 桶的key
       */
      bizCode?: string;
      /**
       * 下载文件的url
       */
      url?: string;
      /**
       * 文件大小描述
       */
      sizeDesc?: string;
    }[];
    /**
     * 0：未收款 1：已收款
     */
    payStatus?: number;
    /**
     * ：0-审批，1-审核，2-出纳
     */
    nodeEvent?: number;
    /**
     * 预算填报记录
     */
    budgetProjectRecordList?: {
      depId?: number;
      depName?: string;
      projectUk?: string;
      projectName?: string;
      subjectUk?: string;
      subjectName?: string;
      budgetProjectRecordUk?: string;
      amount?: number;
      totalAmount?: number;
      availableAmount?: number;
      operatorId?: number;
    }[];
  };
  /**
   * 审批参数
   */
  workflowAuditPO: {
    bizId?: string;
    bizType?: string;
    subType?: string;
    auditRemark?: string;
    executeType: number;
    processDefineKey?: string;
    currentNodeKey: string;
    operatorId?: number;
    context?: string;
    eventType: number;
    rejectNodeKey?: string;
    signAttachment?: {
      fileId?: string;
      type?: string;
      name?: string;
      size?: number;
      bizCode?: string;
      url?: string;
      sizeDesc?: string;
    };
  };
}

/**
 * 接口 [更新申请单↗](http://yapi.cai-inc.com/project/2991/interface/api/653922) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [收入管理-申请单接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_48864)
 * @请求头 `POST /zlb/budget/api/income/apply-form/audit`
 * @更新时间 `2024-05-14 11:44:40`
 * @项目ID 2991
 */
export interface ZlbBudgetApiIncomeApplyFormAuditPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 整体校验
     */
    isSuccess?: boolean;
    /**
     * 预算校验结果
     */
    budgetProjectCheckResultRO?: {
      checkStatus?: number;
      checkResultInfoROS?: {
        budgetProjectRecordUk?: string;
        availableAmount?: number;
        projectCheckStatus?: number;
        subjectCheckStatus?: number;
        amountCheckStatus?: number;
      }[];
    };
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [更新申请单↗](http://yapi.cai-inc.com/project/2991/interface/api/653922) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [收入管理-申请单接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_48864)
 * @请求头 `POST /zlb/budget/api/income/apply-form/audit`
 * @更新时间 `2024-05-14 11:44:40`
 * @项目ID 2991
 */
type ZlbBudgetApiIncomeApplyFormAuditPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/api/income/apply-form/audit',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [更新申请单↗](http://yapi.cai-inc.com/project/2991/interface/api/653922) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [收入管理-申请单接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_48864)
 * @请求头 `POST /zlb/budget/api/income/apply-form/audit`
 * @更新时间 `2024-05-14 11:44:40`
 * @项目ID 2991
 */
const zlbBudgetApiIncomeApplyFormAuditPostRequestConfig: ZlbBudgetApiIncomeApplyFormAuditPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_0,
    devUrl: devUrl_0_4_0_0,
    prodUrl: prodUrl_0_4_0_0,
    path: '/zlb/budget/api/income/apply-form/audit',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbBudgetApiIncomeApplyFormAuditPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [更新申请单↗](http://yapi.cai-inc.com/project/2991/interface/api/653922) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [收入管理-申请单接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_48864)
 * @请求头 `POST /zlb/budget/api/income/apply-form/audit`
 * @更新时间 `2024-05-14 11:44:40`
 * @项目ID 2991
 */
export const zlbBudgetApiIncomeApplyFormAuditPost = /*#__PURE__*/ (
  requestData: ZlbBudgetApiIncomeApplyFormAuditPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetApiIncomeApplyFormAuditPostResponse>(
    prepare(zlbBudgetApiIncomeApplyFormAuditPostRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetApiIncomeApplyFormAuditPost.requestConfig =
  zlbBudgetApiIncomeApplyFormAuditPostRequestConfig;

const mockUrl_0_4_0_1 = 'http://yapi.cai-inc.com/mock/2991' as any;
const devUrl_0_4_0_1 = '' as any;
const prodUrl_0_4_0_1 = '' as any;
const dataKey_0_4_0_1 = 'data' as any;

/**
 * 接口 [获取下拉框配置项↗](http://yapi.cai-inc.com/project/2991/interface/api/315954) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [收入管理-通用接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_48865)
 * @请求头 `POST /zlb/budget/api/income/apply-form/common/select-config`
 * @更新时间 `2022-10-24 14:00:53`
 * @项目ID 2991
 */
export interface ZlbBudgetApiIncomeApplyFormCommonSelectConfigPostRequest {
  /**
   * 配置Key
   */
  configKeys?: string[];
}

/**
 * 接口 [获取下拉框配置项↗](http://yapi.cai-inc.com/project/2991/interface/api/315954) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [收入管理-通用接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_48865)
 * @请求头 `POST /zlb/budget/api/income/apply-form/common/select-config`
 * @更新时间 `2022-10-24 14:00:53`
 * @项目ID 2991
 */
export interface ZlbBudgetApiIncomeApplyFormCommonSelectConfigPostResponse {
  success?: boolean;
  result?: {
    /**
     * 分组Code
     */
    groupCode?: string;
    /**
     * 选择配置集合
     */
    configROS?: {
      /**
       * 枚举值
       */
      code?: number;
      /**
       * 描述
       */
      desc?: string;
    }[];
  }[];
  code?: string;
  message?: string;
}

/**
 * 接口 [获取下拉框配置项↗](http://yapi.cai-inc.com/project/2991/interface/api/315954) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [收入管理-通用接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_48865)
 * @请求头 `POST /zlb/budget/api/income/apply-form/common/select-config`
 * @更新时间 `2022-10-24 14:00:53`
 * @项目ID 2991
 */
type ZlbBudgetApiIncomeApplyFormCommonSelectConfigPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/api/income/apply-form/common/select-config',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [获取下拉框配置项↗](http://yapi.cai-inc.com/project/2991/interface/api/315954) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [收入管理-通用接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_48865)
 * @请求头 `POST /zlb/budget/api/income/apply-form/common/select-config`
 * @更新时间 `2022-10-24 14:00:53`
 * @项目ID 2991
 */
const zlbBudgetApiIncomeApplyFormCommonSelectConfigPostRequestConfig: ZlbBudgetApiIncomeApplyFormCommonSelectConfigPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_1,
    devUrl: devUrl_0_4_0_1,
    prodUrl: prodUrl_0_4_0_1,
    path: '/zlb/budget/api/income/apply-form/common/select-config',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_1,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbBudgetApiIncomeApplyFormCommonSelectConfigPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [获取下拉框配置项↗](http://yapi.cai-inc.com/project/2991/interface/api/315954) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [收入管理-通用接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_48865)
 * @请求头 `POST /zlb/budget/api/income/apply-form/common/select-config`
 * @更新时间 `2022-10-24 14:00:53`
 * @项目ID 2991
 */
export const zlbBudgetApiIncomeApplyFormCommonSelectConfigPost = /*#__PURE__*/ (
  requestData: ZlbBudgetApiIncomeApplyFormCommonSelectConfigPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetApiIncomeApplyFormCommonSelectConfigPostResponse>(
    prepare(zlbBudgetApiIncomeApplyFormCommonSelectConfigPostRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetApiIncomeApplyFormCommonSelectConfigPost.requestConfig =
  zlbBudgetApiIncomeApplyFormCommonSelectConfigPostRequestConfig;

const mockUrl_0_4_0_2 = 'http://yapi.cai-inc.com/mock/2991' as any;
const devUrl_0_4_0_2 = '' as any;
const prodUrl_0_4_0_2 = '' as any;
const dataKey_0_4_0_2 = 'data' as any;

/**
 * 接口 [同步预算指标↗](http://yapi.cai-inc.com/project/2991/interface/api/362050) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [预算指标相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_49781)
 * @请求头 `GET /zlb/budget/info/pull/{orgId}`
 * @更新时间 `2024-12-10 17:46:37`
 * @项目ID 2991
 */
export interface ZlbBudgetInfoPullOrgIdGetRequest {
  orgId: string;
}

/**
 * 接口 [同步预算指标↗](http://yapi.cai-inc.com/project/2991/interface/api/362050) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [预算指标相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_49781)
 * @请求头 `GET /zlb/budget/info/pull/{orgId}`
 * @更新时间 `2024-12-10 17:46:37`
 * @项目ID 2991
 */
export interface ZlbBudgetInfoPullOrgIdGetResponse {
  success?: boolean;
  result?: {};
  code?: string;
  message?: string;
}

/**
 * 接口 [同步预算指标↗](http://yapi.cai-inc.com/project/2991/interface/api/362050) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [预算指标相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_49781)
 * @请求头 `GET /zlb/budget/info/pull/{orgId}`
 * @更新时间 `2024-12-10 17:46:37`
 * @项目ID 2991
 */
type ZlbBudgetInfoPullOrgIdGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/info/pull/{orgId}',
    'data',
    'orgId',
    string,
    false
  >
>;

/**
 * 接口 [同步预算指标↗](http://yapi.cai-inc.com/project/2991/interface/api/362050) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [预算指标相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_49781)
 * @请求头 `GET /zlb/budget/info/pull/{orgId}`
 * @更新时间 `2024-12-10 17:46:37`
 * @项目ID 2991
 */
const zlbBudgetInfoPullOrgIdGetRequestConfig: ZlbBudgetInfoPullOrgIdGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_2,
    devUrl: devUrl_0_4_0_2,
    prodUrl: prodUrl_0_4_0_2,
    path: '/zlb/budget/info/pull/{orgId}',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_2,
    paramNames: ['orgId'],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbBudgetInfoPullOrgIdGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [同步预算指标↗](http://yapi.cai-inc.com/project/2991/interface/api/362050) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [预算指标相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_49781)
 * @请求头 `GET /zlb/budget/info/pull/{orgId}`
 * @更新时间 `2024-12-10 17:46:37`
 * @项目ID 2991
 */
export const zlbBudgetInfoPullOrgIdGet = /*#__PURE__*/ (
  requestData: ZlbBudgetInfoPullOrgIdGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetInfoPullOrgIdGetResponse>(
    prepare(zlbBudgetInfoPullOrgIdGetRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetInfoPullOrgIdGet.requestConfig = zlbBudgetInfoPullOrgIdGetRequestConfig;

/**
 * 接口 [查询预算单位下的预算指标（分页）↗](http://yapi.cai-inc.com/project/2991/interface/api/362058) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [预算指标相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_49781)
 * @请求头 `POST /zlb/budget/info/list`
 * @更新时间 `2024-12-10 17:46:38`
 * @项目ID 2991
 */
export interface ZlbBudgetInfoListPostRequest {
  /**
   * 预算id
   */
  budgetId?: number;
  /**
   * 预算指标文号
   */
  budgetNo?: string;
  /**
   * 内网预算详情id
   */
  financialBudgetDetailId?: string;
  /**
   * 项目名称
   */
  projectName?: string;
  /**
   * 部门经济分类名称
   */
  depExpendEconomicClassifyName?: string;
  /**
   * 是否政府采购（0:否、1：是）
   */
  containsGovPurchaseBudget?: number;
  /**
   * 年份 默认当前年份
   */
  year?: number;
  /**
   * 机构ID
   */
  orgId?: number;
  /**
   * 报销类型id（字典表id）
   */
  scenesId?: number;
  /**
   * 当前页码，默认1
   */
  pageNo?: number;
  /**
   * 每页记录数，默认10
   */
  pageSize?: number;
  /**
   * 排序字段
   */
  sortField?: string;
  /**
   * 排序规则：DESC || ASC
   */
  sortBy?: string;
}

/**
 * 接口 [查询预算单位下的预算指标（分页）↗](http://yapi.cai-inc.com/project/2991/interface/api/362058) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [预算指标相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_49781)
 * @请求头 `POST /zlb/budget/info/list`
 * @更新时间 `2024-12-10 17:46:38`
 * @项目ID 2991
 */
export interface ZlbBudgetInfoListPostResponse {
  success?: boolean;
  result?: {
    /**
     * 总记录数
     */
    total?: number;
    /**
     * 结果集
     */
    data?: {
      /**
       * 预算ID
       */
      budgetId?: number;
      /**
       * 指标文号
       */
      budgetNo?: string;
      /**
       * 项目名称
       */
      projectName?: string;
      /**
       * 单位名称
       */
      orgName?: string;
      /**
       * 经济科目编号
       */
      depExpendEconomicClassifyCode?: string;
      /**
       * 经济科目名称
       */
      depExpendEconomicClassifyName?: string;
      /**
       * 是否包含政府采购预算，1:是、0：否
       */
      containsGovPurchaseBudget?: number;
      /**
       * 指标金额
       */
      totalAmount?: number;
      /**
       * 可用金额
       */
      availableAmount?: number;
      /**
       * 分解金额
       */
      spiltAmount?: number;
      /**
       * 使用金额
       */
      usedAmount?: number;
      /**
       * 冻结金额
       */
      frozenAmount?: number;
      /**
       * 支出进度
       */
      expenditurePercentage?: string;
      /**
       * 可用额度
       */
      quotaAvailableAmount?: number;
      /**
       * 资金性质名称
       */
      fundsNatureName?: string;
      /**
       * 支出功能分类科目名称
       */
      expendFunctionClassifySubjectName?: string;
      /**
       * 部门额度id
       */
      depQuotaId?: string;
      /**
       * 项目类别代码（3：项目支出，其它数值为基本支出）
       */
      programCategoryCode?: string;
      /**
       * 内网预算详情id
       */
      financialBudgetDetailId?: string;
      /**
       * 年份
       */
      year?: number;
      /**
       * 控制方式（0：不控制，1：强控，2：弱控）
       */
      controlMode?: number;
      /**
       * 非浙里报已用金额
       */
      notZlbUsedAmount?: number;
      /**
       * 实施金额
       */
      implementAmount?: number;
    }[];
    pageNum?: number;
    pageSize?: number;
    /**
     * 总页数
     */
    pages?: number;
    /**
     * 第几页
     */
    size?: number;
  };
  code?: string;
  message?: string;
}

/**
 * 接口 [查询预算单位下的预算指标（分页）↗](http://yapi.cai-inc.com/project/2991/interface/api/362058) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [预算指标相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_49781)
 * @请求头 `POST /zlb/budget/info/list`
 * @更新时间 `2024-12-10 17:46:38`
 * @项目ID 2991
 */
type ZlbBudgetInfoListPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/info/list',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [查询预算单位下的预算指标（分页）↗](http://yapi.cai-inc.com/project/2991/interface/api/362058) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [预算指标相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_49781)
 * @请求头 `POST /zlb/budget/info/list`
 * @更新时间 `2024-12-10 17:46:38`
 * @项目ID 2991
 */
const zlbBudgetInfoListPostRequestConfig: ZlbBudgetInfoListPostRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_4_0_2,
  devUrl: devUrl_0_4_0_2,
  prodUrl: prodUrl_0_4_0_2,
  path: '/zlb/budget/info/list',
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_4_0_2,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'zlbBudgetInfoListPost',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * 接口 [查询预算单位下的预算指标（分页）↗](http://yapi.cai-inc.com/project/2991/interface/api/362058) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [预算指标相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_49781)
 * @请求头 `POST /zlb/budget/info/list`
 * @更新时间 `2024-12-10 17:46:38`
 * @项目ID 2991
 */
export const zlbBudgetInfoListPost = /*#__PURE__*/ (
  requestData: ZlbBudgetInfoListPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetInfoListPostResponse>(
    prepare(zlbBudgetInfoListPostRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetInfoListPost.requestConfig = zlbBudgetInfoListPostRequestConfig;

/**
 * 接口 [预算指标详情↗](http://yapi.cai-inc.com/project/2991/interface/api/362066) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [预算指标相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_49781)
 * @请求头 `GET /zlb/budget/info/detail/{budgetId}`
 * @更新时间 `2024-12-10 17:46:38`
 * @项目ID 2991
 */
export interface ZlbBudgetInfoDetailBudgetIdGetRequest {
  budgetId: string;
}

/**
 * 接口 [预算指标详情↗](http://yapi.cai-inc.com/project/2991/interface/api/362066) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [预算指标相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_49781)
 * @请求头 `GET /zlb/budget/info/detail/{budgetId}`
 * @更新时间 `2024-12-10 17:46:38`
 * @项目ID 2991
 */
export interface ZlbBudgetInfoDetailBudgetIdGetResponse {
  success?: boolean;
  result?: {
    budgetId?: number;
    /**
     * 预算年份
     */
    year?: number;
    /**
     * 指标文号
     */
    budgetNo?: string;
    /**
     * 内网预算id
     */
    financialBudgetId?: string;
    /**
     * 发文时间
     */
    releaseTime?: string;
    /**
     * 预算项目名称
     */
    projectName?: string;
    /**
     * 所属单位
     */
    orgName?: string;
    /**
     * 资金性质名称
     */
    fundsNatureName?: string;
    /**
     * 业务主管处室名称
     */
    businessSupervisorOfficeName?: string;
    /**
     * 是否科研：0:否，1:是
     */
    isTech?: number;
    /**
     * 同步时间
     */
    addTime?: string;
    /**
     * 指标类型名称
     */
    budgetTypeName?: string;
    /**
     * 状态：0:待发布、1:可使用、2:冻结中、3:不可用
     */
    status?: number;
    /**
     * 支出功能分类科目名称
     */
    expendFunctionClassifySubjectName?: string;
    /**
     * 部门支出经济分类名称
     */
    depExpendEconomicClassifyName?: string;
    /**
     * 政府支出经济分类名称
     */
    govExpendEconomicClassifyName?: string;
    /**
     * 是否包含政府采购预算，0:否、1：是
     */
    containsGovPurchaseBudget?: number;
    /**
     * 采购目录名称
     */
    buyCatalogName?: string;
    /**
     * 采购类型名称
     */
    buyTypeName?: string;
    /**
     * 总金额
     */
    totalAmount?: number;
    /**
     * 冻结金额
     */
    frozenAmount?: number;
    /**
     * 可用金额
     */
    availableAmount?: number;
    /**
     * 拆分金额
     */
    splitAmount?: number;
    /**
     * 已用金额
     */
    usedAmount?: number;
    /**
     * 部门名称
     */
    depName?: string;
    /**
     * 子部门使用（0：否，1：是）
     */
    isSubUse?: number;
    /**
     * 支出项
     */
    expenditureItem?: string;
    /**
     * 非浙里报已用金额
     */
    notZlbUsedAmount?: number;
  };
  code?: string;
  message?: string;
}

/**
 * 接口 [预算指标详情↗](http://yapi.cai-inc.com/project/2991/interface/api/362066) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [预算指标相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_49781)
 * @请求头 `GET /zlb/budget/info/detail/{budgetId}`
 * @更新时间 `2024-12-10 17:46:38`
 * @项目ID 2991
 */
type ZlbBudgetInfoDetailBudgetIdGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/info/detail/{budgetId}',
    'data',
    'budgetId',
    string,
    false
  >
>;

/**
 * 接口 [预算指标详情↗](http://yapi.cai-inc.com/project/2991/interface/api/362066) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [预算指标相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_49781)
 * @请求头 `GET /zlb/budget/info/detail/{budgetId}`
 * @更新时间 `2024-12-10 17:46:38`
 * @项目ID 2991
 */
const zlbBudgetInfoDetailBudgetIdGetRequestConfig: ZlbBudgetInfoDetailBudgetIdGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_2,
    devUrl: devUrl_0_4_0_2,
    prodUrl: prodUrl_0_4_0_2,
    path: '/zlb/budget/info/detail/{budgetId}',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_2,
    paramNames: ['budgetId'],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbBudgetInfoDetailBudgetIdGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [预算指标详情↗](http://yapi.cai-inc.com/project/2991/interface/api/362066) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [预算指标相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_49781)
 * @请求头 `GET /zlb/budget/info/detail/{budgetId}`
 * @更新时间 `2024-12-10 17:46:38`
 * @项目ID 2991
 */
export const zlbBudgetInfoDetailBudgetIdGet = /*#__PURE__*/ (
  requestData: ZlbBudgetInfoDetailBudgetIdGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetInfoDetailBudgetIdGetResponse>(
    prepare(zlbBudgetInfoDetailBudgetIdGetRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetInfoDetailBudgetIdGet.requestConfig = zlbBudgetInfoDetailBudgetIdGetRequestConfig;

/**
 * 接口 [查询场景关联的指标（分页）↗](http://yapi.cai-inc.com/project/2991/interface/api/362098) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [预算指标相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_49781)
 * @请求头 `POST /zlb/budget/info/query-relation-budget`
 * @更新时间 `2024-12-10 17:46:38`
 * @项目ID 2991
 */
export interface ZlbBudgetInfoQueryRelationBudgetPostRequest {
  /**
   * 预算id
   */
  budgetId?: number;
  /**
   * 预算指标文号
   */
  budgetNo?: string;
  /**
   * 内网预算详情id
   */
  financialBudgetDetailId?: string;
  /**
   * 项目名称
   */
  projectName?: string;
  /**
   * 部门经济分类名称
   */
  depExpendEconomicClassifyName?: string;
  /**
   * 是否政府采购（0:否、1：是）
   */
  containsGovPurchaseBudget?: number;
  /**
   * 年份 默认当前年份
   */
  year?: number;
  /**
   * 机构ID
   */
  orgId?: number;
  /**
   * 报销类型id（字典表id）
   */
  scenesId?: number;
  /**
   * 当前页码，默认1
   */
  pageNo?: number;
  /**
   * 每页记录数，默认10
   */
  pageSize?: number;
  /**
   * 排序字段
   */
  sortField?: string;
  /**
   * 排序规则：DESC || ASC
   */
  sortBy?: string;
}

/**
 * 接口 [查询场景关联的指标（分页）↗](http://yapi.cai-inc.com/project/2991/interface/api/362098) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [预算指标相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_49781)
 * @请求头 `POST /zlb/budget/info/query-relation-budget`
 * @更新时间 `2024-12-10 17:46:38`
 * @项目ID 2991
 */
export interface ZlbBudgetInfoQueryRelationBudgetPostResponse {
  success?: boolean;
  result?: {
    /**
     * 总记录数
     */
    total?: number;
    /**
     * 结果集
     */
    data?: {
      /**
       * 预算ID
       */
      budgetId?: number;
      /**
       * 预算uk
       */
      budgetUk?: string;
      /**
       * 指标文号
       */
      budgetNo?: string;
      /**
       * 项目名称
       */
      projectName?: string;
      /**
       * 项目code
       */
      projectCode?: string;
      /**
       * 单位名称
       */
      orgName?: string;
      /**
       * 经济科目Code
       */
      depExpendEconomicClassifyCode?: string;
      /**
       * 经济科目名称
       */
      depExpendEconomicClassifyName?: string;
      /**
       * 指标金额
       */
      totalAmount?: number;
      /**
       * 可用金额
       */
      availableAmount?: number;
      /**
       * 已分解金额
       */
      splitAmount?: number;
      /**
       * 预算报销关联id
       */
      relationId?: number;
      /**
       * 年份
       */
      year?: number;
      /**
       * 内网预算详情id
       */
      financialBudgetDetailId?: string;
      /**
       * 项目类型
       */
      programCategoryName?: string;
      /**
       * 功能科目
       */
      expendFunctionClassifySubjectName?: string;
      /**
       * 支出功能分类科目编码
       */
      expendFunctionClassifySubjectCode?: string;
      /**
       * 政府经济科目
       */
      govExpendEconomicClassifyName?: string;
      /**
       * 政府支出经济分类编码
       */
      govExpendEconomicClassifyCode?: string;
      /**
       * 指标id（内网预算id）
       */
      financialBudgetId?: string;
      /**
       * 财政区划
       */
      financialDistrictCode?: string;
      /**
       * 机构编码
       */
      orgCode?: string;
      /**
       * 归口处室
       */
      businessSupervisorOfficeName?: string;
      /**
       * 资金性质
       */
      fundsNatureName?: string;
      /**
       * 指标类型
       */
      budgetTypeName?: string;
      /**
       * 是否基建（0：否、1:是）
       */
      isInfrastructure?: number;
      /**
       * 是否政府采购（0:否、1：是）
       */
      containsGovPurchaseBudget?: number;
      /**
       * 是否科研（0:否，1:是）
       */
      isTech?: number;
      /**
       * 项目类别代码（3：项目支出，其它数值为基本支出）
       */
      programCategoryCode?: string;
      /**
       * 部门id
       */
      depId?: number;
      /**
       * 部门名称
       */
      depName?: string;
      /**
       * 子部门是否可用
       */
      isSubUse?: number;
      /**
       * 支出项
       */
      expenditureItem?: string;
      /**
       * 实施金额
       */
      implementAmount?: number;
    }[];
    pageNum?: number;
    pageSize?: number;
    /**
     * 总页数
     */
    pages?: number;
    /**
     * 第几页
     */
    size?: number;
  };
  code?: string;
  message?: string;
}

/**
 * 接口 [查询场景关联的指标（分页）↗](http://yapi.cai-inc.com/project/2991/interface/api/362098) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [预算指标相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_49781)
 * @请求头 `POST /zlb/budget/info/query-relation-budget`
 * @更新时间 `2024-12-10 17:46:38`
 * @项目ID 2991
 */
type ZlbBudgetInfoQueryRelationBudgetPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/info/query-relation-budget',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [查询场景关联的指标（分页）↗](http://yapi.cai-inc.com/project/2991/interface/api/362098) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [预算指标相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_49781)
 * @请求头 `POST /zlb/budget/info/query-relation-budget`
 * @更新时间 `2024-12-10 17:46:38`
 * @项目ID 2991
 */
const zlbBudgetInfoQueryRelationBudgetPostRequestConfig: ZlbBudgetInfoQueryRelationBudgetPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_2,
    devUrl: devUrl_0_4_0_2,
    prodUrl: prodUrl_0_4_0_2,
    path: '/zlb/budget/info/query-relation-budget',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbBudgetInfoQueryRelationBudgetPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [查询场景关联的指标（分页）↗](http://yapi.cai-inc.com/project/2991/interface/api/362098) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [预算指标相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_49781)
 * @请求头 `POST /zlb/budget/info/query-relation-budget`
 * @更新时间 `2024-12-10 17:46:38`
 * @项目ID 2991
 */
export const zlbBudgetInfoQueryRelationBudgetPost = /*#__PURE__*/ (
  requestData: ZlbBudgetInfoQueryRelationBudgetPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetInfoQueryRelationBudgetPostResponse>(
    prepare(zlbBudgetInfoQueryRelationBudgetPostRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetInfoQueryRelationBudgetPost.requestConfig =
  zlbBudgetInfoQueryRelationBudgetPostRequestConfig;

/**
 * 接口 [查询未跟场景关联的指标（分页）↗](http://yapi.cai-inc.com/project/2991/interface/api/362106) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [预算指标相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_49781)
 * @请求头 `POST /zlb/budget/info/query-not-relation-budget`
 * @更新时间 `2024-12-10 17:46:38`
 * @项目ID 2991
 */
export interface ZlbBudgetInfoQueryNotRelationBudgetPostRequest {
  /**
   * 预算id
   */
  budgetId?: number;
  /**
   * 预算指标文号
   */
  budgetNo?: string;
  /**
   * 内网预算详情id
   */
  financialBudgetDetailId?: string;
  /**
   * 项目名称
   */
  projectName?: string;
  /**
   * 部门经济分类名称
   */
  depExpendEconomicClassifyName?: string;
  /**
   * 是否政府采购（0:否、1：是）
   */
  containsGovPurchaseBudget?: number;
  /**
   * 年份 默认当前年份
   */
  year?: number;
  /**
   * 机构ID
   */
  orgId?: number;
  /**
   * 报销类型id（字典表id）
   */
  scenesId?: number;
  /**
   * 当前页码，默认1
   */
  pageNo?: number;
  /**
   * 每页记录数，默认10
   */
  pageSize?: number;
  /**
   * 排序字段
   */
  sortField?: string;
  /**
   * 排序规则：DESC || ASC
   */
  sortBy?: string;
}

/**
 * 接口 [查询未跟场景关联的指标（分页）↗](http://yapi.cai-inc.com/project/2991/interface/api/362106) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [预算指标相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_49781)
 * @请求头 `POST /zlb/budget/info/query-not-relation-budget`
 * @更新时间 `2024-12-10 17:46:38`
 * @项目ID 2991
 */
export interface ZlbBudgetInfoQueryNotRelationBudgetPostResponse {
  success?: boolean;
  result?: {
    /**
     * 总记录数
     */
    total?: number;
    /**
     * 结果集
     */
    data?: {
      /**
       * 预算ID
       */
      budgetId?: number;
      /**
       * 预算uk
       */
      budgetUk?: string;
      /**
       * 指标文号
       */
      budgetNo?: string;
      /**
       * 项目名称
       */
      projectName?: string;
      /**
       * 项目code
       */
      projectCode?: string;
      /**
       * 单位名称
       */
      orgName?: string;
      /**
       * 经济科目Code
       */
      depExpendEconomicClassifyCode?: string;
      /**
       * 经济科目名称
       */
      depExpendEconomicClassifyName?: string;
      /**
       * 指标金额
       */
      totalAmount?: number;
      /**
       * 可用金额
       */
      availableAmount?: number;
      /**
       * 已分解金额
       */
      splitAmount?: number;
      /**
       * 预算报销关联id
       */
      relationId?: number;
      /**
       * 年份
       */
      year?: number;
      /**
       * 内网预算详情id
       */
      financialBudgetDetailId?: string;
      /**
       * 项目类型
       */
      programCategoryName?: string;
      /**
       * 功能科目
       */
      expendFunctionClassifySubjectName?: string;
      /**
       * 支出功能分类科目编码
       */
      expendFunctionClassifySubjectCode?: string;
      /**
       * 政府经济科目
       */
      govExpendEconomicClassifyName?: string;
      /**
       * 政府支出经济分类编码
       */
      govExpendEconomicClassifyCode?: string;
      /**
       * 指标id（内网预算id）
       */
      financialBudgetId?: string;
      /**
       * 财政区划
       */
      financialDistrictCode?: string;
      /**
       * 机构编码
       */
      orgCode?: string;
      /**
       * 归口处室
       */
      businessSupervisorOfficeName?: string;
      /**
       * 资金性质
       */
      fundsNatureName?: string;
      /**
       * 指标类型
       */
      budgetTypeName?: string;
      /**
       * 是否基建（0：否、1:是）
       */
      isInfrastructure?: number;
      /**
       * 是否政府采购（0:否、1：是）
       */
      containsGovPurchaseBudget?: number;
      /**
       * 是否科研（0:否，1:是）
       */
      isTech?: number;
      /**
       * 项目类别代码（3：项目支出，其它数值为基本支出）
       */
      programCategoryCode?: string;
      /**
       * 部门id
       */
      depId?: number;
      /**
       * 部门名称
       */
      depName?: string;
      /**
       * 子部门是否可用
       */
      isSubUse?: number;
      /**
       * 支出项
       */
      expenditureItem?: string;
      /**
       * 实施金额
       */
      implementAmount?: number;
    }[];
    pageNum?: number;
    pageSize?: number;
    /**
     * 总页数
     */
    pages?: number;
    /**
     * 第几页
     */
    size?: number;
  };
  code?: string;
  message?: string;
}

/**
 * 接口 [查询未跟场景关联的指标（分页）↗](http://yapi.cai-inc.com/project/2991/interface/api/362106) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [预算指标相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_49781)
 * @请求头 `POST /zlb/budget/info/query-not-relation-budget`
 * @更新时间 `2024-12-10 17:46:38`
 * @项目ID 2991
 */
type ZlbBudgetInfoQueryNotRelationBudgetPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/info/query-not-relation-budget',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [查询未跟场景关联的指标（分页）↗](http://yapi.cai-inc.com/project/2991/interface/api/362106) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [预算指标相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_49781)
 * @请求头 `POST /zlb/budget/info/query-not-relation-budget`
 * @更新时间 `2024-12-10 17:46:38`
 * @项目ID 2991
 */
const zlbBudgetInfoQueryNotRelationBudgetPostRequestConfig: ZlbBudgetInfoQueryNotRelationBudgetPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_2,
    devUrl: devUrl_0_4_0_2,
    prodUrl: prodUrl_0_4_0_2,
    path: '/zlb/budget/info/query-not-relation-budget',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbBudgetInfoQueryNotRelationBudgetPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [查询未跟场景关联的指标（分页）↗](http://yapi.cai-inc.com/project/2991/interface/api/362106) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [预算指标相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_49781)
 * @请求头 `POST /zlb/budget/info/query-not-relation-budget`
 * @更新时间 `2024-12-10 17:46:38`
 * @项目ID 2991
 */
export const zlbBudgetInfoQueryNotRelationBudgetPost = /*#__PURE__*/ (
  requestData: ZlbBudgetInfoQueryNotRelationBudgetPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetInfoQueryNotRelationBudgetPostResponse>(
    prepare(zlbBudgetInfoQueryNotRelationBudgetPostRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetInfoQueryNotRelationBudgetPost.requestConfig =
  zlbBudgetInfoQueryNotRelationBudgetPostRequestConfig;

/**
 * 接口 [查询场景关联的指标_去重（分页）↗](http://yapi.cai-inc.com/project/2991/interface/api/381306) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [预算指标相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_49781)
 * @请求头 `POST /zlb/budget/info/query-relation-budget-distinct`
 * @更新时间 `2024-12-10 17:46:38`
 * @项目ID 2991
 */
export interface ZlbBudgetInfoQueryRelationBudgetDistinctPostRequest {
  /**
   * 预算id
   */
  budgetId?: number;
  /**
   * 预算指标文号
   */
  budgetNo?: string;
  /**
   * 内网预算详情id
   */
  financialBudgetDetailId?: string;
  /**
   * 项目名称
   */
  projectName?: string;
  /**
   * 部门经济分类名称
   */
  depExpendEconomicClassifyName?: string;
  /**
   * 是否政府采购（0:否、1：是）
   */
  containsGovPurchaseBudget?: number;
  /**
   * 年份 默认当前年份
   */
  year?: number;
  /**
   * 机构ID
   */
  orgId?: number;
  /**
   * 报销类型id（字典表id）
   */
  scenesId?: number;
  /**
   * 当前页码，默认1
   */
  pageNo?: number;
  /**
   * 每页记录数，默认10
   */
  pageSize?: number;
  /**
   * 排序字段
   */
  sortField?: string;
  /**
   * 排序规则：DESC || ASC
   */
  sortBy?: string;
}

/**
 * 接口 [查询场景关联的指标_去重（分页）↗](http://yapi.cai-inc.com/project/2991/interface/api/381306) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [预算指标相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_49781)
 * @请求头 `POST /zlb/budget/info/query-relation-budget-distinct`
 * @更新时间 `2024-12-10 17:46:38`
 * @项目ID 2991
 */
export interface ZlbBudgetInfoQueryRelationBudgetDistinctPostResponse {
  success?: boolean;
  result?: {
    /**
     * 总记录数
     */
    total?: number;
    /**
     * 结果集
     */
    data?: {
      /**
       * 预算ID
       */
      budgetId?: number;
      /**
       * 预算uk
       */
      budgetUk?: string;
      /**
       * 指标文号
       */
      budgetNo?: string;
      /**
       * 项目名称
       */
      projectName?: string;
      /**
       * 项目code
       */
      projectCode?: string;
      /**
       * 单位名称
       */
      orgName?: string;
      /**
       * 经济科目Code
       */
      depExpendEconomicClassifyCode?: string;
      /**
       * 经济科目名称
       */
      depExpendEconomicClassifyName?: string;
      /**
       * 指标金额
       */
      totalAmount?: number;
      /**
       * 可用金额
       */
      availableAmount?: number;
      /**
       * 已分解金额
       */
      splitAmount?: number;
      /**
       * 预算报销关联id
       */
      relationId?: number;
      /**
       * 年份
       */
      year?: number;
      /**
       * 内网预算详情id
       */
      financialBudgetDetailId?: string;
      /**
       * 项目类型
       */
      programCategoryName?: string;
      /**
       * 功能科目
       */
      expendFunctionClassifySubjectName?: string;
      /**
       * 支出功能分类科目编码
       */
      expendFunctionClassifySubjectCode?: string;
      /**
       * 政府经济科目
       */
      govExpendEconomicClassifyName?: string;
      /**
       * 政府支出经济分类编码
       */
      govExpendEconomicClassifyCode?: string;
      /**
       * 指标id（内网预算id）
       */
      financialBudgetId?: string;
      /**
       * 财政区划
       */
      financialDistrictCode?: string;
      /**
       * 机构编码
       */
      orgCode?: string;
      /**
       * 归口处室
       */
      businessSupervisorOfficeName?: string;
      /**
       * 资金性质
       */
      fundsNatureName?: string;
      /**
       * 指标类型
       */
      budgetTypeName?: string;
      /**
       * 是否基建（0：否、1:是）
       */
      isInfrastructure?: number;
      /**
       * 是否政府采购（0:否、1：是）
       */
      containsGovPurchaseBudget?: number;
      /**
       * 是否科研（0:否，1:是）
       */
      isTech?: number;
      /**
       * 项目类别代码（3：项目支出，其它数值为基本支出）
       */
      programCategoryCode?: string;
      /**
       * 部门id
       */
      depId?: number;
      /**
       * 部门名称
       */
      depName?: string;
      /**
       * 子部门是否可用
       */
      isSubUse?: number;
      /**
       * 支出项
       */
      expenditureItem?: string;
      /**
       * 实施金额
       */
      implementAmount?: number;
    }[];
    pageNum?: number;
    pageSize?: number;
    /**
     * 总页数
     */
    pages?: number;
    /**
     * 第几页
     */
    size?: number;
  };
  code?: string;
  message?: string;
}

/**
 * 接口 [查询场景关联的指标_去重（分页）↗](http://yapi.cai-inc.com/project/2991/interface/api/381306) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [预算指标相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_49781)
 * @请求头 `POST /zlb/budget/info/query-relation-budget-distinct`
 * @更新时间 `2024-12-10 17:46:38`
 * @项目ID 2991
 */
type ZlbBudgetInfoQueryRelationBudgetDistinctPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/info/query-relation-budget-distinct',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [查询场景关联的指标_去重（分页）↗](http://yapi.cai-inc.com/project/2991/interface/api/381306) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [预算指标相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_49781)
 * @请求头 `POST /zlb/budget/info/query-relation-budget-distinct`
 * @更新时间 `2024-12-10 17:46:38`
 * @项目ID 2991
 */
const zlbBudgetInfoQueryRelationBudgetDistinctPostRequestConfig: ZlbBudgetInfoQueryRelationBudgetDistinctPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_2,
    devUrl: devUrl_0_4_0_2,
    prodUrl: prodUrl_0_4_0_2,
    path: '/zlb/budget/info/query-relation-budget-distinct',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbBudgetInfoQueryRelationBudgetDistinctPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [查询场景关联的指标_去重（分页）↗](http://yapi.cai-inc.com/project/2991/interface/api/381306) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [预算指标相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_49781)
 * @请求头 `POST /zlb/budget/info/query-relation-budget-distinct`
 * @更新时间 `2024-12-10 17:46:38`
 * @项目ID 2991
 */
export const zlbBudgetInfoQueryRelationBudgetDistinctPost = /*#__PURE__*/ (
  requestData: ZlbBudgetInfoQueryRelationBudgetDistinctPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetInfoQueryRelationBudgetDistinctPostResponse>(
    prepare(zlbBudgetInfoQueryRelationBudgetDistinctPostRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetInfoQueryRelationBudgetDistinctPost.requestConfig =
  zlbBudgetInfoQueryRelationBudgetDistinctPostRequestConfig;

/**
 * 接口 [统计指标金额（经济code | 项目code）↗](http://yapi.cai-inc.com/project/2991/interface/api/381330) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [预算指标相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_49781)
 * @请求头 `POST /zlb/budget/info/statistics-amount`
 * @更新时间 `2024-12-10 17:46:39`
 * @项目ID 2991
 */
export interface ZlbBudgetInfoStatisticsAmountPostRequest {
  /**
   * 新增类型（1：基本支出，2：项目支出）
   */
  addType: number;
  /**
   * 类型code（经济code | 项目code）
   */
  typeCode: string[];
  year?: number;
  /**
   * 机构id
   */
  orgId?: number;
}

/**
 * 接口 [统计指标金额（经济code | 项目code）↗](http://yapi.cai-inc.com/project/2991/interface/api/381330) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [预算指标相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_49781)
 * @请求头 `POST /zlb/budget/info/statistics-amount`
 * @更新时间 `2024-12-10 17:46:39`
 * @项目ID 2991
 */
export interface ZlbBudgetInfoStatisticsAmountPostResponse {
  success?: boolean;
  result?: number;
  code?: string;
  message?: string;
}

/**
 * 接口 [统计指标金额（经济code | 项目code）↗](http://yapi.cai-inc.com/project/2991/interface/api/381330) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [预算指标相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_49781)
 * @请求头 `POST /zlb/budget/info/statistics-amount`
 * @更新时间 `2024-12-10 17:46:39`
 * @项目ID 2991
 */
type ZlbBudgetInfoStatisticsAmountPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/info/statistics-amount',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [统计指标金额（经济code | 项目code）↗](http://yapi.cai-inc.com/project/2991/interface/api/381330) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [预算指标相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_49781)
 * @请求头 `POST /zlb/budget/info/statistics-amount`
 * @更新时间 `2024-12-10 17:46:39`
 * @项目ID 2991
 */
const zlbBudgetInfoStatisticsAmountPostRequestConfig: ZlbBudgetInfoStatisticsAmountPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_2,
    devUrl: devUrl_0_4_0_2,
    prodUrl: prodUrl_0_4_0_2,
    path: '/zlb/budget/info/statistics-amount',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbBudgetInfoStatisticsAmountPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [统计指标金额（经济code | 项目code）↗](http://yapi.cai-inc.com/project/2991/interface/api/381330) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [预算指标相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_49781)
 * @请求头 `POST /zlb/budget/info/statistics-amount`
 * @更新时间 `2024-12-10 17:46:39`
 * @项目ID 2991
 */
export const zlbBudgetInfoStatisticsAmountPost = /*#__PURE__*/ (
  requestData: ZlbBudgetInfoStatisticsAmountPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetInfoStatisticsAmountPostResponse>(
    prepare(zlbBudgetInfoStatisticsAmountPostRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetInfoStatisticsAmountPost.requestConfig = zlbBudgetInfoStatisticsAmountPostRequestConfig;

/**
 * 接口 [修改指标控制方式↗](http://yapi.cai-inc.com/project/2991/interface/api/500058) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [预算指标相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_49781)
 * @请求头 `GET /zlb/budget/info/update-control-mode`
 * @更新时间 `2024-12-10 17:46:39`
 * @项目ID 2991
 */
export interface ZlbBudgetInfoUpdateControlModeGetRequest {
  /**
   * 预算id
   */
  budgetId?: string;
  /**
   * 是否强控（0-不控、1-强控、2-弱控）参见：{@link }
   */
  controlMode?: string;
}

/**
 * 接口 [修改指标控制方式↗](http://yapi.cai-inc.com/project/2991/interface/api/500058) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [预算指标相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_49781)
 * @请求头 `GET /zlb/budget/info/update-control-mode`
 * @更新时间 `2024-12-10 17:46:39`
 * @项目ID 2991
 */
export interface ZlbBudgetInfoUpdateControlModeGetResponse {
  success?: boolean;
  result?: boolean;
  code?: string;
  message?: string;
}

/**
 * 接口 [修改指标控制方式↗](http://yapi.cai-inc.com/project/2991/interface/api/500058) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [预算指标相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_49781)
 * @请求头 `GET /zlb/budget/info/update-control-mode`
 * @更新时间 `2024-12-10 17:46:39`
 * @项目ID 2991
 */
type ZlbBudgetInfoUpdateControlModeGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/info/update-control-mode',
    'data',
    string,
    'budgetId' | 'controlMode',
    false
  >
>;

/**
 * 接口 [修改指标控制方式↗](http://yapi.cai-inc.com/project/2991/interface/api/500058) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [预算指标相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_49781)
 * @请求头 `GET /zlb/budget/info/update-control-mode`
 * @更新时间 `2024-12-10 17:46:39`
 * @项目ID 2991
 */
const zlbBudgetInfoUpdateControlModeGetRequestConfig: ZlbBudgetInfoUpdateControlModeGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_2,
    devUrl: devUrl_0_4_0_2,
    prodUrl: prodUrl_0_4_0_2,
    path: '/zlb/budget/info/update-control-mode',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_2,
    paramNames: [],
    queryNames: ['budgetId', 'controlMode'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbBudgetInfoUpdateControlModeGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [修改指标控制方式↗](http://yapi.cai-inc.com/project/2991/interface/api/500058) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [预算指标相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_49781)
 * @请求头 `GET /zlb/budget/info/update-control-mode`
 * @更新时间 `2024-12-10 17:46:39`
 * @项目ID 2991
 */
export const zlbBudgetInfoUpdateControlModeGet = /*#__PURE__*/ (
  requestData: ZlbBudgetInfoUpdateControlModeGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetInfoUpdateControlModeGetResponse>(
    prepare(zlbBudgetInfoUpdateControlModeGetRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetInfoUpdateControlModeGet.requestConfig = zlbBudgetInfoUpdateControlModeGetRequestConfig;

/**
 * 接口 [查询单位指标↗](http://yapi.cai-inc.com/project/2991/interface/api/525178) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [预算指标相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_49781)
 * @请求头 `POST /zlb/budget/info/query-org-budget`
 * @更新时间 `2023-08-30 15:47:52`
 * @项目ID 2991
 */
export interface ZlbBudgetInfoQueryOrgBudgetPostRequest {
  /**
   * 年份, 必传
   */
  year?: number;
  /**
   * 场景编码, 必传
   */
  scenesCode?: string;
  /**
   * 预算指标文号
   */
  budgetNoLike?: string;
  /**
   * 内网预算详情id
   */
  financialBudgetDetailId?: string;
  /**
   * 项目名称
   */
  projectNameLike?: string;
  /**
   * 部门经济分类名称
   */
  depClassifyNameLike?: string;
  /**
   * 当前页码，默认1
   */
  pageNo?: number;
  /**
   * 每页记录数，默认10
   */
  pageSize?: number;
}

/**
 * 接口 [查询单位指标↗](http://yapi.cai-inc.com/project/2991/interface/api/525178) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [预算指标相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_49781)
 * @请求头 `POST /zlb/budget/info/query-org-budget`
 * @更新时间 `2023-08-30 15:47:52`
 * @项目ID 2991
 */
export interface ZlbBudgetInfoQueryOrgBudgetPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 总记录数
     */
    total?: number;
    /**
     * 结果集
     */
    data?: {
      /**
       * 主键
       */
      id?: number;
      /**
       * 内网预算详情id
       */
      financialBudgetDetailId?: string;
      /**
       * 总金额
       */
      totalAmount?: number;
      /**
       * 可用金额
       */
      availableAmount?: number;
      /**
       * 预算年度
       */
      year?: number;
      /**
       * 单位代码
       */
      orgCode?: string;
      /**
       * 财政区划编码
       */
      financialDistrictCode?: string;
      /**
       * 预算指标文号（名称）
       */
      budgetNo?: string;
      /**
       * 预算项目代码
       */
      projectCode?: string;
      /**
       * 项目类别代码
       */
      programCategoryCode?: string;
      /**
       * 项目类别名称
       */
      programCategoryName?: string;
      /**
       * 预算项目名称
       */
      projectName?: string;
      /**
       * 是否已关联
       */
      alreadyRelation?: boolean;
    }[];
    pageNum?: number;
    pageSize?: number;
    /**
     * 总页数
     */
    pages?: number;
    /**
     * 第几页
     */
    size?: number;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [查询单位指标↗](http://yapi.cai-inc.com/project/2991/interface/api/525178) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [预算指标相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_49781)
 * @请求头 `POST /zlb/budget/info/query-org-budget`
 * @更新时间 `2023-08-30 15:47:52`
 * @项目ID 2991
 */
type ZlbBudgetInfoQueryOrgBudgetPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/info/query-org-budget',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [查询单位指标↗](http://yapi.cai-inc.com/project/2991/interface/api/525178) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [预算指标相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_49781)
 * @请求头 `POST /zlb/budget/info/query-org-budget`
 * @更新时间 `2023-08-30 15:47:52`
 * @项目ID 2991
 */
const zlbBudgetInfoQueryOrgBudgetPostRequestConfig: ZlbBudgetInfoQueryOrgBudgetPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_2,
    devUrl: devUrl_0_4_0_2,
    prodUrl: prodUrl_0_4_0_2,
    path: '/zlb/budget/info/query-org-budget',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbBudgetInfoQueryOrgBudgetPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [查询单位指标↗](http://yapi.cai-inc.com/project/2991/interface/api/525178) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [预算指标相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_49781)
 * @请求头 `POST /zlb/budget/info/query-org-budget`
 * @更新时间 `2023-08-30 15:47:52`
 * @项目ID 2991
 */
export const zlbBudgetInfoQueryOrgBudgetPost = /*#__PURE__*/ (
  requestData: ZlbBudgetInfoQueryOrgBudgetPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetInfoQueryOrgBudgetPostResponse>(
    prepare(zlbBudgetInfoQueryOrgBudgetPostRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetInfoQueryOrgBudgetPost.requestConfig = zlbBudgetInfoQueryOrgBudgetPostRequestConfig;

/**
 * 接口 [导出预算指标↗](http://yapi.cai-inc.com/project/2991/interface/api/650018) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [预算指标相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_49781)
 * @请求头 `POST /zlb/budget/info/export/submit`
 * @更新时间 `2024-12-10 17:46:39`
 * @项目ID 2991
 */
export interface ZlbBudgetInfoExportSubmitPostRequest {
  /**
   * 内网预算详情id
   */
  financialBudgetDetailId?: string;
  /**
   * 年份 默认当前年份
   */
  year?: number;
  /**
   * 当前页码，默认1
   */
  pageNo?: number;
  /**
   * 每页记录数，默认10
   */
  pageSize?: number;
  /**
   * 预算指标文号
   */
  budgetNo?: string;
  /**
   * 项目名称
   */
  projectName?: string;
  /**
   * 部门经济分类名称
   */
  depExpendEconomicClassifyName?: string;
}

/**
 * 接口 [导出预算指标↗](http://yapi.cai-inc.com/project/2991/interface/api/650018) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [预算指标相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_49781)
 * @请求头 `POST /zlb/budget/info/export/submit`
 * @更新时间 `2024-12-10 17:46:39`
 * @项目ID 2991
 */
export interface ZlbBudgetInfoExportSubmitPostResponse {
  success?: boolean;
  result?: string;
  code?: string;
  message?: string;
}

/**
 * 接口 [导出预算指标↗](http://yapi.cai-inc.com/project/2991/interface/api/650018) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [预算指标相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_49781)
 * @请求头 `POST /zlb/budget/info/export/submit`
 * @更新时间 `2024-12-10 17:46:39`
 * @项目ID 2991
 */
type ZlbBudgetInfoExportSubmitPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/info/export/submit',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [导出预算指标↗](http://yapi.cai-inc.com/project/2991/interface/api/650018) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [预算指标相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_49781)
 * @请求头 `POST /zlb/budget/info/export/submit`
 * @更新时间 `2024-12-10 17:46:39`
 * @项目ID 2991
 */
const zlbBudgetInfoExportSubmitPostRequestConfig: ZlbBudgetInfoExportSubmitPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_2,
    devUrl: devUrl_0_4_0_2,
    prodUrl: prodUrl_0_4_0_2,
    path: '/zlb/budget/info/export/submit',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbBudgetInfoExportSubmitPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [导出预算指标↗](http://yapi.cai-inc.com/project/2991/interface/api/650018) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [预算指标相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_49781)
 * @请求头 `POST /zlb/budget/info/export/submit`
 * @更新时间 `2024-12-10 17:46:39`
 * @项目ID 2991
 */
export const zlbBudgetInfoExportSubmitPost = /*#__PURE__*/ (
  requestData: ZlbBudgetInfoExportSubmitPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetInfoExportSubmitPostResponse>(
    prepare(zlbBudgetInfoExportSubmitPostRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetInfoExportSubmitPost.requestConfig = zlbBudgetInfoExportSubmitPostRequestConfig;

/**
 * 接口 [获取导出结果↗](http://yapi.cai-inc.com/project/2991/interface/api/650026) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [预算指标相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_49781)
 * @请求头 `GET /zlb/budget/info/export/result`
 * @更新时间 `2024-12-10 17:46:39`
 * @项目ID 2991
 */
export interface ZlbBudgetInfoExportResultGetRequest {
  /**
   * 任务编码
   */
  serialCode: string;
}

/**
 * 接口 [获取导出结果↗](http://yapi.cai-inc.com/project/2991/interface/api/650026) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [预算指标相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_49781)
 * @请求头 `GET /zlb/budget/info/export/result`
 * @更新时间 `2024-12-10 17:46:39`
 * @项目ID 2991
 */
export interface ZlbBudgetInfoExportResultGetResponse {
  success?: boolean;
  result?: {
    /**
     * 总数
     */
    totalNum?: number;
    /**
     * 成功数量
     */
    successNum?: number;
    /**
     * 失败数量
     */
    failNum?: number;
    /**
     * 成功FileId
     */
    successFileId?: string;
    /**
     * 任务状态
     */
    status?: number;
    /**
     * 任务编号
     */
    serialCode?: string;
    message?: string;
  };
  code?: string;
  message?: string;
}

/**
 * 接口 [获取导出结果↗](http://yapi.cai-inc.com/project/2991/interface/api/650026) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [预算指标相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_49781)
 * @请求头 `GET /zlb/budget/info/export/result`
 * @更新时间 `2024-12-10 17:46:39`
 * @项目ID 2991
 */
type ZlbBudgetInfoExportResultGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/info/export/result',
    'data',
    string,
    'serialCode',
    false
  >
>;

/**
 * 接口 [获取导出结果↗](http://yapi.cai-inc.com/project/2991/interface/api/650026) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [预算指标相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_49781)
 * @请求头 `GET /zlb/budget/info/export/result`
 * @更新时间 `2024-12-10 17:46:39`
 * @项目ID 2991
 */
const zlbBudgetInfoExportResultGetRequestConfig: ZlbBudgetInfoExportResultGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_2,
    devUrl: devUrl_0_4_0_2,
    prodUrl: prodUrl_0_4_0_2,
    path: '/zlb/budget/info/export/result',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_2,
    paramNames: [],
    queryNames: ['serialCode'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbBudgetInfoExportResultGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [获取导出结果↗](http://yapi.cai-inc.com/project/2991/interface/api/650026) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [预算指标相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_49781)
 * @请求头 `GET /zlb/budget/info/export/result`
 * @更新时间 `2024-12-10 17:46:39`
 * @项目ID 2991
 */
export const zlbBudgetInfoExportResultGet = /*#__PURE__*/ (
  requestData: ZlbBudgetInfoExportResultGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetInfoExportResultGetResponse>(
    prepare(zlbBudgetInfoExportResultGetRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetInfoExportResultGet.requestConfig = zlbBudgetInfoExportResultGetRequestConfig;

const mockUrl_0_4_0_3 = 'http://yapi.cai-inc.com/mock/2991' as any;
const devUrl_0_4_0_3 = '' as any;
const prodUrl_0_4_0_3 = '' as any;
const dataKey_0_4_0_3 = 'data' as any;

/**
 * 接口 [预算额度管理列表（分页）↗](http://yapi.cai-inc.com/project/2991/interface/api/362570) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [预算额度相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_49788)
 * @请求头 `POST /zlb/budget/quota/list`
 * @更新时间 `2023-02-01 10:15:53`
 * @项目ID 2991
 */
export interface ZlbBudgetQuotaListPostRequest {
  /**
   * 额度id
   */
  quotaId?: string;
  /**
   * 额度名称
   */
  quotaName?: string;
  /**
   * 资金性质（0：财政资金，1：自有资金）
   */
  fundsNature?: number;
  /**
   * 项目类别（1：基本支出，2：项目支出）
   */
  projectCategory: number;
  /**
   * 类别名称（项目名称 | 经济分类）
   */
  categoryName?: string;
  /**
   * 当前页码，默认1
   */
  pageNo?: number;
  /**
   * 每页记录数，默认10
   */
  pageSize?: number;
  /**
   * 机构id
   */
  orgId?: number;
  /**
   * 年份 YYYY
   */
  year?: number;
}

/**
 * 接口 [预算额度管理列表（分页）↗](http://yapi.cai-inc.com/project/2991/interface/api/362570) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [预算额度相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_49788)
 * @请求头 `POST /zlb/budget/quota/list`
 * @更新时间 `2023-02-01 10:15:53`
 * @项目ID 2991
 */
export interface ZlbBudgetQuotaListPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 总记录数
     */
    total?: number;
    /**
     * 结果集
     */
    data?: {
      /**
       * 预算额度ID
       */
      quotaId?: string;
      /**
       * 额度名称(部门经济分类、项目名称)
       */
      quotaName?: string;
      /**
       * 预算年度
       */
      year?: number;
      /**
       * 总额度（分）
       */
      totalAmount?: number;
      /**
       * 可用额度（分）
       */
      availableAmount?: number;
      /**
       * 已用额度（分）
       */
      usedAmount?: number;
      /**
       * 支出进度
       */
      expenditurePercentage?: string;
      /**
       * 控制方式（0：弱控，1：强控，2：不控制）
       */
      controlMode?: number;
      /**
       * 资金性质（0：财政资金，1：自有资金）
       */
      fundsNature?: number;
      /**
       * 类别名称（项目名称 | 经济分类）
       */
      categoryName?: string;
      /**
       * 支出进度
       */
      field_2: string;
    }[];
    pageNum?: number;
    pageSize?: number;
    /**
     * 总页数
     */
    pages?: number;
    /**
     * 第几页
     */
    size?: number;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [预算额度管理列表（分页）↗](http://yapi.cai-inc.com/project/2991/interface/api/362570) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [预算额度相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_49788)
 * @请求头 `POST /zlb/budget/quota/list`
 * @更新时间 `2023-02-01 10:15:53`
 * @项目ID 2991
 */
type ZlbBudgetQuotaListPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/quota/list',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [预算额度管理列表（分页）↗](http://yapi.cai-inc.com/project/2991/interface/api/362570) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [预算额度相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_49788)
 * @请求头 `POST /zlb/budget/quota/list`
 * @更新时间 `2023-02-01 10:15:53`
 * @项目ID 2991
 */
const zlbBudgetQuotaListPostRequestConfig: ZlbBudgetQuotaListPostRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_4_0_3,
  devUrl: devUrl_0_4_0_3,
  prodUrl: prodUrl_0_4_0_3,
  path: '/zlb/budget/quota/list',
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_4_0_3,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'zlbBudgetQuotaListPost',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * 接口 [预算额度管理列表（分页）↗](http://yapi.cai-inc.com/project/2991/interface/api/362570) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [预算额度相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_49788)
 * @请求头 `POST /zlb/budget/quota/list`
 * @更新时间 `2023-02-01 10:15:53`
 * @项目ID 2991
 */
export const zlbBudgetQuotaListPost = /*#__PURE__*/ (
  requestData: ZlbBudgetQuotaListPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetQuotaListPostResponse>(
    prepare(zlbBudgetQuotaListPostRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetQuotaListPost.requestConfig = zlbBudgetQuotaListPostRequestConfig;

/**
 * 接口 [查询跟场景关联的额度（分页）↗](http://yapi.cai-inc.com/project/2991/interface/api/362578) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [预算额度相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_49788)
 * @请求头 `POST /zlb/budget/quota/query-relation-quota`
 * @更新时间 `2023-02-07 13:52:44`
 * @项目ID 2991
 */
export interface ZlbBudgetQuotaQueryRelationQuotaPostRequest {
  /**
   * 额度名称
   */
  quotaName?: string;
  /**
   * 资金性质（0：财政资金，1：自有资金）
   */
  fundsNature?: number;
  /**
   * 部门经济分类
   */
  depExpendEconomicClassifyName?: string;
  /**
   * 项目名称
   */
  projectName?: string;
  /**
   * 报销场景id
   */
  scenesId?: number;
  /**
   * 当前页码，默认1
   */
  pageNo?: number;
  /**
   * 每页记录数，默认10
   */
  pageSize?: number;
  /**
   * 机构id
   */
  orgId?: number;
  /**
   * 年份 YYYY
   */
  year?: number;
}

/**
 * 接口 [查询跟场景关联的额度（分页）↗](http://yapi.cai-inc.com/project/2991/interface/api/362578) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [预算额度相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_49788)
 * @请求头 `POST /zlb/budget/quota/query-relation-quota`
 * @更新时间 `2023-02-07 13:52:44`
 * @项目ID 2991
 */
export interface ZlbBudgetQuotaQueryRelationQuotaPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 总记录数
     */
    total?: number;
    /**
     * 结果集
     */
    data?: {
      /**
       * 预算额度ID
       */
      quotaId?: string;
      /**
       * 关联id
       */
      relationId?: number;
      /**
       * 额度名称(部门经济分类、项目名称)
       */
      quotaName?: string;
      /**
       * 总额度（分）
       */
      totalAmount?: number;
      /**
       * 可用额度（分）
       */
      availableAmount?: number;
      /**
       * 资金性质（0：财政资金，1：自有资金）
       */
      fundsNature?: number;
      /**
       * 部门经济分类
       */
      depExpendEconomicClassifyCode?: string;
      /**
       * 项目名称
       */
      projectName?: string;
      /**
       * 年度
       */
      year?: number;
      /**
       * 项目类别（1：基本支出，2：项目支出）
       */
      projectCategory?: number;
      /**
       * 类别名称（对应budget_economy_classify#e_name）
       */
      categoryName?: string;
      /**
       * 部门id
       */
      depId?: number;
      /**
       * 部门名称
       */
      depName?: string;
      /**
       * 子部门使用（0：否 1：是）
       */
      isSubUse?: number;
      /**
       * 支出进度
       */
      expenditurePercentage?: string;
    }[];
    pageNum?: number;
    pageSize?: number;
    /**
     * 总页数
     */
    pages?: number;
    /**
     * 第几页
     */
    size?: number;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [查询跟场景关联的额度（分页）↗](http://yapi.cai-inc.com/project/2991/interface/api/362578) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [预算额度相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_49788)
 * @请求头 `POST /zlb/budget/quota/query-relation-quota`
 * @更新时间 `2023-02-07 13:52:44`
 * @项目ID 2991
 */
type ZlbBudgetQuotaQueryRelationQuotaPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/quota/query-relation-quota',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [查询跟场景关联的额度（分页）↗](http://yapi.cai-inc.com/project/2991/interface/api/362578) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [预算额度相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_49788)
 * @请求头 `POST /zlb/budget/quota/query-relation-quota`
 * @更新时间 `2023-02-07 13:52:44`
 * @项目ID 2991
 */
const zlbBudgetQuotaQueryRelationQuotaPostRequestConfig: ZlbBudgetQuotaQueryRelationQuotaPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_3,
    devUrl: devUrl_0_4_0_3,
    prodUrl: prodUrl_0_4_0_3,
    path: '/zlb/budget/quota/query-relation-quota',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbBudgetQuotaQueryRelationQuotaPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [查询跟场景关联的额度（分页）↗](http://yapi.cai-inc.com/project/2991/interface/api/362578) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [预算额度相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_49788)
 * @请求头 `POST /zlb/budget/quota/query-relation-quota`
 * @更新时间 `2023-02-07 13:52:44`
 * @项目ID 2991
 */
export const zlbBudgetQuotaQueryRelationQuotaPost = /*#__PURE__*/ (
  requestData: ZlbBudgetQuotaQueryRelationQuotaPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetQuotaQueryRelationQuotaPostResponse>(
    prepare(zlbBudgetQuotaQueryRelationQuotaPostRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetQuotaQueryRelationQuotaPost.requestConfig =
  zlbBudgetQuotaQueryRelationQuotaPostRequestConfig;

/**
 * 接口 [查询未跟场景关联的额度（分页）↗](http://yapi.cai-inc.com/project/2991/interface/api/362586) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [预算额度相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_49788)
 * @请求头 `POST /zlb/budget/quota/query-not-relation-quota`
 * @更新时间 `2023-02-07 13:51:13`
 * @项目ID 2991
 */
export interface ZlbBudgetQuotaQueryNotRelationQuotaPostRequest {
  /**
   * 额度名称
   */
  quotaName?: string;
  /**
   * 资金性质（0：财政资金，1：自有资金）
   */
  fundsNature?: number;
  /**
   * 部门经济分类
   */
  depExpendEconomicClassifyName?: string;
  /**
   * 项目名称
   */
  projectName?: string;
  /**
   * 报销场景id
   */
  scenesId?: number;
  /**
   * 当前页码，默认1
   */
  pageNo?: number;
  /**
   * 每页记录数，默认10
   */
  pageSize?: number;
  /**
   * 机构id
   */
  orgId?: number;
  /**
   * 年份 YYYY
   */
  year?: number;
}

/**
 * 接口 [查询未跟场景关联的额度（分页）↗](http://yapi.cai-inc.com/project/2991/interface/api/362586) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [预算额度相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_49788)
 * @请求头 `POST /zlb/budget/quota/query-not-relation-quota`
 * @更新时间 `2023-02-07 13:51:13`
 * @项目ID 2991
 */
export interface ZlbBudgetQuotaQueryNotRelationQuotaPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 总记录数
     */
    total?: number;
    /**
     * 结果集
     */
    data?: {
      /**
       * 预算额度ID
       */
      quotaId?: string;
      /**
       * 关联id
       */
      relationId?: number;
      /**
       * 额度名称(部门经济分类、项目名称)
       */
      quotaName?: string;
      /**
       * 总额度（分）
       */
      totalAmount?: number;
      /**
       * 可用额度（分）
       */
      availableAmount?: number;
      /**
       * 资金性质（0：财政资金，1：自有资金）
       */
      fundsNature?: number;
      /**
       * 部门经济分类
       */
      depExpendEconomicClassifyCode?: string;
      /**
       * 项目名称
       */
      projectName?: string;
      /**
       * 年度
       */
      year?: number;
      /**
       * 项目类别（1：基本支出，2：项目支出）
       */
      projectCategory?: number;
      /**
       * 类别名称（对应budget_economy_classify#e_name）
       */
      categoryName?: string;
      /**
       * 部门id
       */
      depId?: number;
      /**
       * 部门名称
       */
      depName?: string;
      /**
       * 子部门使用（0：否 1：是）
       */
      isSubUse?: number;
    }[];
    pageNum?: number;
    pageSize?: number;
    /**
     * 总页数
     */
    pages?: number;
    /**
     * 第几页
     */
    size?: number;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [查询未跟场景关联的额度（分页）↗](http://yapi.cai-inc.com/project/2991/interface/api/362586) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [预算额度相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_49788)
 * @请求头 `POST /zlb/budget/quota/query-not-relation-quota`
 * @更新时间 `2023-02-07 13:51:13`
 * @项目ID 2991
 */
type ZlbBudgetQuotaQueryNotRelationQuotaPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/quota/query-not-relation-quota',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [查询未跟场景关联的额度（分页）↗](http://yapi.cai-inc.com/project/2991/interface/api/362586) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [预算额度相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_49788)
 * @请求头 `POST /zlb/budget/quota/query-not-relation-quota`
 * @更新时间 `2023-02-07 13:51:13`
 * @项目ID 2991
 */
const zlbBudgetQuotaQueryNotRelationQuotaPostRequestConfig: ZlbBudgetQuotaQueryNotRelationQuotaPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_3,
    devUrl: devUrl_0_4_0_3,
    prodUrl: prodUrl_0_4_0_3,
    path: '/zlb/budget/quota/query-not-relation-quota',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbBudgetQuotaQueryNotRelationQuotaPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [查询未跟场景关联的额度（分页）↗](http://yapi.cai-inc.com/project/2991/interface/api/362586) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [预算额度相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_49788)
 * @请求头 `POST /zlb/budget/quota/query-not-relation-quota`
 * @更新时间 `2023-02-07 13:51:13`
 * @项目ID 2991
 */
export const zlbBudgetQuotaQueryNotRelationQuotaPost = /*#__PURE__*/ (
  requestData: ZlbBudgetQuotaQueryNotRelationQuotaPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetQuotaQueryNotRelationQuotaPostResponse>(
    prepare(zlbBudgetQuotaQueryNotRelationQuotaPostRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetQuotaQueryNotRelationQuotaPost.requestConfig =
  zlbBudgetQuotaQueryNotRelationQuotaPostRequestConfig;

/**
 * 接口 [根据额度id查询额度信息↗](http://yapi.cai-inc.com/project/2991/interface/api/362594) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [预算额度相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_49788)
 * @请求头 `GET /zlb/budget/quota/detail/{quotaId}`
 * @更新时间 `2023-01-29 11:22:51`
 * @项目ID 2991
 */
export interface ZlbBudgetQuotaDetailQuotaIdGetRequest {
  quotaId: string;
}

/**
 * 接口 [根据额度id查询额度信息↗](http://yapi.cai-inc.com/project/2991/interface/api/362594) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [预算额度相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_49788)
 * @请求头 `GET /zlb/budget/quota/detail/{quotaId}`
 * @更新时间 `2023-01-29 11:22:51`
 * @项目ID 2991
 */
export interface ZlbBudgetQuotaDetailQuotaIdGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    id?: number;
    /**
     * 预算额度id
     */
    quotaId?: string;
    /**
     * 额度名称
     */
    quotaName?: string;
    /**
     * 区划编码
     */
    financialDistrictCode?: string;
    /**
     * 预算单位编码
     */
    orgCode?: string;
    /**
     * 资金性质（0：财政资金，1：自有资金）
     */
    fundsNature?: number;
    /**
     * 年份
     */
    year?: number;
    /**
     * 类别名称
     */
    categoryName?: string;
    projectCategory?: number;
    /**
     * 预算总额度
     */
    totalAmount?: number;
    /**
     * 可用额度（分）
     */
    availableAmount?: number;
    /**
     * 拆分金额（分）
     */
    splitAmount?: number;
    /**
     * 已用金额（分）
     */
    usedAmount?: number;
    /**
     * 已冻结金额（分）
     */
    frozenAmount?: number;
    /**
     * 是否强控（0：弱控，1：强控，2：不控制）
     */
    controlMode?: number;
    /**
     * 创建时间
     */
    rAddTime?: string;
    /**
     * 修改时间
     */
    rModifiedTime?: string;
    /**
     * 部门id
     */
    depId?: number;
    /**
     * 部门名称
     */
    depName?: string;
    /**
     * 父id
     */
    parentId?: number;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [根据额度id查询额度信息↗](http://yapi.cai-inc.com/project/2991/interface/api/362594) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [预算额度相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_49788)
 * @请求头 `GET /zlb/budget/quota/detail/{quotaId}`
 * @更新时间 `2023-01-29 11:22:51`
 * @项目ID 2991
 */
type ZlbBudgetQuotaDetailQuotaIdGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/quota/detail/{quotaId}',
    'data',
    'quotaId',
    string,
    false
  >
>;

/**
 * 接口 [根据额度id查询额度信息↗](http://yapi.cai-inc.com/project/2991/interface/api/362594) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [预算额度相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_49788)
 * @请求头 `GET /zlb/budget/quota/detail/{quotaId}`
 * @更新时间 `2023-01-29 11:22:51`
 * @项目ID 2991
 */
const zlbBudgetQuotaDetailQuotaIdGetRequestConfig: ZlbBudgetQuotaDetailQuotaIdGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_3,
    devUrl: devUrl_0_4_0_3,
    prodUrl: prodUrl_0_4_0_3,
    path: '/zlb/budget/quota/detail/{quotaId}',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_3,
    paramNames: ['quotaId'],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbBudgetQuotaDetailQuotaIdGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [根据额度id查询额度信息↗](http://yapi.cai-inc.com/project/2991/interface/api/362594) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [预算额度相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_49788)
 * @请求头 `GET /zlb/budget/quota/detail/{quotaId}`
 * @更新时间 `2023-01-29 11:22:51`
 * @项目ID 2991
 */
export const zlbBudgetQuotaDetailQuotaIdGet = /*#__PURE__*/ (
  requestData: ZlbBudgetQuotaDetailQuotaIdGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetQuotaDetailQuotaIdGetResponse>(
    prepare(zlbBudgetQuotaDetailQuotaIdGetRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetQuotaDetailQuotaIdGet.requestConfig = zlbBudgetQuotaDetailQuotaIdGetRequestConfig;

/**
 * 接口 [删除预算额度↗](http://yapi.cai-inc.com/project/2991/interface/api/362618) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [预算额度相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_49788)
 * @请求头 `POST /zlb/budget/quota/delete`
 * @更新时间 `2023-02-06 16:47:22`
 * @项目ID 2991
 */
export interface ZlbBudgetQuotaDeletePostRequest {
  /**
   * 额度id
   */
  quotaId: string;
  /**
   * 机构id
   */
  orgId: string;
}

/**
 * 接口 [删除预算额度↗](http://yapi.cai-inc.com/project/2991/interface/api/362618) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [预算额度相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_49788)
 * @请求头 `POST /zlb/budget/quota/delete`
 * @更新时间 `2023-02-06 16:47:22`
 * @项目ID 2991
 */
export interface ZlbBudgetQuotaDeletePostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [删除预算额度↗](http://yapi.cai-inc.com/project/2991/interface/api/362618) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [预算额度相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_49788)
 * @请求头 `POST /zlb/budget/quota/delete`
 * @更新时间 `2023-02-06 16:47:22`
 * @项目ID 2991
 */
type ZlbBudgetQuotaDeletePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/quota/delete',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [删除预算额度↗](http://yapi.cai-inc.com/project/2991/interface/api/362618) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [预算额度相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_49788)
 * @请求头 `POST /zlb/budget/quota/delete`
 * @更新时间 `2023-02-06 16:47:22`
 * @项目ID 2991
 */
const zlbBudgetQuotaDeletePostRequestConfig: ZlbBudgetQuotaDeletePostRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_4_0_3,
  devUrl: devUrl_0_4_0_3,
  prodUrl: prodUrl_0_4_0_3,
  path: '/zlb/budget/quota/delete',
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_4_0_3,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'zlbBudgetQuotaDeletePost',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * 接口 [删除预算额度↗](http://yapi.cai-inc.com/project/2991/interface/api/362618) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [预算额度相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_49788)
 * @请求头 `POST /zlb/budget/quota/delete`
 * @更新时间 `2023-02-06 16:47:22`
 * @项目ID 2991
 */
export const zlbBudgetQuotaDeletePost = /*#__PURE__*/ (
  requestData: ZlbBudgetQuotaDeletePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetQuotaDeletePostResponse>(
    prepare(zlbBudgetQuotaDeletePostRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetQuotaDeletePost.requestConfig = zlbBudgetQuotaDeletePostRequestConfig;

/**
 * 接口 [保存分解额度↗](http://yapi.cai-inc.com/project/2991/interface/api/362626) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [预算额度相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_49788)
 * @请求头 `POST /zlb/budget/quota/save-sub-quota`
 * @更新时间 `2023-01-29 11:22:52`
 * @项目ID 2991
 */
export interface ZlbBudgetQuotaSaveSubQuotaPostRequest {
  /**
   * 机构id
   */
  orgId?: number;
  /**
   * 额度id
   */
  quotaId: string;
  operatorId?: number;
  subQuotaList: {
    /**
     * 部门id
     */
    depId: number;
    /**
     * 部门名称
     */
    depName: string;
    /**
     * 额度金额
     */
    totalAmount: number;
    /**
     * 是否下级部门可用（0：否，1：是）
     */
    isSubUse: number;
  }[];
}

/**
 * 接口 [保存分解额度↗](http://yapi.cai-inc.com/project/2991/interface/api/362626) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [预算额度相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_49788)
 * @请求头 `POST /zlb/budget/quota/save-sub-quota`
 * @更新时间 `2023-01-29 11:22:52`
 * @项目ID 2991
 */
export interface ZlbBudgetQuotaSaveSubQuotaPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [保存分解额度↗](http://yapi.cai-inc.com/project/2991/interface/api/362626) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [预算额度相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_49788)
 * @请求头 `POST /zlb/budget/quota/save-sub-quota`
 * @更新时间 `2023-01-29 11:22:52`
 * @项目ID 2991
 */
type ZlbBudgetQuotaSaveSubQuotaPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/quota/save-sub-quota',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [保存分解额度↗](http://yapi.cai-inc.com/project/2991/interface/api/362626) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [预算额度相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_49788)
 * @请求头 `POST /zlb/budget/quota/save-sub-quota`
 * @更新时间 `2023-01-29 11:22:52`
 * @项目ID 2991
 */
const zlbBudgetQuotaSaveSubQuotaPostRequestConfig: ZlbBudgetQuotaSaveSubQuotaPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_3,
    devUrl: devUrl_0_4_0_3,
    prodUrl: prodUrl_0_4_0_3,
    path: '/zlb/budget/quota/save-sub-quota',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbBudgetQuotaSaveSubQuotaPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [保存分解额度↗](http://yapi.cai-inc.com/project/2991/interface/api/362626) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [预算额度相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_49788)
 * @请求头 `POST /zlb/budget/quota/save-sub-quota`
 * @更新时间 `2023-01-29 11:22:52`
 * @项目ID 2991
 */
export const zlbBudgetQuotaSaveSubQuotaPost = /*#__PURE__*/ (
  requestData: ZlbBudgetQuotaSaveSubQuotaPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetQuotaSaveSubQuotaPostResponse>(
    prepare(zlbBudgetQuotaSaveSubQuotaPostRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetQuotaSaveSubQuotaPost.requestConfig = zlbBudgetQuotaSaveSubQuotaPostRequestConfig;

/**
 * 接口 [保存预算额度↗](http://yapi.cai-inc.com/project/2991/interface/api/381594) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [预算额度相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_49788)
 * @请求头 `POST /zlb/budget/quota/save`
 * @更新时间 `2023-02-02 17:08:29`
 * @项目ID 2991
 */
export interface ZlbBudgetQuotaSavePostRequest {
  /**
   * 额度名称
   */
  quotaName: string;
  /**
   * 资金性质（0：财政资金 1：自有资金）
   */
  fundsNature: number;
  /**
   * 项目类别（1：基本支出，2：项目支出）
   */
  projectCategory: number;
  /**
   * 类别
   */
  categoryList: {
    /**
     * 类别名称
     */
    categoryName: string;
    /**
     * 类别code
     */
    categoryCode: string;
  }[];
  /**
   * 年份
   */
  year?: number;
  /**
   * 额度总金额（分）
   */
  totalAmount: number;
  /**
   * 是否强控（0：弱控，1：强控，2：不控制）
   */
  controlMode: number;
  /**
   * 机构id（默认取当前机构id）
   */
  orgId?: number;
}

/**
 * 接口 [保存预算额度↗](http://yapi.cai-inc.com/project/2991/interface/api/381594) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [预算额度相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_49788)
 * @请求头 `POST /zlb/budget/quota/save`
 * @更新时间 `2023-02-02 17:08:29`
 * @项目ID 2991
 */
export interface ZlbBudgetQuotaSavePostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [保存预算额度↗](http://yapi.cai-inc.com/project/2991/interface/api/381594) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [预算额度相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_49788)
 * @请求头 `POST /zlb/budget/quota/save`
 * @更新时间 `2023-02-02 17:08:29`
 * @项目ID 2991
 */
type ZlbBudgetQuotaSavePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/quota/save',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [保存预算额度↗](http://yapi.cai-inc.com/project/2991/interface/api/381594) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [预算额度相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_49788)
 * @请求头 `POST /zlb/budget/quota/save`
 * @更新时间 `2023-02-02 17:08:29`
 * @项目ID 2991
 */
const zlbBudgetQuotaSavePostRequestConfig: ZlbBudgetQuotaSavePostRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_4_0_3,
  devUrl: devUrl_0_4_0_3,
  prodUrl: prodUrl_0_4_0_3,
  path: '/zlb/budget/quota/save',
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_4_0_3,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'zlbBudgetQuotaSavePost',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * 接口 [保存预算额度↗](http://yapi.cai-inc.com/project/2991/interface/api/381594) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [预算额度相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_49788)
 * @请求头 `POST /zlb/budget/quota/save`
 * @更新时间 `2023-02-02 17:08:29`
 * @项目ID 2991
 */
export const zlbBudgetQuotaSavePost = /*#__PURE__*/ (
  requestData: ZlbBudgetQuotaSavePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetQuotaSavePostResponse>(
    prepare(zlbBudgetQuotaSavePostRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetQuotaSavePost.requestConfig = zlbBudgetQuotaSavePostRequestConfig;

/**
 * 接口 [编辑预算额度↗](http://yapi.cai-inc.com/project/2991/interface/api/381602) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [预算额度相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_49788)
 * @请求头 `POST /zlb/budget/quota/update`
 * @更新时间 `2023-01-29 11:24:51`
 * @项目ID 2991
 */
export interface ZlbBudgetQuotaUpdatePostRequest {
  /**
   * 机构id(默认取当前机构id)
   */
  orgId?: number;
  quotaId: string;
  /**
   * 额度总金额（分）
   */
  totalAmount: number;
  /**
   * 是否强控（0：弱控，1：强控，2：不控制）
   */
  controlMode?: number;
  /**
   * 子部门使用（0：否 1：是）
   */
  isSubUse?: number;
}

/**
 * 接口 [编辑预算额度↗](http://yapi.cai-inc.com/project/2991/interface/api/381602) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [预算额度相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_49788)
 * @请求头 `POST /zlb/budget/quota/update`
 * @更新时间 `2023-01-29 11:24:51`
 * @项目ID 2991
 */
export interface ZlbBudgetQuotaUpdatePostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [编辑预算额度↗](http://yapi.cai-inc.com/project/2991/interface/api/381602) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [预算额度相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_49788)
 * @请求头 `POST /zlb/budget/quota/update`
 * @更新时间 `2023-01-29 11:24:51`
 * @项目ID 2991
 */
type ZlbBudgetQuotaUpdatePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/quota/update',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [编辑预算额度↗](http://yapi.cai-inc.com/project/2991/interface/api/381602) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [预算额度相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_49788)
 * @请求头 `POST /zlb/budget/quota/update`
 * @更新时间 `2023-01-29 11:24:51`
 * @项目ID 2991
 */
const zlbBudgetQuotaUpdatePostRequestConfig: ZlbBudgetQuotaUpdatePostRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_4_0_3,
  devUrl: devUrl_0_4_0_3,
  prodUrl: prodUrl_0_4_0_3,
  path: '/zlb/budget/quota/update',
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_4_0_3,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'zlbBudgetQuotaUpdatePost',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * 接口 [编辑预算额度↗](http://yapi.cai-inc.com/project/2991/interface/api/381602) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [预算额度相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_49788)
 * @请求头 `POST /zlb/budget/quota/update`
 * @更新时间 `2023-01-29 11:24:51`
 * @项目ID 2991
 */
export const zlbBudgetQuotaUpdatePost = /*#__PURE__*/ (
  requestData: ZlbBudgetQuotaUpdatePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetQuotaUpdatePostResponse>(
    prepare(zlbBudgetQuotaUpdatePostRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetQuotaUpdatePost.requestConfig = zlbBudgetQuotaUpdatePostRequestConfig;

/**
 * 接口 [查询分解额度↗](http://yapi.cai-inc.com/project/2991/interface/api/381610) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [预算额度相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_49788)
 * @请求头 `POST /zlb/budget/quota/query-sub-quota`
 * @更新时间 `2023-01-29 11:26:22`
 * @项目ID 2991
 */
export interface ZlbBudgetQuotaQuerySubQuotaPostRequest {
  /**
   * 额度id
   */
  quotaId?: string;
  /**
   * 项目类别（1：基本支出，2：项目支出）
   */
  projectCategory: number;
  /**
   * 当前页码，默认1
   */
  pageNo?: number;
  /**
   * 每页记录数，默认10
   */
  pageSize?: number;
}

/**
 * 接口 [查询分解额度↗](http://yapi.cai-inc.com/project/2991/interface/api/381610) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [预算额度相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_49788)
 * @请求头 `POST /zlb/budget/quota/query-sub-quota`
 * @更新时间 `2023-01-29 11:26:22`
 * @项目ID 2991
 */
export interface ZlbBudgetQuotaQuerySubQuotaPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 总记录数
     */
    total?: number;
    /**
     * 结果集
     */
    data?: {
      /**
       * 预算额度id
       */
      quotaId?: string;
      /**
       * 额度名称
       */
      quotaName?: string;
      /**
       * 部门名称
       */
      depName?: string;
      /**
       * 额度总金额（分）
       */
      totalAmount?: number;
      /**
       * 额度已用金额（分）
       */
      usedAmount?: number;
    }[];
    pageNum?: number;
    pageSize?: number;
    /**
     * 总页数
     */
    pages?: number;
    /**
     * 第几页
     */
    size?: number;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [查询分解额度↗](http://yapi.cai-inc.com/project/2991/interface/api/381610) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [预算额度相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_49788)
 * @请求头 `POST /zlb/budget/quota/query-sub-quota`
 * @更新时间 `2023-01-29 11:26:22`
 * @项目ID 2991
 */
type ZlbBudgetQuotaQuerySubQuotaPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/quota/query-sub-quota',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [查询分解额度↗](http://yapi.cai-inc.com/project/2991/interface/api/381610) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [预算额度相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_49788)
 * @请求头 `POST /zlb/budget/quota/query-sub-quota`
 * @更新时间 `2023-01-29 11:26:22`
 * @项目ID 2991
 */
const zlbBudgetQuotaQuerySubQuotaPostRequestConfig: ZlbBudgetQuotaQuerySubQuotaPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_3,
    devUrl: devUrl_0_4_0_3,
    prodUrl: prodUrl_0_4_0_3,
    path: '/zlb/budget/quota/query-sub-quota',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbBudgetQuotaQuerySubQuotaPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [查询分解额度↗](http://yapi.cai-inc.com/project/2991/interface/api/381610) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [预算额度相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_49788)
 * @请求头 `POST /zlb/budget/quota/query-sub-quota`
 * @更新时间 `2023-01-29 11:26:22`
 * @项目ID 2991
 */
export const zlbBudgetQuotaQuerySubQuotaPost = /*#__PURE__*/ (
  requestData: ZlbBudgetQuotaQuerySubQuotaPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetQuotaQuerySubQuotaPostResponse>(
    prepare(zlbBudgetQuotaQuerySubQuotaPostRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetQuotaQuerySubQuotaPost.requestConfig = zlbBudgetQuotaQuerySubQuotaPostRequestConfig;

/**
 * 接口 [查询跟场景关联的额度-去重-分页↗](http://yapi.cai-inc.com/project/2991/interface/api/381626) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [预算额度相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_49788)
 * @请求头 `POST /zlb/budget/quota/query-relation-quota-distinct`
 * @更新时间 `2023-02-07 13:52:52`
 * @项目ID 2991
 */
export interface ZlbBudgetQuotaQueryRelationQuotaDistinctPostRequest {
  /**
   * 额度名称
   */
  quotaName?: string;
  /**
   * 资金性质（0：财政资金，1：自有资金）
   */
  fundsNature?: number;
  /**
   * 部门经济分类
   */
  depExpendEconomicClassifyName?: string;
  /**
   * 项目类别（1：基本支出，2：项目支出）
   */
  projectCategory: string;
  /**
   * 项目名称
   */
  projectName?: string;
  /**
   * 当前页码，默认1
   */
  pageNo?: number;
  /**
   * 每页记录数，默认10
   */
  pageSize?: number;
  /**
   * 机构id
   */
  orgId?: number;
  /**
   * 年份 YYYY
   */
  year?: number;
}

/**
 * 接口 [查询跟场景关联的额度-去重-分页↗](http://yapi.cai-inc.com/project/2991/interface/api/381626) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [预算额度相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_49788)
 * @请求头 `POST /zlb/budget/quota/query-relation-quota-distinct`
 * @更新时间 `2023-02-07 13:52:52`
 * @项目ID 2991
 */
export interface ZlbBudgetQuotaQueryRelationQuotaDistinctPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 总记录数
     */
    total?: number;
    /**
     * 结果集
     */
    data?: {
      /**
       * 预算额度ID
       */
      quotaId?: string;
      /**
       * 关联id
       */
      relationId?: number;
      /**
       * 额度名称(部门经济分类、项目名称)
       */
      quotaName?: string;
      /**
       * 总额度（分）
       */
      totalAmount?: number;
      /**
       * 可用额度（分）
       */
      availableAmount?: number;
      /**
       * 资金性质（0：财政资金，1：自有资金）
       */
      fundsNature?: number;
      /**
       * 部门经济分类
       */
      depExpendEconomicClassifyCode?: string;
      /**
       * 项目名称
       */
      projectName?: string;
      /**
       * 年度
       */
      year?: number;
      /**
       * 项目类别（1：基本支出，2：项目支出）
       */
      projectCategory?: number;
      /**
       * 类别名称（对应budget_economy_classify#e_name）
       */
      categoryName?: string;
      /**
       * 部门id
       */
      depId?: number;
      /**
       * 部门名称
       */
      depName?: string;
      /**
       * 子部门使用（0：否 1：是）
       */
      isSubUse?: number;
      /**
       * 支出进度
       */
      expenditurePercentage: string;
    }[];
    pageNum?: number;
    pageSize?: number;
    /**
     * 总页数
     */
    pages?: number;
    /**
     * 第几页
     */
    size?: number;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [查询跟场景关联的额度-去重-分页↗](http://yapi.cai-inc.com/project/2991/interface/api/381626) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [预算额度相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_49788)
 * @请求头 `POST /zlb/budget/quota/query-relation-quota-distinct`
 * @更新时间 `2023-02-07 13:52:52`
 * @项目ID 2991
 */
type ZlbBudgetQuotaQueryRelationQuotaDistinctPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/quota/query-relation-quota-distinct',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [查询跟场景关联的额度-去重-分页↗](http://yapi.cai-inc.com/project/2991/interface/api/381626) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [预算额度相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_49788)
 * @请求头 `POST /zlb/budget/quota/query-relation-quota-distinct`
 * @更新时间 `2023-02-07 13:52:52`
 * @项目ID 2991
 */
const zlbBudgetQuotaQueryRelationQuotaDistinctPostRequestConfig: ZlbBudgetQuotaQueryRelationQuotaDistinctPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_3,
    devUrl: devUrl_0_4_0_3,
    prodUrl: prodUrl_0_4_0_3,
    path: '/zlb/budget/quota/query-relation-quota-distinct',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbBudgetQuotaQueryRelationQuotaDistinctPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [查询跟场景关联的额度-去重-分页↗](http://yapi.cai-inc.com/project/2991/interface/api/381626) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [预算额度相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_49788)
 * @请求头 `POST /zlb/budget/quota/query-relation-quota-distinct`
 * @更新时间 `2023-02-07 13:52:52`
 * @项目ID 2991
 */
export const zlbBudgetQuotaQueryRelationQuotaDistinctPost = /*#__PURE__*/ (
  requestData: ZlbBudgetQuotaQueryRelationQuotaDistinctPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetQuotaQueryRelationQuotaDistinctPostResponse>(
    prepare(zlbBudgetQuotaQueryRelationQuotaDistinctPostRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetQuotaQueryRelationQuotaDistinctPost.requestConfig =
  zlbBudgetQuotaQueryRelationQuotaDistinctPostRequestConfig;

const mockUrl_0_4_0_4 = 'http://yapi.cai-inc.com/mock/2991' as any;
const devUrl_0_4_0_4 = '' as any;
const prodUrl_0_4_0_4 = '' as any;
const dataKey_0_4_0_4 = 'data' as any;

/**
 * 接口 [保存配置↗](http://yapi.cai-inc.com/project/2991/interface/api/362658) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [预算配置相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_50185)
 * @请求头 `POST /zlb/budget/config/batch-edit`
 * @更新时间 `2024-12-10 17:37:34`
 * @项目ID 2991
 */
export interface ZlbBudgetConfigBatchEditPostRequest {
  /**
   * /**
   * 业务类型
   * org：机构
   * district：区划
   * {@link cn.gov.zlb.budget.domain.enums.ConfigBizTypeEnum}
   */
  bizType: string;
  /**
   * 业务编码（机构id或区划code）
   */
  bizCodes?: string[];
  /**
   * 配置编码
   * budgetSelectConfig：场景按指标 | 额度控制
   * {@link cn.gov.zlb.budget.domain.enums.ConfigKeyEnum}
   */
  configKey: string;
  /**
   * 配置值
   */
  configValue: string;
  /**
   * 报销类型id(字典id)
   */
  scenesId: number;
}

/**
 * 接口 [保存配置↗](http://yapi.cai-inc.com/project/2991/interface/api/362658) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [预算配置相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_50185)
 * @请求头 `POST /zlb/budget/config/batch-edit`
 * @更新时间 `2024-12-10 17:37:34`
 * @项目ID 2991
 */
export interface ZlbBudgetConfigBatchEditPostResponse {
  success?: boolean;
  result?: boolean;
  code?: string;
  message?: string;
}

/**
 * 接口 [保存配置↗](http://yapi.cai-inc.com/project/2991/interface/api/362658) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [预算配置相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_50185)
 * @请求头 `POST /zlb/budget/config/batch-edit`
 * @更新时间 `2024-12-10 17:37:34`
 * @项目ID 2991
 */
type ZlbBudgetConfigBatchEditPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/config/batch-edit',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [保存配置↗](http://yapi.cai-inc.com/project/2991/interface/api/362658) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [预算配置相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_50185)
 * @请求头 `POST /zlb/budget/config/batch-edit`
 * @更新时间 `2024-12-10 17:37:34`
 * @项目ID 2991
 */
const zlbBudgetConfigBatchEditPostRequestConfig: ZlbBudgetConfigBatchEditPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_4,
    devUrl: devUrl_0_4_0_4,
    prodUrl: prodUrl_0_4_0_4,
    path: '/zlb/budget/config/batch-edit',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbBudgetConfigBatchEditPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [保存配置↗](http://yapi.cai-inc.com/project/2991/interface/api/362658) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [预算配置相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_50185)
 * @请求头 `POST /zlb/budget/config/batch-edit`
 * @更新时间 `2024-12-10 17:37:34`
 * @项目ID 2991
 */
export const zlbBudgetConfigBatchEditPost = /*#__PURE__*/ (
  requestData: ZlbBudgetConfigBatchEditPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetConfigBatchEditPostResponse>(
    prepare(zlbBudgetConfigBatchEditPostRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetConfigBatchEditPost.requestConfig = zlbBudgetConfigBatchEditPostRequestConfig;

/**
 * 接口 [查询配置↗](http://yapi.cai-inc.com/project/2991/interface/api/368562) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [预算配置相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_50185)
 * @请求头 `POST /zlb/budget/config/query-scenes-config`
 * @更新时间 `2024-12-10 17:37:34`
 * @项目ID 2991
 */
export interface ZlbBudgetConfigQueryScenesConfigPostRequest {
  /**
   * 业务编码
   */
  bizCode?: string;
  /**
   * 业务编码(机构id | 区划code)
   */
  bizCodes?: string[];
  /**
   * 业务类型
   * org：机构
   * district：区划
   * {@link cn.gov.zlb.budget.domain.enums.ConfigBizTypeEnum}
   */
  bizType: string;
  /**
   * 配置编码
   * budgetSelectConfig：场景按指标 | 额度控制
   * {@link cn.gov.zlb.budget.domain.enums.ConfigKeyEnum}
   */
  configKey: string;
  /**
   * 报销类型id
   */
  scenesId: number;
}

/**
 * 接口 [查询配置↗](http://yapi.cai-inc.com/project/2991/interface/api/368562) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [预算配置相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_50185)
 * @请求头 `POST /zlb/budget/config/query-scenes-config`
 * @更新时间 `2024-12-10 17:37:34`
 * @项目ID 2991
 */
export interface ZlbBudgetConfigQueryScenesConfigPostResponse {
  success?: boolean;
  result?: boolean;
  code?: string;
  message?: string;
}

/**
 * 接口 [查询配置↗](http://yapi.cai-inc.com/project/2991/interface/api/368562) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [预算配置相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_50185)
 * @请求头 `POST /zlb/budget/config/query-scenes-config`
 * @更新时间 `2024-12-10 17:37:34`
 * @项目ID 2991
 */
type ZlbBudgetConfigQueryScenesConfigPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/config/query-scenes-config',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [查询配置↗](http://yapi.cai-inc.com/project/2991/interface/api/368562) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [预算配置相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_50185)
 * @请求头 `POST /zlb/budget/config/query-scenes-config`
 * @更新时间 `2024-12-10 17:37:34`
 * @项目ID 2991
 */
const zlbBudgetConfigQueryScenesConfigPostRequestConfig: ZlbBudgetConfigQueryScenesConfigPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_4,
    devUrl: devUrl_0_4_0_4,
    prodUrl: prodUrl_0_4_0_4,
    path: '/zlb/budget/config/query-scenes-config',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbBudgetConfigQueryScenesConfigPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [查询配置↗](http://yapi.cai-inc.com/project/2991/interface/api/368562) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [预算配置相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_50185)
 * @请求头 `POST /zlb/budget/config/query-scenes-config`
 * @更新时间 `2024-12-10 17:37:34`
 * @项目ID 2991
 */
export const zlbBudgetConfigQueryScenesConfigPost = /*#__PURE__*/ (
  requestData: ZlbBudgetConfigQueryScenesConfigPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetConfigQueryScenesConfigPostResponse>(
    prepare(zlbBudgetConfigQueryScenesConfigPostRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetConfigQueryScenesConfigPost.requestConfig =
  zlbBudgetConfigQueryScenesConfigPostRequestConfig;

/**
 * 接口 [判断是否属于宁波区划↗](http://yapi.cai-inc.com/project/2991/interface/api/459258) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [预算配置相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_50185)
 * @请求头 `POST /zlb/budget/config/is-nb-dist`
 * @更新时间 `2024-12-10 17:37:34`
 * @项目ID 2991
 */
export interface ZlbBudgetConfigIsNbDistPostRequest {
  /**
   * 租户code
   */
  tenantCode?: string;
}

/**
 * 接口 [判断是否属于宁波区划↗](http://yapi.cai-inc.com/project/2991/interface/api/459258) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [预算配置相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_50185)
 * @请求头 `POST /zlb/budget/config/is-nb-dist`
 * @更新时间 `2024-12-10 17:37:34`
 * @项目ID 2991
 */
export interface ZlbBudgetConfigIsNbDistPostResponse {
  success?: boolean;
  result?: boolean;
  code?: string;
  message?: string;
}

/**
 * 接口 [判断是否属于宁波区划↗](http://yapi.cai-inc.com/project/2991/interface/api/459258) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [预算配置相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_50185)
 * @请求头 `POST /zlb/budget/config/is-nb-dist`
 * @更新时间 `2024-12-10 17:37:34`
 * @项目ID 2991
 */
type ZlbBudgetConfigIsNbDistPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/config/is-nb-dist',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [判断是否属于宁波区划↗](http://yapi.cai-inc.com/project/2991/interface/api/459258) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [预算配置相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_50185)
 * @请求头 `POST /zlb/budget/config/is-nb-dist`
 * @更新时间 `2024-12-10 17:37:34`
 * @项目ID 2991
 */
const zlbBudgetConfigIsNbDistPostRequestConfig: ZlbBudgetConfigIsNbDistPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_4,
    devUrl: devUrl_0_4_0_4,
    prodUrl: prodUrl_0_4_0_4,
    path: '/zlb/budget/config/is-nb-dist',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbBudgetConfigIsNbDistPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [判断是否属于宁波区划↗](http://yapi.cai-inc.com/project/2991/interface/api/459258) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [预算配置相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_50185)
 * @请求头 `POST /zlb/budget/config/is-nb-dist`
 * @更新时间 `2024-12-10 17:37:34`
 * @项目ID 2991
 */
export const zlbBudgetConfigIsNbDistPost = /*#__PURE__*/ (
  requestData: ZlbBudgetConfigIsNbDistPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetConfigIsNbDistPostResponse>(
    prepare(zlbBudgetConfigIsNbDistPostRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetConfigIsNbDistPost.requestConfig = zlbBudgetConfigIsNbDistPostRequestConfig;

/**
 * 接口 [查询预算项目场景配置↗](http://yapi.cai-inc.com/project/2991/interface/api/621386) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [预算配置相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_50185)
 * @请求头 `POST /zlb/budget/config/project/scenes-config/list`
 * @更新时间 `2024-12-10 17:37:34`
 * @项目ID 2991
 */
export interface ZlbBudgetConfigProjectScenesConfigListPostRequest {
  orgId?: number;
}

/**
 * 接口 [查询预算项目场景配置↗](http://yapi.cai-inc.com/project/2991/interface/api/621386) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [预算配置相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_50185)
 * @请求头 `POST /zlb/budget/config/project/scenes-config/list`
 * @更新时间 `2024-12-10 17:37:34`
 * @项目ID 2991
 */
export interface ZlbBudgetConfigProjectScenesConfigListPostResponse {
  success?: boolean;
  result?: {
    budgetProjectConfigList?: {
      /**
       * 场景code
       */
      scenesCode?: string;
      /**
       * 场景名称
       */
      scenesName?: string;
      /**
       * 是否开启
       */
      enable?: boolean;
      /**
       * 申请单:1
       * 报销单:2
       */
      formType?: number[];
    }[];
    /**
     * 预算辅助编报控制开关 true-开启 false-关闭
     */
    assistedReportControl?: boolean;
    /**
     * 预算项目明细控制开关 true-开启 false-关闭
     */
    projectDetailControl?: boolean;
    /**
     * 预算项目余额显示 true-显示 false-不显示 涉及所有全面预算的申请、报销场景，显示项目可用余额数
     */
    showAvailableAmountControl?: boolean;
    /**
     * 预算项目跨部门权限 true-开启 false-关闭
     */
    crossDepAuthControl?: boolean;
  };
  code?: string;
  message?: string;
}

/**
 * 接口 [查询预算项目场景配置↗](http://yapi.cai-inc.com/project/2991/interface/api/621386) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [预算配置相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_50185)
 * @请求头 `POST /zlb/budget/config/project/scenes-config/list`
 * @更新时间 `2024-12-10 17:37:34`
 * @项目ID 2991
 */
type ZlbBudgetConfigProjectScenesConfigListPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/config/project/scenes-config/list',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [查询预算项目场景配置↗](http://yapi.cai-inc.com/project/2991/interface/api/621386) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [预算配置相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_50185)
 * @请求头 `POST /zlb/budget/config/project/scenes-config/list`
 * @更新时间 `2024-12-10 17:37:34`
 * @项目ID 2991
 */
const zlbBudgetConfigProjectScenesConfigListPostRequestConfig: ZlbBudgetConfigProjectScenesConfigListPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_4,
    devUrl: devUrl_0_4_0_4,
    prodUrl: prodUrl_0_4_0_4,
    path: '/zlb/budget/config/project/scenes-config/list',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbBudgetConfigProjectScenesConfigListPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [查询预算项目场景配置↗](http://yapi.cai-inc.com/project/2991/interface/api/621386) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [预算配置相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_50185)
 * @请求头 `POST /zlb/budget/config/project/scenes-config/list`
 * @更新时间 `2024-12-10 17:37:34`
 * @项目ID 2991
 */
export const zlbBudgetConfigProjectScenesConfigListPost = /*#__PURE__*/ (
  requestData: ZlbBudgetConfigProjectScenesConfigListPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetConfigProjectScenesConfigListPostResponse>(
    prepare(zlbBudgetConfigProjectScenesConfigListPostRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetConfigProjectScenesConfigListPost.requestConfig =
  zlbBudgetConfigProjectScenesConfigListPostRequestConfig;

/**
 * 接口 [编辑预算项目场景配置↗](http://yapi.cai-inc.com/project/2991/interface/api/621394) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [预算配置相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_50185)
 * @请求头 `POST /zlb/budget/config/project/scenes-config/edit`
 * @更新时间 `2024-12-10 17:37:35`
 * @项目ID 2991
 */
export interface ZlbBudgetConfigProjectScenesConfigEditPostRequest {
  /**
   * 机构id
   */
  orgId?: number;
  /**
   * 场景code
   */
  scenesCode?: string;
  /**
   * 是否开启
   */
  enable?: boolean;
  /**
   * 申请单:1
   * 报销单:2
   */
  formType?: number[];
  /**
   * 预算辅助编报控制开关 true-开启 false-关闭
   */
  assistedReportControl?: boolean;
  /**
   * 预算项目明细控制开关 true-开启 false-关闭
   */
  projectDetailControl?: boolean;
  /**
   * 预算项目余额显示 true-显示 false-不显示 涉及所有全面预算的申请、报销场景，显示项目可用余额数
   */
  showAvailableAmountControl?: boolean;
  /**
   * 预算项目跨部门权限 true-开启 false-关闭
   */
  crossDepAuthControl?: boolean;
  /**
   * 预算实施金额权限 true-开启 false-关闭
   */
  implementAmountControl?: boolean;
}

/**
 * 接口 [编辑预算项目场景配置↗](http://yapi.cai-inc.com/project/2991/interface/api/621394) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [预算配置相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_50185)
 * @请求头 `POST /zlb/budget/config/project/scenes-config/edit`
 * @更新时间 `2024-12-10 17:37:35`
 * @项目ID 2991
 */
export interface ZlbBudgetConfigProjectScenesConfigEditPostResponse {
  success?: boolean;
  result?: boolean;
  code?: string;
  message?: string;
}

/**
 * 接口 [编辑预算项目场景配置↗](http://yapi.cai-inc.com/project/2991/interface/api/621394) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [预算配置相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_50185)
 * @请求头 `POST /zlb/budget/config/project/scenes-config/edit`
 * @更新时间 `2024-12-10 17:37:35`
 * @项目ID 2991
 */
type ZlbBudgetConfigProjectScenesConfigEditPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/config/project/scenes-config/edit',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [编辑预算项目场景配置↗](http://yapi.cai-inc.com/project/2991/interface/api/621394) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [预算配置相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_50185)
 * @请求头 `POST /zlb/budget/config/project/scenes-config/edit`
 * @更新时间 `2024-12-10 17:37:35`
 * @项目ID 2991
 */
const zlbBudgetConfigProjectScenesConfigEditPostRequestConfig: ZlbBudgetConfigProjectScenesConfigEditPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_4,
    devUrl: devUrl_0_4_0_4,
    prodUrl: prodUrl_0_4_0_4,
    path: '/zlb/budget/config/project/scenes-config/edit',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbBudgetConfigProjectScenesConfigEditPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [编辑预算项目场景配置↗](http://yapi.cai-inc.com/project/2991/interface/api/621394) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [预算配置相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_50185)
 * @请求头 `POST /zlb/budget/config/project/scenes-config/edit`
 * @更新时间 `2024-12-10 17:37:35`
 * @项目ID 2991
 */
export const zlbBudgetConfigProjectScenesConfigEditPost = /*#__PURE__*/ (
  requestData: ZlbBudgetConfigProjectScenesConfigEditPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetConfigProjectScenesConfigEditPostResponse>(
    prepare(zlbBudgetConfigProjectScenesConfigEditPostRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetConfigProjectScenesConfigEditPost.requestConfig =
  zlbBudgetConfigProjectScenesConfigEditPostRequestConfig;

/**
 * 接口 [判断是否属于嘉兴区划（已改成：判断是否开启了包干经费预算配置）↗](http://yapi.cai-inc.com/project/2991/interface/api/630778) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [预算配置相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_50185)
 * @请求头 `POST /zlb/budget/config/is-jx-dist`
 * @更新时间 `2024-12-10 17:37:35`
 * @项目ID 2991
 */
export interface ZlbBudgetConfigIsJxDistPostRequest {}

/**
 * 接口 [判断是否属于嘉兴区划（已改成：判断是否开启了包干经费预算配置）↗](http://yapi.cai-inc.com/project/2991/interface/api/630778) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [预算配置相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_50185)
 * @请求头 `POST /zlb/budget/config/is-jx-dist`
 * @更新时间 `2024-12-10 17:37:35`
 * @项目ID 2991
 */
export interface ZlbBudgetConfigIsJxDistPostResponse {
  success?: boolean;
  result?: boolean;
  code?: string;
  message?: string;
}

/**
 * 接口 [判断是否属于嘉兴区划（已改成：判断是否开启了包干经费预算配置）↗](http://yapi.cai-inc.com/project/2991/interface/api/630778) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [预算配置相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_50185)
 * @请求头 `POST /zlb/budget/config/is-jx-dist`
 * @更新时间 `2024-12-10 17:37:35`
 * @项目ID 2991
 */
type ZlbBudgetConfigIsJxDistPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/config/is-jx-dist',
    'data',
    string,
    string,
    true
  >
>;

/**
 * 接口 [判断是否属于嘉兴区划（已改成：判断是否开启了包干经费预算配置）↗](http://yapi.cai-inc.com/project/2991/interface/api/630778) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [预算配置相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_50185)
 * @请求头 `POST /zlb/budget/config/is-jx-dist`
 * @更新时间 `2024-12-10 17:37:35`
 * @项目ID 2991
 */
const zlbBudgetConfigIsJxDistPostRequestConfig: ZlbBudgetConfigIsJxDistPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_4,
    devUrl: devUrl_0_4_0_4,
    prodUrl: prodUrl_0_4_0_4,
    path: '/zlb/budget/config/is-jx-dist',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.none,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbBudgetConfigIsJxDistPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [判断是否属于嘉兴区划（已改成：判断是否开启了包干经费预算配置）↗](http://yapi.cai-inc.com/project/2991/interface/api/630778) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [预算配置相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_50185)
 * @请求头 `POST /zlb/budget/config/is-jx-dist`
 * @更新时间 `2024-12-10 17:37:35`
 * @项目ID 2991
 */
export const zlbBudgetConfigIsJxDistPost = /*#__PURE__*/ (
  requestData?: ZlbBudgetConfigIsJxDistPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetConfigIsJxDistPostResponse>(
    prepare(zlbBudgetConfigIsJxDistPostRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetConfigIsJxDistPost.requestConfig = zlbBudgetConfigIsJxDistPostRequestConfig;

/**
 * 接口 [判断是否属于舟山公安↗](http://yapi.cai-inc.com/project/2991/interface/api/653178) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [预算配置相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_50185)
 * @请求头 `POST /zlb/budget/config/is-zs-gong`
 * @更新时间 `2024-12-10 17:37:35`
 * @项目ID 2991
 */
export interface ZlbBudgetConfigIsZsGongPostRequest {}

/**
 * 接口 [判断是否属于舟山公安↗](http://yapi.cai-inc.com/project/2991/interface/api/653178) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [预算配置相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_50185)
 * @请求头 `POST /zlb/budget/config/is-zs-gong`
 * @更新时间 `2024-12-10 17:37:35`
 * @项目ID 2991
 */
export interface ZlbBudgetConfigIsZsGongPostResponse {
  success?: boolean;
  result?: boolean;
  code?: string;
  message?: string;
}

/**
 * 接口 [判断是否属于舟山公安↗](http://yapi.cai-inc.com/project/2991/interface/api/653178) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [预算配置相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_50185)
 * @请求头 `POST /zlb/budget/config/is-zs-gong`
 * @更新时间 `2024-12-10 17:37:35`
 * @项目ID 2991
 */
type ZlbBudgetConfigIsZsGongPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/config/is-zs-gong',
    'data',
    string,
    string,
    true
  >
>;

/**
 * 接口 [判断是否属于舟山公安↗](http://yapi.cai-inc.com/project/2991/interface/api/653178) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [预算配置相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_50185)
 * @请求头 `POST /zlb/budget/config/is-zs-gong`
 * @更新时间 `2024-12-10 17:37:35`
 * @项目ID 2991
 */
const zlbBudgetConfigIsZsGongPostRequestConfig: ZlbBudgetConfigIsZsGongPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_4,
    devUrl: devUrl_0_4_0_4,
    prodUrl: prodUrl_0_4_0_4,
    path: '/zlb/budget/config/is-zs-gong',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.none,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbBudgetConfigIsZsGongPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [判断是否属于舟山公安↗](http://yapi.cai-inc.com/project/2991/interface/api/653178) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [预算配置相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_50185)
 * @请求头 `POST /zlb/budget/config/is-zs-gong`
 * @更新时间 `2024-12-10 17:37:35`
 * @项目ID 2991
 */
export const zlbBudgetConfigIsZsGongPost = /*#__PURE__*/ (
  requestData?: ZlbBudgetConfigIsZsGongPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetConfigIsZsGongPostResponse>(
    prepare(zlbBudgetConfigIsZsGongPostRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetConfigIsZsGongPost.requestConfig = zlbBudgetConfigIsZsGongPostRequestConfig;

const mockUrl_0_4_0_5 = 'http://yapi.cai-inc.com/mock/2991' as any;
const devUrl_0_4_0_5 = '' as any;
const prodUrl_0_4_0_5 = '' as any;
const dataKey_0_4_0_5 = 'data' as any;

/**
 * 接口 [根据typeCode查询字典表数据↗](http://yapi.cai-inc.com/project/2991/interface/api/381298) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [预算字典相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_50188)
 * @请求头 `GET /zlb/budget/dict/get-dict-by-type-code`
 * @更新时间 `2023-01-29 10:29:34`
 * @项目ID 2991
 */
export interface ZlbBudgetDictGetDictByTypeCodeGetRequest {
  configValue?: string;
  typeCode?: string;
}

/**
 * 接口 [根据typeCode查询字典表数据↗](http://yapi.cai-inc.com/project/2991/interface/api/381298) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [预算字典相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_50188)
 * @请求头 `GET /zlb/budget/dict/get-dict-by-type-code`
 * @更新时间 `2023-01-29 10:29:34`
 * @项目ID 2991
 */
export interface ZlbBudgetDictGetDictByTypeCodeGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * id
     */
    dictId?: number;
    /**
     * 数据字典-code
     */
    configCode?: string;
    /**
     * 数据字典-value
     */
    configValue?: string;
  }[];
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [根据typeCode查询字典表数据↗](http://yapi.cai-inc.com/project/2991/interface/api/381298) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [预算字典相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_50188)
 * @请求头 `GET /zlb/budget/dict/get-dict-by-type-code`
 * @更新时间 `2023-01-29 10:29:34`
 * @项目ID 2991
 */
type ZlbBudgetDictGetDictByTypeCodeGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/dict/get-dict-by-type-code',
    'data',
    string,
    'configValue' | 'typeCode',
    false
  >
>;

/**
 * 接口 [根据typeCode查询字典表数据↗](http://yapi.cai-inc.com/project/2991/interface/api/381298) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [预算字典相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_50188)
 * @请求头 `GET /zlb/budget/dict/get-dict-by-type-code`
 * @更新时间 `2023-01-29 10:29:34`
 * @项目ID 2991
 */
const zlbBudgetDictGetDictByTypeCodeGetRequestConfig: ZlbBudgetDictGetDictByTypeCodeGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_5,
    devUrl: devUrl_0_4_0_5,
    prodUrl: prodUrl_0_4_0_5,
    path: '/zlb/budget/dict/get-dict-by-type-code',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_5,
    paramNames: [],
    queryNames: ['configValue', 'typeCode'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbBudgetDictGetDictByTypeCodeGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [根据typeCode查询字典表数据↗](http://yapi.cai-inc.com/project/2991/interface/api/381298) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [预算字典相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_50188)
 * @请求头 `GET /zlb/budget/dict/get-dict-by-type-code`
 * @更新时间 `2023-01-29 10:29:34`
 * @项目ID 2991
 */
export const zlbBudgetDictGetDictByTypeCodeGet = /*#__PURE__*/ (
  requestData: ZlbBudgetDictGetDictByTypeCodeGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetDictGetDictByTypeCodeGetResponse>(
    prepare(zlbBudgetDictGetDictByTypeCodeGetRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetDictGetDictByTypeCodeGet.requestConfig = zlbBudgetDictGetDictByTypeCodeGetRequestConfig;

const mockUrl_0_4_0_6 = 'http://yapi.cai-inc.com/mock/2991' as any;
const devUrl_0_4_0_6 = '' as any;
const prodUrl_0_4_0_6 = '' as any;
const dataKey_0_4_0_6 = 'data' as any;

/**
 * 接口 [查询预算使用记录（分页）↗](http://yapi.cai-inc.com/project/2991/interface/api/381338) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [预算通用相关接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_50189)
 * @请求头 `POST /zlb/budget/manage/query-budget-used-record`
 * @更新时间 `2023-01-30 14:59:19`
 * @项目ID 2991
 */
export interface ZlbBudgetManageQueryBudgetUsedRecordPostRequest {
  /**
   * 预算id或者额度id
   */
  relationId: string;
  /**
   * 机构id（relationType=2必传）
   */
  orgId?: number;
  /**
   * 关联类型（1：指标，2：额度）
   */
  relationType: number;
  /**
   * 当前页码，默认1
   */
  pageNo?: number;
  /**
   * 每页记录数，默认10
   */
  pageSize?: number;
}

/**
 * 接口 [查询预算使用记录（分页）↗](http://yapi.cai-inc.com/project/2991/interface/api/381338) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [预算通用相关接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_50189)
 * @请求头 `POST /zlb/budget/manage/query-budget-used-record`
 * @更新时间 `2023-01-30 14:59:19`
 * @项目ID 2991
 */
export interface ZlbBudgetManageQueryBudgetUsedRecordPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 总记录数
     */
    total?: number;
    /**
     * 结果集
     */
    data?: {
      /**
       * 主键
       */
      id?: number;
      /**
       * 用户名称
       */
      userName?: string;
      /**
       * 操作类型（冻结：freeze、释放：release、结算：settlement）
       */
      type?: string;
      /**
       * 操作时间
       */
      addTime?: string;
      /**
       * 外部请求唯一标识
       */
      requestId?: string;
      /**
       * 外部请求业务代码
       */
      businessCode?: string;
      /**
       * 内容
       */
      content?: string;
      /**
       * 所属部门
       */
      depName?: string;
    }[];
    pageNum?: number;
    pageSize?: number;
    /**
     * 总页数
     */
    pages?: number;
    /**
     * 第几页
     */
    size?: number;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [查询预算使用记录（分页）↗](http://yapi.cai-inc.com/project/2991/interface/api/381338) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [预算通用相关接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_50189)
 * @请求头 `POST /zlb/budget/manage/query-budget-used-record`
 * @更新时间 `2023-01-30 14:59:19`
 * @项目ID 2991
 */
type ZlbBudgetManageQueryBudgetUsedRecordPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/manage/query-budget-used-record',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [查询预算使用记录（分页）↗](http://yapi.cai-inc.com/project/2991/interface/api/381338) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [预算通用相关接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_50189)
 * @请求头 `POST /zlb/budget/manage/query-budget-used-record`
 * @更新时间 `2023-01-30 14:59:19`
 * @项目ID 2991
 */
const zlbBudgetManageQueryBudgetUsedRecordPostRequestConfig: ZlbBudgetManageQueryBudgetUsedRecordPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_6,
    devUrl: devUrl_0_4_0_6,
    prodUrl: prodUrl_0_4_0_6,
    path: '/zlb/budget/manage/query-budget-used-record',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_6,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbBudgetManageQueryBudgetUsedRecordPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [查询预算使用记录（分页）↗](http://yapi.cai-inc.com/project/2991/interface/api/381338) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [预算通用相关接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_50189)
 * @请求头 `POST /zlb/budget/manage/query-budget-used-record`
 * @更新时间 `2023-01-30 14:59:19`
 * @项目ID 2991
 */
export const zlbBudgetManageQueryBudgetUsedRecordPost = /*#__PURE__*/ (
  requestData: ZlbBudgetManageQueryBudgetUsedRecordPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetManageQueryBudgetUsedRecordPostResponse>(
    prepare(zlbBudgetManageQueryBudgetUsedRecordPostRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetManageQueryBudgetUsedRecordPost.requestConfig =
  zlbBudgetManageQueryBudgetUsedRecordPostRequestConfig;

/**
 * 接口 [指标操作记录（分页）↗](http://yapi.cai-inc.com/project/2991/interface/api/381346) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [预算通用相关接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_50189)
 * @请求头 `POST /zlb/budget/manage/operation-log`
 * @更新时间 `2023-01-29 10:40:23`
 * @项目ID 2991
 */
export interface ZlbBudgetManageOperationLogPostRequest {
  /**
   * 支出场景(取字典表中id字段)
   */
  scenesId: number;
  /**
   * relationType=2时必传
   */
  orgId?: number;
  /**
   * 关联类型（1：指标，2：额度）
   */
  relationType: number;
  /**
   * 年份
   */
  year?: number;
  /**
   * 当前页码，默认1
   */
  pageNo?: number;
  /**
   * 每页记录数，默认10
   */
  pageSize?: number;
}

/**
 * 接口 [指标操作记录（分页）↗](http://yapi.cai-inc.com/project/2991/interface/api/381346) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [预算通用相关接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_50189)
 * @请求头 `POST /zlb/budget/manage/operation-log`
 * @更新时间 `2023-01-29 10:40:23`
 * @项目ID 2991
 */
export interface ZlbBudgetManageOperationLogPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 总记录数
     */
    total?: number;
    /**
     * 结果集
     */
    data?: {
      /**
       * 操作记录id
       */
      recordId?: string;
      /**
       * 操作人名称
       */
      operatorName?: string;
      /**
       * 指标文号 | 额度名称
       */
      relationName?: string;
      /**
       * 操作类型(1：关联，-1：取消关联)
       */
      operatorType?: string;
      /**
       * 场景名称
       */
      scenesName?: string;
      /**
       * 预算id
       */
      budgetId?: number;
      /**
       * 额度id
       */
      quotaId?: string;
      /**
       * 创建时间
       */
      addTime?: string;
    }[];
    pageNum?: number;
    pageSize?: number;
    /**
     * 总页数
     */
    pages?: number;
    /**
     * 第几页
     */
    size?: number;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [指标操作记录（分页）↗](http://yapi.cai-inc.com/project/2991/interface/api/381346) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [预算通用相关接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_50189)
 * @请求头 `POST /zlb/budget/manage/operation-log`
 * @更新时间 `2023-01-29 10:40:23`
 * @项目ID 2991
 */
type ZlbBudgetManageOperationLogPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/manage/operation-log',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [指标操作记录（分页）↗](http://yapi.cai-inc.com/project/2991/interface/api/381346) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [预算通用相关接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_50189)
 * @请求头 `POST /zlb/budget/manage/operation-log`
 * @更新时间 `2023-01-29 10:40:23`
 * @项目ID 2991
 */
const zlbBudgetManageOperationLogPostRequestConfig: ZlbBudgetManageOperationLogPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_6,
    devUrl: devUrl_0_4_0_6,
    prodUrl: prodUrl_0_4_0_6,
    path: '/zlb/budget/manage/operation-log',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_6,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbBudgetManageOperationLogPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [指标操作记录（分页）↗](http://yapi.cai-inc.com/project/2991/interface/api/381346) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [预算通用相关接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_50189)
 * @请求头 `POST /zlb/budget/manage/operation-log`
 * @更新时间 `2023-01-29 10:40:23`
 * @项目ID 2991
 */
export const zlbBudgetManageOperationLogPost = /*#__PURE__*/ (
  requestData: ZlbBudgetManageOperationLogPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetManageOperationLogPostResponse>(
    prepare(zlbBudgetManageOperationLogPostRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetManageOperationLogPost.requestConfig = zlbBudgetManageOperationLogPostRequestConfig;

/**
 * 接口 [取消指标场景关联关系↗](http://yapi.cai-inc.com/project/2991/interface/api/381354) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [预算通用相关接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_50189)
 * @请求头 `POST /zlb/budget/manage/cancel-scenes-relation`
 * @更新时间 `2023-02-07 13:54:21`
 * @项目ID 2991
 */
export interface ZlbBudgetManageCancelScenesRelationPostRequest {
  /**
   * relationID
   */
  id: number;
}

/**
 * 接口 [取消指标场景关联关系↗](http://yapi.cai-inc.com/project/2991/interface/api/381354) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [预算通用相关接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_50189)
 * @请求头 `POST /zlb/budget/manage/cancel-scenes-relation`
 * @更新时间 `2023-02-07 13:54:21`
 * @项目ID 2991
 */
export interface ZlbBudgetManageCancelScenesRelationPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [取消指标场景关联关系↗](http://yapi.cai-inc.com/project/2991/interface/api/381354) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [预算通用相关接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_50189)
 * @请求头 `POST /zlb/budget/manage/cancel-scenes-relation`
 * @更新时间 `2023-02-07 13:54:21`
 * @项目ID 2991
 */
type ZlbBudgetManageCancelScenesRelationPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/manage/cancel-scenes-relation',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [取消指标场景关联关系↗](http://yapi.cai-inc.com/project/2991/interface/api/381354) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [预算通用相关接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_50189)
 * @请求头 `POST /zlb/budget/manage/cancel-scenes-relation`
 * @更新时间 `2023-02-07 13:54:21`
 * @项目ID 2991
 */
const zlbBudgetManageCancelScenesRelationPostRequestConfig: ZlbBudgetManageCancelScenesRelationPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_6,
    devUrl: devUrl_0_4_0_6,
    prodUrl: prodUrl_0_4_0_6,
    path: '/zlb/budget/manage/cancel-scenes-relation',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_6,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbBudgetManageCancelScenesRelationPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [取消指标场景关联关系↗](http://yapi.cai-inc.com/project/2991/interface/api/381354) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [预算通用相关接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_50189)
 * @请求头 `POST /zlb/budget/manage/cancel-scenes-relation`
 * @更新时间 `2023-02-07 13:54:21`
 * @项目ID 2991
 */
export const zlbBudgetManageCancelScenesRelationPost = /*#__PURE__*/ (
  requestData: ZlbBudgetManageCancelScenesRelationPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetManageCancelScenesRelationPostResponse>(
    prepare(zlbBudgetManageCancelScenesRelationPostRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetManageCancelScenesRelationPost.requestConfig =
  zlbBudgetManageCancelScenesRelationPostRequestConfig;

/**
 * 接口 [（指标 | 额度）与报销场景关联↗](http://yapi.cai-inc.com/project/2991/interface/api/381362) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [预算通用相关接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_50189)
 * @请求头 `POST /zlb/budget/manage/scenes-relation`
 * @更新时间 `2023-01-29 10:40:24`
 * @项目ID 2991
 */
export interface ZlbBudgetManageScenesRelationPostRequest {
  /**
   * 报销类型id
   */
  scenesId: number;
  /**
   * 关联类型（1：指标，2：额度）
   */
  relationType: number;
  /**
   * relationType=2时必传
   */
  orgId?: number;
  /**
   * 指标id
   */
  budgetId?: number[];
  /**
   * 额度id
   */
  quotaId?: string[];
}

/**
 * 接口 [（指标 | 额度）与报销场景关联↗](http://yapi.cai-inc.com/project/2991/interface/api/381362) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [预算通用相关接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_50189)
 * @请求头 `POST /zlb/budget/manage/scenes-relation`
 * @更新时间 `2023-01-29 10:40:24`
 * @项目ID 2991
 */
export interface ZlbBudgetManageScenesRelationPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [（指标 | 额度）与报销场景关联↗](http://yapi.cai-inc.com/project/2991/interface/api/381362) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [预算通用相关接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_50189)
 * @请求头 `POST /zlb/budget/manage/scenes-relation`
 * @更新时间 `2023-01-29 10:40:24`
 * @项目ID 2991
 */
type ZlbBudgetManageScenesRelationPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/manage/scenes-relation',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [（指标 | 额度）与报销场景关联↗](http://yapi.cai-inc.com/project/2991/interface/api/381362) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [预算通用相关接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_50189)
 * @请求头 `POST /zlb/budget/manage/scenes-relation`
 * @更新时间 `2023-01-29 10:40:24`
 * @项目ID 2991
 */
const zlbBudgetManageScenesRelationPostRequestConfig: ZlbBudgetManageScenesRelationPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_6,
    devUrl: devUrl_0_4_0_6,
    prodUrl: prodUrl_0_4_0_6,
    path: '/zlb/budget/manage/scenes-relation',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_6,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbBudgetManageScenesRelationPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [（指标 | 额度）与报销场景关联↗](http://yapi.cai-inc.com/project/2991/interface/api/381362) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [预算通用相关接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_50189)
 * @请求头 `POST /zlb/budget/manage/scenes-relation`
 * @更新时间 `2023-01-29 10:40:24`
 * @项目ID 2991
 */
export const zlbBudgetManageScenesRelationPost = /*#__PURE__*/ (
  requestData: ZlbBudgetManageScenesRelationPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetManageScenesRelationPostResponse>(
    prepare(zlbBudgetManageScenesRelationPostRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetManageScenesRelationPost.requestConfig = zlbBudgetManageScenesRelationPostRequestConfig;

/**
 * 接口 [查询经济分类↗](http://yapi.cai-inc.com/project/2991/interface/api/381370) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [预算通用相关接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_50189)
 * @请求头 `POST /zlb/budget/manage/query-economy-classify`
 * @更新时间 `2023-01-29 10:40:24`
 * @项目ID 2991
 */
export interface ZlbBudgetManageQueryEconomyClassifyPostRequest {
  /**
   * 年份
   */
  year?: number;
  /**
   * 类型（1：政府经济分类，2：部门经济分类）
   */
  type: number;
}

/**
 * 接口 [查询经济分类↗](http://yapi.cai-inc.com/project/2991/interface/api/381370) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [预算通用相关接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_50189)
 * @请求头 `POST /zlb/budget/manage/query-economy-classify`
 * @更新时间 `2023-01-29 10:40:24`
 * @项目ID 2991
 */
export interface ZlbBudgetManageQueryEconomyClassifyPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    id?: number;
    /**
     * code
     */
    code?: string;
    /**
     * 名称
     */
    name?: string;
    /**
     * 是否有子节点
     * true：有 false：无
     */
    leaf?: boolean;
    /**
     * 子节点数据
     */
    children?: {
      id?: number;
      /**
       * code
       */
      code?: string;
      /**
       * 名称
       */
      name?: string;
      /**
       * 是否有子节点
       * true：有 false：无
       */
      leaf?: boolean;
      /**
       * 子节点数据
       */
      children?: {}[];
    }[];
  }[];
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [查询经济分类↗](http://yapi.cai-inc.com/project/2991/interface/api/381370) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [预算通用相关接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_50189)
 * @请求头 `POST /zlb/budget/manage/query-economy-classify`
 * @更新时间 `2023-01-29 10:40:24`
 * @项目ID 2991
 */
type ZlbBudgetManageQueryEconomyClassifyPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/manage/query-economy-classify',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [查询经济分类↗](http://yapi.cai-inc.com/project/2991/interface/api/381370) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [预算通用相关接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_50189)
 * @请求头 `POST /zlb/budget/manage/query-economy-classify`
 * @更新时间 `2023-01-29 10:40:24`
 * @项目ID 2991
 */
const zlbBudgetManageQueryEconomyClassifyPostRequestConfig: ZlbBudgetManageQueryEconomyClassifyPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_6,
    devUrl: devUrl_0_4_0_6,
    prodUrl: prodUrl_0_4_0_6,
    path: '/zlb/budget/manage/query-economy-classify',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_6,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbBudgetManageQueryEconomyClassifyPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [查询经济分类↗](http://yapi.cai-inc.com/project/2991/interface/api/381370) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [预算通用相关接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_50189)
 * @请求头 `POST /zlb/budget/manage/query-economy-classify`
 * @更新时间 `2023-01-29 10:40:24`
 * @项目ID 2991
 */
export const zlbBudgetManageQueryEconomyClassifyPost = /*#__PURE__*/ (
  requestData: ZlbBudgetManageQueryEconomyClassifyPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetManageQueryEconomyClassifyPostResponse>(
    prepare(zlbBudgetManageQueryEconomyClassifyPostRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetManageQueryEconomyClassifyPost.requestConfig =
  zlbBudgetManageQueryEconomyClassifyPostRequestConfig;

/**
 * 接口 [查询功能科目↗](http://yapi.cai-inc.com/project/2991/interface/api/646370) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [预算通用相关接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_50189)
 * @请求头 `POST /zlb/budget/manage/query-function-section`
 * @更新时间 `2024-04-22 15:33:19`
 * @项目ID 2991
 */
export interface ZlbBudgetManageQueryFunctionSectionPostRequest {
  /**
   * 年份，非必填，默认当前系统时间年份
   */
  year?: number;
}

/**
 * 接口 [查询功能科目↗](http://yapi.cai-inc.com/project/2991/interface/api/646370) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [预算通用相关接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_50189)
 * @请求头 `POST /zlb/budget/manage/query-function-section`
 * @更新时间 `2024-04-22 15:33:19`
 * @项目ID 2991
 */
export interface ZlbBudgetManageQueryFunctionSectionPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    id?: number;
    /**
     * code
     */
    code?: string;
    /**
     * 名称
     */
    name?: string;
    /**
     * 是否有子节点
     * true：有 false：无
     */
    leaf?: boolean;
    /**
     * 子节点数据
     */
    children?: {
      id?: number;
      /**
       * code
       */
      code?: string;
      /**
       * 名称
       */
      name?: string;
      /**
       * 是否有子节点
       * true：有 false：无
       */
      leaf?: boolean;
      /**
       * 子节点数据
       */
      children?: {}[];
    }[];
  }[];
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [查询功能科目↗](http://yapi.cai-inc.com/project/2991/interface/api/646370) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [预算通用相关接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_50189)
 * @请求头 `POST /zlb/budget/manage/query-function-section`
 * @更新时间 `2024-04-22 15:33:19`
 * @项目ID 2991
 */
type ZlbBudgetManageQueryFunctionSectionPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/manage/query-function-section',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [查询功能科目↗](http://yapi.cai-inc.com/project/2991/interface/api/646370) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [预算通用相关接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_50189)
 * @请求头 `POST /zlb/budget/manage/query-function-section`
 * @更新时间 `2024-04-22 15:33:19`
 * @项目ID 2991
 */
const zlbBudgetManageQueryFunctionSectionPostRequestConfig: ZlbBudgetManageQueryFunctionSectionPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_6,
    devUrl: devUrl_0_4_0_6,
    prodUrl: prodUrl_0_4_0_6,
    path: '/zlb/budget/manage/query-function-section',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_6,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbBudgetManageQueryFunctionSectionPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [查询功能科目↗](http://yapi.cai-inc.com/project/2991/interface/api/646370) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [预算通用相关接口↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_50189)
 * @请求头 `POST /zlb/budget/manage/query-function-section`
 * @更新时间 `2024-04-22 15:33:19`
 * @项目ID 2991
 */
export const zlbBudgetManageQueryFunctionSectionPost = /*#__PURE__*/ (
  requestData: ZlbBudgetManageQueryFunctionSectionPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetManageQueryFunctionSectionPostResponse>(
    prepare(zlbBudgetManageQueryFunctionSectionPostRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetManageQueryFunctionSectionPost.requestConfig =
  zlbBudgetManageQueryFunctionSectionPostRequestConfig;

const mockUrl_0_4_0_7 = 'http://yapi.cai-inc.com/mock/2991' as any;
const devUrl_0_4_0_7 = '' as any;
const prodUrl_0_4_0_7 = '' as any;
const dataKey_0_4_0_7 = 'data' as any;

/**
 * 接口 [查询会计科目↗](http://yapi.cai-inc.com/project/2991/interface/api/521122) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [会计科目↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_52940)
 * @请求头 `POST /zlb/budget/account/subject/paging`
 * @更新时间 `2024-08-22 10:19:11`
 * @项目ID 2991
 */
export interface ZlbBudgetAccountSubjectPagingPostRequest {
  pageSize?: number;
  pageNo?: number;
  sortField?: string;
  sortBy?: string;
  year?: number;
  subjectCode?: string;
  subjectName?: string;
}

/**
 * 接口 [查询会计科目↗](http://yapi.cai-inc.com/project/2991/interface/api/521122) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [会计科目↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_52940)
 * @请求头 `POST /zlb/budget/account/subject/paging`
 * @更新时间 `2024-08-22 10:19:11`
 * @项目ID 2991
 */
export interface ZlbBudgetAccountSubjectPagingPostResponse {
  success?: boolean;
  result?: {
    total?: number;
    /**
     * [{"uniqueCode":"","subjectCode":"","subjectName":"","balanceDirection":0,"balanceDirectionDesc":"","remarks":"","childList":[{"uniqueCode":"","subjectCode":"","subjectName":"","balanceDirection":0,"balanceDirectionDesc":"","remarks":"","childList":[]}]}]
     */
    data?: {
      uniqueCode?: string;
      subjectCode?: string;
      subjectName?: string;
      balanceDirection?: number;
      balanceDirectionDesc?: string;
      remarks?: string;
      /**
       * [{"uniqueCode":"","subjectCode":"","subjectName":"","balanceDirection":0,"balanceDirectionDesc":"","remarks":"","childList":[]}]
       */
      childList?: {
        uniqueCode?: string;
        subjectCode?: string;
        subjectName?: string;
        balanceDirection?: number;
        balanceDirectionDesc?: string;
        remarks?: string;
        /**
         * []
         */
        childList?: unknown[];
      }[];
    }[];
    pageNum?: number;
    pageSize?: number;
    pages?: number;
    size?: number;
  };
  code?: string;
  message?: string;
}

/**
 * 接口 [查询会计科目↗](http://yapi.cai-inc.com/project/2991/interface/api/521122) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [会计科目↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_52940)
 * @请求头 `POST /zlb/budget/account/subject/paging`
 * @更新时间 `2024-08-22 10:19:11`
 * @项目ID 2991
 */
type ZlbBudgetAccountSubjectPagingPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/account/subject/paging',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [查询会计科目↗](http://yapi.cai-inc.com/project/2991/interface/api/521122) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [会计科目↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_52940)
 * @请求头 `POST /zlb/budget/account/subject/paging`
 * @更新时间 `2024-08-22 10:19:11`
 * @项目ID 2991
 */
const zlbBudgetAccountSubjectPagingPostRequestConfig: ZlbBudgetAccountSubjectPagingPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_7,
    devUrl: devUrl_0_4_0_7,
    prodUrl: prodUrl_0_4_0_7,
    path: '/zlb/budget/account/subject/paging',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_7,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbBudgetAccountSubjectPagingPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [查询会计科目↗](http://yapi.cai-inc.com/project/2991/interface/api/521122) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [会计科目↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_52940)
 * @请求头 `POST /zlb/budget/account/subject/paging`
 * @更新时间 `2024-08-22 10:19:11`
 * @项目ID 2991
 */
export const zlbBudgetAccountSubjectPagingPost = /*#__PURE__*/ (
  requestData: ZlbBudgetAccountSubjectPagingPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetAccountSubjectPagingPostResponse>(
    prepare(zlbBudgetAccountSubjectPagingPostRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetAccountSubjectPagingPost.requestConfig = zlbBudgetAccountSubjectPagingPostRequestConfig;

/**
 * 接口 [会计科目详情↗](http://yapi.cai-inc.com/project/2991/interface/api/521130) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [会计科目↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_52940)
 * @请求头 `GET /zlb/budget/account/subject/detail/{uniqueCode}`
 * @更新时间 `2025-01-04 17:44:00`
 * @项目ID 2991
 */
export interface ZlbBudgetAccountSubjectDetailUniqueCodeGetRequest {
  uniqueCode: string;
}

/**
 * 接口 [会计科目详情↗](http://yapi.cai-inc.com/project/2991/interface/api/521130) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [会计科目↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_52940)
 * @请求头 `GET /zlb/budget/account/subject/detail/{uniqueCode}`
 * @更新时间 `2025-01-04 17:44:00`
 * @项目ID 2991
 */
export interface ZlbBudgetAccountSubjectDetailUniqueCodeGetResponse {
  success?: boolean;
  result?: {
    uniqueCode?: string;
    subjectCode?: string;
    subjectName?: string;
    parentSubjectCode?: string;
    balanceDirection?: number;
    remarks?: string;
  };
  code?: string;
  message?: string;
}

/**
 * 接口 [会计科目详情↗](http://yapi.cai-inc.com/project/2991/interface/api/521130) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [会计科目↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_52940)
 * @请求头 `GET /zlb/budget/account/subject/detail/{uniqueCode}`
 * @更新时间 `2025-01-04 17:44:00`
 * @项目ID 2991
 */
type ZlbBudgetAccountSubjectDetailUniqueCodeGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/account/subject/detail/{uniqueCode}',
    'data',
    'uniqueCode',
    string,
    false
  >
>;

/**
 * 接口 [会计科目详情↗](http://yapi.cai-inc.com/project/2991/interface/api/521130) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [会计科目↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_52940)
 * @请求头 `GET /zlb/budget/account/subject/detail/{uniqueCode}`
 * @更新时间 `2025-01-04 17:44:00`
 * @项目ID 2991
 */
const zlbBudgetAccountSubjectDetailUniqueCodeGetRequestConfig: ZlbBudgetAccountSubjectDetailUniqueCodeGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_7,
    devUrl: devUrl_0_4_0_7,
    prodUrl: prodUrl_0_4_0_7,
    path: '/zlb/budget/account/subject/detail/{uniqueCode}',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_7,
    paramNames: ['uniqueCode'],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbBudgetAccountSubjectDetailUniqueCodeGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [会计科目详情↗](http://yapi.cai-inc.com/project/2991/interface/api/521130) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [会计科目↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_52940)
 * @请求头 `GET /zlb/budget/account/subject/detail/{uniqueCode}`
 * @更新时间 `2025-01-04 17:44:00`
 * @项目ID 2991
 */
export const zlbBudgetAccountSubjectDetailUniqueCodeGet = /*#__PURE__*/ (
  requestData: ZlbBudgetAccountSubjectDetailUniqueCodeGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetAccountSubjectDetailUniqueCodeGetResponse>(
    prepare(zlbBudgetAccountSubjectDetailUniqueCodeGetRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetAccountSubjectDetailUniqueCodeGet.requestConfig =
  zlbBudgetAccountSubjectDetailUniqueCodeGetRequestConfig;

/**
 * 接口 [保存会计科目↗](http://yapi.cai-inc.com/project/2991/interface/api/521138) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [会计科目↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_52940)
 * @请求头 `POST /zlb/budget/account/subject/save`
 * @更新时间 `2025-01-04 17:44:00`
 * @项目ID 2991
 */
export interface ZlbBudgetAccountSubjectSavePostRequest {
  subjectCode?: string;
  subjectName?: string;
  year?: number;
  parentSubjectCode?: string;
  balanceDirection?: number;
  remarks?: string;
}

/**
 * 接口 [保存会计科目↗](http://yapi.cai-inc.com/project/2991/interface/api/521138) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [会计科目↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_52940)
 * @请求头 `POST /zlb/budget/account/subject/save`
 * @更新时间 `2025-01-04 17:44:00`
 * @项目ID 2991
 */
export interface ZlbBudgetAccountSubjectSavePostResponse {
  success?: boolean;
  result?: boolean;
  code?: string;
  message?: string;
}

/**
 * 接口 [保存会计科目↗](http://yapi.cai-inc.com/project/2991/interface/api/521138) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [会计科目↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_52940)
 * @请求头 `POST /zlb/budget/account/subject/save`
 * @更新时间 `2025-01-04 17:44:00`
 * @项目ID 2991
 */
type ZlbBudgetAccountSubjectSavePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/account/subject/save',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [保存会计科目↗](http://yapi.cai-inc.com/project/2991/interface/api/521138) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [会计科目↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_52940)
 * @请求头 `POST /zlb/budget/account/subject/save`
 * @更新时间 `2025-01-04 17:44:00`
 * @项目ID 2991
 */
const zlbBudgetAccountSubjectSavePostRequestConfig: ZlbBudgetAccountSubjectSavePostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_7,
    devUrl: devUrl_0_4_0_7,
    prodUrl: prodUrl_0_4_0_7,
    path: '/zlb/budget/account/subject/save',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_7,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbBudgetAccountSubjectSavePost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [保存会计科目↗](http://yapi.cai-inc.com/project/2991/interface/api/521138) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [会计科目↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_52940)
 * @请求头 `POST /zlb/budget/account/subject/save`
 * @更新时间 `2025-01-04 17:44:00`
 * @项目ID 2991
 */
export const zlbBudgetAccountSubjectSavePost = /*#__PURE__*/ (
  requestData: ZlbBudgetAccountSubjectSavePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetAccountSubjectSavePostResponse>(
    prepare(zlbBudgetAccountSubjectSavePostRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetAccountSubjectSavePost.requestConfig = zlbBudgetAccountSubjectSavePostRequestConfig;

/**
 * 接口 [编辑会计科目↗](http://yapi.cai-inc.com/project/2991/interface/api/521146) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [会计科目↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_52940)
 * @请求头 `POST /zlb/budget/account/subject/edit`
 * @更新时间 `2025-01-04 17:44:00`
 * @项目ID 2991
 */
export interface ZlbBudgetAccountSubjectEditPostRequest {
  uniqueCode?: string;
  subjectName?: string;
  year?: number;
  balanceDirection?: number;
  remarks?: string;
  bankAccountCode?: string;
  amount?: number;
  isEnable?: number;
}

/**
 * 接口 [编辑会计科目↗](http://yapi.cai-inc.com/project/2991/interface/api/521146) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [会计科目↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_52940)
 * @请求头 `POST /zlb/budget/account/subject/edit`
 * @更新时间 `2025-01-04 17:44:00`
 * @项目ID 2991
 */
export interface ZlbBudgetAccountSubjectEditPostResponse {
  success?: boolean;
  result?: boolean;
  code?: string;
  message?: string;
}

/**
 * 接口 [编辑会计科目↗](http://yapi.cai-inc.com/project/2991/interface/api/521146) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [会计科目↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_52940)
 * @请求头 `POST /zlb/budget/account/subject/edit`
 * @更新时间 `2025-01-04 17:44:00`
 * @项目ID 2991
 */
type ZlbBudgetAccountSubjectEditPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/account/subject/edit',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [编辑会计科目↗](http://yapi.cai-inc.com/project/2991/interface/api/521146) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [会计科目↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_52940)
 * @请求头 `POST /zlb/budget/account/subject/edit`
 * @更新时间 `2025-01-04 17:44:00`
 * @项目ID 2991
 */
const zlbBudgetAccountSubjectEditPostRequestConfig: ZlbBudgetAccountSubjectEditPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_7,
    devUrl: devUrl_0_4_0_7,
    prodUrl: prodUrl_0_4_0_7,
    path: '/zlb/budget/account/subject/edit',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_7,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbBudgetAccountSubjectEditPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [编辑会计科目↗](http://yapi.cai-inc.com/project/2991/interface/api/521146) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [会计科目↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_52940)
 * @请求头 `POST /zlb/budget/account/subject/edit`
 * @更新时间 `2025-01-04 17:44:00`
 * @项目ID 2991
 */
export const zlbBudgetAccountSubjectEditPost = /*#__PURE__*/ (
  requestData: ZlbBudgetAccountSubjectEditPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetAccountSubjectEditPostResponse>(
    prepare(zlbBudgetAccountSubjectEditPostRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetAccountSubjectEditPost.requestConfig = zlbBudgetAccountSubjectEditPostRequestConfig;

/**
 * 接口 [删除会计科目↗](http://yapi.cai-inc.com/project/2991/interface/api/521154) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [会计科目↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_52940)
 * @请求头 `POST /zlb/budget/account/subject/delete`
 * @更新时间 `2025-01-04 17:44:00`
 * @项目ID 2991
 */
export interface ZlbBudgetAccountSubjectDeletePostRequest {
  /**
   * [""]
   */
  uniqueCodeList?: string[];
}

/**
 * 接口 [删除会计科目↗](http://yapi.cai-inc.com/project/2991/interface/api/521154) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [会计科目↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_52940)
 * @请求头 `POST /zlb/budget/account/subject/delete`
 * @更新时间 `2025-01-04 17:44:00`
 * @项目ID 2991
 */
export interface ZlbBudgetAccountSubjectDeletePostResponse {
  success?: boolean;
  result?: boolean;
  code?: string;
  message?: string;
}

/**
 * 接口 [删除会计科目↗](http://yapi.cai-inc.com/project/2991/interface/api/521154) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [会计科目↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_52940)
 * @请求头 `POST /zlb/budget/account/subject/delete`
 * @更新时间 `2025-01-04 17:44:00`
 * @项目ID 2991
 */
type ZlbBudgetAccountSubjectDeletePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/account/subject/delete',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [删除会计科目↗](http://yapi.cai-inc.com/project/2991/interface/api/521154) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [会计科目↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_52940)
 * @请求头 `POST /zlb/budget/account/subject/delete`
 * @更新时间 `2025-01-04 17:44:00`
 * @项目ID 2991
 */
const zlbBudgetAccountSubjectDeletePostRequestConfig: ZlbBudgetAccountSubjectDeletePostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_7,
    devUrl: devUrl_0_4_0_7,
    prodUrl: prodUrl_0_4_0_7,
    path: '/zlb/budget/account/subject/delete',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_7,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbBudgetAccountSubjectDeletePost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [删除会计科目↗](http://yapi.cai-inc.com/project/2991/interface/api/521154) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [会计科目↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_52940)
 * @请求头 `POST /zlb/budget/account/subject/delete`
 * @更新时间 `2025-01-04 17:44:00`
 * @项目ID 2991
 */
export const zlbBudgetAccountSubjectDeletePost = /*#__PURE__*/ (
  requestData: ZlbBudgetAccountSubjectDeletePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetAccountSubjectDeletePostResponse>(
    prepare(zlbBudgetAccountSubjectDeletePostRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetAccountSubjectDeletePost.requestConfig = zlbBudgetAccountSubjectDeletePostRequestConfig;

/**
 * 接口 [查询余额方向枚举↗](http://yapi.cai-inc.com/project/2991/interface/api/521162) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [会计科目↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_52940)
 * @请求头 `GET /zlb/budget/account/subject/query-balance-direction`
 * @更新时间 `2025-01-04 17:44:00`
 * @项目ID 2991
 */
export interface ZlbBudgetAccountSubjectQueryBalanceDirectionGetRequest {}

/**
 * 接口 [查询余额方向枚举↗](http://yapi.cai-inc.com/project/2991/interface/api/521162) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [会计科目↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_52940)
 * @请求头 `GET /zlb/budget/account/subject/query-balance-direction`
 * @更新时间 `2025-01-04 17:44:00`
 * @项目ID 2991
 */
export interface ZlbBudgetAccountSubjectQueryBalanceDirectionGetResponse {
  success?: boolean;
  /**
   * [{"code":0,"name":""}]
   */
  result?: {
    code?: number;
    name?: string;
  }[];
  code?: string;
  message?: string;
}

/**
 * 接口 [查询余额方向枚举↗](http://yapi.cai-inc.com/project/2991/interface/api/521162) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [会计科目↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_52940)
 * @请求头 `GET /zlb/budget/account/subject/query-balance-direction`
 * @更新时间 `2025-01-04 17:44:00`
 * @项目ID 2991
 */
type ZlbBudgetAccountSubjectQueryBalanceDirectionGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/account/subject/query-balance-direction',
    'data',
    string,
    string,
    true
  >
>;

/**
 * 接口 [查询余额方向枚举↗](http://yapi.cai-inc.com/project/2991/interface/api/521162) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [会计科目↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_52940)
 * @请求头 `GET /zlb/budget/account/subject/query-balance-direction`
 * @更新时间 `2025-01-04 17:44:00`
 * @项目ID 2991
 */
const zlbBudgetAccountSubjectQueryBalanceDirectionGetRequestConfig: ZlbBudgetAccountSubjectQueryBalanceDirectionGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_7,
    devUrl: devUrl_0_4_0_7,
    prodUrl: prodUrl_0_4_0_7,
    path: '/zlb/budget/account/subject/query-balance-direction',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_7,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbBudgetAccountSubjectQueryBalanceDirectionGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [查询余额方向枚举↗](http://yapi.cai-inc.com/project/2991/interface/api/521162) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [会计科目↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_52940)
 * @请求头 `GET /zlb/budget/account/subject/query-balance-direction`
 * @更新时间 `2025-01-04 17:44:00`
 * @项目ID 2991
 */
export const zlbBudgetAccountSubjectQueryBalanceDirectionGet = /*#__PURE__*/ (
  requestData?: ZlbBudgetAccountSubjectQueryBalanceDirectionGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetAccountSubjectQueryBalanceDirectionGetResponse>(
    prepare(zlbBudgetAccountSubjectQueryBalanceDirectionGetRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetAccountSubjectQueryBalanceDirectionGet.requestConfig =
  zlbBudgetAccountSubjectQueryBalanceDirectionGetRequestConfig;

/**
 * 接口 [科目查询↗](http://yapi.cai-inc.com/project/2991/interface/api/699066) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [会计科目↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_52940)
 * @请求头 `POST /zlb/budget/account/subject/list`
 * @更新时间 `2025-01-04 17:43:59`
 * @项目ID 2991
 */
export interface ZlbBudgetAccountSubjectListPostRequest {
  orgId?: number;
  year?: number;
  subjectCode?: string;
  subjectName?: string;
  isAmount?: number;
  isTaizhang?: number;
  isZhichu?: number;
  isInput?: number;
  isEnable?: number;
}

/**
 * 接口 [科目查询↗](http://yapi.cai-inc.com/project/2991/interface/api/699066) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [会计科目↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_52940)
 * @请求头 `POST /zlb/budget/account/subject/list`
 * @更新时间 `2025-01-04 17:43:59`
 * @项目ID 2991
 */
export interface ZlbBudgetAccountSubjectListPostResponse {
  success?: boolean;
  /**
   * [{"orgId":0,"uniqueCode":"","subjectCode":"","subjectName":"","year":0,"level":0,"parentUniqueCode":"","balanceDirection":0,"remarks":"","isAmount":0,"amount":0,"cunkuanBankAccountCode":"","isTaizhang":0,"isZhichu":0,"departmentEconomyClassifyList":[{"financialId":"","eCode":"","eName":""}]}]
   */
  result?: {
    orgId?: number;
    uniqueCode?: string;
    subjectCode?: string;
    subjectName?: string;
    year?: number;
    level?: number;
    parentUniqueCode?: string;
    balanceDirection?: number;
    remarks?: string;
    isAmount?: number;
    amount?: number;
    cunkuanBankAccountCode?: string;
    isTaizhang?: number;
    isZhichu?: number;
    /**
     * [{"financialId":"","eCode":"","eName":""}]
     */
    departmentEconomyClassifyList?: {
      financialId?: string;
      eCode?: string;
      eName?: string;
    }[];
  }[];
  code?: string;
  message?: string;
}

/**
 * 接口 [科目查询↗](http://yapi.cai-inc.com/project/2991/interface/api/699066) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [会计科目↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_52940)
 * @请求头 `POST /zlb/budget/account/subject/list`
 * @更新时间 `2025-01-04 17:43:59`
 * @项目ID 2991
 */
type ZlbBudgetAccountSubjectListPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/account/subject/list',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [科目查询↗](http://yapi.cai-inc.com/project/2991/interface/api/699066) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [会计科目↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_52940)
 * @请求头 `POST /zlb/budget/account/subject/list`
 * @更新时间 `2025-01-04 17:43:59`
 * @项目ID 2991
 */
const zlbBudgetAccountSubjectListPostRequestConfig: ZlbBudgetAccountSubjectListPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_7,
    devUrl: devUrl_0_4_0_7,
    prodUrl: prodUrl_0_4_0_7,
    path: '/zlb/budget/account/subject/list',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_7,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbBudgetAccountSubjectListPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [科目查询↗](http://yapi.cai-inc.com/project/2991/interface/api/699066) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [会计科目↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_52940)
 * @请求头 `POST /zlb/budget/account/subject/list`
 * @更新时间 `2025-01-04 17:43:59`
 * @项目ID 2991
 */
export const zlbBudgetAccountSubjectListPost = /*#__PURE__*/ (
  requestData: ZlbBudgetAccountSubjectListPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetAccountSubjectListPostResponse>(
    prepare(zlbBudgetAccountSubjectListPostRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetAccountSubjectListPost.requestConfig = zlbBudgetAccountSubjectListPostRequestConfig;

/**
 * 接口 [科目打标↗](http://yapi.cai-inc.com/project/2991/interface/api/699074) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [会计科目↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_52940)
 * @请求头 `POST /zlb/budget/account/subject/make-tag`
 * @更新时间 `2025-01-04 17:44:00`
 * @项目ID 2991
 */
export interface ZlbBudgetAccountSubjectMakeTagPostRequest {
  /**
   * [""]
   */
  uniqueCodeList?: string[];
  tag?: string;
}

/**
 * 接口 [科目打标↗](http://yapi.cai-inc.com/project/2991/interface/api/699074) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [会计科目↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_52940)
 * @请求头 `POST /zlb/budget/account/subject/make-tag`
 * @更新时间 `2025-01-04 17:44:00`
 * @项目ID 2991
 */
export interface ZlbBudgetAccountSubjectMakeTagPostResponse {
  success?: boolean;
  result?: {};
  code?: string;
  message?: string;
}

/**
 * 接口 [科目打标↗](http://yapi.cai-inc.com/project/2991/interface/api/699074) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [会计科目↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_52940)
 * @请求头 `POST /zlb/budget/account/subject/make-tag`
 * @更新时间 `2025-01-04 17:44:00`
 * @项目ID 2991
 */
type ZlbBudgetAccountSubjectMakeTagPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/account/subject/make-tag',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [科目打标↗](http://yapi.cai-inc.com/project/2991/interface/api/699074) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [会计科目↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_52940)
 * @请求头 `POST /zlb/budget/account/subject/make-tag`
 * @更新时间 `2025-01-04 17:44:00`
 * @项目ID 2991
 */
const zlbBudgetAccountSubjectMakeTagPostRequestConfig: ZlbBudgetAccountSubjectMakeTagPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_7,
    devUrl: devUrl_0_4_0_7,
    prodUrl: prodUrl_0_4_0_7,
    path: '/zlb/budget/account/subject/make-tag',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_7,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbBudgetAccountSubjectMakeTagPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [科目打标↗](http://yapi.cai-inc.com/project/2991/interface/api/699074) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [会计科目↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_52940)
 * @请求头 `POST /zlb/budget/account/subject/make-tag`
 * @更新时间 `2025-01-04 17:44:00`
 * @项目ID 2991
 */
export const zlbBudgetAccountSubjectMakeTagPost = /*#__PURE__*/ (
  requestData: ZlbBudgetAccountSubjectMakeTagPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetAccountSubjectMakeTagPostResponse>(
    prepare(zlbBudgetAccountSubjectMakeTagPostRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetAccountSubjectMakeTagPost.requestConfig = zlbBudgetAccountSubjectMakeTagPostRequestConfig;

/**
 * 接口 [移除科目标签↗](http://yapi.cai-inc.com/project/2991/interface/api/699082) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [会计科目↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_52940)
 * @请求头 `POST /zlb/budget/account/subject/move-tag`
 * @更新时间 `2025-01-04 17:44:00`
 * @项目ID 2991
 */
export interface ZlbBudgetAccountSubjectMoveTagPostRequest {
  /**
   * [""]
   */
  uniqueCodeList?: string[];
  tag?: string;
}

/**
 * 接口 [移除科目标签↗](http://yapi.cai-inc.com/project/2991/interface/api/699082) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [会计科目↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_52940)
 * @请求头 `POST /zlb/budget/account/subject/move-tag`
 * @更新时间 `2025-01-04 17:44:00`
 * @项目ID 2991
 */
export interface ZlbBudgetAccountSubjectMoveTagPostResponse {
  success?: boolean;
  result?: {};
  code?: string;
  message?: string;
}

/**
 * 接口 [移除科目标签↗](http://yapi.cai-inc.com/project/2991/interface/api/699082) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [会计科目↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_52940)
 * @请求头 `POST /zlb/budget/account/subject/move-tag`
 * @更新时间 `2025-01-04 17:44:00`
 * @项目ID 2991
 */
type ZlbBudgetAccountSubjectMoveTagPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/account/subject/move-tag',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [移除科目标签↗](http://yapi.cai-inc.com/project/2991/interface/api/699082) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [会计科目↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_52940)
 * @请求头 `POST /zlb/budget/account/subject/move-tag`
 * @更新时间 `2025-01-04 17:44:00`
 * @项目ID 2991
 */
const zlbBudgetAccountSubjectMoveTagPostRequestConfig: ZlbBudgetAccountSubjectMoveTagPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_7,
    devUrl: devUrl_0_4_0_7,
    prodUrl: prodUrl_0_4_0_7,
    path: '/zlb/budget/account/subject/move-tag',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_7,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbBudgetAccountSubjectMoveTagPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [移除科目标签↗](http://yapi.cai-inc.com/project/2991/interface/api/699082) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [会计科目↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_52940)
 * @请求头 `POST /zlb/budget/account/subject/move-tag`
 * @更新时间 `2025-01-04 17:44:00`
 * @项目ID 2991
 */
export const zlbBudgetAccountSubjectMoveTagPost = /*#__PURE__*/ (
  requestData: ZlbBudgetAccountSubjectMoveTagPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetAccountSubjectMoveTagPostResponse>(
    prepare(zlbBudgetAccountSubjectMoveTagPostRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetAccountSubjectMoveTagPost.requestConfig = zlbBudgetAccountSubjectMoveTagPostRequestConfig;

/**
 * 接口 [关联部门经济分类↗](http://yapi.cai-inc.com/project/2991/interface/api/699090) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [会计科目↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_52940)
 * @请求头 `POST /zlb/budget/account/subject/update-department-economy-classify`
 * @更新时间 `2025-01-04 17:44:00`
 * @项目ID 2991
 */
export interface ZlbBudgetAccountSubjectUpdateDepartmentEconomyClassifyPostRequest {
  uniqueCode?: string;
  /**
   * [""]
   */
  depEcoClassifyFinancialIdList?: string[];
}

/**
 * 接口 [关联部门经济分类↗](http://yapi.cai-inc.com/project/2991/interface/api/699090) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [会计科目↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_52940)
 * @请求头 `POST /zlb/budget/account/subject/update-department-economy-classify`
 * @更新时间 `2025-01-04 17:44:00`
 * @项目ID 2991
 */
export interface ZlbBudgetAccountSubjectUpdateDepartmentEconomyClassifyPostResponse {
  success?: boolean;
  result?: {};
  code?: string;
  message?: string;
}

/**
 * 接口 [关联部门经济分类↗](http://yapi.cai-inc.com/project/2991/interface/api/699090) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [会计科目↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_52940)
 * @请求头 `POST /zlb/budget/account/subject/update-department-economy-classify`
 * @更新时间 `2025-01-04 17:44:00`
 * @项目ID 2991
 */
type ZlbBudgetAccountSubjectUpdateDepartmentEconomyClassifyPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/account/subject/update-department-economy-classify',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [关联部门经济分类↗](http://yapi.cai-inc.com/project/2991/interface/api/699090) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [会计科目↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_52940)
 * @请求头 `POST /zlb/budget/account/subject/update-department-economy-classify`
 * @更新时间 `2025-01-04 17:44:00`
 * @项目ID 2991
 */
const zlbBudgetAccountSubjectUpdateDepartmentEconomyClassifyPostRequestConfig: ZlbBudgetAccountSubjectUpdateDepartmentEconomyClassifyPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_7,
    devUrl: devUrl_0_4_0_7,
    prodUrl: prodUrl_0_4_0_7,
    path: '/zlb/budget/account/subject/update-department-economy-classify',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_7,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbBudgetAccountSubjectUpdateDepartmentEconomyClassifyPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [关联部门经济分类↗](http://yapi.cai-inc.com/project/2991/interface/api/699090) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [会计科目↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_52940)
 * @请求头 `POST /zlb/budget/account/subject/update-department-economy-classify`
 * @更新时间 `2025-01-04 17:44:00`
 * @项目ID 2991
 */
export const zlbBudgetAccountSubjectUpdateDepartmentEconomyClassifyPost = /*#__PURE__*/ (
  requestData: ZlbBudgetAccountSubjectUpdateDepartmentEconomyClassifyPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetAccountSubjectUpdateDepartmentEconomyClassifyPostResponse>(
    prepare(zlbBudgetAccountSubjectUpdateDepartmentEconomyClassifyPostRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetAccountSubjectUpdateDepartmentEconomyClassifyPost.requestConfig =
  zlbBudgetAccountSubjectUpdateDepartmentEconomyClassifyPostRequestConfig;

/**
 * 接口 [科目树查询↗](http://yapi.cai-inc.com/project/2991/interface/api/699194) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [会计科目↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_52940)
 * @请求头 `POST /zlb/budget/account/subject/list-tree`
 * @更新时间 `2025-01-04 17:43:59`
 * @项目ID 2991
 */
export interface ZlbBudgetAccountSubjectListTreePostRequest {
  orgId?: number;
  year?: number;
  subjectCode?: string;
  subjectName?: string;
  isAmount?: number;
  isTaizhang?: number;
  isZhichu?: number;
  isInput?: number;
  isEnable?: number;
}

/**
 * 接口 [科目树查询↗](http://yapi.cai-inc.com/project/2991/interface/api/699194) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [会计科目↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_52940)
 * @请求头 `POST /zlb/budget/account/subject/list-tree`
 * @更新时间 `2025-01-04 17:43:59`
 * @项目ID 2991
 */
export interface ZlbBudgetAccountSubjectListTreePostResponse {
  success?: boolean;
  /**
   * [{"uniqueCode":"","subjectCode":"","subjectName":"","balanceDirection":0,"balanceDirectionDesc":"","remarks":"","year":0,"leaf":0,"isAmount":0,"amount":0,"availableAmount":0,"cunkuanBankAccountCode":"","isTaizhang":0,"isZhichu":0,"cunkuanBankAccount":{"bankAccountCode":"","bankAccountNo":"","bankAccountName":"","bankName":"","city":"","branchBankName":""},"departmentEconomyClassifyList":[{"financialId":"","eCode":"","eName":""}],"parentUniqueCode":"","parentSubjectCode":"","children":[{"uniqueCode":"","subjectCode":"","subjectName":"","balanceDirection":0,"balanceDirectionDesc":"","remarks":"","year":0,"leaf":0,"isAmount":0,"amount":0,"availableAmount":0,"cunkuanBankAccountCode":"","isTaizhang":0,"isZhichu":0,"cunkuanBankAccount":{"bankAccountCode":"","bankAccountNo":"","bankAccountName":"","bankName":"","city":"","branchBankName":""},"departmentEconomyClassifyList":[{"financialId":"","eCode":"","eName":""}],"parentUniqueCode":"","parentSubjectCode":"","children":[],"isInput":0,"isEnable":0}],"isInput":0,"isEnable":0}]
   */
  result?: {
    uniqueCode?: string;
    subjectCode?: string;
    subjectName?: string;
    balanceDirection?: number;
    balanceDirectionDesc?: string;
    remarks?: string;
    year?: number;
    leaf?: number;
    isAmount?: number;
    amount?: number;
    availableAmount?: number;
    cunkuanBankAccountCode?: string;
    isTaizhang?: number;
    isZhichu?: number;
    cunkuanBankAccount?: {
      bankAccountCode?: string;
      bankAccountNo?: string;
      bankAccountName?: string;
      bankName?: string;
      city?: string;
      branchBankName?: string;
    };
    /**
     * [{"financialId":"","eCode":"","eName":""}]
     */
    departmentEconomyClassifyList?: {
      financialId?: string;
      eCode?: string;
      eName?: string;
    }[];
    parentUniqueCode?: string;
    parentSubjectCode?: string;
    /**
     * [{"uniqueCode":"","subjectCode":"","subjectName":"","balanceDirection":0,"balanceDirectionDesc":"","remarks":"","year":0,"leaf":0,"isAmount":0,"amount":0,"availableAmount":0,"cunkuanBankAccountCode":"","isTaizhang":0,"isZhichu":0,"cunkuanBankAccount":{"bankAccountCode":"","bankAccountNo":"","bankAccountName":"","bankName":"","city":"","branchBankName":""},"departmentEconomyClassifyList":[{"financialId":"","eCode":"","eName":""}],"parentUniqueCode":"","parentSubjectCode":"","children":[],"isInput":0,"isEnable":0}]
     */
    children?: {
      uniqueCode?: string;
      subjectCode?: string;
      subjectName?: string;
      balanceDirection?: number;
      balanceDirectionDesc?: string;
      remarks?: string;
      year?: number;
      leaf?: number;
      isAmount?: number;
      amount?: number;
      availableAmount?: number;
      cunkuanBankAccountCode?: string;
      isTaizhang?: number;
      isZhichu?: number;
      cunkuanBankAccount?: {
        bankAccountCode?: string;
        bankAccountNo?: string;
        bankAccountName?: string;
        bankName?: string;
        city?: string;
        branchBankName?: string;
      };
      /**
       * [{"financialId":"","eCode":"","eName":""}]
       */
      departmentEconomyClassifyList?: {
        financialId?: string;
        eCode?: string;
        eName?: string;
      }[];
      parentUniqueCode?: string;
      parentSubjectCode?: string;
      /**
       * []
       */
      children?: unknown[];
      isInput?: number;
      isEnable?: number;
    }[];
    isInput?: number;
    isEnable?: number;
  }[];
  code?: string;
  message?: string;
}

/**
 * 接口 [科目树查询↗](http://yapi.cai-inc.com/project/2991/interface/api/699194) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [会计科目↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_52940)
 * @请求头 `POST /zlb/budget/account/subject/list-tree`
 * @更新时间 `2025-01-04 17:43:59`
 * @项目ID 2991
 */
type ZlbBudgetAccountSubjectListTreePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/account/subject/list-tree',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [科目树查询↗](http://yapi.cai-inc.com/project/2991/interface/api/699194) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [会计科目↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_52940)
 * @请求头 `POST /zlb/budget/account/subject/list-tree`
 * @更新时间 `2025-01-04 17:43:59`
 * @项目ID 2991
 */
const zlbBudgetAccountSubjectListTreePostRequestConfig: ZlbBudgetAccountSubjectListTreePostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_7,
    devUrl: devUrl_0_4_0_7,
    prodUrl: prodUrl_0_4_0_7,
    path: '/zlb/budget/account/subject/list-tree',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_7,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbBudgetAccountSubjectListTreePost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [科目树查询↗](http://yapi.cai-inc.com/project/2991/interface/api/699194) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [会计科目↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_52940)
 * @请求头 `POST /zlb/budget/account/subject/list-tree`
 * @更新时间 `2025-01-04 17:43:59`
 * @项目ID 2991
 */
export const zlbBudgetAccountSubjectListTreePost = /*#__PURE__*/ (
  requestData: ZlbBudgetAccountSubjectListTreePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetAccountSubjectListTreePostResponse>(
    prepare(zlbBudgetAccountSubjectListTreePostRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetAccountSubjectListTreePost.requestConfig =
  zlbBudgetAccountSubjectListTreePostRequestConfig;

/**
 * 接口 [查询单位集团子账户对应的科目↗](http://yapi.cai-inc.com/project/2991/interface/api/717762) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [会计科目↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_52940)
 * @请求头 `POST /zlb/budget/account/subject/list/group-account-subject`
 * @更新时间 `2024-10-29 15:07:42`
 * @项目ID 2991
 */
export interface ZlbBudgetAccountSubjectListGroupAccountSubjectPostRequest {}

/**
 * 接口 [查询单位集团子账户对应的科目↗](http://yapi.cai-inc.com/project/2991/interface/api/717762) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [会计科目↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_52940)
 * @请求头 `POST /zlb/budget/account/subject/list/group-account-subject`
 * @更新时间 `2024-10-29 15:07:42`
 * @项目ID 2991
 */
export interface ZlbBudgetAccountSubjectListGroupAccountSubjectPostResponse {
  success?: boolean;
  /**
   * [{"orgId":0,"uniqueCode":"","subjectCode":"","subjectName":"","year":0,"level":0,"leaf":0,"parentUniqueCode":"","balanceDirection":0,"remarks":"","isAmount":0,"amount":0,"availableAmount":0,"frozenAmount":0,"usedAmount":0,"cunkuanBankAccountCode":"","isTaizhang":0,"isZhichu":0}]
   */
  result?: {
    orgId?: number;
    uniqueCode?: string;
    subjectCode?: string;
    subjectName?: string;
    year?: number;
    level?: number;
    leaf?: number;
    parentUniqueCode?: string;
    balanceDirection?: number;
    remarks?: string;
    isAmount?: number;
    amount?: number;
    availableAmount?: number;
    frozenAmount?: number;
    usedAmount?: number;
    cunkuanBankAccountCode?: string;
    isTaizhang?: number;
    isZhichu?: number;
  }[];
  code?: string;
  message?: string;
}

/**
 * 接口 [查询单位集团子账户对应的科目↗](http://yapi.cai-inc.com/project/2991/interface/api/717762) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [会计科目↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_52940)
 * @请求头 `POST /zlb/budget/account/subject/list/group-account-subject`
 * @更新时间 `2024-10-29 15:07:42`
 * @项目ID 2991
 */
type ZlbBudgetAccountSubjectListGroupAccountSubjectPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/account/subject/list/group-account-subject',
    'data',
    string,
    string,
    true
  >
>;

/**
 * 接口 [查询单位集团子账户对应的科目↗](http://yapi.cai-inc.com/project/2991/interface/api/717762) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [会计科目↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_52940)
 * @请求头 `POST /zlb/budget/account/subject/list/group-account-subject`
 * @更新时间 `2024-10-29 15:07:42`
 * @项目ID 2991
 */
const zlbBudgetAccountSubjectListGroupAccountSubjectPostRequestConfig: ZlbBudgetAccountSubjectListGroupAccountSubjectPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_7,
    devUrl: devUrl_0_4_0_7,
    prodUrl: prodUrl_0_4_0_7,
    path: '/zlb/budget/account/subject/list/group-account-subject',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.none,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_7,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbBudgetAccountSubjectListGroupAccountSubjectPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [查询单位集团子账户对应的科目↗](http://yapi.cai-inc.com/project/2991/interface/api/717762) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [会计科目↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_52940)
 * @请求头 `POST /zlb/budget/account/subject/list/group-account-subject`
 * @更新时间 `2024-10-29 15:07:42`
 * @项目ID 2991
 */
export const zlbBudgetAccountSubjectListGroupAccountSubjectPost = /*#__PURE__*/ (
  requestData?: ZlbBudgetAccountSubjectListGroupAccountSubjectPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetAccountSubjectListGroupAccountSubjectPostResponse>(
    prepare(zlbBudgetAccountSubjectListGroupAccountSubjectPostRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetAccountSubjectListGroupAccountSubjectPost.requestConfig =
  zlbBudgetAccountSubjectListGroupAccountSubjectPostRequestConfig;

/**
 * 接口 [查询单位托收账户对应的科目↗](http://yapi.cai-inc.com/project/2991/interface/api/719786) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [会计科目↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_52940)
 * @请求头 `POST /zlb/budget/account/subject/list/tuoshou-account-subject`
 * @更新时间 `2024-10-29 15:07:42`
 * @项目ID 2991
 */
export interface ZlbBudgetAccountSubjectListTuoshouAccountSubjectPostRequest {}

/**
 * 接口 [查询单位托收账户对应的科目↗](http://yapi.cai-inc.com/project/2991/interface/api/719786) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [会计科目↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_52940)
 * @请求头 `POST /zlb/budget/account/subject/list/tuoshou-account-subject`
 * @更新时间 `2024-10-29 15:07:42`
 * @项目ID 2991
 */
export interface ZlbBudgetAccountSubjectListTuoshouAccountSubjectPostResponse {
  success?: boolean;
  /**
   * [{"orgId":0,"uniqueCode":"","subjectCode":"","subjectName":"","year":0,"level":0,"leaf":0,"parentUniqueCode":"","balanceDirection":0,"remarks":"","isAmount":0,"amount":0,"availableAmount":0,"frozenAmount":0,"usedAmount":0,"cunkuanBankAccountCode":"","isTaizhang":0,"isZhichu":0}]
   */
  result?: {
    orgId?: number;
    uniqueCode?: string;
    subjectCode?: string;
    subjectName?: string;
    year?: number;
    level?: number;
    leaf?: number;
    parentUniqueCode?: string;
    balanceDirection?: number;
    remarks?: string;
    isAmount?: number;
    amount?: number;
    availableAmount?: number;
    frozenAmount?: number;
    usedAmount?: number;
    cunkuanBankAccountCode?: string;
    isTaizhang?: number;
    isZhichu?: number;
  }[];
  code?: string;
  message?: string;
}

/**
 * 接口 [查询单位托收账户对应的科目↗](http://yapi.cai-inc.com/project/2991/interface/api/719786) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [会计科目↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_52940)
 * @请求头 `POST /zlb/budget/account/subject/list/tuoshou-account-subject`
 * @更新时间 `2024-10-29 15:07:42`
 * @项目ID 2991
 */
type ZlbBudgetAccountSubjectListTuoshouAccountSubjectPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/account/subject/list/tuoshou-account-subject',
    'data',
    string,
    string,
    true
  >
>;

/**
 * 接口 [查询单位托收账户对应的科目↗](http://yapi.cai-inc.com/project/2991/interface/api/719786) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [会计科目↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_52940)
 * @请求头 `POST /zlb/budget/account/subject/list/tuoshou-account-subject`
 * @更新时间 `2024-10-29 15:07:42`
 * @项目ID 2991
 */
const zlbBudgetAccountSubjectListTuoshouAccountSubjectPostRequestConfig: ZlbBudgetAccountSubjectListTuoshouAccountSubjectPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_7,
    devUrl: devUrl_0_4_0_7,
    prodUrl: prodUrl_0_4_0_7,
    path: '/zlb/budget/account/subject/list/tuoshou-account-subject',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.none,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_7,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbBudgetAccountSubjectListTuoshouAccountSubjectPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [查询单位托收账户对应的科目↗](http://yapi.cai-inc.com/project/2991/interface/api/719786) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [会计科目↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_52940)
 * @请求头 `POST /zlb/budget/account/subject/list/tuoshou-account-subject`
 * @更新时间 `2024-10-29 15:07:42`
 * @项目ID 2991
 */
export const zlbBudgetAccountSubjectListTuoshouAccountSubjectPost = /*#__PURE__*/ (
  requestData?: ZlbBudgetAccountSubjectListTuoshouAccountSubjectPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetAccountSubjectListTuoshouAccountSubjectPostResponse>(
    prepare(zlbBudgetAccountSubjectListTuoshouAccountSubjectPostRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetAccountSubjectListTuoshouAccountSubjectPost.requestConfig =
  zlbBudgetAccountSubjectListTuoshouAccountSubjectPostRequestConfig;

/**
 * 接口 [查询单位集团子账户对应的科目↗](http://yapi.cai-inc.com/project/2991/interface/api/744946) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [会计科目↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_52940)
 * @请求头 `GET /zlb/budget/account/subject/list/group-account-subject`
 * @更新时间 `2025-01-04 17:44:00`
 * @项目ID 2991
 */
export interface ZlbBudgetAccountSubjectListGroupAccountSubjectGetRequest {
  orgId: string;
}

/**
 * 接口 [查询单位集团子账户对应的科目↗](http://yapi.cai-inc.com/project/2991/interface/api/744946) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [会计科目↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_52940)
 * @请求头 `GET /zlb/budget/account/subject/list/group-account-subject`
 * @更新时间 `2025-01-04 17:44:00`
 * @项目ID 2991
 */
export interface ZlbBudgetAccountSubjectListGroupAccountSubjectGetResponse {
  success?: boolean;
  /**
   * [{"orgId":0,"uniqueCode":"","subjectCode":"","subjectName":"","year":0,"level":0,"leaf":0,"parentUniqueCode":"","balanceDirection":0,"remarks":"","isAmount":0,"amount":0,"availableAmount":0,"frozenAmount":0,"usedAmount":0,"cunkuanBankAccountCode":"","isTaizhang":0,"isZhichu":0}]
   */
  result?: {
    orgId?: number;
    uniqueCode?: string;
    subjectCode?: string;
    subjectName?: string;
    year?: number;
    level?: number;
    leaf?: number;
    parentUniqueCode?: string;
    balanceDirection?: number;
    remarks?: string;
    isAmount?: number;
    amount?: number;
    availableAmount?: number;
    frozenAmount?: number;
    usedAmount?: number;
    cunkuanBankAccountCode?: string;
    isTaizhang?: number;
    isZhichu?: number;
  }[];
  code?: string;
  message?: string;
}

/**
 * 接口 [查询单位集团子账户对应的科目↗](http://yapi.cai-inc.com/project/2991/interface/api/744946) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [会计科目↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_52940)
 * @请求头 `GET /zlb/budget/account/subject/list/group-account-subject`
 * @更新时间 `2025-01-04 17:44:00`
 * @项目ID 2991
 */
type ZlbBudgetAccountSubjectListGroupAccountSubjectGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/account/subject/list/group-account-subject',
    'data',
    string,
    'orgId',
    false
  >
>;

/**
 * 接口 [查询单位集团子账户对应的科目↗](http://yapi.cai-inc.com/project/2991/interface/api/744946) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [会计科目↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_52940)
 * @请求头 `GET /zlb/budget/account/subject/list/group-account-subject`
 * @更新时间 `2025-01-04 17:44:00`
 * @项目ID 2991
 */
const zlbBudgetAccountSubjectListGroupAccountSubjectGetRequestConfig: ZlbBudgetAccountSubjectListGroupAccountSubjectGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_7,
    devUrl: devUrl_0_4_0_7,
    prodUrl: prodUrl_0_4_0_7,
    path: '/zlb/budget/account/subject/list/group-account-subject',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_7,
    paramNames: [],
    queryNames: ['orgId'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbBudgetAccountSubjectListGroupAccountSubjectGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [查询单位集团子账户对应的科目↗](http://yapi.cai-inc.com/project/2991/interface/api/744946) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [会计科目↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_52940)
 * @请求头 `GET /zlb/budget/account/subject/list/group-account-subject`
 * @更新时间 `2025-01-04 17:44:00`
 * @项目ID 2991
 */
export const zlbBudgetAccountSubjectListGroupAccountSubjectGet = /*#__PURE__*/ (
  requestData: ZlbBudgetAccountSubjectListGroupAccountSubjectGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetAccountSubjectListGroupAccountSubjectGetResponse>(
    prepare(zlbBudgetAccountSubjectListGroupAccountSubjectGetRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetAccountSubjectListGroupAccountSubjectGet.requestConfig =
  zlbBudgetAccountSubjectListGroupAccountSubjectGetRequestConfig;

/**
 * 接口 [查询单位托收账户对应的科目↗](http://yapi.cai-inc.com/project/2991/interface/api/744954) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [会计科目↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_52940)
 * @请求头 `GET /zlb/budget/account/subject/list/tuoshou-account-subject`
 * @更新时间 `2025-01-04 17:44:00`
 * @项目ID 2991
 */
export interface ZlbBudgetAccountSubjectListTuoshouAccountSubjectGetRequest {
  orgId: string;
}

/**
 * 接口 [查询单位托收账户对应的科目↗](http://yapi.cai-inc.com/project/2991/interface/api/744954) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [会计科目↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_52940)
 * @请求头 `GET /zlb/budget/account/subject/list/tuoshou-account-subject`
 * @更新时间 `2025-01-04 17:44:00`
 * @项目ID 2991
 */
export interface ZlbBudgetAccountSubjectListTuoshouAccountSubjectGetResponse {
  success?: boolean;
  /**
   * [{"orgId":0,"uniqueCode":"","subjectCode":"","subjectName":"","year":0,"level":0,"leaf":0,"parentUniqueCode":"","balanceDirection":0,"remarks":"","isAmount":0,"amount":0,"availableAmount":0,"frozenAmount":0,"usedAmount":0,"cunkuanBankAccountCode":"","isTaizhang":0,"isZhichu":0}]
   */
  result?: {
    orgId?: number;
    uniqueCode?: string;
    subjectCode?: string;
    subjectName?: string;
    year?: number;
    level?: number;
    leaf?: number;
    parentUniqueCode?: string;
    balanceDirection?: number;
    remarks?: string;
    isAmount?: number;
    amount?: number;
    availableAmount?: number;
    frozenAmount?: number;
    usedAmount?: number;
    cunkuanBankAccountCode?: string;
    isTaizhang?: number;
    isZhichu?: number;
  }[];
  code?: string;
  message?: string;
}

/**
 * 接口 [查询单位托收账户对应的科目↗](http://yapi.cai-inc.com/project/2991/interface/api/744954) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [会计科目↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_52940)
 * @请求头 `GET /zlb/budget/account/subject/list/tuoshou-account-subject`
 * @更新时间 `2025-01-04 17:44:00`
 * @项目ID 2991
 */
type ZlbBudgetAccountSubjectListTuoshouAccountSubjectGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/account/subject/list/tuoshou-account-subject',
    'data',
    string,
    'orgId',
    false
  >
>;

/**
 * 接口 [查询单位托收账户对应的科目↗](http://yapi.cai-inc.com/project/2991/interface/api/744954) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [会计科目↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_52940)
 * @请求头 `GET /zlb/budget/account/subject/list/tuoshou-account-subject`
 * @更新时间 `2025-01-04 17:44:00`
 * @项目ID 2991
 */
const zlbBudgetAccountSubjectListTuoshouAccountSubjectGetRequestConfig: ZlbBudgetAccountSubjectListTuoshouAccountSubjectGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_7,
    devUrl: devUrl_0_4_0_7,
    prodUrl: prodUrl_0_4_0_7,
    path: '/zlb/budget/account/subject/list/tuoshou-account-subject',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_7,
    paramNames: [],
    queryNames: ['orgId'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbBudgetAccountSubjectListTuoshouAccountSubjectGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [查询单位托收账户对应的科目↗](http://yapi.cai-inc.com/project/2991/interface/api/744954) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [会计科目↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_52940)
 * @请求头 `GET /zlb/budget/account/subject/list/tuoshou-account-subject`
 * @更新时间 `2025-01-04 17:44:00`
 * @项目ID 2991
 */
export const zlbBudgetAccountSubjectListTuoshouAccountSubjectGet = /*#__PURE__*/ (
  requestData: ZlbBudgetAccountSubjectListTuoshouAccountSubjectGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetAccountSubjectListTuoshouAccountSubjectGetResponse>(
    prepare(zlbBudgetAccountSubjectListTuoshouAccountSubjectGetRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetAccountSubjectListTuoshouAccountSubjectGet.requestConfig =
  zlbBudgetAccountSubjectListTuoshouAccountSubjectGetRequestConfig;

/**
 * 接口 [通过文件导入↗](http://yapi.cai-inc.com/project/2991/interface/api/744962) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [会计科目↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_52940)
 * @请求头 `POST /zlb/budget/account/subject/importSubjectByExcel`
 * @更新时间 `2025-01-04 17:44:00`
 * @项目ID 2991
 */
export interface ZlbBudgetAccountSubjectImportSubjectByExcelPostRequest {
  file: FileData;
}

/**
 * 接口 [通过文件导入↗](http://yapi.cai-inc.com/project/2991/interface/api/744962) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [会计科目↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_52940)
 * @请求头 `POST /zlb/budget/account/subject/importSubjectByExcel`
 * @更新时间 `2025-01-04 17:44:00`
 * @项目ID 2991
 */
export interface ZlbBudgetAccountSubjectImportSubjectByExcelPostResponse {
  success?: boolean;
  result?: boolean;
  code?: string;
  message?: string;
}

/**
 * 接口 [通过文件导入↗](http://yapi.cai-inc.com/project/2991/interface/api/744962) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [会计科目↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_52940)
 * @请求头 `POST /zlb/budget/account/subject/importSubjectByExcel`
 * @更新时间 `2025-01-04 17:44:00`
 * @项目ID 2991
 */
type ZlbBudgetAccountSubjectImportSubjectByExcelPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/account/subject/importSubjectByExcel',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [通过文件导入↗](http://yapi.cai-inc.com/project/2991/interface/api/744962) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [会计科目↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_52940)
 * @请求头 `POST /zlb/budget/account/subject/importSubjectByExcel`
 * @更新时间 `2025-01-04 17:44:00`
 * @项目ID 2991
 */
const zlbBudgetAccountSubjectImportSubjectByExcelPostRequestConfig: ZlbBudgetAccountSubjectImportSubjectByExcelPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_7,
    devUrl: devUrl_0_4_0_7,
    prodUrl: prodUrl_0_4_0_7,
    path: '/zlb/budget/account/subject/importSubjectByExcel',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_7,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbBudgetAccountSubjectImportSubjectByExcelPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [通过文件导入↗](http://yapi.cai-inc.com/project/2991/interface/api/744962) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [会计科目↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_52940)
 * @请求头 `POST /zlb/budget/account/subject/importSubjectByExcel`
 * @更新时间 `2025-01-04 17:44:00`
 * @项目ID 2991
 */
export const zlbBudgetAccountSubjectImportSubjectByExcelPost = /*#__PURE__*/ (
  requestData: ZlbBudgetAccountSubjectImportSubjectByExcelPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetAccountSubjectImportSubjectByExcelPostResponse>(
    prepare(zlbBudgetAccountSubjectImportSubjectByExcelPostRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetAccountSubjectImportSubjectByExcelPost.requestConfig =
  zlbBudgetAccountSubjectImportSubjectByExcelPostRequestConfig;

const mockUrl_0_4_0_8 = 'http://yapi.cai-inc.com/mock/2991' as any;
const devUrl_0_4_0_8 = '' as any;
const prodUrl_0_4_0_8 = '' as any;
const dataKey_0_4_0_8 = 'data' as any;

/**
 * 接口 [经办人查询填报单信息，部门维度↗](http://yapi.cai-inc.com/project/2991/interface/api/580042) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [预算填报单↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54091)
 * @请求头 `GET /zlb/budget/ep/fill/order/info`
 * @更新时间 `2024-04-18 20:35:02`
 * @项目ID 2991
 */
export interface ZlbBudgetEpFillOrderInfoGetRequest {
  /**
   * 年度
   */
  year?: string;
  /**
   * 订单号
   */
  orderNo?: string;
  /**
   * 用户部门id
   */
  departmentId?: string;
}

/**
 * 接口 [经办人查询填报单信息，部门维度↗](http://yapi.cai-inc.com/project/2991/interface/api/580042) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [预算填报单↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54091)
 * @请求头 `GET /zlb/budget/ep/fill/order/info`
 * @更新时间 `2024-04-18 20:35:02`
 * @项目ID 2991
 */
export interface ZlbBudgetEpFillOrderInfoGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 申报单审核状态: init-未提交、progress-审批中、rejected-已驳回、completed-已完成、invalid-已作废
     */
    auditStatus?: string;
    /**
     * 申报单审核状态描述
     */
    auditStatusDesc?: string;
    /**
     * 填报状态，0-待下发，1-已下发
     */
    fillStatus?: number;
    /**
     * 填报状态描述
     */
    fillStatusDesc?: string;
    /**
     * 是否下发，0-待下发，1-已下发
     */
    pushed?: number;
    /**
     * 是否下发描述
     */
    pushedDesc?: string;
    /**
     * 总收入金额
     */
    incomeAmount?: number;
    /**
     * 收入预算执行率
     */
    incomeExecuteRate?: number;
    /**
     * 总支出金额
     */
    disburseAmount?: number;
    /**
     * 支出预算执行率
     */
    disburseExecuteRate?: number;
    /**
     * 部门名称
     */
    departmentName?: string;
    /**
     * 填报单部门id
     */
    departmentId?: number;
    /**
     * 年度
     */
    year?: number;
    /**
     * 已完成的填报单
     */
    completedFileOrderNum?: number;
    /**
     * 所有的填报单
     */
    allFillOrderNum?: number;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [经办人查询填报单信息，部门维度↗](http://yapi.cai-inc.com/project/2991/interface/api/580042) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [预算填报单↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54091)
 * @请求头 `GET /zlb/budget/ep/fill/order/info`
 * @更新时间 `2024-04-18 20:35:02`
 * @项目ID 2991
 */
type ZlbBudgetEpFillOrderInfoGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/ep/fill/order/info',
    'data',
    string,
    'year' | 'orderNo' | 'departmentId',
    false
  >
>;

/**
 * 接口 [经办人查询填报单信息，部门维度↗](http://yapi.cai-inc.com/project/2991/interface/api/580042) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [预算填报单↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54091)
 * @请求头 `GET /zlb/budget/ep/fill/order/info`
 * @更新时间 `2024-04-18 20:35:02`
 * @项目ID 2991
 */
const zlbBudgetEpFillOrderInfoGetRequestConfig: ZlbBudgetEpFillOrderInfoGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_8,
    devUrl: devUrl_0_4_0_8,
    prodUrl: prodUrl_0_4_0_8,
    path: '/zlb/budget/ep/fill/order/info',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_8,
    paramNames: [],
    queryNames: ['year', 'orderNo', 'departmentId'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbBudgetEpFillOrderInfoGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [经办人查询填报单信息，部门维度↗](http://yapi.cai-inc.com/project/2991/interface/api/580042) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [预算填报单↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54091)
 * @请求头 `GET /zlb/budget/ep/fill/order/info`
 * @更新时间 `2024-04-18 20:35:02`
 * @项目ID 2991
 */
export const zlbBudgetEpFillOrderInfoGet = /*#__PURE__*/ (
  requestData: ZlbBudgetEpFillOrderInfoGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetEpFillOrderInfoGetResponse>(
    prepare(zlbBudgetEpFillOrderInfoGetRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetEpFillOrderInfoGet.requestConfig = zlbBudgetEpFillOrderInfoGetRequestConfig;

/**
 * 接口 [填报单信息↗](http://yapi.cai-inc.com/project/2991/interface/api/580050) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [预算填报单↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54091)
 * @请求头 `GET /zlb/budget/ep/fill/order/statistic/info`
 * @更新时间 `2024-04-19 13:48:01`
 * @项目ID 2991
 */
export interface ZlbBudgetEpFillOrderStatisticInfoGetRequest {
  /**
   * 年度
   */
  year: string;
}

/**
 * 接口 [填报单信息↗](http://yapi.cai-inc.com/project/2991/interface/api/580050) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [预算填报单↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54091)
 * @请求头 `GET /zlb/budget/ep/fill/order/statistic/info`
 * @更新时间 `2024-04-19 13:48:01`
 * @项目ID 2991
 */
export interface ZlbBudgetEpFillOrderStatisticInfoGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 申报单审核状态: init-未提交、progress-审批中、rejected-已驳回、completed-已完成、invalid-已作废
     */
    auditStatus?: string;
    /**
     * 申报单审核状态描述
     */
    auditStatusDesc?: string;
    /**
     * 填报状态，0-待下发，1-已下发
     */
    fillStatus?: number;
    /**
     * 填报状态描述
     */
    fillStatusDesc?: string;
    /**
     * 是否下发，0-待下发，1-已下发
     */
    pushed?: number;
    /**
     * 是否下发描述
     */
    pushedDesc?: string;
    /**
     * 总收入金额
     */
    incomeAmount?: number;
    /**
     * 收入预算执行率
     */
    incomeExecuteRate?: number;
    /**
     * 总支出金额
     */
    disburseAmount?: number;
    /**
     * 支出预算执行率
     */
    disburseExecuteRate?: number;
    /**
     * 部门名称
     */
    departmentName?: string;
    /**
     * 填报单部门id
     */
    departmentId?: number;
    /**
     * 年度
     */
    year?: number;
    /**
     * 已完成的填报单
     */
    completedFileOrderNum?: number;
    /**
     * 所有的填报单
     */
    allFillOrderNum?: number;
    /**
     * 已完成填报的部门
     */
    completedFillDeps?: string;
    /**
     * 已完成填报的部门
     */
    noCompletedFillDeps?: string;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [填报单信息↗](http://yapi.cai-inc.com/project/2991/interface/api/580050) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [预算填报单↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54091)
 * @请求头 `GET /zlb/budget/ep/fill/order/statistic/info`
 * @更新时间 `2024-04-19 13:48:01`
 * @项目ID 2991
 */
type ZlbBudgetEpFillOrderStatisticInfoGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/ep/fill/order/statistic/info',
    'data',
    string,
    'year',
    false
  >
>;

/**
 * 接口 [填报单信息↗](http://yapi.cai-inc.com/project/2991/interface/api/580050) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [预算填报单↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54091)
 * @请求头 `GET /zlb/budget/ep/fill/order/statistic/info`
 * @更新时间 `2024-04-19 13:48:01`
 * @项目ID 2991
 */
const zlbBudgetEpFillOrderStatisticInfoGetRequestConfig: ZlbBudgetEpFillOrderStatisticInfoGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_8,
    devUrl: devUrl_0_4_0_8,
    prodUrl: prodUrl_0_4_0_8,
    path: '/zlb/budget/ep/fill/order/statistic/info',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_8,
    paramNames: [],
    queryNames: ['year'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbBudgetEpFillOrderStatisticInfoGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [填报单信息↗](http://yapi.cai-inc.com/project/2991/interface/api/580050) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [预算填报单↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54091)
 * @请求头 `GET /zlb/budget/ep/fill/order/statistic/info`
 * @更新时间 `2024-04-19 13:48:01`
 * @项目ID 2991
 */
export const zlbBudgetEpFillOrderStatisticInfoGet = /*#__PURE__*/ (
  requestData: ZlbBudgetEpFillOrderStatisticInfoGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetEpFillOrderStatisticInfoGetResponse>(
    prepare(zlbBudgetEpFillOrderStatisticInfoGetRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetEpFillOrderStatisticInfoGet.requestConfig =
  zlbBudgetEpFillOrderStatisticInfoGetRequestConfig;

/**
 * 接口 [年度预算_下发↗](http://yapi.cai-inc.com/project/2991/interface/api/587938) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [预算填报单↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54091)
 * @请求头 `POST /zlb/budget/ep/fill/order/statistic/push`
 * @更新时间 `2023-12-08 11:41:17`
 * @项目ID 2991
 */
export interface ZlbBudgetEpFillOrderStatisticPushPostRequest {
  /**
   * 年度
   */
  year: number;
}

/**
 * 接口 [年度预算_下发↗](http://yapi.cai-inc.com/project/2991/interface/api/587938) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [预算填报单↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54091)
 * @请求头 `POST /zlb/budget/ep/fill/order/statistic/push`
 * @更新时间 `2023-12-08 11:41:17`
 * @项目ID 2991
 */
export interface ZlbBudgetEpFillOrderStatisticPushPostResponse {
  success?: boolean;
  result?: boolean;
  code?: string;
  message?: string;
}

/**
 * 接口 [年度预算_下发↗](http://yapi.cai-inc.com/project/2991/interface/api/587938) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [预算填报单↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54091)
 * @请求头 `POST /zlb/budget/ep/fill/order/statistic/push`
 * @更新时间 `2023-12-08 11:41:17`
 * @项目ID 2991
 */
type ZlbBudgetEpFillOrderStatisticPushPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/ep/fill/order/statistic/push',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [年度预算_下发↗](http://yapi.cai-inc.com/project/2991/interface/api/587938) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [预算填报单↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54091)
 * @请求头 `POST /zlb/budget/ep/fill/order/statistic/push`
 * @更新时间 `2023-12-08 11:41:17`
 * @项目ID 2991
 */
const zlbBudgetEpFillOrderStatisticPushPostRequestConfig: ZlbBudgetEpFillOrderStatisticPushPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_8,
    devUrl: devUrl_0_4_0_8,
    prodUrl: prodUrl_0_4_0_8,
    path: '/zlb/budget/ep/fill/order/statistic/push',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_8,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbBudgetEpFillOrderStatisticPushPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [年度预算_下发↗](http://yapi.cai-inc.com/project/2991/interface/api/587938) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [预算填报单↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54091)
 * @请求头 `POST /zlb/budget/ep/fill/order/statistic/push`
 * @更新时间 `2023-12-08 11:41:17`
 * @项目ID 2991
 */
export const zlbBudgetEpFillOrderStatisticPushPost = /*#__PURE__*/ (
  requestData: ZlbBudgetEpFillOrderStatisticPushPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetEpFillOrderStatisticPushPostResponse>(
    prepare(zlbBudgetEpFillOrderStatisticPushPostRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetEpFillOrderStatisticPushPost.requestConfig =
  zlbBudgetEpFillOrderStatisticPushPostRequestConfig;

/**
 * 接口 [财务查询填报单信息，部门维度↗](http://yapi.cai-inc.com/project/2991/interface/api/588346) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [预算填报单↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54091)
 * @请求头 `GET /zlb/budget/ep/fill/order/finance/info`
 * @更新时间 `2023-12-08 11:41:17`
 * @项目ID 2991
 */
export interface ZlbBudgetEpFillOrderFinanceInfoGetRequest {
  /**
   * 年度
   */
  year?: string;
  /**
   * 订单号
   */
  orderNo?: string;
}

/**
 * 接口 [财务查询填报单信息，部门维度↗](http://yapi.cai-inc.com/project/2991/interface/api/588346) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [预算填报单↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54091)
 * @请求头 `GET /zlb/budget/ep/fill/order/finance/info`
 * @更新时间 `2023-12-08 11:41:17`
 * @项目ID 2991
 */
export interface ZlbBudgetEpFillOrderFinanceInfoGetResponse {
  success?: boolean;
  result?: {
    /**
     * 申报单审核状态: init-未提交、progress-审批中、rejected-已驳回、completed-已完成、invalid-已作废
     */
    auditStatus?: string;
    /**
     * 申报单审核状态描述
     */
    auditStatusDesc?: string;
    /**
     * 填报状态，0-待下发，1-已下发
     */
    fillStatus?: number;
    /**
     * 填报状态描述
     */
    fillStatusDesc?: string;
    /**
     * 是否下发，0-待下发，1-已下发
     */
    pushed?: number;
    /**
     * 是否下发描述
     */
    pushedDesc?: string;
    /**
     * 总收入金额
     */
    incomeAmount?: number;
    /**
     * 总支出金额
     */
    disburseAmount?: number;
    /**
     * 部门名称
     */
    departmentName?: string;
    /**
     * 年度
     */
    year?: number;
    /**
     * 已完成的填报单
     */
    completedFileOrderNum?: number;
    /**
     * 所有的填报单
     */
    allFillOrderNum?: number;
  };
  code?: string;
  message?: string;
}

/**
 * 接口 [财务查询填报单信息，部门维度↗](http://yapi.cai-inc.com/project/2991/interface/api/588346) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [预算填报单↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54091)
 * @请求头 `GET /zlb/budget/ep/fill/order/finance/info`
 * @更新时间 `2023-12-08 11:41:17`
 * @项目ID 2991
 */
type ZlbBudgetEpFillOrderFinanceInfoGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/ep/fill/order/finance/info',
    'data',
    string,
    'year' | 'orderNo',
    false
  >
>;

/**
 * 接口 [财务查询填报单信息，部门维度↗](http://yapi.cai-inc.com/project/2991/interface/api/588346) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [预算填报单↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54091)
 * @请求头 `GET /zlb/budget/ep/fill/order/finance/info`
 * @更新时间 `2023-12-08 11:41:17`
 * @项目ID 2991
 */
const zlbBudgetEpFillOrderFinanceInfoGetRequestConfig: ZlbBudgetEpFillOrderFinanceInfoGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_8,
    devUrl: devUrl_0_4_0_8,
    prodUrl: prodUrl_0_4_0_8,
    path: '/zlb/budget/ep/fill/order/finance/info',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_8,
    paramNames: [],
    queryNames: ['year', 'orderNo'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbBudgetEpFillOrderFinanceInfoGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [财务查询填报单信息，部门维度↗](http://yapi.cai-inc.com/project/2991/interface/api/588346) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [预算填报单↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54091)
 * @请求头 `GET /zlb/budget/ep/fill/order/finance/info`
 * @更新时间 `2023-12-08 11:41:17`
 * @项目ID 2991
 */
export const zlbBudgetEpFillOrderFinanceInfoGet = /*#__PURE__*/ (
  requestData: ZlbBudgetEpFillOrderFinanceInfoGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetEpFillOrderFinanceInfoGetResponse>(
    prepare(zlbBudgetEpFillOrderFinanceInfoGetRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetEpFillOrderFinanceInfoGet.requestConfig = zlbBudgetEpFillOrderFinanceInfoGetRequestConfig;

const mockUrl_0_4_0_9 = 'http://yapi.cai-inc.com/mock/2991' as any;
const devUrl_0_4_0_9 = '' as any;
const prodUrl_0_4_0_9 = '' as any;
const dataKey_0_4_0_9 = 'data' as any;

/**
 * 接口 [获取导入结果↗](http://yapi.cai-inc.com/project/2991/interface/api/579418) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [预算填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54092)
 * @请求头 `GET /zlb/budget/ep/fill/record/import/result`
 * @更新时间 `2024-09-23 14:47:44`
 * @项目ID 2991
 */
export interface ZlbBudgetEpFillRecordImportResultGetRequest {
  /**
   * 任务编码
   */
  serialCode: string;
}

/**
 * 接口 [获取导入结果↗](http://yapi.cai-inc.com/project/2991/interface/api/579418) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [预算填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54092)
 * @请求头 `GET /zlb/budget/ep/fill/record/import/result`
 * @更新时间 `2024-09-23 14:47:44`
 * @项目ID 2991
 */
export interface ZlbBudgetEpFillRecordImportResultGetResponse {
  success?: boolean;
  result?: {
    /**
     * 导入总条数
     */
    totalNum?: number;
    /**
     * 成功条数
     */
    successNum?: number;
    /**
     * 失败条数
     */
    failNum?: number;
    /**
     * 完整fileId
     */
    failFileId?: string;
    message?: string;
    serialCode?: string;
    operatorId?: number;
    orgId?: number;
    operatorName?: string;
    /**
     * 任务状态
     */
    status?: number;
    /**
     * 异常统计
     */
    errStatistics?: {
      /**
       * 错误提示
       */
      errMsg?: string;
      /**
       * 错误编码
       */
      code?:
        | 10001
        | 10002
        | 10003
        | 10004
        | 10005
        | 10006
        | 10007
        | 10008
        | 10009
        | 10010
        | 10011
        | 10012
        | 10013
        | 10014
        | 10015
        | 10016
        | 10017
        | 10018
        | 10019
        | 10020
        | 10021
        | 10022
        | 10023
        | 10024
        | 'DEPARTMENT_NAME_ERROR'
        | 'PROJECT_CODE'
        | 'PROJECT_NAME'
        | 'OWN_DEPARTMENT_NAME'
        | 'SUBJECT_CODE'
        | 'SUBJECT_NAME'
        | 'YEAR_AMOUNT'
        | 'Q1_AMOUNT'
        | 'Q2_AMOUNT'
        | 'Q3_AMOUNT'
        | 'Q4_AMOUNT'
        | 'M1_AMOUNT'
        | 'M2_AMOUNT'
        | 'M3_AMOUNT'
        | 'M4_AMOUNT'
        | 'M5_AMOUNT'
        | 'M6_AMOUNT'
        | 'M7_AMOUNT'
        | 'M8_AMOUNT'
        | 'M9_AMOUNT'
        | 'M10_AMOUNT'
        | 'M11_AMOUNT'
        | 'M12_AMOUNT'
        | 'FILL_INSTRUCTION';
    }[];
  };
  code?: string;
  message?: string;
}

/**
 * 接口 [获取导入结果↗](http://yapi.cai-inc.com/project/2991/interface/api/579418) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [预算填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54092)
 * @请求头 `GET /zlb/budget/ep/fill/record/import/result`
 * @更新时间 `2024-09-23 14:47:44`
 * @项目ID 2991
 */
type ZlbBudgetEpFillRecordImportResultGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/ep/fill/record/import/result',
    'data',
    string,
    'serialCode',
    false
  >
>;

/**
 * 接口 [获取导入结果↗](http://yapi.cai-inc.com/project/2991/interface/api/579418) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [预算填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54092)
 * @请求头 `GET /zlb/budget/ep/fill/record/import/result`
 * @更新时间 `2024-09-23 14:47:44`
 * @项目ID 2991
 */
const zlbBudgetEpFillRecordImportResultGetRequestConfig: ZlbBudgetEpFillRecordImportResultGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_9,
    devUrl: devUrl_0_4_0_9,
    prodUrl: prodUrl_0_4_0_9,
    path: '/zlb/budget/ep/fill/record/import/result',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_9,
    paramNames: [],
    queryNames: ['serialCode'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbBudgetEpFillRecordImportResultGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [获取导入结果↗](http://yapi.cai-inc.com/project/2991/interface/api/579418) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [预算填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54092)
 * @请求头 `GET /zlb/budget/ep/fill/record/import/result`
 * @更新时间 `2024-09-23 14:47:44`
 * @项目ID 2991
 */
export const zlbBudgetEpFillRecordImportResultGet = /*#__PURE__*/ (
  requestData: ZlbBudgetEpFillRecordImportResultGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetEpFillRecordImportResultGetResponse>(
    prepare(zlbBudgetEpFillRecordImportResultGetRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetEpFillRecordImportResultGet.requestConfig =
  zlbBudgetEpFillRecordImportResultGetRequestConfig;

/**
 * 接口 [获取导出结果↗](http://yapi.cai-inc.com/project/2991/interface/api/579434) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [预算填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54092)
 * @请求头 `GET /zlb/budget/ep/fill/record/export/result`
 * @更新时间 `2024-09-23 14:47:44`
 * @项目ID 2991
 */
export interface ZlbBudgetEpFillRecordExportResultGetRequest {
  /**
   * 任务编码
   */
  serialCode: string;
}

/**
 * 接口 [获取导出结果↗](http://yapi.cai-inc.com/project/2991/interface/api/579434) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [预算填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54092)
 * @请求头 `GET /zlb/budget/ep/fill/record/export/result`
 * @更新时间 `2024-09-23 14:47:44`
 * @项目ID 2991
 */
export interface ZlbBudgetEpFillRecordExportResultGetResponse {
  success?: boolean;
  result?: {
    /**
     * 总数
     */
    totalNum?: number;
    /**
     * 成功数量
     */
    successNum?: number;
    /**
     * 失败数量
     */
    failNum?: number;
    /**
     * 成功FileId
     */
    successFileId?: string;
    /**
     * 任务状态
     */
    status?: number;
    /**
     * 任务编号
     */
    serialCode?: string;
    message?: string;
  };
  code?: string;
  message?: string;
}

/**
 * 接口 [获取导出结果↗](http://yapi.cai-inc.com/project/2991/interface/api/579434) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [预算填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54092)
 * @请求头 `GET /zlb/budget/ep/fill/record/export/result`
 * @更新时间 `2024-09-23 14:47:44`
 * @项目ID 2991
 */
type ZlbBudgetEpFillRecordExportResultGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/ep/fill/record/export/result',
    'data',
    string,
    'serialCode',
    false
  >
>;

/**
 * 接口 [获取导出结果↗](http://yapi.cai-inc.com/project/2991/interface/api/579434) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [预算填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54092)
 * @请求头 `GET /zlb/budget/ep/fill/record/export/result`
 * @更新时间 `2024-09-23 14:47:44`
 * @项目ID 2991
 */
const zlbBudgetEpFillRecordExportResultGetRequestConfig: ZlbBudgetEpFillRecordExportResultGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_9,
    devUrl: devUrl_0_4_0_9,
    prodUrl: prodUrl_0_4_0_9,
    path: '/zlb/budget/ep/fill/record/export/result',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_9,
    paramNames: [],
    queryNames: ['serialCode'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbBudgetEpFillRecordExportResultGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [获取导出结果↗](http://yapi.cai-inc.com/project/2991/interface/api/579434) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [预算填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54092)
 * @请求头 `GET /zlb/budget/ep/fill/record/export/result`
 * @更新时间 `2024-09-23 14:47:44`
 * @项目ID 2991
 */
export const zlbBudgetEpFillRecordExportResultGet = /*#__PURE__*/ (
  requestData: ZlbBudgetEpFillRecordExportResultGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetEpFillRecordExportResultGetResponse>(
    prepare(zlbBudgetEpFillRecordExportResultGetRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetEpFillRecordExportResultGet.requestConfig =
  zlbBudgetEpFillRecordExportResultGetRequestConfig;

/**
 * 接口 [经办人使用-分页查询项目下的填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/580058) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [预算填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54092)
 * @请求头 `GET /zlb/budget/ep/fill/record/agent/list`
 * @更新时间 `2024-09-23 14:47:42`
 * @项目ID 2991
 */
export interface ZlbBudgetEpFillRecordAgentListGetRequest {
  pageSize?: string;
  pageNo?: string;
  sortField?: string;
  sortBy?: string;
  /**
   * 项目唯一编码
   */
  projectUk?: string;
  /**
   * 科目唯一编码
   */
  subjectUk?: string;
  /**
   * 科目分类：income-收入,disburse-支出
   */
  classify?: string;
  /**
   * 年度
   */
  year: string;
  /**
   * 用户部门id
   */
  departmentId?: string;
}

/**
 * 接口 [经办人使用-分页查询项目下的填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/580058) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [预算填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54092)
 * @请求头 `GET /zlb/budget/ep/fill/record/agent/list`
 * @更新时间 `2024-09-23 14:47:42`
 * @项目ID 2991
 */
export interface ZlbBudgetEpFillRecordAgentListGetResponse {
  success?: boolean;
  result?: {
    /**
     * 项目信息
     */
    projects?: {
      /**
       * 总记录数
       */
      total?: number;
      /**
       * 结果集
       */
      data?: {
        /**
         * 填报记录数据
         */
        list?: {
          id?: number;
          /**
           * 填报记录唯一uk
           */
          uk?: string;
          /**
           * 责任部门id
           */
          responsibleDepartmentId?: number;
          /**
           * 责任部门名称
           */
          responsibleDepartmentName?: string;
          /**
           * 填报部门id
           */
          fillDepartmentId?: number;
          /**
           * 填报部门名称
           */
          fillDepartmentName?: string;
          /**
           * 项目唯一编码
           */
          projectUk?: string;
          /**
           * 科目唯一编码
           */
          subjectUk?: string;
          /**
           * 科目名称
           */
          subjectName?: string;
          /**
           * 填报方式
           */
          fillMethod?: string;
          /**
           * 科目类型
           */
          subjectType?: string;
          /**
           * 年度
           */
          year?: number;
          /**
           * 年度金额
           */
          yearAmount?: number;
          /**
           * 季度金额
           */
          q1Amount?: number;
          q2Amount?: number;
          q3Amount?: number;
          q4Amount?: number;
          /**
           * 月度金额
           */
          m1Amount?: number;
          m2Amount?: number;
          m3Amount?: number;
          m4Amount?: number;
          m5Amount?: number;
          m6Amount?: number;
          m7Amount?: number;
          m8Amount?: number;
          m9Amount?: number;
          m10Amount?: number;
          m11Amount?: number;
          m12Amount?: number;
          /**
           * 年度金额
           */
          originalYearAmount?: number;
          /**
           * 季度金额
           */
          originalQ1Amount?: number;
          originalQ2Amount?: number;
          originalQ3Amount?: number;
          originalQ4Amount?: number;
          /**
           * 月度金额
           */
          originalM1Amount?: number;
          originalM2Amount?: number;
          originalM3Amount?: number;
          originalM4Amount?: number;
          originalM5Amount?: number;
          originalM6Amount?: number;
          originalM7Amount?: number;
          originalM8Amount?: number;
          originalM9Amount?: number;
          originalM10Amount?: number;
          originalM11Amount?: number;
          originalM12Amount?: number;
          /**
           * 预算金额，分
           */
          budgetAmount?: number;
          /**
           * 预算金额同比上年变化（格式 +0.89% -1.23%）
           */
          budgetAmountYearOverYearChange?: string;
          /**
           * 预算金额，分
           */
          originalBudgetAmount?: number;
          /**
           * 执行金额
           */
          executeAmount?: number;
          /**
           * 执行金额同比变化（格式 +0.89% -1.23%）
           */
          executeAmountYearOverYearChange?: string;
          /**
           * 执行金额环比变化（格式 +0.89% -1.23%）
           */
          executeAmountMonthOverMonthChange?: string;
          /**
           * 冻结金额
           */
          freezeAmount?: number;
          /**
           * 在途金额
           */
          inTransitAmount?: number;
          /**
           * 可用金额
           */
          availableAmount?: number;
          /**
           * 预算执行率
           */
          executeRate?: string;
          /**
           * 预算执行率同比变化（格式 +0.89% -1.23%）
           */
          executeRateYearOverYearChange?: string;
          /**
           * 预算执行率环比变化（格式 +0.89% -1.23%）
           */
          executeRateMonthOverMonthChange?: string;
          /**
           * 科目备注
           */
          subjectRemark?: string;
          /**
           * 填报说明
           */
          fillInstruction?: string;
          /**
           * 科目类型描述
           */
          subjectTypeDesc?: string;
          /**
           * 预算项目使用唯一uk
           */
          useUk?: string;
          /**
           * 限制使用人员集合
           */
          useOperatorList?: {
            id?: number;
            name?: string;
          }[];
          /**
           * 状态
           */
          status?: 'NORMAL' | 'FROZEN' | 'TRANSFERRED' | 'ADJUSTING';
          /**
           * 是否是结转过来的（1-是 0-否）
           */
          isFromTransferred?: number;
          /**
           * 结转金额
           */
          transferredAmount?: number;
          /**
           * 项目结转code
           */
          projectCode?: string;
          /**
           * 科目结转code
           */
          subjectCode?: string;
          /**
           * 操作按钮
           */
          operatorBtn?: {
            /**
             * 限制人员是否展示
             */
            limitPersonBtn?: boolean;
            /**
             * 冻结
             */
            frozenBtn?: boolean;
            /**
             * 解冻
             */
            unFrozenBtn?: boolean;
            /**
             * 结转
             */
            transferBtn?: boolean;
            /**
             * 日志
             */
            logBtn?: boolean;
          };
        }[];
        /**
         * 项目唯一编码
         */
        projectUk?: string;
        /**
         * 项目唯一编码
         */
        projectName?: string;
        /**
         * 是否是结转过来的项目 1-是 0-否
         */
        isFromTransferred?: number;
        /**
         * 原始收入金额
         */
        originalIncomeAmount?: number;
        /**
         * 收入金额
         */
        incomeAmount?: number;
        /**
         * 收入执行金额
         */
        incomeExecuteAmount?: number;
        /**
         * 收入冻结金额
         */
        incomeFreezeAmount?: number;
        /**
         * 收入在途金额
         */
        incomeInTransitAmount?: number;
        /**
         * 收入可用金额
         */
        incomeAvailableAmount?: number;
        /**
         * 收入预算执行率
         */
        incomeExecuteRate?: string;
        /**
         * 调整前收入金额较上年变化
         */
        originalIncomeChangeFromLastYear?: number;
        /**
         * 收入金额较上年变化
         */
        incomeChangeFromLastYear?: number;
        /**
         * 上年预算收入金额
         */
        lastYearIncomeAmount?: number;
        /**
         * 上年预算收入执行率
         */
        lastYearIncomeExecuteRate?: number;
        /**
         * 预计全年收入执行金额
         */
        annualIncomeExecuteAmount?: number;
        /**
         * 收入情况说明
         */
        incomeSituationDesc?: string;
        /**
         * 收入浮动比例控制下限
         */
        incomeFloatingRatioMin?: number;
        /**
         * 收入浮动比例控制上限
         */
        incomeFloatingRatioMax?: number;
        /**
         * 原始支出金额
         */
        originalDisburseAmount?: number;
        /**
         * 支出金额
         */
        disburseAmount?: number;
        /**
         * 支出执行金额
         */
        disburseExecuteAmount?: number;
        /**
         * 支出冻结金额
         */
        disburseFreezeAmount?: number;
        /**
         * 支出在途金额
         */
        disburseInTransitAmount?: number;
        /**
         * 支出可用金额
         */
        disburseAvailableAmount?: number;
        /**
         * 支出预算执行率
         */
        disburseExecuteRate?: string;
        /**
         * 调整前支出金额较上年变化
         */
        originalDisburseChangeFromLastYear?: number;
        /**
         * 支出金额较上年变化
         */
        disburseChangeFromLastYear?: number;
        /**
         * 上年预算支出金额
         */
        lastYearDisburseAmount?: number;
        /**
         * 上年预算支出执行率
         */
        lastYearDisburseExecuteRate?: number;
        /**
         * 预计全年支出执行金额
         */
        annualDisburseExecuteAmount?: number;
        /**
         * 支出情况说明
         */
        disburseSituationDesc?: string;
        /**
         * 支出浮动比例控制下限
         */
        disburseFloatingRatioMin?: number;
        /**
         * 支出浮动比例控制上限
         */
        disburseFloatingRatioMax?: number;
        /**
         * 截止月份
         */
        cutoffMonth?: number;
        /**
         * 项目编码
         */
        projectCode?: string;
        /**
         * 项目类型
         */
        projectType?: string;
        projectRemark?: string;
        /**
         * 收入是否超过比例0-未超过 1-超过
         */
        incomeIsExceedRatio?: number;
        /**
         * 支出是否超过比例0-未超过 1-超过
         */
        disburseIsExceedRatio?: number;
        /**
         * 项目申报金额
         */
        projectReportAmount?: number;
        /**
         * 是否有实际采购 0-无 1-有
         */
        isActualPurchase?: number;
      }[];
      /**
       * 第几页
       */
      pageNum?: number;
      /**
       * 每页记录数
       */
      pageSize?: number;
      /**
       * 总页数
       */
      pages?: number;
      /**
       * 当前页的数量 <= pageSize，该属性来自ArrayList的size属性
       */
      size?: number;
    };
    /**
     * 工作流权限按钮
     */
    authButton?: {
      /**
       * 是否能导入
       */
      enableImport?: boolean;
      /**
       * 是否能加签
       */
      enableAddNode?: boolean;
      /**
       * 是否能审批驳回
       */
      enableCancel?: boolean;
      /**
       * 是否能审批通过
       */
      enablePass?: boolean;
      /**
       * 是否能够添加科目
       */
      enableAddSubject?: boolean;
      /**
       * 是否能够删除科目
       */
      enableDelete?: boolean;
      /**
       * 是否能够撤回
       */
      enableRevoke?: boolean;
      /**
       * 能否下发
       */
      enablePush?: boolean;
      /**
       * 是否能够查看
       */
      enableView?: boolean;
      /**
       * 是否能够编辑
       */
      enableEdit?: boolean;
    };
    /**
     * 最近保存时间
     */
    lastSaveTime?: number;
    /**
     * 填报方式
     */
    fillMethod?: string;
    /**
     * 预算填报单唯一单号
     */
    orderNo?: string;
    /**
     * 审核状态
     */
    auditStatus?: string;
    /**
     * 填报单部门id
     */
    departmentId?: number;
    /**
     * 附件信息
     */
    attachmentList?: {
      id?: number;
      /**
       * 附件OssId
       */
      fileId?: string;
      /**
       * 附件url
       */
      url?: string;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 附件名称
       */
      name?: string;
      /**
       * 附件大小
       */
      size?: number;
    }[];
  };
  code?: string;
  message?: string;
}

/**
 * 接口 [经办人使用-分页查询项目下的填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/580058) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [预算填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54092)
 * @请求头 `GET /zlb/budget/ep/fill/record/agent/list`
 * @更新时间 `2024-09-23 14:47:42`
 * @项目ID 2991
 */
type ZlbBudgetEpFillRecordAgentListGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/ep/fill/record/agent/list',
    'data',
    string,
    | 'pageSize'
    | 'pageNo'
    | 'sortField'
    | 'sortBy'
    | 'projectUk'
    | 'subjectUk'
    | 'classify'
    | 'year'
    | 'departmentId',
    false
  >
>;

/**
 * 接口 [经办人使用-分页查询项目下的填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/580058) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [预算填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54092)
 * @请求头 `GET /zlb/budget/ep/fill/record/agent/list`
 * @更新时间 `2024-09-23 14:47:42`
 * @项目ID 2991
 */
const zlbBudgetEpFillRecordAgentListGetRequestConfig: ZlbBudgetEpFillRecordAgentListGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_9,
    devUrl: devUrl_0_4_0_9,
    prodUrl: prodUrl_0_4_0_9,
    path: '/zlb/budget/ep/fill/record/agent/list',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_9,
    paramNames: [],
    queryNames: [
      'pageSize',
      'pageNo',
      'sortField',
      'sortBy',
      'projectUk',
      'subjectUk',
      'classify',
      'year',
      'departmentId',
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbBudgetEpFillRecordAgentListGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [经办人使用-分页查询项目下的填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/580058) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [预算填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54092)
 * @请求头 `GET /zlb/budget/ep/fill/record/agent/list`
 * @更新时间 `2024-09-23 14:47:42`
 * @项目ID 2991
 */
export const zlbBudgetEpFillRecordAgentListGet = /*#__PURE__*/ (
  requestData: ZlbBudgetEpFillRecordAgentListGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetEpFillRecordAgentListGetResponse>(
    prepare(zlbBudgetEpFillRecordAgentListGetRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetEpFillRecordAgentListGet.requestConfig = zlbBudgetEpFillRecordAgentListGetRequestConfig;

/**
 * 接口 [财务审批审核使用-分页查询项目下的填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/580066) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [预算填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54092)
 * @请求头 `GET /zlb/budget/ep/fill/record/finance/list`
 * @更新时间 `2024-11-14 10:55:36`
 * @项目ID 2991
 */
export interface ZlbBudgetEpFillRecordFinanceListGetRequest {
  /**
   * 填报单编码
   */
  orderNo: string;
  /**
   * 工作流流程编号
   */
  workflowProcessNo: string;
  /**
   * special-特殊情况，已处理下无需展示按钮
   */
  identity?: string;
  /**
   * 项目唯一编码
   */
  projectUk?: string;
  /**
   * 科目唯一编码
   */
  subjectUk?: string;
  /**
   * 科目分类：income-收入,disburse-支出
   */
  classify?: string;
  /**
   * 年度
   */
  year: string;
  /**
   * 用户部门id
   */
  departmentId?: string;
  /**
   * 页面大小
   */
  pageSize?: string;
  /**
   * 页码
   */
  pageNo?: string;
  /**
   * 排序字段
   */
  sortField?: string;
  /**
   * 排序规则：DESC || ASC
   */
  sortBy?: string;
}

/**
 * 接口 [财务审批审核使用-分页查询项目下的填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/580066) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [预算填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54092)
 * @请求头 `GET /zlb/budget/ep/fill/record/finance/list`
 * @更新时间 `2024-11-14 10:55:36`
 * @项目ID 2991
 */
export interface ZlbBudgetEpFillRecordFinanceListGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 项目信息
     */
    projects?: {
      /**
       * 总记录数
       */
      total?: number;
      /**
       * 结果集
       */
      data?: {
        /**
         * 填报记录数据
         */
        list?: {
          id?: number;
          /**
           * 填报记录唯一uk
           */
          uk?: string;
          /**
           * 责任部门id
           */
          responsibleDepartmentId?: number;
          /**
           * 责任部门名称
           */
          responsibleDepartmentName?: string;
          /**
           * 填报部门id
           */
          fillDepartmentId?: number;
          /**
           * 填报部门名称
           */
          fillDepartmentName?: string;
          /**
           * 项目唯一编码
           */
          projectUk?: string;
          /**
           * 科目唯一编码
           */
          subjectUk?: string;
          /**
           * 科目名称
           */
          subjectName?: string;
          /**
           * 填报方式
           */
          fillMethod?: string;
          /**
           * 科目类型
           */
          subjectType?: string;
          /**
           * 年度
           */
          year?: number;
          /**
           * 年度金额
           */
          yearAmount?: number;
          /**
           * 季度金额
           */
          q1Amount?: number;
          q2Amount?: number;
          q3Amount?: number;
          q4Amount?: number;
          /**
           * 月度金额
           */
          m1Amount?: number;
          m2Amount?: number;
          m3Amount?: number;
          m4Amount?: number;
          m5Amount?: number;
          m6Amount?: number;
          m7Amount?: number;
          m8Amount?: number;
          m9Amount?: number;
          m10Amount?: number;
          m11Amount?: number;
          m12Amount?: number;
          /**
           * 年度金额
           */
          originalYearAmount?: number;
          /**
           * 季度金额
           */
          originalQ1Amount?: number;
          originalQ2Amount?: number;
          originalQ3Amount?: number;
          originalQ4Amount?: number;
          /**
           * 月度金额
           */
          originalM1Amount?: number;
          originalM2Amount?: number;
          originalM3Amount?: number;
          originalM4Amount?: number;
          originalM5Amount?: number;
          originalM6Amount?: number;
          originalM7Amount?: number;
          originalM8Amount?: number;
          originalM9Amount?: number;
          originalM10Amount?: number;
          originalM11Amount?: number;
          originalM12Amount?: number;
          /**
           * 预算金额，分
           */
          budgetAmount?: number;
          /**
           * 预算金额同比上年变化（格式 +0.89% -1.23%）
           */
          budgetAmountYearOverYearChange?: string;
          /**
           * 预算金额，分
           */
          originalBudgetAmount?: number;
          /**
           * 执行金额
           */
          executeAmount?: number;
          /**
           * 执行金额同比变化（格式 +0.89% -1.23%）
           */
          executeAmountYearOverYearChange?: string;
          /**
           * 执行金额环比变化（格式 +0.89% -1.23%）
           */
          executeAmountMonthOverMonthChange?: string;
          /**
           * 冻结金额
           */
          freezeAmount?: number;
          /**
           * 在途金额
           */
          inTransitAmount?: number;
          /**
           * 可用金额
           */
          availableAmount?: number;
          /**
           * 预算执行率
           */
          executeRate?: string;
          /**
           * 预算执行率同比变化（格式 +0.89% -1.23%）
           */
          executeRateYearOverYearChange?: string;
          /**
           * 预算执行率环比变化（格式 +0.89% -1.23%）
           */
          executeRateMonthOverMonthChange?: string;
          /**
           * 科目备注
           */
          subjectRemark?: string;
          /**
           * 填报说明
           */
          fillInstruction?: string;
          /**
           * 科目类型描述
           */
          subjectTypeDesc?: string;
          /**
           * 预算项目使用唯一uk
           */
          useUk?: string;
          /**
           * 限制使用人员集合
           */
          useOperatorList?: {
            id?: number;
            name?: string;
          }[];
          /**
           * 状态
           */
          status?: 'NORMAL' | 'FROZEN' | 'TRANSFERRED' | 'ADJUSTING';
          /**
           * 是否是结转过来的（1-是 0-否）
           */
          isFromTransferred?: number;
          /**
           * 结转金额
           */
          transferredAmount?: number;
          /**
           * 项目结转code
           */
          projectCode?: string;
          /**
           * 科目结转code
           */
          subjectCode?: string;
          /**
           * 操作按钮
           */
          operatorBtn?: {
            /**
             * 限制人员是否展示
             */
            limitPersonBtn?: boolean;
            /**
             * 冻结
             */
            frozenBtn?: boolean;
            /**
             * 解冻
             */
            unFrozenBtn?: boolean;
            /**
             * 结转
             */
            transferBtn?: boolean;
            /**
             * 日志
             */
            logBtn?: boolean;
          };
        }[];
        /**
         * 项目唯一编码
         */
        projectUk?: string;
        /**
         * 项目唯一编码
         */
        projectName?: string;
        /**
         * 是否是结转过来的项目 1-是 0-否
         */
        isFromTransferred?: number;
        /**
         * 原始收入金额
         */
        originalIncomeAmount?: number;
        /**
         * 收入金额
         */
        incomeAmount?: number;
        /**
         * 收入执行金额
         */
        incomeExecuteAmount?: number;
        /**
         * 收入冻结金额
         */
        incomeFreezeAmount?: number;
        /**
         * 收入在途金额
         */
        incomeInTransitAmount?: number;
        /**
         * 收入可用金额
         */
        incomeAvailableAmount?: number;
        /**
         * 收入预算执行率
         */
        incomeExecuteRate?: string;
        /**
         * 调整前收入金额较上年变化
         */
        originalIncomeChangeFromLastYear?: number;
        /**
         * 收入金额较上年变化
         */
        incomeChangeFromLastYear?: number;
        /**
         * 上年预算收入金额
         */
        lastYearIncomeAmount?: number;
        /**
         * 上年预算收入执行率
         */
        lastYearIncomeExecuteRate?: number;
        /**
         * 预计全年收入执行金额
         */
        annualIncomeExecuteAmount?: number;
        /**
         * 收入情况说明
         */
        incomeSituationDesc?: string;
        /**
         * 收入浮动比例控制下限
         */
        incomeFloatingRatioMin?: number;
        /**
         * 收入浮动比例控制上限
         */
        incomeFloatingRatioMax?: number;
        /**
         * 原始支出金额
         */
        originalDisburseAmount?: number;
        /**
         * 支出金额
         */
        disburseAmount?: number;
        /**
         * 支出执行金额
         */
        disburseExecuteAmount?: number;
        /**
         * 支出冻结金额
         */
        disburseFreezeAmount?: number;
        /**
         * 支出在途金额
         */
        disburseInTransitAmount?: number;
        /**
         * 支出可用金额
         */
        disburseAvailableAmount?: number;
        /**
         * 支出预算执行率
         */
        disburseExecuteRate?: string;
        /**
         * 调整前支出金额较上年变化
         */
        originalDisburseChangeFromLastYear?: number;
        /**
         * 支出金额较上年变化
         */
        disburseChangeFromLastYear?: number;
        /**
         * 上年预算支出金额
         */
        lastYearDisburseAmount?: number;
        /**
         * 上年预算支出执行率
         */
        lastYearDisburseExecuteRate?: number;
        /**
         * 预计全年支出执行金额
         */
        annualDisburseExecuteAmount?: number;
        /**
         * 支出情况说明
         */
        disburseSituationDesc?: string;
        /**
         * 支出浮动比例控制下限
         */
        disburseFloatingRatioMin?: number;
        /**
         * 支出浮动比例控制上限
         */
        disburseFloatingRatioMax?: number;
        /**
         * 截止月份
         */
        cutoffMonth?: number;
        /**
         * 项目编码
         */
        projectCode?: string;
        /**
         * 项目类型
         */
        projectType?: string;
        projectRemark?: string;
        /**
         * 收入是否超过比例0-未超过 1-超过
         */
        incomeIsExceedRatio?: number;
        /**
         * 支出是否超过比例0-未超过 1-超过
         */
        disburseIsExceedRatio?: number;
        /**
         * 项目申报金额
         */
        projectReportAmount?: number;
        /**
         * 是否有实际采购 0-无 1-有
         */
        isActualPurchase?: number;
      }[];
      /**
       * 第几页
       */
      pageNum?: number;
      /**
       * 每页记录数
       */
      pageSize?: number;
      /**
       * 总页数
       */
      pages?: number;
      /**
       * 当前页的数量 <= pageSize，该属性来自ArrayList的size属性
       */
      size?: number;
    };
    /**
     * 工作流权限按钮
     */
    authButton?: {
      /**
       * 是否能导入
       */
      enableImport?: boolean;
      /**
       * 是否能加签
       */
      enableAddNode?: boolean;
      /**
       * 是否能审批驳回
       */
      enableCancel?: boolean;
      /**
       * 是否能审批通过
       */
      enablePass?: boolean;
      /**
       * 是否能够添加科目
       */
      enableAddSubject?: boolean;
      /**
       * 是否能够删除科目
       */
      enableDelete?: boolean;
      /**
       * 是否能够撤回
       */
      enableRevoke?: boolean;
      /**
       * 能否下发
       */
      enablePush?: boolean;
      /**
       * 是否能够查看
       */
      enableView?: boolean;
      /**
       * 是否能够编辑
       */
      enableEdit?: boolean;
    };
    /**
     * 最近保存时间
     */
    lastSaveTime?: number;
    /**
     * 填报方式
     */
    fillMethod?: string;
    /**
     * 预算填报单唯一单号
     */
    orderNo?: string;
    /**
     * 审核状态
     */
    auditStatus?: string;
    /**
     * 填报单部门id
     */
    departmentId?: number;
    /**
     * 附件信息
     */
    attachmentList?: {
      id?: number;
      /**
       * 附件OssId
       */
      fileId?: string;
      /**
       * 附件url
       */
      url?: string;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 附件名称
       */
      name?: string;
      /**
       * 附件大小
       */
      size?: number;
    }[];
    /**
     * 科目uk集合
     */
    subjectUkList?: string[];
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [财务审批审核使用-分页查询项目下的填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/580066) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [预算填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54092)
 * @请求头 `GET /zlb/budget/ep/fill/record/finance/list`
 * @更新时间 `2024-11-14 10:55:36`
 * @项目ID 2991
 */
type ZlbBudgetEpFillRecordFinanceListGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/ep/fill/record/finance/list',
    'data',
    string,
    | 'orderNo'
    | 'workflowProcessNo'
    | 'identity'
    | 'projectUk'
    | 'subjectUk'
    | 'classify'
    | 'year'
    | 'departmentId'
    | 'pageSize'
    | 'pageNo'
    | 'sortField'
    | 'sortBy',
    false
  >
>;

/**
 * 接口 [财务审批审核使用-分页查询项目下的填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/580066) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [预算填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54092)
 * @请求头 `GET /zlb/budget/ep/fill/record/finance/list`
 * @更新时间 `2024-11-14 10:55:36`
 * @项目ID 2991
 */
const zlbBudgetEpFillRecordFinanceListGetRequestConfig: ZlbBudgetEpFillRecordFinanceListGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_9,
    devUrl: devUrl_0_4_0_9,
    prodUrl: prodUrl_0_4_0_9,
    path: '/zlb/budget/ep/fill/record/finance/list',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_9,
    paramNames: [],
    queryNames: [
      'orderNo',
      'workflowProcessNo',
      'identity',
      'projectUk',
      'subjectUk',
      'classify',
      'year',
      'departmentId',
      'pageSize',
      'pageNo',
      'sortField',
      'sortBy',
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbBudgetEpFillRecordFinanceListGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [财务审批审核使用-分页查询项目下的填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/580066) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [预算填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54092)
 * @请求头 `GET /zlb/budget/ep/fill/record/finance/list`
 * @更新时间 `2024-11-14 10:55:36`
 * @项目ID 2991
 */
export const zlbBudgetEpFillRecordFinanceListGet = /*#__PURE__*/ (
  requestData: ZlbBudgetEpFillRecordFinanceListGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetEpFillRecordFinanceListGetResponse>(
    prepare(zlbBudgetEpFillRecordFinanceListGetRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetEpFillRecordFinanceListGet.requestConfig =
  zlbBudgetEpFillRecordFinanceListGetRequestConfig;

/**
 * 接口 [年度预算管理-分页查询项目下的填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/580074) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [预算填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54092)
 * @请求头 `GET /zlb/budget/ep/fill/record/year/statistic/list`
 * @更新时间 `2023-11-29 10:55:36`
 * @项目ID 2991
 */
export interface ZlbBudgetEpFillRecordYearStatisticListGetRequest {
  /**
   * 填报部门id
   */
  fillDepartmentId?: string;
  /**
   * 项目唯一编码
   */
  projectUk?: string;
  /**
   * 科目唯一编码
   */
  subjectUk?: string;
  /**
   * 科目分类：income-收入,disburse-支出
   */
  classify?: string;
  /**
   * 年度
   */
  year?: string;
  /**
   * 页面大小
   */
  pageSize?: string;
  /**
   * 页码
   */
  pageNo?: string;
  /**
   * 排序字段
   */
  sortField?: string;
  /**
   * 排序规则：DESC || ASC
   */
  sortBy?: string;
}

/**
 * 接口 [年度预算管理-分页查询项目下的填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/580074) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [预算填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54092)
 * @请求头 `GET /zlb/budget/ep/fill/record/year/statistic/list`
 * @更新时间 `2023-11-29 10:55:36`
 * @项目ID 2991
 */
export interface ZlbBudgetEpFillRecordYearStatisticListGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 项目信息
     */
    projects?: {
      /**
       * 总记录数
       */
      total?: number;
      /**
       * 结果集
       */
      data?: {
        /**
         * 填报记录数据
         */
        list?: {
          id?: number;
          /**
           * 部门id
           */
          departmentId?: number;
          /**
           * 部门名称
           */
          departmentName?: string;
          /**
           * 项目唯一编码
           */
          projectUk?: string;
          /**
           * 项目名称
           */
          subjectName?: string;
          /**
           * 填报方式
           */
          fillMethod?: string;
          /**
           * 科目类型
           */
          subjectType?: string;
          /**
           * 年度
           */
          year?: number;
          /**
           * 年度金额
           */
          yearAmount?: number;
          /**
           * 季度金额
           */
          q1Amount?: number;
          q2Amount?: number;
          q3Amount?: number;
          q4Amount?: number;
          /**
           * 月度金额
           */
          m1Amount?: number;
          m2Amount?: number;
          m3Amount?: number;
          m4Amount?: number;
          m5Amount?: number;
          m6Amount?: number;
          m7Amount?: number;
          m8Amount?: number;
          m9Amount?: number;
          m10Amount?: number;
          m11Amount?: number;
          m12Amount?: number;
          /**
           * 年度金额
           */
          originalYearAmount?: number;
          /**
           * 季度金额
           */
          originalQ1Amount?: number;
          originalQ2Amount?: number;
          originalQ3Amount?: number;
          originalQ4Amount?: number;
          /**
           * 月度金额
           */
          originalM1Amount?: number;
          originalM2Amount?: number;
          originalM3Amount?: number;
          originalM4Amount?: number;
          originalM5Amount?: number;
          originalM6Amount?: number;
          originalM7Amount?: number;
          originalM8Amount?: number;
          originalM9Amount?: number;
          originalM10Amount?: number;
          originalM11Amount?: number;
          originalM12Amount?: number;
          /**
           * 预算金额，分
           */
          budgetAmount?: number;
          /**
           * 预算金额，分
           */
          originalBudgetAmount?: number;
        }[];
        /**
         * 项目唯一编码
         */
        projectUk?: string;
        /**
         * 项目唯一编码
         */
        projectName?: string;
        /**
         * 收入金额
         */
        incomeAmount?: number;
        /**
         * 支出金额
         */
        disburseAmount?: number;
      }[];
      /**
       * 第几页
       */
      pageNum?: number;
      /**
       * 每页记录数
       */
      pageSize?: number;
      /**
       * 总页数
       */
      pages?: number;
      /**
       * 当前页的数量 <= pageSize，该属性来自ArrayList的size属性
       */
      size?: number;
    };
    /**
     * 工作流权限按钮
     */
    authButton?: {
      /**
       * 是否能导入
       */
      enableImport?: boolean;
      /**
       * 是否能导出
       */
      enableExport?: boolean;
      /**
       * 是否能加签
       */
      enableAddNode?: boolean;
      /**
       * 是否能审批驳回
       */
      enableCancel?: boolean;
      /**
       * 是否能审批通过
       */
      enablePass?: boolean;
    };
    /**
     * 最近保存时间
     */
    lastSaveTime?: number;
    /**
     * 填报方式
     */
    fillMethod?: string;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [年度预算管理-分页查询项目下的填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/580074) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [预算填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54092)
 * @请求头 `GET /zlb/budget/ep/fill/record/year/statistic/list`
 * @更新时间 `2023-11-29 10:55:36`
 * @项目ID 2991
 */
type ZlbBudgetEpFillRecordYearStatisticListGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/ep/fill/record/year/statistic/list',
    'data',
    string,
    | 'fillDepartmentId'
    | 'projectUk'
    | 'subjectUk'
    | 'classify'
    | 'year'
    | 'pageSize'
    | 'pageNo'
    | 'sortField'
    | 'sortBy',
    false
  >
>;

/**
 * 接口 [年度预算管理-分页查询项目下的填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/580074) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [预算填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54092)
 * @请求头 `GET /zlb/budget/ep/fill/record/year/statistic/list`
 * @更新时间 `2023-11-29 10:55:36`
 * @项目ID 2991
 */
const zlbBudgetEpFillRecordYearStatisticListGetRequestConfig: ZlbBudgetEpFillRecordYearStatisticListGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_9,
    devUrl: devUrl_0_4_0_9,
    prodUrl: prodUrl_0_4_0_9,
    path: '/zlb/budget/ep/fill/record/year/statistic/list',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_9,
    paramNames: [],
    queryNames: [
      'fillDepartmentId',
      'projectUk',
      'subjectUk',
      'classify',
      'year',
      'pageSize',
      'pageNo',
      'sortField',
      'sortBy',
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbBudgetEpFillRecordYearStatisticListGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [年度预算管理-分页查询项目下的填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/580074) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [预算填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54092)
 * @请求头 `GET /zlb/budget/ep/fill/record/year/statistic/list`
 * @更新时间 `2023-11-29 10:55:36`
 * @项目ID 2991
 */
export const zlbBudgetEpFillRecordYearStatisticListGet = /*#__PURE__*/ (
  requestData: ZlbBudgetEpFillRecordYearStatisticListGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetEpFillRecordYearStatisticListGetResponse>(
    prepare(zlbBudgetEpFillRecordYearStatisticListGetRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetEpFillRecordYearStatisticListGet.requestConfig =
  zlbBudgetEpFillRecordYearStatisticListGetRequestConfig;

/**
 * 接口 [导入填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/580082) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [预算填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54092)
 * @请求头 `POST /zlb/budget/ep/fill/record/import/submit`
 * @更新时间 `2024-09-23 14:47:44`
 * @项目ID 2991
 */
export interface ZlbBudgetEpFillRecordImportSubmitPostRequest {
  /**
   * oss的文件ID
   */
  fileId: string;
  orderNo: string;
}

/**
 * 接口 [导入填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/580082) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [预算填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54092)
 * @请求头 `POST /zlb/budget/ep/fill/record/import/submit`
 * @更新时间 `2024-09-23 14:47:44`
 * @项目ID 2991
 */
export interface ZlbBudgetEpFillRecordImportSubmitPostResponse {
  success?: boolean;
  result?: string;
  code?: string;
  message?: string;
}

/**
 * 接口 [导入填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/580082) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [预算填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54092)
 * @请求头 `POST /zlb/budget/ep/fill/record/import/submit`
 * @更新时间 `2024-09-23 14:47:44`
 * @项目ID 2991
 */
type ZlbBudgetEpFillRecordImportSubmitPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/ep/fill/record/import/submit',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [导入填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/580082) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [预算填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54092)
 * @请求头 `POST /zlb/budget/ep/fill/record/import/submit`
 * @更新时间 `2024-09-23 14:47:44`
 * @项目ID 2991
 */
const zlbBudgetEpFillRecordImportSubmitPostRequestConfig: ZlbBudgetEpFillRecordImportSubmitPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_9,
    devUrl: devUrl_0_4_0_9,
    prodUrl: prodUrl_0_4_0_9,
    path: '/zlb/budget/ep/fill/record/import/submit',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_9,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbBudgetEpFillRecordImportSubmitPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [导入填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/580082) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [预算填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54092)
 * @请求头 `POST /zlb/budget/ep/fill/record/import/submit`
 * @更新时间 `2024-09-23 14:47:44`
 * @项目ID 2991
 */
export const zlbBudgetEpFillRecordImportSubmitPost = /*#__PURE__*/ (
  requestData: ZlbBudgetEpFillRecordImportSubmitPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetEpFillRecordImportSubmitPostResponse>(
    prepare(zlbBudgetEpFillRecordImportSubmitPostRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetEpFillRecordImportSubmitPost.requestConfig =
  zlbBudgetEpFillRecordImportSubmitPostRequestConfig;

/**
 * 接口 [导出填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/580090) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [预算填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54092)
 * @请求头 `POST /zlb/budget/ep/fill/record/export/submit`
 * @更新时间 `2024-09-23 14:47:44`
 * @项目ID 2991
 */
export interface ZlbBudgetEpFillRecordExportSubmitPostRequest {
  orderNo: string;
}

/**
 * 接口 [导出填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/580090) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [预算填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54092)
 * @请求头 `POST /zlb/budget/ep/fill/record/export/submit`
 * @更新时间 `2024-09-23 14:47:44`
 * @项目ID 2991
 */
export interface ZlbBudgetEpFillRecordExportSubmitPostResponse {
  success?: boolean;
  result?: string;
  code?: string;
  message?: string;
}

/**
 * 接口 [导出填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/580090) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [预算填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54092)
 * @请求头 `POST /zlb/budget/ep/fill/record/export/submit`
 * @更新时间 `2024-09-23 14:47:44`
 * @项目ID 2991
 */
type ZlbBudgetEpFillRecordExportSubmitPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/ep/fill/record/export/submit',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [导出填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/580090) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [预算填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54092)
 * @请求头 `POST /zlb/budget/ep/fill/record/export/submit`
 * @更新时间 `2024-09-23 14:47:44`
 * @项目ID 2991
 */
const zlbBudgetEpFillRecordExportSubmitPostRequestConfig: ZlbBudgetEpFillRecordExportSubmitPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_9,
    devUrl: devUrl_0_4_0_9,
    prodUrl: prodUrl_0_4_0_9,
    path: '/zlb/budget/ep/fill/record/export/submit',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_9,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbBudgetEpFillRecordExportSubmitPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [导出填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/580090) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [预算填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54092)
 * @请求头 `POST /zlb/budget/ep/fill/record/export/submit`
 * @更新时间 `2024-09-23 14:47:44`
 * @项目ID 2991
 */
export const zlbBudgetEpFillRecordExportSubmitPost = /*#__PURE__*/ (
  requestData: ZlbBudgetEpFillRecordExportSubmitPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetEpFillRecordExportSubmitPostResponse>(
    prepare(zlbBudgetEpFillRecordExportSubmitPostRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetEpFillRecordExportSubmitPost.requestConfig =
  zlbBudgetEpFillRecordExportSubmitPostRequestConfig;

/**
 * 接口 [删除填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/580546) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [预算填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54092)
 * @请求头 `POST /zlb/budget/ep/fill/record/delete`
 * @更新时间 `2024-09-23 14:47:44`
 * @项目ID 2991
 */
export interface ZlbBudgetEpFillRecordDeletePostRequest {
  /**
   * 填报记录id
   */
  id: number;
}

/**
 * 接口 [删除填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/580546) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [预算填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54092)
 * @请求头 `POST /zlb/budget/ep/fill/record/delete`
 * @更新时间 `2024-09-23 14:47:44`
 * @项目ID 2991
 */
export interface ZlbBudgetEpFillRecordDeletePostResponse {
  success?: boolean;
  result?: boolean;
  code?: string;
  message?: string;
}

/**
 * 接口 [删除填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/580546) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [预算填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54092)
 * @请求头 `POST /zlb/budget/ep/fill/record/delete`
 * @更新时间 `2024-09-23 14:47:44`
 * @项目ID 2991
 */
type ZlbBudgetEpFillRecordDeletePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/ep/fill/record/delete',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [删除填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/580546) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [预算填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54092)
 * @请求头 `POST /zlb/budget/ep/fill/record/delete`
 * @更新时间 `2024-09-23 14:47:44`
 * @项目ID 2991
 */
const zlbBudgetEpFillRecordDeletePostRequestConfig: ZlbBudgetEpFillRecordDeletePostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_9,
    devUrl: devUrl_0_4_0_9,
    prodUrl: prodUrl_0_4_0_9,
    path: '/zlb/budget/ep/fill/record/delete',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_9,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbBudgetEpFillRecordDeletePost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [删除填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/580546) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [预算填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54092)
 * @请求头 `POST /zlb/budget/ep/fill/record/delete`
 * @更新时间 `2024-09-23 14:47:44`
 * @项目ID 2991
 */
export const zlbBudgetEpFillRecordDeletePost = /*#__PURE__*/ (
  requestData: ZlbBudgetEpFillRecordDeletePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetEpFillRecordDeletePostResponse>(
    prepare(zlbBudgetEpFillRecordDeletePostRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetEpFillRecordDeletePost.requestConfig = zlbBudgetEpFillRecordDeletePostRequestConfig;

/**
 * 接口 [经办人使用-批量保存更新填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/581578) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [预算填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54092)
 * @请求头 `POST /zlb/budget/ep/fill/record/batch-save`
 * @更新时间 `2024-09-23 14:47:43`
 * @项目ID 2991
 */
export interface ZlbBudgetEpFillRecordBatchSavePostRequest {
  /**
   * 年度
   */
  year: number;
  /**
   * 预算填报单订单号
   */
  orderNo?: string;
  /**
   * 填报记录
   */
  fillRecords: {
    /**
     * 填报记录id
     */
    id?: number;
    /**
     * 填报部门id
     */
    fillDepartmentId?: number;
    /**
     * 填报部门名称
     */
    fillDepartmentName?: string;
    /**
     * 责任部门id
     */
    responsibleDepartmentId?: number;
    /**
     * 责任部门名称
     */
    responsibleDepartmentName?: string;
    /**
     * 项目uk
     */
    projectUk: string;
    /**
     * 预算填报方式
     * Y-年度、Q-季度、M-月度
     */
    fillMethod: string;
    /**
     * 科目uk
     */
    subjectUk: string;
    /**
     * 科目类型
     */
    subjectType?: string;
    /**
     * 年度金额
     */
    yearAmount?: number;
    /**
     * 季度金额
     */
    q1Amount?: number;
    q2Amount?: number;
    q3Amount?: number;
    q4Amount?: number;
    /**
     * 月度金额
     */
    m1Amount?: number;
    m2Amount?: number;
    m3Amount?: number;
    m4Amount?: number;
    m5Amount?: number;
    m6Amount?: number;
    m7Amount?: number;
    m8Amount?: number;
    m9Amount?: number;
    m10Amount?: number;
    m11Amount?: number;
    m12Amount?: number;
    /**
     * 填报说明
     */
    fillInstruction?: string;
  }[];
  /**
   * 附件信息
   */
  attachmentList?: {
    id?: number;
    /**
     * 附件OssId
     */
    fileId?: string;
    /**
     * 附件url
     */
    url?: string;
    /**
     * 附件类型
     */
    type?: string;
    /**
     * 附件名称
     */
    name?: string;
    /**
     * 附件大小
     */
    size?: number;
  }[];
}

/**
 * 接口 [经办人使用-批量保存更新填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/581578) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [预算填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54092)
 * @请求头 `POST /zlb/budget/ep/fill/record/batch-save`
 * @更新时间 `2024-09-23 14:47:43`
 * @项目ID 2991
 */
export interface ZlbBudgetEpFillRecordBatchSavePostResponse {
  success?: boolean;
  result?: boolean;
  code?: string;
  message?: string;
}

/**
 * 接口 [经办人使用-批量保存更新填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/581578) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [预算填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54092)
 * @请求头 `POST /zlb/budget/ep/fill/record/batch-save`
 * @更新时间 `2024-09-23 14:47:43`
 * @项目ID 2991
 */
type ZlbBudgetEpFillRecordBatchSavePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/ep/fill/record/batch-save',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [经办人使用-批量保存更新填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/581578) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [预算填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54092)
 * @请求头 `POST /zlb/budget/ep/fill/record/batch-save`
 * @更新时间 `2024-09-23 14:47:43`
 * @项目ID 2991
 */
const zlbBudgetEpFillRecordBatchSavePostRequestConfig: ZlbBudgetEpFillRecordBatchSavePostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_9,
    devUrl: devUrl_0_4_0_9,
    prodUrl: prodUrl_0_4_0_9,
    path: '/zlb/budget/ep/fill/record/batch-save',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_9,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbBudgetEpFillRecordBatchSavePost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [经办人使用-批量保存更新填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/581578) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [预算填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54092)
 * @请求头 `POST /zlb/budget/ep/fill/record/batch-save`
 * @更新时间 `2024-09-23 14:47:43`
 * @项目ID 2991
 */
export const zlbBudgetEpFillRecordBatchSavePost = /*#__PURE__*/ (
  requestData: ZlbBudgetEpFillRecordBatchSavePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetEpFillRecordBatchSavePostResponse>(
    prepare(zlbBudgetEpFillRecordBatchSavePostRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetEpFillRecordBatchSavePost.requestConfig = zlbBudgetEpFillRecordBatchSavePostRequestConfig;

/**
 * 接口 [年度预算管理-分页查询项目下的填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/582362) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [预算填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54092)
 * @请求头 `GET /zlb/budget/ep/fill/record/year/statistic/page`
 * @更新时间 `2024-09-23 14:47:42`
 * @项目ID 2991
 */
export interface ZlbBudgetEpFillRecordYearStatisticPageGetRequest {
  pageSize?: string;
  pageNo?: string;
  sortField?: string;
  sortBy?: string;
  /**
   * 项目唯一编码
   */
  projectUk?: string;
  /**
   * 科目唯一编码
   */
  subjectUk?: string;
  /**
   * 科目分类：income-收入,disburse-支出
   */
  classify?: string;
  /**
   * 年度
   */
  year: string;
  /**
   * 用户部门id
   */
  departmentId?: string;
  /**
   * 填报部门id
   */
  fillDepartmentId?: string;
  /**
   * 开始时间
   */
  beginDate?: string;
  /**
   * 结束时间
   */
  endDate?: string;
  /**
   * 是否隐藏收入
   */
  hiddenIncome?: string;
}

/**
 * 接口 [年度预算管理-分页查询项目下的填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/582362) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [预算填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54092)
 * @请求头 `GET /zlb/budget/ep/fill/record/year/statistic/page`
 * @更新时间 `2024-09-23 14:47:42`
 * @项目ID 2991
 */
export interface ZlbBudgetEpFillRecordYearStatisticPageGetResponse {
  success?: boolean;
  result?: {
    /**
     * 项目信息
     */
    projects?: {
      /**
       * 总记录数
       */
      total?: number;
      /**
       * 结果集
       */
      data?: {
        /**
         * 填报记录数据
         */
        list?: {
          id?: number;
          /**
           * 填报记录唯一uk
           */
          uk?: string;
          /**
           * 责任部门id
           */
          responsibleDepartmentId?: number;
          /**
           * 责任部门名称
           */
          responsibleDepartmentName?: string;
          /**
           * 填报部门id
           */
          fillDepartmentId?: number;
          /**
           * 填报部门名称
           */
          fillDepartmentName?: string;
          /**
           * 项目唯一编码
           */
          projectUk?: string;
          /**
           * 科目唯一编码
           */
          subjectUk?: string;
          /**
           * 科目名称
           */
          subjectName?: string;
          /**
           * 填报方式
           */
          fillMethod?: string;
          /**
           * 科目类型
           */
          subjectType?: string;
          /**
           * 年度
           */
          year?: number;
          /**
           * 年度金额
           */
          yearAmount?: number;
          /**
           * 季度金额
           */
          q1Amount?: number;
          q2Amount?: number;
          q3Amount?: number;
          q4Amount?: number;
          /**
           * 月度金额
           */
          m1Amount?: number;
          m2Amount?: number;
          m3Amount?: number;
          m4Amount?: number;
          m5Amount?: number;
          m6Amount?: number;
          m7Amount?: number;
          m8Amount?: number;
          m9Amount?: number;
          m10Amount?: number;
          m11Amount?: number;
          m12Amount?: number;
          /**
           * 年度金额
           */
          originalYearAmount?: number;
          /**
           * 季度金额
           */
          originalQ1Amount?: number;
          originalQ2Amount?: number;
          originalQ3Amount?: number;
          originalQ4Amount?: number;
          /**
           * 月度金额
           */
          originalM1Amount?: number;
          originalM2Amount?: number;
          originalM3Amount?: number;
          originalM4Amount?: number;
          originalM5Amount?: number;
          originalM6Amount?: number;
          originalM7Amount?: number;
          originalM8Amount?: number;
          originalM9Amount?: number;
          originalM10Amount?: number;
          originalM11Amount?: number;
          originalM12Amount?: number;
          /**
           * 预算金额，分
           */
          budgetAmount?: number;
          /**
           * 预算金额同比上年变化（格式 +0.89% -1.23%）
           */
          budgetAmountYearOverYearChange?: string;
          /**
           * 预算金额，分
           */
          originalBudgetAmount?: number;
          /**
           * 执行金额
           */
          executeAmount?: number;
          /**
           * 执行金额同比变化（格式 +0.89% -1.23%）
           */
          executeAmountYearOverYearChange?: string;
          /**
           * 执行金额环比变化（格式 +0.89% -1.23%）
           */
          executeAmountMonthOverMonthChange?: string;
          /**
           * 冻结金额
           */
          freezeAmount?: number;
          /**
           * 在途金额
           */
          inTransitAmount?: number;
          /**
           * 可用金额
           */
          availableAmount?: number;
          /**
           * 预算执行率
           */
          executeRate?: string;
          /**
           * 预算执行率同比变化（格式 +0.89% -1.23%）
           */
          executeRateYearOverYearChange?: string;
          /**
           * 预算执行率环比变化（格式 +0.89% -1.23%）
           */
          executeRateMonthOverMonthChange?: string;
          /**
           * 科目备注
           */
          subjectRemark?: string;
          /**
           * 填报说明
           */
          fillInstruction?: string;
          /**
           * 科目类型描述
           */
          subjectTypeDesc?: string;
          /**
           * 预算项目使用唯一uk
           */
          useUk?: string;
          /**
           * 限制使用人员集合
           */
          useOperatorList?: {
            id?: number;
            name?: string;
          }[];
          /**
           * 状态
           */
          status?: 'NORMAL' | 'FROZEN' | 'TRANSFERRED' | 'ADJUSTING';
          /**
           * 是否是结转过来的（1-是 0-否）
           */
          isFromTransferred?: number;
          /**
           * 结转金额
           */
          transferredAmount?: number;
          /**
           * 项目结转code
           */
          projectCode?: string;
          /**
           * 科目结转code
           */
          subjectCode?: string;
          /**
           * 操作按钮
           */
          operatorBtn?: {
            /**
             * 限制人员是否展示
             */
            limitPersonBtn?: boolean;
            /**
             * 冻结
             */
            frozenBtn?: boolean;
            /**
             * 解冻
             */
            unFrozenBtn?: boolean;
            /**
             * 结转
             */
            transferBtn?: boolean;
            /**
             * 日志
             */
            logBtn?: boolean;
          };
        }[];
        /**
         * 项目唯一编码
         */
        projectUk?: string;
        /**
         * 项目唯一编码
         */
        projectName?: string;
        /**
         * 是否是结转过来的项目 1-是 0-否
         */
        isFromTransferred?: number;
        /**
         * 原始收入金额
         */
        originalIncomeAmount?: number;
        /**
         * 收入金额
         */
        incomeAmount?: number;
        /**
         * 收入执行金额
         */
        incomeExecuteAmount?: number;
        /**
         * 收入冻结金额
         */
        incomeFreezeAmount?: number;
        /**
         * 收入在途金额
         */
        incomeInTransitAmount?: number;
        /**
         * 收入可用金额
         */
        incomeAvailableAmount?: number;
        /**
         * 收入预算执行率
         */
        incomeExecuteRate?: string;
        /**
         * 调整前收入金额较上年变化
         */
        originalIncomeChangeFromLastYear?: number;
        /**
         * 收入金额较上年变化
         */
        incomeChangeFromLastYear?: number;
        /**
         * 上年预算收入金额
         */
        lastYearIncomeAmount?: number;
        /**
         * 上年预算收入执行率
         */
        lastYearIncomeExecuteRate?: number;
        /**
         * 预计全年收入执行金额
         */
        annualIncomeExecuteAmount?: number;
        /**
         * 收入情况说明
         */
        incomeSituationDesc?: string;
        /**
         * 收入浮动比例控制下限
         */
        incomeFloatingRatioMin?: number;
        /**
         * 收入浮动比例控制上限
         */
        incomeFloatingRatioMax?: number;
        /**
         * 原始支出金额
         */
        originalDisburseAmount?: number;
        /**
         * 支出金额
         */
        disburseAmount?: number;
        /**
         * 支出执行金额
         */
        disburseExecuteAmount?: number;
        /**
         * 支出冻结金额
         */
        disburseFreezeAmount?: number;
        /**
         * 支出在途金额
         */
        disburseInTransitAmount?: number;
        /**
         * 支出可用金额
         */
        disburseAvailableAmount?: number;
        /**
         * 支出预算执行率
         */
        disburseExecuteRate?: string;
        /**
         * 调整前支出金额较上年变化
         */
        originalDisburseChangeFromLastYear?: number;
        /**
         * 支出金额较上年变化
         */
        disburseChangeFromLastYear?: number;
        /**
         * 上年预算支出金额
         */
        lastYearDisburseAmount?: number;
        /**
         * 上年预算支出执行率
         */
        lastYearDisburseExecuteRate?: number;
        /**
         * 预计全年支出执行金额
         */
        annualDisburseExecuteAmount?: number;
        /**
         * 支出情况说明
         */
        disburseSituationDesc?: string;
        /**
         * 支出浮动比例控制下限
         */
        disburseFloatingRatioMin?: number;
        /**
         * 支出浮动比例控制上限
         */
        disburseFloatingRatioMax?: number;
        /**
         * 截止月份
         */
        cutoffMonth?: number;
        /**
         * 项目编码
         */
        projectCode?: string;
        /**
         * 项目类型
         */
        projectType?: string;
        projectRemark?: string;
        /**
         * 收入是否超过比例0-未超过 1-超过
         */
        incomeIsExceedRatio?: number;
        /**
         * 支出是否超过比例0-未超过 1-超过
         */
        disburseIsExceedRatio?: number;
        /**
         * 项目申报金额
         */
        projectReportAmount?: number;
        /**
         * 是否有实际采购 0-无 1-有
         */
        isActualPurchase?: number;
      }[];
      /**
       * 第几页
       */
      pageNum?: number;
      /**
       * 每页记录数
       */
      pageSize?: number;
      /**
       * 总页数
       */
      pages?: number;
      /**
       * 当前页的数量 <= pageSize，该属性来自ArrayList的size属性
       */
      size?: number;
    };
    /**
     * 工作流权限按钮
     */
    authButton?: {
      /**
       * 是否能导入
       */
      enableImport?: boolean;
      /**
       * 是否能加签
       */
      enableAddNode?: boolean;
      /**
       * 是否能审批驳回
       */
      enableCancel?: boolean;
      /**
       * 是否能审批通过
       */
      enablePass?: boolean;
      /**
       * 是否能够添加科目
       */
      enableAddSubject?: boolean;
      /**
       * 是否能够删除科目
       */
      enableDelete?: boolean;
      /**
       * 是否能够撤回
       */
      enableRevoke?: boolean;
      /**
       * 能否下发
       */
      enablePush?: boolean;
      /**
       * 是否能够查看
       */
      enableView?: boolean;
      /**
       * 是否能够编辑
       */
      enableEdit?: boolean;
    };
    /**
     * 最近保存时间
     */
    lastSaveTime?: number;
    /**
     * 填报方式
     */
    fillMethod?: string;
    /**
     * 预算填报单唯一单号
     */
    orderNo?: string;
    /**
     * 审核状态
     */
    auditStatus?: string;
    /**
     * 填报单部门id
     */
    departmentId?: number;
    /**
     * 附件信息
     */
    attachmentList?: {
      id?: number;
      /**
       * 附件OssId
       */
      fileId?: string;
      /**
       * 附件url
       */
      url?: string;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 附件名称
       */
      name?: string;
      /**
       * 附件大小
       */
      size?: number;
    }[];
  };
  code?: string;
  message?: string;
}

/**
 * 接口 [年度预算管理-分页查询项目下的填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/582362) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [预算填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54092)
 * @请求头 `GET /zlb/budget/ep/fill/record/year/statistic/page`
 * @更新时间 `2024-09-23 14:47:42`
 * @项目ID 2991
 */
type ZlbBudgetEpFillRecordYearStatisticPageGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/ep/fill/record/year/statistic/page',
    'data',
    string,
    | 'pageSize'
    | 'pageNo'
    | 'sortField'
    | 'sortBy'
    | 'projectUk'
    | 'subjectUk'
    | 'classify'
    | 'year'
    | 'departmentId'
    | 'fillDepartmentId'
    | 'beginDate'
    | 'endDate'
    | 'hiddenIncome',
    false
  >
>;

/**
 * 接口 [年度预算管理-分页查询项目下的填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/582362) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [预算填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54092)
 * @请求头 `GET /zlb/budget/ep/fill/record/year/statistic/page`
 * @更新时间 `2024-09-23 14:47:42`
 * @项目ID 2991
 */
const zlbBudgetEpFillRecordYearStatisticPageGetRequestConfig: ZlbBudgetEpFillRecordYearStatisticPageGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_9,
    devUrl: devUrl_0_4_0_9,
    prodUrl: prodUrl_0_4_0_9,
    path: '/zlb/budget/ep/fill/record/year/statistic/page',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_9,
    paramNames: [],
    queryNames: [
      'pageSize',
      'pageNo',
      'sortField',
      'sortBy',
      'projectUk',
      'subjectUk',
      'classify',
      'year',
      'departmentId',
      'fillDepartmentId',
      'beginDate',
      'endDate',
      'hiddenIncome',
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbBudgetEpFillRecordYearStatisticPageGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [年度预算管理-分页查询项目下的填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/582362) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [预算填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54092)
 * @请求头 `GET /zlb/budget/ep/fill/record/year/statistic/page`
 * @更新时间 `2024-09-23 14:47:42`
 * @项目ID 2991
 */
export const zlbBudgetEpFillRecordYearStatisticPageGet = /*#__PURE__*/ (
  requestData: ZlbBudgetEpFillRecordYearStatisticPageGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetEpFillRecordYearStatisticPageGetResponse>(
    prepare(zlbBudgetEpFillRecordYearStatisticPageGetRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetEpFillRecordYearStatisticPageGet.requestConfig =
  zlbBudgetEpFillRecordYearStatisticPageGetRequestConfig;

/**
 * 接口 [财务使用-批量保存更新填报记录（前端暂时未使用）↗](http://yapi.cai-inc.com/project/2991/interface/api/587850) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [预算填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54092)
 * @标签 `deprecated`
 * @请求头 `POST /zlb/budget/ep/fill/record/finance/batch-save`
 * @更新时间 `2024-09-23 14:47:43`
 * @项目ID 2991
 */
export interface ZlbBudgetEpFillRecordFinanceBatchSavePostRequest {
  /**
   * 年度
   */
  year: number;
  /**
   * 预算填报单订单号
   */
  orderNo?: string;
  /**
   * 填报记录
   */
  fillRecords: {
    /**
     * 填报记录id
     */
    id?: number;
    /**
     * 填报部门id
     */
    fillDepartmentId?: number;
    /**
     * 填报部门名称
     */
    fillDepartmentName?: string;
    /**
     * 责任部门id
     */
    responsibleDepartmentId?: number;
    /**
     * 责任部门名称
     */
    responsibleDepartmentName?: string;
    /**
     * 项目uk
     */
    projectUk: string;
    /**
     * 预算填报方式
     * Y-年度、Q-季度、M-月度
     */
    fillMethod: string;
    /**
     * 科目uk
     */
    subjectUk: string;
    /**
     * 科目类型
     */
    subjectType?: string;
    /**
     * 年度金额
     */
    yearAmount?: number;
    /**
     * 季度金额
     */
    q1Amount?: number;
    q2Amount?: number;
    q3Amount?: number;
    q4Amount?: number;
    /**
     * 月度金额
     */
    m1Amount?: number;
    m2Amount?: number;
    m3Amount?: number;
    m4Amount?: number;
    m5Amount?: number;
    m6Amount?: number;
    m7Amount?: number;
    m8Amount?: number;
    m9Amount?: number;
    m10Amount?: number;
    m11Amount?: number;
    m12Amount?: number;
    /**
     * 填报说明
     */
    fillInstruction?: string;
  }[];
  /**
   * 附件信息
   */
  attachmentList?: {
    id?: number;
    /**
     * 附件OssId
     */
    fileId?: string;
    /**
     * 附件url
     */
    url?: string;
    /**
     * 附件类型
     */
    type?: string;
    /**
     * 附件名称
     */
    name?: string;
    /**
     * 附件大小
     */
    size?: number;
  }[];
}

/**
 * 接口 [财务使用-批量保存更新填报记录（前端暂时未使用）↗](http://yapi.cai-inc.com/project/2991/interface/api/587850) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [预算填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54092)
 * @标签 `deprecated`
 * @请求头 `POST /zlb/budget/ep/fill/record/finance/batch-save`
 * @更新时间 `2024-09-23 14:47:43`
 * @项目ID 2991
 */
export interface ZlbBudgetEpFillRecordFinanceBatchSavePostResponse {
  success?: boolean;
  result?: boolean;
  code?: string;
  message?: string;
}

/**
 * 接口 [财务使用-批量保存更新填报记录（前端暂时未使用）↗](http://yapi.cai-inc.com/project/2991/interface/api/587850) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [预算填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54092)
 * @标签 `deprecated`
 * @请求头 `POST /zlb/budget/ep/fill/record/finance/batch-save`
 * @更新时间 `2024-09-23 14:47:43`
 * @项目ID 2991
 */
type ZlbBudgetEpFillRecordFinanceBatchSavePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/ep/fill/record/finance/batch-save',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [财务使用-批量保存更新填报记录（前端暂时未使用）↗](http://yapi.cai-inc.com/project/2991/interface/api/587850) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [预算填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54092)
 * @标签 `deprecated`
 * @请求头 `POST /zlb/budget/ep/fill/record/finance/batch-save`
 * @更新时间 `2024-09-23 14:47:43`
 * @项目ID 2991
 */
const zlbBudgetEpFillRecordFinanceBatchSavePostRequestConfig: ZlbBudgetEpFillRecordFinanceBatchSavePostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_9,
    devUrl: devUrl_0_4_0_9,
    prodUrl: prodUrl_0_4_0_9,
    path: '/zlb/budget/ep/fill/record/finance/batch-save',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_9,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbBudgetEpFillRecordFinanceBatchSavePost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [财务使用-批量保存更新填报记录（前端暂时未使用）↗](http://yapi.cai-inc.com/project/2991/interface/api/587850) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [预算填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54092)
 * @标签 `deprecated`
 * @请求头 `POST /zlb/budget/ep/fill/record/finance/batch-save`
 * @更新时间 `2024-09-23 14:47:43`
 * @项目ID 2991
 */
export const zlbBudgetEpFillRecordFinanceBatchSavePost = /*#__PURE__*/ (
  requestData: ZlbBudgetEpFillRecordFinanceBatchSavePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetEpFillRecordFinanceBatchSavePostResponse>(
    prepare(zlbBudgetEpFillRecordFinanceBatchSavePostRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetEpFillRecordFinanceBatchSavePost.requestConfig =
  zlbBudgetEpFillRecordFinanceBatchSavePostRequestConfig;

/**
 * 接口 [获取当前用户所有部门列表↗](http://yapi.cai-inc.com/project/2991/interface/api/593042) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [预算填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54092)
 * @请求头 `GET /zlb/budget/ep/fill/record/user-dept-list`
 * @更新时间 `2024-09-23 14:47:45`
 * @项目ID 2991
 */
export interface ZlbBudgetEpFillRecordUserDeptListGetRequest {}

/**
 * 接口 [获取当前用户所有部门列表↗](http://yapi.cai-inc.com/project/2991/interface/api/593042) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [预算填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54092)
 * @请求头 `GET /zlb/budget/ep/fill/record/user-dept-list`
 * @更新时间 `2024-09-23 14:47:45`
 * @项目ID 2991
 */
export interface ZlbBudgetEpFillRecordUserDeptListGetResponse {
  success?: boolean;
  result?: {
    /**
     * 部门id
     */
    id?: number;
    /**
     * 部门名称
     */
    name?: string;
  }[];
  code?: string;
  message?: string;
}

/**
 * 接口 [获取当前用户所有部门列表↗](http://yapi.cai-inc.com/project/2991/interface/api/593042) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [预算填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54092)
 * @请求头 `GET /zlb/budget/ep/fill/record/user-dept-list`
 * @更新时间 `2024-09-23 14:47:45`
 * @项目ID 2991
 */
type ZlbBudgetEpFillRecordUserDeptListGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/ep/fill/record/user-dept-list',
    'data',
    string,
    string,
    true
  >
>;

/**
 * 接口 [获取当前用户所有部门列表↗](http://yapi.cai-inc.com/project/2991/interface/api/593042) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [预算填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54092)
 * @请求头 `GET /zlb/budget/ep/fill/record/user-dept-list`
 * @更新时间 `2024-09-23 14:47:45`
 * @项目ID 2991
 */
const zlbBudgetEpFillRecordUserDeptListGetRequestConfig: ZlbBudgetEpFillRecordUserDeptListGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_9,
    devUrl: devUrl_0_4_0_9,
    prodUrl: prodUrl_0_4_0_9,
    path: '/zlb/budget/ep/fill/record/user-dept-list',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_9,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbBudgetEpFillRecordUserDeptListGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [获取当前用户所有部门列表↗](http://yapi.cai-inc.com/project/2991/interface/api/593042) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [预算填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54092)
 * @请求头 `GET /zlb/budget/ep/fill/record/user-dept-list`
 * @更新时间 `2024-09-23 14:47:45`
 * @项目ID 2991
 */
export const zlbBudgetEpFillRecordUserDeptListGet = /*#__PURE__*/ (
  requestData?: ZlbBudgetEpFillRecordUserDeptListGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetEpFillRecordUserDeptListGetResponse>(
    prepare(zlbBudgetEpFillRecordUserDeptListGetRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetEpFillRecordUserDeptListGet.requestConfig =
  zlbBudgetEpFillRecordUserDeptListGetRequestConfig;

/**
 * 接口 [查询当前模版的科目↗](http://yapi.cai-inc.com/project/2991/interface/api/594018) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [预算填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54092)
 * @请求头 `GET /zlb/budget/ep/fill/record/subject/list`
 * @更新时间 `2024-09-23 14:47:45`
 * @项目ID 2991
 */
export interface ZlbBudgetEpFillRecordSubjectListGetRequest {
  /**
   * 项目唯一编码
   */
  projectUk: string;
  /**
   * 年度
   */
  year: string;
  /**
   * 用户部门id
   */
  departmentId: string;
}

/**
 * 接口 [查询当前模版的科目↗](http://yapi.cai-inc.com/project/2991/interface/api/594018) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [预算填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54092)
 * @请求头 `GET /zlb/budget/ep/fill/record/subject/list`
 * @更新时间 `2024-09-23 14:47:45`
 * @项目ID 2991
 */
export interface ZlbBudgetEpFillRecordSubjectListGetResponse {
  success?: boolean;
  result?: null;
  code?: string;
  message?: string;
}

/**
 * 接口 [查询当前模版的科目↗](http://yapi.cai-inc.com/project/2991/interface/api/594018) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [预算填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54092)
 * @请求头 `GET /zlb/budget/ep/fill/record/subject/list`
 * @更新时间 `2024-09-23 14:47:45`
 * @项目ID 2991
 */
type ZlbBudgetEpFillRecordSubjectListGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/ep/fill/record/subject/list',
    'data',
    string,
    'projectUk' | 'year' | 'departmentId',
    false
  >
>;

/**
 * 接口 [查询当前模版的科目↗](http://yapi.cai-inc.com/project/2991/interface/api/594018) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [预算填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54092)
 * @请求头 `GET /zlb/budget/ep/fill/record/subject/list`
 * @更新时间 `2024-09-23 14:47:45`
 * @项目ID 2991
 */
const zlbBudgetEpFillRecordSubjectListGetRequestConfig: ZlbBudgetEpFillRecordSubjectListGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_9,
    devUrl: devUrl_0_4_0_9,
    prodUrl: prodUrl_0_4_0_9,
    path: '/zlb/budget/ep/fill/record/subject/list',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_9,
    paramNames: [],
    queryNames: ['projectUk', 'year', 'departmentId'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbBudgetEpFillRecordSubjectListGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [查询当前模版的科目↗](http://yapi.cai-inc.com/project/2991/interface/api/594018) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [预算填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54092)
 * @请求头 `GET /zlb/budget/ep/fill/record/subject/list`
 * @更新时间 `2024-09-23 14:47:45`
 * @项目ID 2991
 */
export const zlbBudgetEpFillRecordSubjectListGet = /*#__PURE__*/ (
  requestData: ZlbBudgetEpFillRecordSubjectListGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetEpFillRecordSubjectListGetResponse>(
    prepare(zlbBudgetEpFillRecordSubjectListGetRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetEpFillRecordSubjectListGet.requestConfig =
  zlbBudgetEpFillRecordSubjectListGetRequestConfig;

/**
 * 接口 [年度预算管理-限制人员保存↗](http://yapi.cai-inc.com/project/2991/interface/api/642626) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [预算填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54092)
 * @请求头 `GET /zlb/budget/ep/fill/record/limit-person/save`
 * @更新时间 `2024-04-19 16:36:38`
 * @项目ID 2991
 */
export interface ZlbBudgetEpFillRecordLimitPersonSaveGetRequest {
  /**
   * 预算项目使用uk
   */
  useUk?: string;
  /**
   * 人员id集合
   */
  'operatorIdList[0]'?: string;
}

/**
 * 接口 [年度预算管理-限制人员保存↗](http://yapi.cai-inc.com/project/2991/interface/api/642626) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [预算填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54092)
 * @请求头 `GET /zlb/budget/ep/fill/record/limit-person/save`
 * @更新时间 `2024-04-19 16:36:38`
 * @项目ID 2991
 */
export interface ZlbBudgetEpFillRecordLimitPersonSaveGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [年度预算管理-限制人员保存↗](http://yapi.cai-inc.com/project/2991/interface/api/642626) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [预算填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54092)
 * @请求头 `GET /zlb/budget/ep/fill/record/limit-person/save`
 * @更新时间 `2024-04-19 16:36:38`
 * @项目ID 2991
 */
type ZlbBudgetEpFillRecordLimitPersonSaveGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/ep/fill/record/limit-person/save',
    'data',
    string,
    'useUk' | 'operatorIdList[0]',
    false
  >
>;

/**
 * 接口 [年度预算管理-限制人员保存↗](http://yapi.cai-inc.com/project/2991/interface/api/642626) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [预算填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54092)
 * @请求头 `GET /zlb/budget/ep/fill/record/limit-person/save`
 * @更新时间 `2024-04-19 16:36:38`
 * @项目ID 2991
 */
const zlbBudgetEpFillRecordLimitPersonSaveGetRequestConfig: ZlbBudgetEpFillRecordLimitPersonSaveGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_9,
    devUrl: devUrl_0_4_0_9,
    prodUrl: prodUrl_0_4_0_9,
    path: '/zlb/budget/ep/fill/record/limit-person/save',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_9,
    paramNames: [],
    queryNames: ['useUk', 'operatorIdList[0]'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbBudgetEpFillRecordLimitPersonSaveGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [年度预算管理-限制人员保存↗](http://yapi.cai-inc.com/project/2991/interface/api/642626) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [预算填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54092)
 * @请求头 `GET /zlb/budget/ep/fill/record/limit-person/save`
 * @更新时间 `2024-04-19 16:36:38`
 * @项目ID 2991
 */
export const zlbBudgetEpFillRecordLimitPersonSaveGet = /*#__PURE__*/ (
  requestData: ZlbBudgetEpFillRecordLimitPersonSaveGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetEpFillRecordLimitPersonSaveGetResponse>(
    prepare(zlbBudgetEpFillRecordLimitPersonSaveGetRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetEpFillRecordLimitPersonSaveGet.requestConfig =
  zlbBudgetEpFillRecordLimitPersonSaveGetRequestConfig;

/**
 * 接口 [年度预算管理-限制人员保存↗](http://yapi.cai-inc.com/project/2991/interface/api/662978) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [预算填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54092)
 * @请求头 `POST /zlb/budget/ep/fill/record/limit-person/save`
 * @更新时间 `2024-09-23 14:47:45`
 * @项目ID 2991
 */
export interface ZlbBudgetEpFillRecordLimitPersonSavePostRequest {
  useUk?: string;
  /**
   * 人员id集合
   */
  operatorIdList?: number[];
}

/**
 * 接口 [年度预算管理-限制人员保存↗](http://yapi.cai-inc.com/project/2991/interface/api/662978) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [预算填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54092)
 * @请求头 `POST /zlb/budget/ep/fill/record/limit-person/save`
 * @更新时间 `2024-09-23 14:47:45`
 * @项目ID 2991
 */
export interface ZlbBudgetEpFillRecordLimitPersonSavePostResponse {
  success?: boolean;
  result?: boolean;
  code?: string;
  message?: string;
}

/**
 * 接口 [年度预算管理-限制人员保存↗](http://yapi.cai-inc.com/project/2991/interface/api/662978) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [预算填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54092)
 * @请求头 `POST /zlb/budget/ep/fill/record/limit-person/save`
 * @更新时间 `2024-09-23 14:47:45`
 * @项目ID 2991
 */
type ZlbBudgetEpFillRecordLimitPersonSavePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/ep/fill/record/limit-person/save',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [年度预算管理-限制人员保存↗](http://yapi.cai-inc.com/project/2991/interface/api/662978) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [预算填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54092)
 * @请求头 `POST /zlb/budget/ep/fill/record/limit-person/save`
 * @更新时间 `2024-09-23 14:47:45`
 * @项目ID 2991
 */
const zlbBudgetEpFillRecordLimitPersonSavePostRequestConfig: ZlbBudgetEpFillRecordLimitPersonSavePostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_9,
    devUrl: devUrl_0_4_0_9,
    prodUrl: prodUrl_0_4_0_9,
    path: '/zlb/budget/ep/fill/record/limit-person/save',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_9,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbBudgetEpFillRecordLimitPersonSavePost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [年度预算管理-限制人员保存↗](http://yapi.cai-inc.com/project/2991/interface/api/662978) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [预算填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54092)
 * @请求头 `POST /zlb/budget/ep/fill/record/limit-person/save`
 * @更新时间 `2024-09-23 14:47:45`
 * @项目ID 2991
 */
export const zlbBudgetEpFillRecordLimitPersonSavePost = /*#__PURE__*/ (
  requestData: ZlbBudgetEpFillRecordLimitPersonSavePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetEpFillRecordLimitPersonSavePostResponse>(
    prepare(zlbBudgetEpFillRecordLimitPersonSavePostRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetEpFillRecordLimitPersonSavePost.requestConfig =
  zlbBudgetEpFillRecordLimitPersonSavePostRequestConfig;

/**
 * 接口 [导出预算支出明细执行情况表↗](http://yapi.cai-inc.com/project/2991/interface/api/665010) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [预算填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54092)
 * @请求头 `POST /zlb/budget/ep/fill/record/export/disburse-detail/submit`
 * @更新时间 `2024-07-23 17:01:52`
 * @项目ID 2991
 */
export interface ZlbBudgetEpFillRecordExportDisburseDetailSubmitPostRequest {
  /**
   * 填报部门id
   */
  fillDepartmentId?: number;
  /**
   * 开始时间
   */
  beginDate?: number;
  /**
   * 结束时间
   */
  endDate?: number;
  /**
   * 是否隐藏收入
   */
  hiddenIncome?: boolean;
  /**
   * 项目唯一编码
   */
  projectUk?: string;
  /**
   * 科目唯一编码
   */
  subjectUk?: string;
  /**
   * 科目分类：income-收入,disburse-支出
   */
  classify?: string;
  /**
   * 年度
   */
  year: number;
  /**
   * 用户部门id
   */
  departmentId?: number;
  /**
   * 页面大小
   */
  pageSize?: number;
  /**
   * 页码
   */
  pageNo?: number;
  /**
   * 排序字段
   */
  sortField?: string;
  /**
   * 排序规则：DESC || ASC
   */
  sortBy?: string;
}

/**
 * 接口 [导出预算支出明细执行情况表↗](http://yapi.cai-inc.com/project/2991/interface/api/665010) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [预算填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54092)
 * @请求头 `POST /zlb/budget/ep/fill/record/export/disburse-detail/submit`
 * @更新时间 `2024-07-23 17:01:52`
 * @项目ID 2991
 */
export interface ZlbBudgetEpFillRecordExportDisburseDetailSubmitPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: string;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [导出预算支出明细执行情况表↗](http://yapi.cai-inc.com/project/2991/interface/api/665010) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [预算填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54092)
 * @请求头 `POST /zlb/budget/ep/fill/record/export/disburse-detail/submit`
 * @更新时间 `2024-07-23 17:01:52`
 * @项目ID 2991
 */
type ZlbBudgetEpFillRecordExportDisburseDetailSubmitPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/ep/fill/record/export/disburse-detail/submit',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [导出预算支出明细执行情况表↗](http://yapi.cai-inc.com/project/2991/interface/api/665010) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [预算填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54092)
 * @请求头 `POST /zlb/budget/ep/fill/record/export/disburse-detail/submit`
 * @更新时间 `2024-07-23 17:01:52`
 * @项目ID 2991
 */
const zlbBudgetEpFillRecordExportDisburseDetailSubmitPostRequestConfig: ZlbBudgetEpFillRecordExportDisburseDetailSubmitPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_9,
    devUrl: devUrl_0_4_0_9,
    prodUrl: prodUrl_0_4_0_9,
    path: '/zlb/budget/ep/fill/record/export/disburse-detail/submit',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_9,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbBudgetEpFillRecordExportDisburseDetailSubmitPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [导出预算支出明细执行情况表↗](http://yapi.cai-inc.com/project/2991/interface/api/665010) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [预算填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54092)
 * @请求头 `POST /zlb/budget/ep/fill/record/export/disburse-detail/submit`
 * @更新时间 `2024-07-23 17:01:52`
 * @项目ID 2991
 */
export const zlbBudgetEpFillRecordExportDisburseDetailSubmitPost = /*#__PURE__*/ (
  requestData: ZlbBudgetEpFillRecordExportDisburseDetailSubmitPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetEpFillRecordExportDisburseDetailSubmitPostResponse>(
    prepare(zlbBudgetEpFillRecordExportDisburseDetailSubmitPostRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetEpFillRecordExportDisburseDetailSubmitPost.requestConfig =
  zlbBudgetEpFillRecordExportDisburseDetailSubmitPostRequestConfig;

/**
 * 接口 [导出项目执行情况表↗](http://yapi.cai-inc.com/project/2991/interface/api/665018) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [预算填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54092)
 * @请求头 `POST /zlb/budget/ep/fill/record/export/project-execute/submit`
 * @更新时间 `2024-09-23 14:47:45`
 * @项目ID 2991
 */
export interface ZlbBudgetEpFillRecordExportProjectExecuteSubmitPostRequest {
  pageSize?: number;
  pageNo?: number;
  sortField?: string;
  sortBy?: string;
  /**
   * 项目唯一编码
   */
  projectUk?: string;
  /**
   * 科目唯一编码
   */
  subjectUk?: string;
  /**
   * 科目分类：income-收入,disburse-支出
   */
  classify?: string;
  /**
   * 年度
   */
  year: number;
  /**
   * 用户部门id
   */
  departmentId?: number;
  /**
   * 填报部门id
   */
  fillDepartmentId?: number;
  /**
   * 开始时间
   */
  beginDate?: number;
  /**
   * 结束时间
   */
  endDate?: number;
  /**
   * 是否隐藏收入
   */
  hiddenIncome?: boolean;
}

/**
 * 接口 [导出项目执行情况表↗](http://yapi.cai-inc.com/project/2991/interface/api/665018) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [预算填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54092)
 * @请求头 `POST /zlb/budget/ep/fill/record/export/project-execute/submit`
 * @更新时间 `2024-09-23 14:47:45`
 * @项目ID 2991
 */
export interface ZlbBudgetEpFillRecordExportProjectExecuteSubmitPostResponse {
  success?: boolean;
  result?: string;
  code?: string;
  message?: string;
}

/**
 * 接口 [导出项目执行情况表↗](http://yapi.cai-inc.com/project/2991/interface/api/665018) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [预算填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54092)
 * @请求头 `POST /zlb/budget/ep/fill/record/export/project-execute/submit`
 * @更新时间 `2024-09-23 14:47:45`
 * @项目ID 2991
 */
type ZlbBudgetEpFillRecordExportProjectExecuteSubmitPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/ep/fill/record/export/project-execute/submit',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [导出项目执行情况表↗](http://yapi.cai-inc.com/project/2991/interface/api/665018) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [预算填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54092)
 * @请求头 `POST /zlb/budget/ep/fill/record/export/project-execute/submit`
 * @更新时间 `2024-09-23 14:47:45`
 * @项目ID 2991
 */
const zlbBudgetEpFillRecordExportProjectExecuteSubmitPostRequestConfig: ZlbBudgetEpFillRecordExportProjectExecuteSubmitPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_9,
    devUrl: devUrl_0_4_0_9,
    prodUrl: prodUrl_0_4_0_9,
    path: '/zlb/budget/ep/fill/record/export/project-execute/submit',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_9,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbBudgetEpFillRecordExportProjectExecuteSubmitPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [导出项目执行情况表↗](http://yapi.cai-inc.com/project/2991/interface/api/665018) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [预算填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54092)
 * @请求头 `POST /zlb/budget/ep/fill/record/export/project-execute/submit`
 * @更新时间 `2024-09-23 14:47:45`
 * @项目ID 2991
 */
export const zlbBudgetEpFillRecordExportProjectExecuteSubmitPost = /*#__PURE__*/ (
  requestData: ZlbBudgetEpFillRecordExportProjectExecuteSubmitPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetEpFillRecordExportProjectExecuteSubmitPostResponse>(
    prepare(zlbBudgetEpFillRecordExportProjectExecuteSubmitPostRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetEpFillRecordExportProjectExecuteSubmitPost.requestConfig =
  zlbBudgetEpFillRecordExportProjectExecuteSubmitPostRequestConfig;

/**
 * 接口 [冻结↗](http://yapi.cai-inc.com/project/2991/interface/api/686138) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [预算填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54092)
 * @请求头 `POST /zlb/budget/ep/fill/record/frozen`
 * @更新时间 `2024-09-23 14:47:46`
 * @项目ID 2991
 */
export interface ZlbBudgetEpFillRecordFrozenPostRequest {
  /**
   * 预算项目使用uk
   */
  bpuUk: string;
  /**
   * 操作人所属部门id
   */
  depId?: number;
}

/**
 * 接口 [冻结↗](http://yapi.cai-inc.com/project/2991/interface/api/686138) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [预算填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54092)
 * @请求头 `POST /zlb/budget/ep/fill/record/frozen`
 * @更新时间 `2024-09-23 14:47:46`
 * @项目ID 2991
 */
export interface ZlbBudgetEpFillRecordFrozenPostResponse {
  success?: boolean;
  result?: boolean;
  code?: string;
  message?: string;
}

/**
 * 接口 [冻结↗](http://yapi.cai-inc.com/project/2991/interface/api/686138) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [预算填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54092)
 * @请求头 `POST /zlb/budget/ep/fill/record/frozen`
 * @更新时间 `2024-09-23 14:47:46`
 * @项目ID 2991
 */
type ZlbBudgetEpFillRecordFrozenPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/ep/fill/record/frozen',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [冻结↗](http://yapi.cai-inc.com/project/2991/interface/api/686138) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [预算填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54092)
 * @请求头 `POST /zlb/budget/ep/fill/record/frozen`
 * @更新时间 `2024-09-23 14:47:46`
 * @项目ID 2991
 */
const zlbBudgetEpFillRecordFrozenPostRequestConfig: ZlbBudgetEpFillRecordFrozenPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_9,
    devUrl: devUrl_0_4_0_9,
    prodUrl: prodUrl_0_4_0_9,
    path: '/zlb/budget/ep/fill/record/frozen',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_9,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbBudgetEpFillRecordFrozenPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [冻结↗](http://yapi.cai-inc.com/project/2991/interface/api/686138) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [预算填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54092)
 * @请求头 `POST /zlb/budget/ep/fill/record/frozen`
 * @更新时间 `2024-09-23 14:47:46`
 * @项目ID 2991
 */
export const zlbBudgetEpFillRecordFrozenPost = /*#__PURE__*/ (
  requestData: ZlbBudgetEpFillRecordFrozenPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetEpFillRecordFrozenPostResponse>(
    prepare(zlbBudgetEpFillRecordFrozenPostRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetEpFillRecordFrozenPost.requestConfig = zlbBudgetEpFillRecordFrozenPostRequestConfig;

/**
 * 接口 [日志查询↗](http://yapi.cai-inc.com/project/2991/interface/api/686154) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [预算填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54092)
 * @请求头 `POST /zlb/budget/ep/fill/record/log/page`
 * @更新时间 `2024-09-23 14:47:46`
 * @项目ID 2991
 */
export interface ZlbBudgetEpFillRecordLogPagePostRequest {
  pageSize?: number;
  pageNo?: number;
  sortField?: string;
  sortBy?: string;
  /**
   * 预算项目使用uk
   */
  bpuUk: string;
}

/**
 * 接口 [日志查询↗](http://yapi.cai-inc.com/project/2991/interface/api/686154) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [预算填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54092)
 * @请求头 `POST /zlb/budget/ep/fill/record/log/page`
 * @更新时间 `2024-09-23 14:47:46`
 * @项目ID 2991
 */
export interface ZlbBudgetEpFillRecordLogPagePostResponse {
  success?: boolean;
  result?: {
    /**
     * 总记录数
     */
    total?: number;
    /**
     * 结果集
     */
    data?: {
      /**
       * 操作类型名称
       */
      operationTypeName?: string;
      /**
       * 操作人
       */
      operatorName?: string;
      /**
       * 部门名称 返回null 前端展示“-”
       */
      depName?: string;
      /**
       * 操作内容
       */
      content?: string;
      /**
       * 可用金额
       */
      availableAmount?: number;
      /**
       * 操作时间
       */
      operationTime?: string;
    }[];
    /**
     * 第几页
     */
    pageNum?: number;
    /**
     * 每页记录数
     */
    pageSize?: number;
    /**
     * 总页数
     */
    pages?: number;
    /**
     * 当前页的数量 <= pageSize，该属性来自ArrayList的size属性
     */
    size?: number;
  };
  code?: string;
  message?: string;
}

/**
 * 接口 [日志查询↗](http://yapi.cai-inc.com/project/2991/interface/api/686154) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [预算填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54092)
 * @请求头 `POST /zlb/budget/ep/fill/record/log/page`
 * @更新时间 `2024-09-23 14:47:46`
 * @项目ID 2991
 */
type ZlbBudgetEpFillRecordLogPagePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/ep/fill/record/log/page',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [日志查询↗](http://yapi.cai-inc.com/project/2991/interface/api/686154) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [预算填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54092)
 * @请求头 `POST /zlb/budget/ep/fill/record/log/page`
 * @更新时间 `2024-09-23 14:47:46`
 * @项目ID 2991
 */
const zlbBudgetEpFillRecordLogPagePostRequestConfig: ZlbBudgetEpFillRecordLogPagePostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_9,
    devUrl: devUrl_0_4_0_9,
    prodUrl: prodUrl_0_4_0_9,
    path: '/zlb/budget/ep/fill/record/log/page',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_9,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbBudgetEpFillRecordLogPagePost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [日志查询↗](http://yapi.cai-inc.com/project/2991/interface/api/686154) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [预算填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54092)
 * @请求头 `POST /zlb/budget/ep/fill/record/log/page`
 * @更新时间 `2024-09-23 14:47:46`
 * @项目ID 2991
 */
export const zlbBudgetEpFillRecordLogPagePost = /*#__PURE__*/ (
  requestData: ZlbBudgetEpFillRecordLogPagePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetEpFillRecordLogPagePostResponse>(
    prepare(zlbBudgetEpFillRecordLogPagePostRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetEpFillRecordLogPagePost.requestConfig = zlbBudgetEpFillRecordLogPagePostRequestConfig;

/**
 * 接口 [结转↗](http://yapi.cai-inc.com/project/2991/interface/api/686162) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [预算填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54092)
 * @请求头 `POST /zlb/budget/ep/fill/record/transfer`
 * @更新时间 `2024-09-23 14:47:46`
 * @项目ID 2991
 */
export interface ZlbBudgetEpFillRecordTransferPostRequest {
  /**
   * 预算项目使用uk
   */
  bpuUk: string;
  /**
   * 操作人所属部门id
   */
  depId?: number;
}

/**
 * 接口 [结转↗](http://yapi.cai-inc.com/project/2991/interface/api/686162) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [预算填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54092)
 * @请求头 `POST /zlb/budget/ep/fill/record/transfer`
 * @更新时间 `2024-09-23 14:47:46`
 * @项目ID 2991
 */
export interface ZlbBudgetEpFillRecordTransferPostResponse {
  success?: boolean;
  result?: boolean;
  code?: string;
  message?: string;
}

/**
 * 接口 [结转↗](http://yapi.cai-inc.com/project/2991/interface/api/686162) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [预算填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54092)
 * @请求头 `POST /zlb/budget/ep/fill/record/transfer`
 * @更新时间 `2024-09-23 14:47:46`
 * @项目ID 2991
 */
type ZlbBudgetEpFillRecordTransferPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/ep/fill/record/transfer',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [结转↗](http://yapi.cai-inc.com/project/2991/interface/api/686162) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [预算填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54092)
 * @请求头 `POST /zlb/budget/ep/fill/record/transfer`
 * @更新时间 `2024-09-23 14:47:46`
 * @项目ID 2991
 */
const zlbBudgetEpFillRecordTransferPostRequestConfig: ZlbBudgetEpFillRecordTransferPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_9,
    devUrl: devUrl_0_4_0_9,
    prodUrl: prodUrl_0_4_0_9,
    path: '/zlb/budget/ep/fill/record/transfer',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_9,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbBudgetEpFillRecordTransferPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [结转↗](http://yapi.cai-inc.com/project/2991/interface/api/686162) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [预算填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54092)
 * @请求头 `POST /zlb/budget/ep/fill/record/transfer`
 * @更新时间 `2024-09-23 14:47:46`
 * @项目ID 2991
 */
export const zlbBudgetEpFillRecordTransferPost = /*#__PURE__*/ (
  requestData: ZlbBudgetEpFillRecordTransferPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetEpFillRecordTransferPostResponse>(
    prepare(zlbBudgetEpFillRecordTransferPostRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetEpFillRecordTransferPost.requestConfig = zlbBudgetEpFillRecordTransferPostRequestConfig;

/**
 * 接口 [批量结转↗](http://yapi.cai-inc.com/project/2991/interface/api/686170) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [预算填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54092)
 * @请求头 `POST /zlb/budget/ep/fill/record/batch-transfer`
 * @更新时间 `2024-09-23 14:47:46`
 * @项目ID 2991
 */
export interface ZlbBudgetEpFillRecordBatchTransferPostRequest {
  /**
   * 结转记录集合
   */
  transferList: {
    /**
     * 预算项目使用uk
     */
    bpuUk: string;
    /**
     * 操作人所属部门id
     */
    depId?: number;
  }[];
}

/**
 * 接口 [批量结转↗](http://yapi.cai-inc.com/project/2991/interface/api/686170) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [预算填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54092)
 * @请求头 `POST /zlb/budget/ep/fill/record/batch-transfer`
 * @更新时间 `2024-09-23 14:47:46`
 * @项目ID 2991
 */
export interface ZlbBudgetEpFillRecordBatchTransferPostResponse {
  success?: boolean;
  result?: boolean;
  code?: string;
  message?: string;
}

/**
 * 接口 [批量结转↗](http://yapi.cai-inc.com/project/2991/interface/api/686170) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [预算填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54092)
 * @请求头 `POST /zlb/budget/ep/fill/record/batch-transfer`
 * @更新时间 `2024-09-23 14:47:46`
 * @项目ID 2991
 */
type ZlbBudgetEpFillRecordBatchTransferPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/ep/fill/record/batch-transfer',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [批量结转↗](http://yapi.cai-inc.com/project/2991/interface/api/686170) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [预算填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54092)
 * @请求头 `POST /zlb/budget/ep/fill/record/batch-transfer`
 * @更新时间 `2024-09-23 14:47:46`
 * @项目ID 2991
 */
const zlbBudgetEpFillRecordBatchTransferPostRequestConfig: ZlbBudgetEpFillRecordBatchTransferPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_9,
    devUrl: devUrl_0_4_0_9,
    prodUrl: prodUrl_0_4_0_9,
    path: '/zlb/budget/ep/fill/record/batch-transfer',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_9,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbBudgetEpFillRecordBatchTransferPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [批量结转↗](http://yapi.cai-inc.com/project/2991/interface/api/686170) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [预算填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54092)
 * @请求头 `POST /zlb/budget/ep/fill/record/batch-transfer`
 * @更新时间 `2024-09-23 14:47:46`
 * @项目ID 2991
 */
export const zlbBudgetEpFillRecordBatchTransferPost = /*#__PURE__*/ (
  requestData: ZlbBudgetEpFillRecordBatchTransferPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetEpFillRecordBatchTransferPostResponse>(
    prepare(zlbBudgetEpFillRecordBatchTransferPostRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetEpFillRecordBatchTransferPost.requestConfig =
  zlbBudgetEpFillRecordBatchTransferPostRequestConfig;

/**
 * 接口 [解冻↗](http://yapi.cai-inc.com/project/2991/interface/api/687058) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [预算填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54092)
 * @请求头 `POST /zlb/budget/ep/fill/record/un-frozen`
 * @更新时间 `2024-09-23 14:47:46`
 * @项目ID 2991
 */
export interface ZlbBudgetEpFillRecordUnFrozenPostRequest {
  /**
   * 预算项目使用uk
   */
  bpuUk: string;
  /**
   * 操作人所属部门id
   */
  depId?: number;
}

/**
 * 接口 [解冻↗](http://yapi.cai-inc.com/project/2991/interface/api/687058) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [预算填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54092)
 * @请求头 `POST /zlb/budget/ep/fill/record/un-frozen`
 * @更新时间 `2024-09-23 14:47:46`
 * @项目ID 2991
 */
export interface ZlbBudgetEpFillRecordUnFrozenPostResponse {
  success?: boolean;
  result?: boolean;
  code?: string;
  message?: string;
}

/**
 * 接口 [解冻↗](http://yapi.cai-inc.com/project/2991/interface/api/687058) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [预算填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54092)
 * @请求头 `POST /zlb/budget/ep/fill/record/un-frozen`
 * @更新时间 `2024-09-23 14:47:46`
 * @项目ID 2991
 */
type ZlbBudgetEpFillRecordUnFrozenPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/ep/fill/record/un-frozen',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [解冻↗](http://yapi.cai-inc.com/project/2991/interface/api/687058) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [预算填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54092)
 * @请求头 `POST /zlb/budget/ep/fill/record/un-frozen`
 * @更新时间 `2024-09-23 14:47:46`
 * @项目ID 2991
 */
const zlbBudgetEpFillRecordUnFrozenPostRequestConfig: ZlbBudgetEpFillRecordUnFrozenPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_9,
    devUrl: devUrl_0_4_0_9,
    prodUrl: prodUrl_0_4_0_9,
    path: '/zlb/budget/ep/fill/record/un-frozen',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_9,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbBudgetEpFillRecordUnFrozenPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [解冻↗](http://yapi.cai-inc.com/project/2991/interface/api/687058) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [预算填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54092)
 * @请求头 `POST /zlb/budget/ep/fill/record/un-frozen`
 * @更新时间 `2024-09-23 14:47:46`
 * @项目ID 2991
 */
export const zlbBudgetEpFillRecordUnFrozenPost = /*#__PURE__*/ (
  requestData: ZlbBudgetEpFillRecordUnFrozenPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetEpFillRecordUnFrozenPostResponse>(
    prepare(zlbBudgetEpFillRecordUnFrozenPostRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetEpFillRecordUnFrozenPost.requestConfig = zlbBudgetEpFillRecordUnFrozenPostRequestConfig;

/**
 * 接口 [导出预算执行情况表↗](http://yapi.cai-inc.com/project/2991/interface/api/705554) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [预算填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54092)
 * @请求头 `POST /zlb/budget/ep/fill/record/export/budget-execute/submit`
 * @更新时间 `2024-09-23 14:47:45`
 * @项目ID 2991
 */
export interface ZlbBudgetEpFillRecordExportBudgetExecuteSubmitPostRequest {
  pageSize?: number;
  pageNo?: number;
  sortField?: string;
  sortBy?: string;
  /**
   * 项目唯一编码
   */
  projectUk?: string;
  /**
   * 科目唯一编码
   */
  subjectUk?: string;
  /**
   * 科目分类：income-收入,disburse-支出
   */
  classify?: string;
  /**
   * 年度
   */
  year: number;
  /**
   * 用户部门id
   */
  departmentId?: number;
  /**
   * 填报部门id
   */
  fillDepartmentId?: number;
  /**
   * 开始时间
   */
  beginDate?: number;
  /**
   * 结束时间
   */
  endDate?: number;
  /**
   * 是否隐藏收入
   */
  hiddenIncome?: boolean;
}

/**
 * 接口 [导出预算执行情况表↗](http://yapi.cai-inc.com/project/2991/interface/api/705554) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [预算填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54092)
 * @请求头 `POST /zlb/budget/ep/fill/record/export/budget-execute/submit`
 * @更新时间 `2024-09-23 14:47:45`
 * @项目ID 2991
 */
export interface ZlbBudgetEpFillRecordExportBudgetExecuteSubmitPostResponse {
  success?: boolean;
  result?: string;
  code?: string;
  message?: string;
}

/**
 * 接口 [导出预算执行情况表↗](http://yapi.cai-inc.com/project/2991/interface/api/705554) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [预算填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54092)
 * @请求头 `POST /zlb/budget/ep/fill/record/export/budget-execute/submit`
 * @更新时间 `2024-09-23 14:47:45`
 * @项目ID 2991
 */
type ZlbBudgetEpFillRecordExportBudgetExecuteSubmitPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/ep/fill/record/export/budget-execute/submit',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [导出预算执行情况表↗](http://yapi.cai-inc.com/project/2991/interface/api/705554) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [预算填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54092)
 * @请求头 `POST /zlb/budget/ep/fill/record/export/budget-execute/submit`
 * @更新时间 `2024-09-23 14:47:45`
 * @项目ID 2991
 */
const zlbBudgetEpFillRecordExportBudgetExecuteSubmitPostRequestConfig: ZlbBudgetEpFillRecordExportBudgetExecuteSubmitPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_9,
    devUrl: devUrl_0_4_0_9,
    prodUrl: prodUrl_0_4_0_9,
    path: '/zlb/budget/ep/fill/record/export/budget-execute/submit',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_9,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbBudgetEpFillRecordExportBudgetExecuteSubmitPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [导出预算执行情况表↗](http://yapi.cai-inc.com/project/2991/interface/api/705554) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [预算填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54092)
 * @请求头 `POST /zlb/budget/ep/fill/record/export/budget-execute/submit`
 * @更新时间 `2024-09-23 14:47:45`
 * @项目ID 2991
 */
export const zlbBudgetEpFillRecordExportBudgetExecuteSubmitPost = /*#__PURE__*/ (
  requestData: ZlbBudgetEpFillRecordExportBudgetExecuteSubmitPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetEpFillRecordExportBudgetExecuteSubmitPostResponse>(
    prepare(zlbBudgetEpFillRecordExportBudgetExecuteSubmitPostRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetEpFillRecordExportBudgetExecuteSubmitPost.requestConfig =
  zlbBudgetEpFillRecordExportBudgetExecuteSubmitPostRequestConfig;

/**
 * 接口 [提交校验↗](http://yapi.cai-inc.com/project/2991/interface/api/707010) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [预算填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54092)
 * @请求头 `POST /zlb/budget/ep/fill/record/submit/check`
 * @更新时间 `2024-09-23 14:47:43`
 * @项目ID 2991
 */
export interface ZlbBudgetEpFillRecordSubmitCheckPostRequest {
  pageSize?: number;
  pageNo?: number;
  sortField?: string;
  sortBy?: string;
  /**
   * 项目唯一编码
   */
  projectUk?: string;
  /**
   * 科目唯一编码
   */
  subjectUk?: string;
  /**
   * 科目分类：income-收入,disburse-支出
   */
  classify?: string;
  /**
   * 年度
   */
  year: number;
  /**
   * 用户部门id
   */
  departmentId?: number;
}

/**
 * 接口 [提交校验↗](http://yapi.cai-inc.com/project/2991/interface/api/707010) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [预算填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54092)
 * @请求头 `POST /zlb/budget/ep/fill/record/submit/check`
 * @更新时间 `2024-09-23 14:47:43`
 * @项目ID 2991
 */
export interface ZlbBudgetEpFillRecordSubmitCheckPostResponse {
  success?: boolean;
  result?: {
    /**
     * 是否超过浮动范围
     */
    exceedRatio?: boolean;
    /**
     * 项目超过浮动详情
     */
    projectExceedFloatRemarkList?: {
      /**
       * 项目uk
       */
      projectUk?: string;
      /**
       * 项目名称
       */
      projectName?: string;
      /**
       * 收支类型 income-收入 disburse-支出
       */
      subjectClassify?: string;
      /**
       * 收支类型 income-收入 disburse-支出
       */
      subjectClassifyDesc?: string;
      /**
       * 浮动控制比例下限
       */
      floatingRatioMin?: number;
      /**
       * 浮动控制比例上限
       */
      floatingRatioMax?: number;
      /**
       * 当前浮动比例
       */
      currRatio?: number;
    }[];
  };
  code?: string;
  message?: string;
}

/**
 * 接口 [提交校验↗](http://yapi.cai-inc.com/project/2991/interface/api/707010) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [预算填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54092)
 * @请求头 `POST /zlb/budget/ep/fill/record/submit/check`
 * @更新时间 `2024-09-23 14:47:43`
 * @项目ID 2991
 */
type ZlbBudgetEpFillRecordSubmitCheckPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/ep/fill/record/submit/check',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [提交校验↗](http://yapi.cai-inc.com/project/2991/interface/api/707010) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [预算填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54092)
 * @请求头 `POST /zlb/budget/ep/fill/record/submit/check`
 * @更新时间 `2024-09-23 14:47:43`
 * @项目ID 2991
 */
const zlbBudgetEpFillRecordSubmitCheckPostRequestConfig: ZlbBudgetEpFillRecordSubmitCheckPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_9,
    devUrl: devUrl_0_4_0_9,
    prodUrl: prodUrl_0_4_0_9,
    path: '/zlb/budget/ep/fill/record/submit/check',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_9,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbBudgetEpFillRecordSubmitCheckPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [提交校验↗](http://yapi.cai-inc.com/project/2991/interface/api/707010) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [预算填报记录↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54092)
 * @请求头 `POST /zlb/budget/ep/fill/record/submit/check`
 * @更新时间 `2024-09-23 14:47:43`
 * @项目ID 2991
 */
export const zlbBudgetEpFillRecordSubmitCheckPost = /*#__PURE__*/ (
  requestData: ZlbBudgetEpFillRecordSubmitCheckPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetEpFillRecordSubmitCheckPostResponse>(
    prepare(zlbBudgetEpFillRecordSubmitCheckPostRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetEpFillRecordSubmitCheckPost.requestConfig =
  zlbBudgetEpFillRecordSubmitCheckPostRequestConfig;

const mockUrl_0_4_0_10 = 'http://yapi.cai-inc.com/mock/2991' as any;
const devUrl_0_4_0_10 = '' as any;
const prodUrl_0_4_0_10 = '' as any;
const dataKey_0_4_0_10 = 'data' as any;

/**
 * 接口 [撤销↗](http://yapi.cai-inc.com/project/2991/interface/api/583082) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [预算填报单工作流相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54162)
 * @请求头 `POST /zlb/budget/perform/fill/workflow/cancel`
 * @更新时间 `2024-02-22 17:13:21`
 * @项目ID 2991
 */
export interface ZlbBudgetPerformFillWorkflowCancelPostRequest {
  /**
   * 业务编码
   */
  bizId?: string;
  /**
   * 业务类型
   */
  bizType?: string;
  /**
   * 业务子类型
   */
  subType?: string;
  /**
   * 备注
   */
  remark?: string;
  /**
   * 操作人
   */
  operatorId?: number;
}

/**
 * 接口 [撤销↗](http://yapi.cai-inc.com/project/2991/interface/api/583082) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [预算填报单工作流相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54162)
 * @请求头 `POST /zlb/budget/perform/fill/workflow/cancel`
 * @更新时间 `2024-02-22 17:13:21`
 * @项目ID 2991
 */
export interface ZlbBudgetPerformFillWorkflowCancelPostResponse {
  success?: boolean;
  code?: string;
  message?: string;
  result?: {};
}

/**
 * 接口 [撤销↗](http://yapi.cai-inc.com/project/2991/interface/api/583082) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [预算填报单工作流相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54162)
 * @请求头 `POST /zlb/budget/perform/fill/workflow/cancel`
 * @更新时间 `2024-02-22 17:13:21`
 * @项目ID 2991
 */
type ZlbBudgetPerformFillWorkflowCancelPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/perform/fill/workflow/cancel',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [撤销↗](http://yapi.cai-inc.com/project/2991/interface/api/583082) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [预算填报单工作流相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54162)
 * @请求头 `POST /zlb/budget/perform/fill/workflow/cancel`
 * @更新时间 `2024-02-22 17:13:21`
 * @项目ID 2991
 */
const zlbBudgetPerformFillWorkflowCancelPostRequestConfig: ZlbBudgetPerformFillWorkflowCancelPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_10,
    devUrl: devUrl_0_4_0_10,
    prodUrl: prodUrl_0_4_0_10,
    path: '/zlb/budget/perform/fill/workflow/cancel',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_10,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbBudgetPerformFillWorkflowCancelPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [撤销↗](http://yapi.cai-inc.com/project/2991/interface/api/583082) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [预算填报单工作流相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54162)
 * @请求头 `POST /zlb/budget/perform/fill/workflow/cancel`
 * @更新时间 `2024-02-22 17:13:21`
 * @项目ID 2991
 */
export const zlbBudgetPerformFillWorkflowCancelPost = /*#__PURE__*/ (
  requestData: ZlbBudgetPerformFillWorkflowCancelPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetPerformFillWorkflowCancelPostResponse>(
    prepare(zlbBudgetPerformFillWorkflowCancelPostRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetPerformFillWorkflowCancelPost.requestConfig =
  zlbBudgetPerformFillWorkflowCancelPostRequestConfig;

/**
 * 接口 [加签（添加审批人）↗](http://yapi.cai-inc.com/project/2991/interface/api/583090) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [预算填报单工作流相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54162)
 * @请求头 `POST /zlb/budget/perform/fill/workflow/addOperator`
 * @更新时间 `2024-02-22 17:13:29`
 * @项目ID 2991
 */
export interface ZlbBudgetPerformFillWorkflowAddOperatorPostRequest {
  /**
   * 必填，业务标识
   */
  bizId?: string;
  /**
   * 必填, 业务场景
   */
  bizType?: string;
  /**
   * 必填, 子类型
   */
  subType?: string;
  /**
   * 必填, 前加签 后加签
   */
  countersignType?: number;
  /**
   * 当前审批节点key
   */
  curTaskDefineKey?: string;
  /**
   * 加签人
   */
  operatorIds?: number[];
  /**
   * 备注
   */
  remark?: string;
  /**
   * 上下文
   */
  context?: string;
  /**
   * 操作人
   */
  operatorId?: number;
}

/**
 * 接口 [加签（添加审批人）↗](http://yapi.cai-inc.com/project/2991/interface/api/583090) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [预算填报单工作流相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54162)
 * @请求头 `POST /zlb/budget/perform/fill/workflow/addOperator`
 * @更新时间 `2024-02-22 17:13:29`
 * @项目ID 2991
 */
export interface ZlbBudgetPerformFillWorkflowAddOperatorPostResponse {
  success?: boolean;
  code?: string;
  message?: string;
  result?: {};
}

/**
 * 接口 [加签（添加审批人）↗](http://yapi.cai-inc.com/project/2991/interface/api/583090) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [预算填报单工作流相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54162)
 * @请求头 `POST /zlb/budget/perform/fill/workflow/addOperator`
 * @更新时间 `2024-02-22 17:13:29`
 * @项目ID 2991
 */
type ZlbBudgetPerformFillWorkflowAddOperatorPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/perform/fill/workflow/addOperator',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [加签（添加审批人）↗](http://yapi.cai-inc.com/project/2991/interface/api/583090) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [预算填报单工作流相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54162)
 * @请求头 `POST /zlb/budget/perform/fill/workflow/addOperator`
 * @更新时间 `2024-02-22 17:13:29`
 * @项目ID 2991
 */
const zlbBudgetPerformFillWorkflowAddOperatorPostRequestConfig: ZlbBudgetPerformFillWorkflowAddOperatorPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_10,
    devUrl: devUrl_0_4_0_10,
    prodUrl: prodUrl_0_4_0_10,
    path: '/zlb/budget/perform/fill/workflow/addOperator',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_10,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbBudgetPerformFillWorkflowAddOperatorPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [加签（添加审批人）↗](http://yapi.cai-inc.com/project/2991/interface/api/583090) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [预算填报单工作流相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54162)
 * @请求头 `POST /zlb/budget/perform/fill/workflow/addOperator`
 * @更新时间 `2024-02-22 17:13:29`
 * @项目ID 2991
 */
export const zlbBudgetPerformFillWorkflowAddOperatorPost = /*#__PURE__*/ (
  requestData: ZlbBudgetPerformFillWorkflowAddOperatorPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetPerformFillWorkflowAddOperatorPostResponse>(
    prepare(zlbBudgetPerformFillWorkflowAddOperatorPostRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetPerformFillWorkflowAddOperatorPost.requestConfig =
  zlbBudgetPerformFillWorkflowAddOperatorPostRequestConfig;

/**
 * 接口 [加签（添加审批节点）↗](http://yapi.cai-inc.com/project/2991/interface/api/583098) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [预算填报单工作流相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54162)
 * @请求头 `POST /zlb/budget/perform/fill/workflow/addNode`
 * @更新时间 `2024-02-22 17:13:37`
 * @项目ID 2991
 */
export interface ZlbBudgetPerformFillWorkflowAddNodePostRequest {
  /**
   * 必填，业务标识
   */
  bizId?: string;
  /**
   * 必填, 业务场景
   */
  bizType?: string;
  /**
   * 必填, 子类型
   */
  subType?: string;
  /**
   * 必填, 前加签 后加签
   */
  countersignType?: number;
  /**
   * 当前审批节点key
   */
  curTaskDefineKey?: string;
  /**
   * 加签人
   */
  operatorIds?: number[];
  /**
   * 备注
   */
  remark?: string;
  /**
   * 上下文
   */
  context?: string;
  /**
   * 操作人
   */
  operatorId?: number;
}

/**
 * 接口 [加签（添加审批节点）↗](http://yapi.cai-inc.com/project/2991/interface/api/583098) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [预算填报单工作流相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54162)
 * @请求头 `POST /zlb/budget/perform/fill/workflow/addNode`
 * @更新时间 `2024-02-22 17:13:37`
 * @项目ID 2991
 */
export interface ZlbBudgetPerformFillWorkflowAddNodePostResponse {
  success?: boolean;
  code?: string;
  message?: string;
  result?: {};
}

/**
 * 接口 [加签（添加审批节点）↗](http://yapi.cai-inc.com/project/2991/interface/api/583098) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [预算填报单工作流相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54162)
 * @请求头 `POST /zlb/budget/perform/fill/workflow/addNode`
 * @更新时间 `2024-02-22 17:13:37`
 * @项目ID 2991
 */
type ZlbBudgetPerformFillWorkflowAddNodePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/perform/fill/workflow/addNode',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [加签（添加审批节点）↗](http://yapi.cai-inc.com/project/2991/interface/api/583098) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [预算填报单工作流相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54162)
 * @请求头 `POST /zlb/budget/perform/fill/workflow/addNode`
 * @更新时间 `2024-02-22 17:13:37`
 * @项目ID 2991
 */
const zlbBudgetPerformFillWorkflowAddNodePostRequestConfig: ZlbBudgetPerformFillWorkflowAddNodePostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_10,
    devUrl: devUrl_0_4_0_10,
    prodUrl: prodUrl_0_4_0_10,
    path: '/zlb/budget/perform/fill/workflow/addNode',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_10,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbBudgetPerformFillWorkflowAddNodePost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [加签（添加审批节点）↗](http://yapi.cai-inc.com/project/2991/interface/api/583098) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [预算填报单工作流相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54162)
 * @请求头 `POST /zlb/budget/perform/fill/workflow/addNode`
 * @更新时间 `2024-02-22 17:13:37`
 * @项目ID 2991
 */
export const zlbBudgetPerformFillWorkflowAddNodePost = /*#__PURE__*/ (
  requestData: ZlbBudgetPerformFillWorkflowAddNodePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetPerformFillWorkflowAddNodePostResponse>(
    prepare(zlbBudgetPerformFillWorkflowAddNodePostRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetPerformFillWorkflowAddNodePost.requestConfig =
  zlbBudgetPerformFillWorkflowAddNodePostRequestConfig;

/**
 * 接口 [审批↗](http://yapi.cai-inc.com/project/2991/interface/api/583106) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [预算填报单工作流相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54162)
 * @请求头 `POST /zlb/budget/perform/fill/workflow/audit`
 * @更新时间 `2024-02-22 17:13:43`
 * @项目ID 2991
 */
export interface ZlbBudgetPerformFillWorkflowAuditPostRequest {
  /**
   * 业务单据编码
   */
  bizId?: string;
  /**
   * 业务类型
   */
  bizType?: string;
  /**
   * 业务子类型
   */
  subType?: string;
  /**
   * 审批备注
   */
  auditRemark?: string;
  /**
   * 审批类型
   */
  executeType?: number;
  /**
   * 工作流类型Key
   */
  processDefineKey?: string;
  /**
   * 当前节点key
   */
  currentNodeKey?: string;
  /**
   * 操作人
   */
  operatorId?: number;
  context?: string;
  /**
   * 事件类型：0-审批，1-审核，2-出纳
   */
  eventType?: number;
  /**
   * 签名相关
   */
  signAttachment?: {
    fileId?: string;
    type?: string;
    name?: string;
    size?: number;
    bizCode?: string;
    url?: string;
    sizeDesc?: string;
  };
}

/**
 * 接口 [审批↗](http://yapi.cai-inc.com/project/2991/interface/api/583106) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [预算填报单工作流相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54162)
 * @请求头 `POST /zlb/budget/perform/fill/workflow/audit`
 * @更新时间 `2024-02-22 17:13:43`
 * @项目ID 2991
 */
export interface ZlbBudgetPerformFillWorkflowAuditPostResponse {
  success?: boolean;
  code?: string;
  message?: string;
  result?: {};
}

/**
 * 接口 [审批↗](http://yapi.cai-inc.com/project/2991/interface/api/583106) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [预算填报单工作流相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54162)
 * @请求头 `POST /zlb/budget/perform/fill/workflow/audit`
 * @更新时间 `2024-02-22 17:13:43`
 * @项目ID 2991
 */
type ZlbBudgetPerformFillWorkflowAuditPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/perform/fill/workflow/audit',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [审批↗](http://yapi.cai-inc.com/project/2991/interface/api/583106) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [预算填报单工作流相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54162)
 * @请求头 `POST /zlb/budget/perform/fill/workflow/audit`
 * @更新时间 `2024-02-22 17:13:43`
 * @项目ID 2991
 */
const zlbBudgetPerformFillWorkflowAuditPostRequestConfig: ZlbBudgetPerformFillWorkflowAuditPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_10,
    devUrl: devUrl_0_4_0_10,
    prodUrl: prodUrl_0_4_0_10,
    path: '/zlb/budget/perform/fill/workflow/audit',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_10,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbBudgetPerformFillWorkflowAuditPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [审批↗](http://yapi.cai-inc.com/project/2991/interface/api/583106) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [预算填报单工作流相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54162)
 * @请求头 `POST /zlb/budget/perform/fill/workflow/audit`
 * @更新时间 `2024-02-22 17:13:43`
 * @项目ID 2991
 */
export const zlbBudgetPerformFillWorkflowAuditPost = /*#__PURE__*/ (
  requestData: ZlbBudgetPerformFillWorkflowAuditPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetPerformFillWorkflowAuditPostResponse>(
    prepare(zlbBudgetPerformFillWorkflowAuditPostRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetPerformFillWorkflowAuditPost.requestConfig =
  zlbBudgetPerformFillWorkflowAuditPostRequestConfig;

/**
 * 接口 [提交↗](http://yapi.cai-inc.com/project/2991/interface/api/583114) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [预算填报单工作流相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54162)
 * @请求头 `POST /zlb/budget/perform/fill/workflow/submit`
 * @更新时间 `2024-02-22 17:13:52`
 * @项目ID 2991
 */
export interface ZlbBudgetPerformFillWorkflowSubmitPostRequest {
  /**
   * 预算填报单
   */
  bizId?: string;
  /**
   * 必填, 单据类型
   */
  bizType?: string;
  /**
   * 必填, 子单据类型
   */
  subType?: string;
  /**
   * 必填, 工作流key
   */
  processDefineKey?: string;
  /**
   * 必填, 工作流ModelId
   */
  processModelId?: number;
  /**
   * 必填, 工作流版本
   */
  version?: number;
  /**
   * 审批节点
   */
  auditInfos?: {
    /**
     * 节点key
     */
    taskDefineKey: string;
    /**
     * 审批人
     */
    operatorIds: number[];
  }[];
  /**
   * {
   *    "year":2023 // 年度
   * }
   *
   *
   */
  context?: string;
  /**
   * 当前操作人Id
   */
  operatorId?: number;
}

/**
 * 接口 [提交↗](http://yapi.cai-inc.com/project/2991/interface/api/583114) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [预算填报单工作流相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54162)
 * @请求头 `POST /zlb/budget/perform/fill/workflow/submit`
 * @更新时间 `2024-02-22 17:13:52`
 * @项目ID 2991
 */
export interface ZlbBudgetPerformFillWorkflowSubmitPostResponse {
  success?: boolean;
  code?: string;
  message?: string;
  result?: {};
}

/**
 * 接口 [提交↗](http://yapi.cai-inc.com/project/2991/interface/api/583114) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [预算填报单工作流相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54162)
 * @请求头 `POST /zlb/budget/perform/fill/workflow/submit`
 * @更新时间 `2024-02-22 17:13:52`
 * @项目ID 2991
 */
type ZlbBudgetPerformFillWorkflowSubmitPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/perform/fill/workflow/submit',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [提交↗](http://yapi.cai-inc.com/project/2991/interface/api/583114) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [预算填报单工作流相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54162)
 * @请求头 `POST /zlb/budget/perform/fill/workflow/submit`
 * @更新时间 `2024-02-22 17:13:52`
 * @项目ID 2991
 */
const zlbBudgetPerformFillWorkflowSubmitPostRequestConfig: ZlbBudgetPerformFillWorkflowSubmitPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_10,
    devUrl: devUrl_0_4_0_10,
    prodUrl: prodUrl_0_4_0_10,
    path: '/zlb/budget/perform/fill/workflow/submit',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_10,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbBudgetPerformFillWorkflowSubmitPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [提交↗](http://yapi.cai-inc.com/project/2991/interface/api/583114) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [预算填报单工作流相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54162)
 * @请求头 `POST /zlb/budget/perform/fill/workflow/submit`
 * @更新时间 `2024-02-22 17:13:52`
 * @项目ID 2991
 */
export const zlbBudgetPerformFillWorkflowSubmitPost = /*#__PURE__*/ (
  requestData: ZlbBudgetPerformFillWorkflowSubmitPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetPerformFillWorkflowSubmitPostResponse>(
    prepare(zlbBudgetPerformFillWorkflowSubmitPostRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetPerformFillWorkflowSubmitPost.requestConfig =
  zlbBudgetPerformFillWorkflowSubmitPostRequestConfig;

/**
 * 接口 [获取工作流实例↗](http://yapi.cai-inc.com/project/2991/interface/api/583122) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [预算填报单工作流相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54162)
 * @请求头 `POST /zlb/budget/perform/fill/workflow/getInstance`
 * @更新时间 `2024-02-22 17:12:44`
 * @项目ID 2991
 */
export interface ZlbBudgetPerformFillWorkflowGetInstancePostRequest {
  /**
   * 流程key
   */
  processDefineKey: string;
  /**
   * 业务Id
   */
  bizId: string;
  /**
   * 业务类型
   */
  bizType: string;
  /**
   * 业务子类型
   */
  subType?: string;
  /**
   * 操作人
   */
  operatorId?: string;
  /**
   * 部门ID 查询部门主管需要
   */
  departmentId?: string;
  amount?: string;
  /**
   * 同行人
   */
  accompanyOperatorIds?: string;
}

/**
 * 接口 [获取工作流实例↗](http://yapi.cai-inc.com/project/2991/interface/api/583122) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [预算填报单工作流相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54162)
 * @请求头 `POST /zlb/budget/perform/fill/workflow/getInstance`
 * @更新时间 `2024-02-22 17:12:44`
 * @项目ID 2991
 */
export interface ZlbBudgetPerformFillWorkflowGetInstancePostResponse {
  success?: boolean;
  code?: string;
  message?: string;
  result?: {
    /**
     * 工作流key
     */
    workflowProcessKey?: string;
    /**
     * 工作流ModelId
     */
    workflowModelId?: number;
    /**
     * 工作流版本
     */
    workflowVersion?: number;
    /**
     * 申请人ID
     */
    applyOperatorId?: number;
    /**
     * 申请人姓名
     */
    applyOperatorName?: string;
    /**
     * 申请时间
     */
    applyTime?: string;
    /**
     * 申请说明
     */
    applyRemark?: string;
    /**
     * 是否能加签 0-否 1-是
     */
    isAddTaskAccess?: number;
    /**
     * 工作流是否开启签名：true-开启；false-未开启
     */
    isEnableSign?: boolean;
    /**
     * 签名配置：0-使用上次签名；1-每次重新签名；
     */
    signConfig?: number;
    /**
     * 审核节点列表
     */
    auditNodeList?: {
      /**
       * 审核用户类型：0-"按部门"；1-"按全机构";2-"全平台";3-"按岗位"
       */
      userRangeType?: number;
      userRangeTypeNew?: number;
      /**
       * 对应userRangeType的值
       */
      userRangeValues?: string[];
      userRangeValuesNew?: string[];
      /**
       * 审核人数(总人数)
       */
      personCount?: number;
      /**
       * 审核状态：0-待审批，1-已审批，2-审批驳回
       */
      auditStatus?: number;
      /**
       * 审核时间
       */
      auditTime?: string;
      /**
       * 审核描述
       */
      auditDesc?: string;
      /**
       * 审批类型：0-或签，1-会签，2-依次审批
       */
      auditType?: number;
      /**
       * 事件类型：0-审批，1-审核，2-出纳
       */
      eventType?: number;
      /**
       * 是否自选:0-指定，1-自选
       */
      nodeType?: number;
      /**
       * 节点key
       */
      nodeKey?: string;
      /**
       * 节点名称
       */
      nodeName?: string;
      /**
       * 审批策略：单人、多人会签、依次会签
       */
      checkStrategy?: number;
      /**
       * 部门id （为了获取部门主管）
       */
      departmentId?: number;
      /**
       * 审核人列表
       */
      auditOperatorList?: {
        /**
         * 审批意见
         */
        auditRemark?: string;
        /**
         * 审批状态：0-待审批，1-审批通过，2-审批驳回
         */
        auditStatus?: number;
        /**
         * 审核时间
         */
        auditTime?: string;
        /**
         * 签名附件
         */
        signAttachment?: {
          fileId?: string;
          type?: string;
          name?: string;
          size?: number;
          bizCode?: string;
          url?: string;
          sizeDesc?: string;
        };
        /**
         * 最新的个人历史签名附件
         */
        oneselfHistorySignAttachment?: {
          fileId?: string;
          type?: string;
          name?: string;
          size?: number;
          bizCode?: string;
          url?: string;
          sizeDesc?: string;
        };
        /**
         * 人员id
         */
        operatorId?: number;
        /**
         * 人员Name
         */
        operatorName?: string;
        /**
         * 机构ID
         */
        institutionId?: number;
        /**
         * 机构Name
         */
        institutionName?: string;
      }[];
      /**
       * 机构
       */
      institutionSelfDtos?: {
        /**
         * 机构编码
         */
        code?: string;
        /**
         * 机构Name
         */
        name?: string;
        /**
         * 人员类型
         */
        userType?: string;
        /**
         * 租户编码
         */
        tenantCode?: string;
        /**
         * 租户Name
         */
        tenantName?: string;
        /**
         * 唯一key
         */
        uniqueKey?: string;
        /**
         * 父机构
         */
        parentInstitution?: {
          parentCode?: number;
          parentName?: string;
        };
      }[];
      /**
       * 常用审核人列表
       */
      commonAuditorList?: {
        code?: string;
        name?: string;
        userType?: string;
        tenantCode?: string;
        tenantName?: string;
        uniqueKey?: string;
        parentInstitution?: {
          parentCode?: number;
          parentName?: string;
        };
      }[];
    }[];
  };
}

/**
 * 接口 [获取工作流实例↗](http://yapi.cai-inc.com/project/2991/interface/api/583122) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [预算填报单工作流相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54162)
 * @请求头 `POST /zlb/budget/perform/fill/workflow/getInstance`
 * @更新时间 `2024-02-22 17:12:44`
 * @项目ID 2991
 */
type ZlbBudgetPerformFillWorkflowGetInstancePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/perform/fill/workflow/getInstance',
    'data',
    string,
    | 'processDefineKey'
    | 'bizId'
    | 'bizType'
    | 'subType'
    | 'operatorId'
    | 'departmentId'
    | 'amount'
    | 'accompanyOperatorIds',
    false
  >
>;

/**
 * 接口 [获取工作流实例↗](http://yapi.cai-inc.com/project/2991/interface/api/583122) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [预算填报单工作流相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54162)
 * @请求头 `POST /zlb/budget/perform/fill/workflow/getInstance`
 * @更新时间 `2024-02-22 17:12:44`
 * @项目ID 2991
 */
const zlbBudgetPerformFillWorkflowGetInstancePostRequestConfig: ZlbBudgetPerformFillWorkflowGetInstancePostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_10,
    devUrl: devUrl_0_4_0_10,
    prodUrl: prodUrl_0_4_0_10,
    path: '/zlb/budget/perform/fill/workflow/getInstance',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_10,
    paramNames: [],
    queryNames: [
      'processDefineKey',
      'bizId',
      'bizType',
      'subType',
      'operatorId',
      'departmentId',
      'amount',
      'accompanyOperatorIds',
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbBudgetPerformFillWorkflowGetInstancePost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [获取工作流实例↗](http://yapi.cai-inc.com/project/2991/interface/api/583122) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [预算填报单工作流相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54162)
 * @请求头 `POST /zlb/budget/perform/fill/workflow/getInstance`
 * @更新时间 `2024-02-22 17:12:44`
 * @项目ID 2991
 */
export const zlbBudgetPerformFillWorkflowGetInstancePost = /*#__PURE__*/ (
  requestData: ZlbBudgetPerformFillWorkflowGetInstancePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetPerformFillWorkflowGetInstancePostResponse>(
    prepare(zlbBudgetPerformFillWorkflowGetInstancePostRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetPerformFillWorkflowGetInstancePost.requestConfig =
  zlbBudgetPerformFillWorkflowGetInstancePostRequestConfig;

/**
 * 接口 [获取工作流模板↗](http://yapi.cai-inc.com/project/2991/interface/api/583130) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [预算填报单工作流相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54162)
 * @请求头 `POST /zlb/budget/perform/fill/workflow/getTemplate`
 * @更新时间 `2024-02-22 17:13:11`
 * @项目ID 2991
 */
export interface ZlbBudgetPerformFillWorkflowGetTemplatePostRequest {
  /**
   * 流程key
   */
  processDefineKey: string;
  /**
   * 业务Id
   */
  bizId: string;
  /**
   * 业务类型
   */
  bizType: string;
  /**
   * 业务子类型
   */
  subType?: string;
  /**
   * 操作人
   */
  operatorId?: string;
  /**
   * 部门ID 查询部门主管需要
   */
  departmentId?: string;
  amount?: string;
  /**
   * 同行人
   */
  accompanyOperatorIds?: string;
}

/**
 * 接口 [获取工作流模板↗](http://yapi.cai-inc.com/project/2991/interface/api/583130) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [预算填报单工作流相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54162)
 * @请求头 `POST /zlb/budget/perform/fill/workflow/getTemplate`
 * @更新时间 `2024-02-22 17:13:11`
 * @项目ID 2991
 */
export interface ZlbBudgetPerformFillWorkflowGetTemplatePostResponse {
  success?: boolean;
  code?: string;
  message?: string;
  result?: {
    /**
     * 工作流key
     */
    workflowProcessKey?: string;
    /**
     * 工作流ModelId
     */
    workflowModelId?: number;
    /**
     * 工作流版本
     */
    workflowVersion?: number;
    /**
     * 审核节点列表
     */
    auditNodeList?: {
      /**
       * 审核用户类型：0-"按部门"；1-"按全机构";2-"全平台";3-"按岗位"
       */
      userRangeType?: number;
      userRangeTypeNew?: number;
      /**
       * 对应userRangeType的值
       */
      userRangeValues?: string[];
      userRangeValuesNew?: string[];
      /**
       * 审核人数(总人数)
       */
      personCount?: number;
      /**
       * 审核状态：0-待审批，1-已审批，2-审批驳回
       */
      auditStatus?: number;
      /**
       * 审核时间
       */
      auditTime?: string;
      /**
       * 审核描述
       */
      auditDesc?: string;
      /**
       * 审批类型：0-或签，1-会签，2-依次审批
       */
      auditType?: number;
      /**
       * 事件类型：0-审批，1-审核，2-出纳
       */
      eventType?: number;
      /**
       * 是否自选:0-指定，1-自选
       */
      nodeType?: number;
      /**
       * 节点key
       */
      nodeKey?: string;
      /**
       * 节点名称
       */
      nodeName?: string;
      /**
       * 审批策略：单人、多人会签、依次会签
       */
      checkStrategy?: number;
      /**
       * 部门id （为了获取部门主管）
       */
      departmentId?: number;
      /**
       * 审核人列表
       */
      auditOperatorList?: {
        /**
         * 审批意见
         */
        auditRemark?: string;
        /**
         * 审批状态：0-待审批，1-审批通过，2-审批驳回
         */
        auditStatus?: number;
        /**
         * 审核时间
         */
        auditTime?: string;
        /**
         * 签名附件
         */
        signAttachment?: {
          fileId?: string;
          type?: string;
          name?: string;
          size?: number;
          bizCode?: string;
          url?: string;
          sizeDesc?: string;
        };
        /**
         * 最新的个人历史签名附件
         */
        oneselfHistorySignAttachment?: {
          fileId?: string;
          type?: string;
          name?: string;
          size?: number;
          bizCode?: string;
          url?: string;
          sizeDesc?: string;
        };
        /**
         * 人员id
         */
        operatorId?: number;
        /**
         * 人员Name
         */
        operatorName?: string;
        /**
         * 机构ID
         */
        institutionId?: number;
        /**
         * 机构Name
         */
        institutionName?: string;
      }[];
      /**
       * 机构
       */
      institutionSelfDtos?: {
        /**
         * 机构编码
         */
        code?: string;
        /**
         * 机构Name
         */
        name?: string;
        /**
         * 人员类型
         */
        userType?: string;
        /**
         * 租户编码
         */
        tenantCode?: string;
        /**
         * 租户Name
         */
        tenantName?: string;
        /**
         * 唯一key
         */
        uniqueKey?: string;
        /**
         * 父机构
         */
        parentInstitution?: {
          parentCode?: number;
          parentName?: string;
        };
      }[];
      /**
       * 常用审核人列表
       */
      commonAuditorList?: {
        code?: string;
        name?: string;
        userType?: string;
        tenantCode?: string;
        tenantName?: string;
        uniqueKey?: string;
        parentInstitution?: {
          parentCode?: number;
          parentName?: string;
        };
      }[];
    }[];
  };
}

/**
 * 接口 [获取工作流模板↗](http://yapi.cai-inc.com/project/2991/interface/api/583130) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [预算填报单工作流相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54162)
 * @请求头 `POST /zlb/budget/perform/fill/workflow/getTemplate`
 * @更新时间 `2024-02-22 17:13:11`
 * @项目ID 2991
 */
type ZlbBudgetPerformFillWorkflowGetTemplatePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/perform/fill/workflow/getTemplate',
    'data',
    string,
    | 'processDefineKey'
    | 'bizId'
    | 'bizType'
    | 'subType'
    | 'operatorId'
    | 'departmentId'
    | 'amount'
    | 'accompanyOperatorIds',
    false
  >
>;

/**
 * 接口 [获取工作流模板↗](http://yapi.cai-inc.com/project/2991/interface/api/583130) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [预算填报单工作流相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54162)
 * @请求头 `POST /zlb/budget/perform/fill/workflow/getTemplate`
 * @更新时间 `2024-02-22 17:13:11`
 * @项目ID 2991
 */
const zlbBudgetPerformFillWorkflowGetTemplatePostRequestConfig: ZlbBudgetPerformFillWorkflowGetTemplatePostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_10,
    devUrl: devUrl_0_4_0_10,
    prodUrl: prodUrl_0_4_0_10,
    path: '/zlb/budget/perform/fill/workflow/getTemplate',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_10,
    paramNames: [],
    queryNames: [
      'processDefineKey',
      'bizId',
      'bizType',
      'subType',
      'operatorId',
      'departmentId',
      'amount',
      'accompanyOperatorIds',
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbBudgetPerformFillWorkflowGetTemplatePost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [获取工作流模板↗](http://yapi.cai-inc.com/project/2991/interface/api/583130) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [预算填报单工作流相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54162)
 * @请求头 `POST /zlb/budget/perform/fill/workflow/getTemplate`
 * @更新时间 `2024-02-22 17:13:11`
 * @项目ID 2991
 */
export const zlbBudgetPerformFillWorkflowGetTemplatePost = /*#__PURE__*/ (
  requestData: ZlbBudgetPerformFillWorkflowGetTemplatePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetPerformFillWorkflowGetTemplatePostResponse>(
    prepare(zlbBudgetPerformFillWorkflowGetTemplatePostRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetPerformFillWorkflowGetTemplatePost.requestConfig =
  zlbBudgetPerformFillWorkflowGetTemplatePostRequestConfig;

const mockUrl_0_4_0_11 = 'http://yapi.cai-inc.com/mock/2991' as any;
const devUrl_0_4_0_11 = '' as any;
const prodUrl_0_4_0_11 = '' as any;
const dataKey_0_4_0_11 = 'data' as any;

/**
 * 接口 [支付限额_分页查询↗](http://yapi.cai-inc.com/project/2991/interface/api/596698) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [预算限额相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54429)
 * @请求头 `GET /zlb/budget/plan/page`
 * @更新时间 `2023-12-25 14:54:13`
 * @项目ID 2991
 */
export interface ZlbBudgetPlanPageGetRequest {
  /**
   * 年份
   */
  year: string;
  /**
   * 一体化的支付限额ID
   */
  financialBudgetPlanId?: string;
  /**
   * 一体化指标ID
   */
  financialBudgetDetailId?: string;
  /**
   * 指标文号
   */
  purchaseNo?: string;
  /**
   * 预算项目名称
   */
  projectName?: string;
  /**
   * 部门经济科目编码
   */
  depEconomicClassifyCode?: string;
  pageSize?: string;
  pageNo?: string;
  sortField?: string;
  sortBy?: string;
}

/**
 * 接口 [支付限额_分页查询↗](http://yapi.cai-inc.com/project/2991/interface/api/596698) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [预算限额相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54429)
 * @请求头 `GET /zlb/budget/plan/page`
 * @更新时间 `2023-12-25 14:54:13`
 * @项目ID 2991
 */
export interface ZlbBudgetPlanPageGetResponse {
  success?: boolean;
  result?: {
    total?: number;
    data?: {
      /**
       * 主键
       */
      id?: number;
      /**
       * 唯一编码
       */
      uk?: string;
      /**
       * 一体化预算指标ID
       */
      financialBudgetDetailId?: string;
      /**
       * 一体化的支付限额ID
       */
      financialBudgetPlanId?: string;
      /**
       * 年份
       */
      year?: number;
      /**
       * 月份
       */
      month?: number;
      /**
       * 指标文号
       */
      purchaseNo?: string;
      /**
       * 项目编码
       */
      projectCode?: string;
      /**
       * 项目名称
       */
      projectName?: string;
      /**
       * 功能科目代码
       */
      functionCode?: string;
      /**
       * 功能科目名称
       */
      functionName?: string;
      /**
       * 资金性质编码
       */
      fundTypeCode?: string;
      /**
       * 资金性质名称
       */
      fundTypeName?: string;
      /**
       * 部门经济科目编码
       */
      depEconomicClassifyCode?: string;
      /**
       * 部门经济科目名称
       */
      depEconomicClassifyName?: string;
      /**
       * 总金额
       */
      totalAmount?: number;
    }[];
    pageNum?: number;
    pageSize?: number;
    pages?: number;
    size?: number;
  };
  code?: string;
  message?: string;
}

/**
 * 接口 [支付限额_分页查询↗](http://yapi.cai-inc.com/project/2991/interface/api/596698) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [预算限额相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54429)
 * @请求头 `GET /zlb/budget/plan/page`
 * @更新时间 `2023-12-25 14:54:13`
 * @项目ID 2991
 */
type ZlbBudgetPlanPageGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/plan/page',
    'data',
    string,
    | 'year'
    | 'financialBudgetPlanId'
    | 'financialBudgetDetailId'
    | 'purchaseNo'
    | 'projectName'
    | 'depEconomicClassifyCode'
    | 'pageSize'
    | 'pageNo'
    | 'sortField'
    | 'sortBy',
    false
  >
>;

/**
 * 接口 [支付限额_分页查询↗](http://yapi.cai-inc.com/project/2991/interface/api/596698) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [预算限额相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54429)
 * @请求头 `GET /zlb/budget/plan/page`
 * @更新时间 `2023-12-25 14:54:13`
 * @项目ID 2991
 */
const zlbBudgetPlanPageGetRequestConfig: ZlbBudgetPlanPageGetRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_4_0_11,
  devUrl: devUrl_0_4_0_11,
  prodUrl: prodUrl_0_4_0_11,
  path: '/zlb/budget/plan/page',
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_4_0_11,
  paramNames: [],
  queryNames: [
    'year',
    'financialBudgetPlanId',
    'financialBudgetDetailId',
    'purchaseNo',
    'projectName',
    'depEconomicClassifyCode',
    'pageSize',
    'pageNo',
    'sortField',
    'sortBy',
  ],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'zlbBudgetPlanPageGet',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * 接口 [支付限额_分页查询↗](http://yapi.cai-inc.com/project/2991/interface/api/596698) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [预算限额相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54429)
 * @请求头 `GET /zlb/budget/plan/page`
 * @更新时间 `2023-12-25 14:54:13`
 * @项目ID 2991
 */
export const zlbBudgetPlanPageGet = /*#__PURE__*/ (
  requestData: ZlbBudgetPlanPageGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetPlanPageGetResponse>(
    prepare(zlbBudgetPlanPageGetRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetPlanPageGet.requestConfig = zlbBudgetPlanPageGetRequestConfig;

/**
 * 接口 [支付限额_查询详情↗](http://yapi.cai-inc.com/project/2991/interface/api/596706) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [预算限额相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54429)
 * @请求头 `GET /zlb/budget/plan/info/{uk}`
 * @更新时间 `2023-12-23 16:21:09`
 * @项目ID 2991
 */
export interface ZlbBudgetPlanInfoUkGetRequest {
  uk: string;
}

/**
 * 接口 [支付限额_查询详情↗](http://yapi.cai-inc.com/project/2991/interface/api/596706) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [预算限额相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54429)
 * @请求头 `GET /zlb/budget/plan/info/{uk}`
 * @更新时间 `2023-12-23 16:21:09`
 * @项目ID 2991
 */
export interface ZlbBudgetPlanInfoUkGetResponse {
  success?: boolean;
  result?: {
    /**
     * 月份
     */
    month?: number;
    /**
     * 指标文号
     */
    purchaseNo?: string;
    /**
     * 一体化指标ID
     */
    financialBudgetDetailId?: string;
    /**
     * 一体化的支付限额ID
     */
    financialBudgetPlanId?: string;
    /**
     * 项目名称
     */
    projectName?: string;
    /**
     * 预算单位名称
     */
    orgName?: string;
    /**
     * 资金性质名称
     */
    fundTypeName?: string;
    /**
     * 主管业务处室
     */
    businessSupervisorOfficeName?: string;
    /**
     * 是否科研1是0否
     */
    isTech?: number;
    /**
     * 更新时间
     */
    syncTime?: string;
    /**
     * 指标类型名称
     */
    budgetTypeName?: string;
    /**
     * 支付类型名称
     */
    payTypeName?: string;
    /**
     * 发布状态：0:待发布、1:可使用、2:冻结中、3:不可用
     */
    publishStatus?: number;
    /**
     * 支出功能分类科目名称
     */
    expendFunctionClassifySubjectName?: string;
    /**
     * 政府经济科目名称
     */
    govExpendEconomicClassifyName?: string;
    /**
     * 部门经济科目名称
     */
    depExpendEconomicClassifyName?: string;
    /**
     * 是否采购1是0否
     */
    isPurchase?: number;
    /**
     * 年份
     */
    year?: number;
    /**
     * 采购目录名称
     */
    buyCatalogName?: string;
    /**
     * 采购类型名称
     */
    buyTypeName?: string;
    /**
     * 总金额
     */
    totalAmount?: number;
  };
  code?: string;
  message?: string;
}

/**
 * 接口 [支付限额_查询详情↗](http://yapi.cai-inc.com/project/2991/interface/api/596706) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [预算限额相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54429)
 * @请求头 `GET /zlb/budget/plan/info/{uk}`
 * @更新时间 `2023-12-23 16:21:09`
 * @项目ID 2991
 */
type ZlbBudgetPlanInfoUkGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/plan/info/{uk}',
    'data',
    'uk',
    string,
    false
  >
>;

/**
 * 接口 [支付限额_查询详情↗](http://yapi.cai-inc.com/project/2991/interface/api/596706) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [预算限额相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54429)
 * @请求头 `GET /zlb/budget/plan/info/{uk}`
 * @更新时间 `2023-12-23 16:21:09`
 * @项目ID 2991
 */
const zlbBudgetPlanInfoUkGetRequestConfig: ZlbBudgetPlanInfoUkGetRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_4_0_11,
  devUrl: devUrl_0_4_0_11,
  prodUrl: prodUrl_0_4_0_11,
  path: '/zlb/budget/plan/info/{uk}',
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_4_0_11,
  paramNames: ['uk'],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'zlbBudgetPlanInfoUkGet',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * 接口 [支付限额_查询详情↗](http://yapi.cai-inc.com/project/2991/interface/api/596706) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [预算限额相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54429)
 * @请求头 `GET /zlb/budget/plan/info/{uk}`
 * @更新时间 `2023-12-23 16:21:09`
 * @项目ID 2991
 */
export const zlbBudgetPlanInfoUkGet = /*#__PURE__*/ (
  requestData: ZlbBudgetPlanInfoUkGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetPlanInfoUkGetResponse>(
    prepare(zlbBudgetPlanInfoUkGetRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetPlanInfoUkGet.requestConfig = zlbBudgetPlanInfoUkGetRequestConfig;

/**
 * 接口 [支付限额_获取同步时间↗](http://yapi.cai-inc.com/project/2991/interface/api/596714) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [预算限额相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54429)
 * @请求头 `GET /zlb/budget/plan/sync/info`
 * @更新时间 `2023-12-23 16:21:09`
 * @项目ID 2991
 */
export interface ZlbBudgetPlanSyncInfoGetRequest {}

/**
 * 接口 [支付限额_获取同步时间↗](http://yapi.cai-inc.com/project/2991/interface/api/596714) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [预算限额相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54429)
 * @请求头 `GET /zlb/budget/plan/sync/info`
 * @更新时间 `2023-12-23 16:21:09`
 * @项目ID 2991
 */
export interface ZlbBudgetPlanSyncInfoGetResponse {
  success?: boolean;
  result?: {
    /**
     * 上次同步时间
     */
    lastSyncTime?: string;
  };
  code?: string;
  message?: string;
}

/**
 * 接口 [支付限额_获取同步时间↗](http://yapi.cai-inc.com/project/2991/interface/api/596714) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [预算限额相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54429)
 * @请求头 `GET /zlb/budget/plan/sync/info`
 * @更新时间 `2023-12-23 16:21:09`
 * @项目ID 2991
 */
type ZlbBudgetPlanSyncInfoGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/plan/sync/info',
    'data',
    string,
    string,
    true
  >
>;

/**
 * 接口 [支付限额_获取同步时间↗](http://yapi.cai-inc.com/project/2991/interface/api/596714) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [预算限额相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54429)
 * @请求头 `GET /zlb/budget/plan/sync/info`
 * @更新时间 `2023-12-23 16:21:09`
 * @项目ID 2991
 */
const zlbBudgetPlanSyncInfoGetRequestConfig: ZlbBudgetPlanSyncInfoGetRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_4_0_11,
  devUrl: devUrl_0_4_0_11,
  prodUrl: prodUrl_0_4_0_11,
  path: '/zlb/budget/plan/sync/info',
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_4_0_11,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'zlbBudgetPlanSyncInfoGet',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * 接口 [支付限额_获取同步时间↗](http://yapi.cai-inc.com/project/2991/interface/api/596714) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [预算限额相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54429)
 * @请求头 `GET /zlb/budget/plan/sync/info`
 * @更新时间 `2023-12-23 16:21:09`
 * @项目ID 2991
 */
export const zlbBudgetPlanSyncInfoGet = /*#__PURE__*/ (
  requestData?: ZlbBudgetPlanSyncInfoGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetPlanSyncInfoGetResponse>(
    prepare(zlbBudgetPlanSyncInfoGetRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetPlanSyncInfoGet.requestConfig = zlbBudgetPlanSyncInfoGetRequestConfig;

/**
 * 接口 [支付限额_同步限额数据↗](http://yapi.cai-inc.com/project/2991/interface/api/596722) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [预算限额相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54429)
 * @请求头 `POST /zlb/budget/plan/sync`
 * @更新时间 `2023-12-23 16:21:58`
 * @项目ID 2991
 */
export interface ZlbBudgetPlanSyncPostRequest {}

/**
 * 接口 [支付限额_同步限额数据↗](http://yapi.cai-inc.com/project/2991/interface/api/596722) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [预算限额相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54429)
 * @请求头 `POST /zlb/budget/plan/sync`
 * @更新时间 `2023-12-23 16:21:58`
 * @项目ID 2991
 */
export interface ZlbBudgetPlanSyncPostResponse {
  success?: boolean;
  result?: null;
  code?: string;
  message?: string;
}

/**
 * 接口 [支付限额_同步限额数据↗](http://yapi.cai-inc.com/project/2991/interface/api/596722) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [预算限额相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54429)
 * @请求头 `POST /zlb/budget/plan/sync`
 * @更新时间 `2023-12-23 16:21:58`
 * @项目ID 2991
 */
type ZlbBudgetPlanSyncPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/plan/sync',
    'data',
    string,
    string,
    true
  >
>;

/**
 * 接口 [支付限额_同步限额数据↗](http://yapi.cai-inc.com/project/2991/interface/api/596722) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [预算限额相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54429)
 * @请求头 `POST /zlb/budget/plan/sync`
 * @更新时间 `2023-12-23 16:21:58`
 * @项目ID 2991
 */
const zlbBudgetPlanSyncPostRequestConfig: ZlbBudgetPlanSyncPostRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_4_0_11,
  devUrl: devUrl_0_4_0_11,
  prodUrl: prodUrl_0_4_0_11,
  path: '/zlb/budget/plan/sync',
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_4_0_11,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'zlbBudgetPlanSyncPost',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * 接口 [支付限额_同步限额数据↗](http://yapi.cai-inc.com/project/2991/interface/api/596722) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [预算限额相关↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54429)
 * @请求头 `POST /zlb/budget/plan/sync`
 * @更新时间 `2023-12-23 16:21:58`
 * @项目ID 2991
 */
export const zlbBudgetPlanSyncPost = /*#__PURE__*/ (
  requestData?: ZlbBudgetPlanSyncPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetPlanSyncPostResponse>(
    prepare(zlbBudgetPlanSyncPostRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetPlanSyncPost.requestConfig = zlbBudgetPlanSyncPostRequestConfig;

const mockUrl_0_4_0_12 = 'http://yapi.cai-inc.com/mock/2991' as any;
const devUrl_0_4_0_12 = '' as any;
const prodUrl_0_4_0_12 = '' as any;
const dataKey_0_4_0_12 = 'data' as any;

/**
 * 接口 [预算申报单保存更新↗](http://yapi.cai-inc.com/project/2991/interface/api/609658) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [预算绩效申报单管理↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54685)
 * @请求头 `POST /zlb/budget/perform/report/save-or-update`
 * @更新时间 `2024-02-04 09:54:59`
 * @项目ID 2991
 */
export interface ZlbBudgetPerformReportSaveOrUpdatePostRequest {
  /**
   * 申报单单号
   */
  reportOrderNo?: string;
  /**
   * 年份
   */
  year?: number;
  /**
   * 项目uk
   */
  projectUk?: string;
  /**
   * 项目编码
   */
  projectCode?: string;
  /**
   * 项目名称
   */
  projectName?: string;
  /**
   * 所属部门id
   */
  ownDepartmentId?: number;
  /**
   * 父级所属部门名称
   */
  parentOwnDepartmentName?: string;
  /**
   * 所属部门名称
   */
  ownDepartmentName?: string;
  /**
   * 负责人ID
   */
  ownId?: number;
  /**
   * 负责人名称
   */
  ownName?: string;
  /**
   * 预算金额
   */
  budgetAmount?: number;
  /**
   * 总体预算目标
   */
  totalPerformTarget?: string;
  operatorId?: number;
  orgId?: number;
  /**
   * 附件
   */
  attachmentList?: {
    id?: number;
    /**
     * 附件OssId
     */
    fileId?: string;
    /**
     * 附件类型
     */
    type?: string;
    /**
     * 附件名称
     */
    name?: string;
    /**
     * 附件大小
     */
    size?: number;
  }[];
  /**
   * 所有实施计划
   */
  implementationPlans?: {
    uk?: string;
    fillOrderNo?: string;
    month?: number;
    monthDesc?: string;
    implementationPlan?: string;
    implementationProgress?: string;
    isPlanned?: number;
    executedAmount?: number;
    executedRate?: number;
    status?: number;
    statusDesc?: string;
    projectUk?: string;
  }[];
}

/**
 * 接口 [预算申报单保存更新↗](http://yapi.cai-inc.com/project/2991/interface/api/609658) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [预算绩效申报单管理↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54685)
 * @请求头 `POST /zlb/budget/perform/report/save-or-update`
 * @更新时间 `2024-02-04 09:54:59`
 * @项目ID 2991
 */
export interface ZlbBudgetPerformReportSaveOrUpdatePostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [预算申报单保存更新↗](http://yapi.cai-inc.com/project/2991/interface/api/609658) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [预算绩效申报单管理↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54685)
 * @请求头 `POST /zlb/budget/perform/report/save-or-update`
 * @更新时间 `2024-02-04 09:54:59`
 * @项目ID 2991
 */
type ZlbBudgetPerformReportSaveOrUpdatePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/perform/report/save-or-update',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [预算申报单保存更新↗](http://yapi.cai-inc.com/project/2991/interface/api/609658) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [预算绩效申报单管理↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54685)
 * @请求头 `POST /zlb/budget/perform/report/save-or-update`
 * @更新时间 `2024-02-04 09:54:59`
 * @项目ID 2991
 */
const zlbBudgetPerformReportSaveOrUpdatePostRequestConfig: ZlbBudgetPerformReportSaveOrUpdatePostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_12,
    devUrl: devUrl_0_4_0_12,
    prodUrl: prodUrl_0_4_0_12,
    path: '/zlb/budget/perform/report/save-or-update',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_12,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbBudgetPerformReportSaveOrUpdatePost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [预算申报单保存更新↗](http://yapi.cai-inc.com/project/2991/interface/api/609658) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [预算绩效申报单管理↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54685)
 * @请求头 `POST /zlb/budget/perform/report/save-or-update`
 * @更新时间 `2024-02-04 09:54:59`
 * @项目ID 2991
 */
export const zlbBudgetPerformReportSaveOrUpdatePost = /*#__PURE__*/ (
  requestData: ZlbBudgetPerformReportSaveOrUpdatePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetPerformReportSaveOrUpdatePostResponse>(
    prepare(zlbBudgetPerformReportSaveOrUpdatePostRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetPerformReportSaveOrUpdatePost.requestConfig =
  zlbBudgetPerformReportSaveOrUpdatePostRequestConfig;

/**
 * 接口 [经办人-查询申报单详情↗](http://yapi.cai-inc.com/project/2991/interface/api/609666) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [预算绩效申报单管理↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54685)
 * @请求头 `GET /zlb/budget/perform/report/agent/detail`
 * @更新时间 `2024-02-04 09:54:59`
 * @项目ID 2991
 */
export interface ZlbBudgetPerformReportAgentDetailGetRequest {
  /**
   * 申报单单号
   */
  reportOrderNo: string;
}

/**
 * 接口 [经办人-查询申报单详情↗](http://yapi.cai-inc.com/project/2991/interface/api/609666) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [预算绩效申报单管理↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54685)
 * @请求头 `GET /zlb/budget/perform/report/agent/detail`
 * @更新时间 `2024-02-04 09:54:59`
 * @项目ID 2991
 */
export interface ZlbBudgetPerformReportAgentDetailGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 申报单单号
     */
    reportOrderNo?: string;
    /**
     * 年份
     */
    year?: number;
    /**
     * 项目uk
     */
    projectUk?: string;
    /**
     * 项目编码
     */
    projectCode?: string;
    /**
     * 项目名称
     */
    projectName?: string;
    /**
     * 所属部门id
     */
    ownDepartmentId?: number;
    /**
     * 父级所属部门名称
     */
    parentOwnDepartmentName?: string;
    /**
     * 所属部门名称
     */
    ownDepartmentName?: string;
    /**
     * 负责人ID
     */
    ownId?: number;
    /**
     * 负责人名称
     */
    ownName?: string;
    /**
     * 预算金额
     */
    budgetAmount?: number;
    /**
     * 总体预算目标
     */
    totalPerformTarget?: string;
    operatorId?: number;
    orgId?: number;
    /**
     * 附件
     */
    attachmentList?: {
      id?: number;
      /**
       * 附件OssId
       */
      fileId?: string;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 附件名称
       */
      name?: string;
      /**
       * 附件大小
       */
      size?: number;
    }[];
    /**
     * 所有实施计划
     */
    implementationPlans?: {
      uk?: string;
      fillOrderNo?: string;
      month?: number;
      monthDesc?: string;
      implementationPlan?: string;
      implementationProgress?: string;
      isPlanned?: number;
      executedAmount?: number;
      executedRate?: number;
      status?: number;
      statusDesc?: string;
      projectUk?: string;
    }[];
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [经办人-查询申报单详情↗](http://yapi.cai-inc.com/project/2991/interface/api/609666) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [预算绩效申报单管理↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54685)
 * @请求头 `GET /zlb/budget/perform/report/agent/detail`
 * @更新时间 `2024-02-04 09:54:59`
 * @项目ID 2991
 */
type ZlbBudgetPerformReportAgentDetailGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/perform/report/agent/detail',
    'data',
    string,
    'reportOrderNo',
    false
  >
>;

/**
 * 接口 [经办人-查询申报单详情↗](http://yapi.cai-inc.com/project/2991/interface/api/609666) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [预算绩效申报单管理↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54685)
 * @请求头 `GET /zlb/budget/perform/report/agent/detail`
 * @更新时间 `2024-02-04 09:54:59`
 * @项目ID 2991
 */
const zlbBudgetPerformReportAgentDetailGetRequestConfig: ZlbBudgetPerformReportAgentDetailGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_12,
    devUrl: devUrl_0_4_0_12,
    prodUrl: prodUrl_0_4_0_12,
    path: '/zlb/budget/perform/report/agent/detail',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_12,
    paramNames: [],
    queryNames: ['reportOrderNo'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbBudgetPerformReportAgentDetailGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [经办人-查询申报单详情↗](http://yapi.cai-inc.com/project/2991/interface/api/609666) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [预算绩效申报单管理↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54685)
 * @请求头 `GET /zlb/budget/perform/report/agent/detail`
 * @更新时间 `2024-02-04 09:54:59`
 * @项目ID 2991
 */
export const zlbBudgetPerformReportAgentDetailGet = /*#__PURE__*/ (
  requestData: ZlbBudgetPerformReportAgentDetailGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetPerformReportAgentDetailGetResponse>(
    prepare(zlbBudgetPerformReportAgentDetailGetRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetPerformReportAgentDetailGet.requestConfig =
  zlbBudgetPerformReportAgentDetailGetRequestConfig;

/**
 * 接口 [经办人-查询申报单列表↗](http://yapi.cai-inc.com/project/2991/interface/api/609674) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [预算绩效申报单管理↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54685)
 * @请求头 `GET /zlb/budget/perform/report/agent/list`
 * @更新时间 `2024-02-04 09:55:00`
 * @项目ID 2991
 */
export interface ZlbBudgetPerformReportAgentListGetRequest {
  /**
   * 年份
   */
  year?: string;
  /**
   * 项目编码
   */
  projectCode?: string;
  /**
   * 年份
   */
  projectName?: string;
  /**
   * 所属部门id
   */
  ownDepartmentId?: string;
  /**
   * 状态
   */
  status?: string;
  /**
   * 是否展示只有异常的申报单
   */
  isException?: string;
  /**
   * 操作人ID
   */
  operatorId?: string;
  /**
   * 页面大小
   */
  pageSize?: string;
  /**
   * 页码
   */
  pageNo?: string;
  /**
   * 排序字段
   */
  sortField?: string;
  /**
   * 排序规则：DESC || ASC
   */
  sortBy?: string;
}

/**
 * 接口 [经办人-查询申报单列表↗](http://yapi.cai-inc.com/project/2991/interface/api/609674) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [预算绩效申报单管理↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54685)
 * @请求头 `GET /zlb/budget/perform/report/agent/list`
 * @更新时间 `2024-02-04 09:55:00`
 * @项目ID 2991
 */
export interface ZlbBudgetPerformReportAgentListGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 总记录数
     */
    total?: number;
    /**
     * 结果集
     */
    data?: {
      /**
       * 项目uk
       */
      projectUk?: string;
      /**
       * 项目编码
       */
      projectCode?: string;
      /**
       * 项目名称
       */
      projectName?: string;
      /**
       * 所属部门id
       */
      ownDepartmentId?: number;
      /**
       * 所属部门名称
       */
      ownDepartmentName?: string;
      /**
       * 父级所属部门
       */
      parentOwnDepartmentName?: string;
      /**
       * 负责人id
       */
      ownId?: number;
      /**
       * 负责人名字
       */
      ownName?: string;
      /**
       * 预算金额
       */
      budgetAmount?: number;
      /**
       * 状态
       */
      status?: number;
      /**
       * 状态描述
       */
      statusDesc?: string;
      /**
       * 最近填报
       */
      recentFill?: string;
      /**
       * 执行率
       */
      executedRate?: number;
      /**
       * 是否异常
       */
      isException?: number;
      /**
       * 列表按钮权限
       */
      listButton?: {
        /**
         * 是否可编辑
         */
        enableEdit?: boolean;
        /**
         * 是否能删除
         */
        enableDelete?: boolean;
        /**
         * 是否可查看
         */
        enableSearch?: boolean;
        /**
         * 是否撤回申报
         */
        enableReportRevoke?: boolean;
        /**
         * 是否撤回填报
         */
        enableFillRevoke?: boolean;
        /**
         * 是否可以填报
         */
        enableFill?: boolean;
        /**
         * 是否可转交
         */
        enableTransfer?: boolean;
      };
    }[];
    /**
     * 第几页
     */
    pageNum?: number;
    /**
     * 每页记录数
     */
    pageSize?: number;
    /**
     * 总页数
     */
    pages?: number;
    /**
     * 当前页的数量 <= pageSize，该属性来自ArrayList的size属性
     */
    size?: number;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [经办人-查询申报单列表↗](http://yapi.cai-inc.com/project/2991/interface/api/609674) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [预算绩效申报单管理↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54685)
 * @请求头 `GET /zlb/budget/perform/report/agent/list`
 * @更新时间 `2024-02-04 09:55:00`
 * @项目ID 2991
 */
type ZlbBudgetPerformReportAgentListGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/perform/report/agent/list',
    'data',
    string,
    | 'year'
    | 'projectCode'
    | 'projectName'
    | 'ownDepartmentId'
    | 'status'
    | 'isException'
    | 'operatorId'
    | 'pageSize'
    | 'pageNo'
    | 'sortField'
    | 'sortBy',
    false
  >
>;

/**
 * 接口 [经办人-查询申报单列表↗](http://yapi.cai-inc.com/project/2991/interface/api/609674) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [预算绩效申报单管理↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54685)
 * @请求头 `GET /zlb/budget/perform/report/agent/list`
 * @更新时间 `2024-02-04 09:55:00`
 * @项目ID 2991
 */
const zlbBudgetPerformReportAgentListGetRequestConfig: ZlbBudgetPerformReportAgentListGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_12,
    devUrl: devUrl_0_4_0_12,
    prodUrl: prodUrl_0_4_0_12,
    path: '/zlb/budget/perform/report/agent/list',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_12,
    paramNames: [],
    queryNames: [
      'year',
      'projectCode',
      'projectName',
      'ownDepartmentId',
      'status',
      'isException',
      'operatorId',
      'pageSize',
      'pageNo',
      'sortField',
      'sortBy',
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbBudgetPerformReportAgentListGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [经办人-查询申报单列表↗](http://yapi.cai-inc.com/project/2991/interface/api/609674) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [预算绩效申报单管理↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54685)
 * @请求头 `GET /zlb/budget/perform/report/agent/list`
 * @更新时间 `2024-02-04 09:55:00`
 * @项目ID 2991
 */
export const zlbBudgetPerformReportAgentListGet = /*#__PURE__*/ (
  requestData: ZlbBudgetPerformReportAgentListGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetPerformReportAgentListGetResponse>(
    prepare(zlbBudgetPerformReportAgentListGetRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetPerformReportAgentListGet.requestConfig = zlbBudgetPerformReportAgentListGetRequestConfig;

/**
 * 接口 [申报单删除↗](http://yapi.cai-inc.com/project/2991/interface/api/609682) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [预算绩效申报单管理↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54685)
 * @请求头 `POST /zlb/budget/perform/report/delete`
 * @更新时间 `2024-02-04 09:55:00`
 * @项目ID 2991
 */
export interface ZlbBudgetPerformReportDeletePostRequest {
  /**
   * 绩效申报单单号
   */
  reportOrderNo: string;
}

/**
 * 接口 [申报单删除↗](http://yapi.cai-inc.com/project/2991/interface/api/609682) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [预算绩效申报单管理↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54685)
 * @请求头 `POST /zlb/budget/perform/report/delete`
 * @更新时间 `2024-02-04 09:55:00`
 * @项目ID 2991
 */
export interface ZlbBudgetPerformReportDeletePostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [申报单删除↗](http://yapi.cai-inc.com/project/2991/interface/api/609682) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [预算绩效申报单管理↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54685)
 * @请求头 `POST /zlb/budget/perform/report/delete`
 * @更新时间 `2024-02-04 09:55:00`
 * @项目ID 2991
 */
type ZlbBudgetPerformReportDeletePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/perform/report/delete',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [申报单删除↗](http://yapi.cai-inc.com/project/2991/interface/api/609682) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [预算绩效申报单管理↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54685)
 * @请求头 `POST /zlb/budget/perform/report/delete`
 * @更新时间 `2024-02-04 09:55:00`
 * @项目ID 2991
 */
const zlbBudgetPerformReportDeletePostRequestConfig: ZlbBudgetPerformReportDeletePostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_12,
    devUrl: devUrl_0_4_0_12,
    prodUrl: prodUrl_0_4_0_12,
    path: '/zlb/budget/perform/report/delete',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_12,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbBudgetPerformReportDeletePost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [申报单删除↗](http://yapi.cai-inc.com/project/2991/interface/api/609682) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [预算绩效申报单管理↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54685)
 * @请求头 `POST /zlb/budget/perform/report/delete`
 * @更新时间 `2024-02-04 09:55:00`
 * @项目ID 2991
 */
export const zlbBudgetPerformReportDeletePost = /*#__PURE__*/ (
  requestData: ZlbBudgetPerformReportDeletePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetPerformReportDeletePostResponse>(
    prepare(zlbBudgetPerformReportDeletePostRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetPerformReportDeletePost.requestConfig = zlbBudgetPerformReportDeletePostRequestConfig;

/**
 * 接口 [绩效管理员-查询申报单列表↗](http://yapi.cai-inc.com/project/2991/interface/api/609690) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [预算绩效申报单管理↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54685)
 * @请求头 `GET /zlb/budget/perform/report/manager/list`
 * @更新时间 `2024-02-04 09:55:00`
 * @项目ID 2991
 */
export interface ZlbBudgetPerformReportManagerListGetRequest {
  /**
   * 年份
   */
  year?: string;
  /**
   * 项目编码
   */
  projectCode?: string;
  /**
   * 年份
   */
  projectName?: string;
  /**
   * 所属部门id
   */
  ownDepartmentId?: string;
  /**
   * 状态
   */
  status?: string;
  /**
   * 是否展示只有异常的申报单
   */
  isException?: string;
  /**
   * 操作人ID
   */
  operatorId?: string;
  /**
   * 页面大小
   */
  pageSize?: string;
  /**
   * 页码
   */
  pageNo?: string;
  /**
   * 排序字段
   */
  sortField?: string;
  /**
   * 排序规则：DESC || ASC
   */
  sortBy?: string;
}

/**
 * 接口 [绩效管理员-查询申报单列表↗](http://yapi.cai-inc.com/project/2991/interface/api/609690) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [预算绩效申报单管理↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54685)
 * @请求头 `GET /zlb/budget/perform/report/manager/list`
 * @更新时间 `2024-02-04 09:55:00`
 * @项目ID 2991
 */
export interface ZlbBudgetPerformReportManagerListGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 总记录数
     */
    total?: number;
    /**
     * 结果集
     */
    data?: {
      /**
       * 项目uk
       */
      projectUk?: string;
      /**
       * 项目编码
       */
      projectCode?: string;
      /**
       * 项目名称
       */
      projectName?: string;
      /**
       * 所属部门id
       */
      ownDepartmentId?: number;
      /**
       * 所属部门名称
       */
      ownDepartmentName?: string;
      /**
       * 父级所属部门
       */
      parentOwnDepartmentName?: string;
      /**
       * 负责人id
       */
      ownId?: number;
      /**
       * 负责人名字
       */
      ownName?: string;
      /**
       * 预算金额
       */
      budgetAmount?: number;
      /**
       * 状态
       */
      status?: number;
      /**
       * 状态描述
       */
      statusDesc?: string;
      /**
       * 最近填报
       */
      recentFill?: string;
      /**
       * 执行率
       */
      executedRate?: number;
      /**
       * 是否异常
       */
      isException?: number;
      /**
       * 列表按钮权限
       */
      listButton?: {
        /**
         * 是否可编辑
         */
        enableEdit?: boolean;
        /**
         * 是否能删除
         */
        enableDelete?: boolean;
        /**
         * 是否可查看
         */
        enableSearch?: boolean;
        /**
         * 是否撤回申报
         */
        enableReportRevoke?: boolean;
        /**
         * 是否撤回填报
         */
        enableFillRevoke?: boolean;
        /**
         * 是否可以填报
         */
        enableFill?: boolean;
        /**
         * 是否可转交
         */
        enableTransfer?: boolean;
      };
    }[];
    /**
     * 第几页
     */
    pageNum?: number;
    /**
     * 每页记录数
     */
    pageSize?: number;
    /**
     * 总页数
     */
    pages?: number;
    /**
     * 当前页的数量 <= pageSize，该属性来自ArrayList的size属性
     */
    size?: number;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [绩效管理员-查询申报单列表↗](http://yapi.cai-inc.com/project/2991/interface/api/609690) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [预算绩效申报单管理↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54685)
 * @请求头 `GET /zlb/budget/perform/report/manager/list`
 * @更新时间 `2024-02-04 09:55:00`
 * @项目ID 2991
 */
type ZlbBudgetPerformReportManagerListGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/perform/report/manager/list',
    'data',
    string,
    | 'year'
    | 'projectCode'
    | 'projectName'
    | 'ownDepartmentId'
    | 'status'
    | 'isException'
    | 'operatorId'
    | 'pageSize'
    | 'pageNo'
    | 'sortField'
    | 'sortBy',
    false
  >
>;

/**
 * 接口 [绩效管理员-查询申报单列表↗](http://yapi.cai-inc.com/project/2991/interface/api/609690) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [预算绩效申报单管理↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54685)
 * @请求头 `GET /zlb/budget/perform/report/manager/list`
 * @更新时间 `2024-02-04 09:55:00`
 * @项目ID 2991
 */
const zlbBudgetPerformReportManagerListGetRequestConfig: ZlbBudgetPerformReportManagerListGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_12,
    devUrl: devUrl_0_4_0_12,
    prodUrl: prodUrl_0_4_0_12,
    path: '/zlb/budget/perform/report/manager/list',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_12,
    paramNames: [],
    queryNames: [
      'year',
      'projectCode',
      'projectName',
      'ownDepartmentId',
      'status',
      'isException',
      'operatorId',
      'pageSize',
      'pageNo',
      'sortField',
      'sortBy',
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbBudgetPerformReportManagerListGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [绩效管理员-查询申报单列表↗](http://yapi.cai-inc.com/project/2991/interface/api/609690) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [预算绩效申报单管理↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54685)
 * @请求头 `GET /zlb/budget/perform/report/manager/list`
 * @更新时间 `2024-02-04 09:55:00`
 * @项目ID 2991
 */
export const zlbBudgetPerformReportManagerListGet = /*#__PURE__*/ (
  requestData: ZlbBudgetPerformReportManagerListGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetPerformReportManagerListGetResponse>(
    prepare(zlbBudgetPerformReportManagerListGetRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetPerformReportManagerListGet.requestConfig =
  zlbBudgetPerformReportManagerListGetRequestConfig;

/**
 * 接口 [绩效管理员-查询申报单详情↗](http://yapi.cai-inc.com/project/2991/interface/api/609698) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [预算绩效申报单管理↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54685)
 * @请求头 `GET /zlb/budget/perform/report/manager/detail`
 * @更新时间 `2024-02-04 09:55:00`
 * @项目ID 2991
 */
export interface ZlbBudgetPerformReportManagerDetailGetRequest {
  /**
   * 申报单单号
   */
  reportOrderNo: string;
}

/**
 * 接口 [绩效管理员-查询申报单详情↗](http://yapi.cai-inc.com/project/2991/interface/api/609698) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [预算绩效申报单管理↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54685)
 * @请求头 `GET /zlb/budget/perform/report/manager/detail`
 * @更新时间 `2024-02-04 09:55:00`
 * @项目ID 2991
 */
export interface ZlbBudgetPerformReportManagerDetailGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 申报单单号
     */
    reportOrderNo?: string;
    /**
     * 年份
     */
    year?: number;
    /**
     * 项目uk
     */
    projectUk?: string;
    /**
     * 项目编码
     */
    projectCode?: string;
    /**
     * 项目名称
     */
    projectName?: string;
    /**
     * 所属部门id
     */
    ownDepartmentId?: number;
    /**
     * 父级所属部门名称
     */
    parentOwnDepartmentName?: string;
    /**
     * 所属部门名称
     */
    ownDepartmentName?: string;
    /**
     * 负责人ID
     */
    ownId?: number;
    /**
     * 负责人名称
     */
    ownName?: string;
    /**
     * 预算金额
     */
    budgetAmount?: number;
    /**
     * 总体预算目标
     */
    totalPerformTarget?: string;
    operatorId?: number;
    orgId?: number;
    /**
     * 附件
     */
    attachmentList?: {
      id?: number;
      /**
       * 附件OssId
       */
      fileId?: string;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 附件名称
       */
      name?: string;
      /**
       * 附件大小
       */
      size?: number;
    }[];
    /**
     * 所有实施计划
     */
    implementationPlans?: {
      uk?: string;
      fillOrderNo?: string;
      month?: number;
      monthDesc?: string;
      implementationPlan?: string;
      implementationProgress?: string;
      isPlanned?: number;
      executedAmount?: number;
      executedRate?: number;
      status?: number;
      statusDesc?: string;
      projectUk?: string;
    }[];
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [绩效管理员-查询申报单详情↗](http://yapi.cai-inc.com/project/2991/interface/api/609698) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [预算绩效申报单管理↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54685)
 * @请求头 `GET /zlb/budget/perform/report/manager/detail`
 * @更新时间 `2024-02-04 09:55:00`
 * @项目ID 2991
 */
type ZlbBudgetPerformReportManagerDetailGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/perform/report/manager/detail',
    'data',
    string,
    'reportOrderNo',
    false
  >
>;

/**
 * 接口 [绩效管理员-查询申报单详情↗](http://yapi.cai-inc.com/project/2991/interface/api/609698) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [预算绩效申报单管理↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54685)
 * @请求头 `GET /zlb/budget/perform/report/manager/detail`
 * @更新时间 `2024-02-04 09:55:00`
 * @项目ID 2991
 */
const zlbBudgetPerformReportManagerDetailGetRequestConfig: ZlbBudgetPerformReportManagerDetailGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_12,
    devUrl: devUrl_0_4_0_12,
    prodUrl: prodUrl_0_4_0_12,
    path: '/zlb/budget/perform/report/manager/detail',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_12,
    paramNames: [],
    queryNames: ['reportOrderNo'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbBudgetPerformReportManagerDetailGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [绩效管理员-查询申报单详情↗](http://yapi.cai-inc.com/project/2991/interface/api/609698) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [预算绩效申报单管理↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54685)
 * @请求头 `GET /zlb/budget/perform/report/manager/detail`
 * @更新时间 `2024-02-04 09:55:00`
 * @项目ID 2991
 */
export const zlbBudgetPerformReportManagerDetailGet = /*#__PURE__*/ (
  requestData: ZlbBudgetPerformReportManagerDetailGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetPerformReportManagerDetailGetResponse>(
    prepare(zlbBudgetPerformReportManagerDetailGetRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetPerformReportManagerDetailGet.requestConfig =
  zlbBudgetPerformReportManagerDetailGetRequestConfig;

/**
 * 接口 [异常项目发送预警↗](http://yapi.cai-inc.com/project/2991/interface/api/609706) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [预算绩效申报单管理↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54685)
 * @请求头 `POST /zlb/budget/perform/report/send-alert`
 * @更新时间 `2024-02-04 09:55:01`
 * @项目ID 2991
 */
export interface ZlbBudgetPerformReportSendAlertPostRequest {}

/**
 * 接口 [异常项目发送预警↗](http://yapi.cai-inc.com/project/2991/interface/api/609706) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [预算绩效申报单管理↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54685)
 * @请求头 `POST /zlb/budget/perform/report/send-alert`
 * @更新时间 `2024-02-04 09:55:01`
 * @项目ID 2991
 */
export interface ZlbBudgetPerformReportSendAlertPostResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: boolean;
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [异常项目发送预警↗](http://yapi.cai-inc.com/project/2991/interface/api/609706) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [预算绩效申报单管理↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54685)
 * @请求头 `POST /zlb/budget/perform/report/send-alert`
 * @更新时间 `2024-02-04 09:55:01`
 * @项目ID 2991
 */
type ZlbBudgetPerformReportSendAlertPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/perform/report/send-alert',
    'data',
    string,
    string,
    true
  >
>;

/**
 * 接口 [异常项目发送预警↗](http://yapi.cai-inc.com/project/2991/interface/api/609706) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [预算绩效申报单管理↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54685)
 * @请求头 `POST /zlb/budget/perform/report/send-alert`
 * @更新时间 `2024-02-04 09:55:01`
 * @项目ID 2991
 */
const zlbBudgetPerformReportSendAlertPostRequestConfig: ZlbBudgetPerformReportSendAlertPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_12,
    devUrl: devUrl_0_4_0_12,
    prodUrl: prodUrl_0_4_0_12,
    path: '/zlb/budget/perform/report/send-alert',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.none,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_12,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbBudgetPerformReportSendAlertPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [异常项目发送预警↗](http://yapi.cai-inc.com/project/2991/interface/api/609706) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [预算绩效申报单管理↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54685)
 * @请求头 `POST /zlb/budget/perform/report/send-alert`
 * @更新时间 `2024-02-04 09:55:01`
 * @项目ID 2991
 */
export const zlbBudgetPerformReportSendAlertPost = /*#__PURE__*/ (
  requestData?: ZlbBudgetPerformReportSendAlertPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetPerformReportSendAlertPostResponse>(
    prepare(zlbBudgetPerformReportSendAlertPostRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetPerformReportSendAlertPost.requestConfig =
  zlbBudgetPerformReportSendAlertPostRequestConfig;

/**
 * 接口 [审核人-查询申报单详情↗](http://yapi.cai-inc.com/project/2991/interface/api/615090) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [预算绩效申报单管理↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54685)
 * @请求头 `GET /zlb/budget/perform/report/audit/detail`
 * @更新时间 `2024-02-04 09:55:01`
 * @项目ID 2991
 */
export interface ZlbBudgetPerformReportAuditDetailGetRequest {
  /**
   * 申报单单号
   */
  reportOrderNo: string;
}

/**
 * 接口 [审核人-查询申报单详情↗](http://yapi.cai-inc.com/project/2991/interface/api/615090) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [预算绩效申报单管理↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54685)
 * @请求头 `GET /zlb/budget/perform/report/audit/detail`
 * @更新时间 `2024-02-04 09:55:01`
 * @项目ID 2991
 */
export interface ZlbBudgetPerformReportAuditDetailGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 按钮控制
     */
    buttonControl?: {
      /**
       * 通过
       */
      pass?: boolean;
      /**
       * 驳回
       */
      reject?: boolean;
      /**
       * 加签
       */
      signature?: boolean;
    };
    /**
     * 申报单单号
     */
    reportOrderNo?: string;
    /**
     * 年份
     */
    year?: number;
    /**
     * 项目uk
     */
    projectUk?: string;
    /**
     * 项目编码
     */
    projectCode?: string;
    /**
     * 项目名称
     */
    projectName?: string;
    /**
     * 所属部门id
     */
    ownDepartmentId?: number;
    /**
     * 父级所属部门名称
     */
    parentOwnDepartmentName?: string;
    /**
     * 所属部门名称
     */
    ownDepartmentName?: string;
    /**
     * 负责人ID
     */
    ownId?: number;
    /**
     * 负责人名称
     */
    ownName?: string;
    /**
     * 预算金额
     */
    budgetAmount?: number;
    /**
     * 总体预算目标
     */
    totalPerformTarget?: string;
    operatorId?: number;
    orgId?: number;
    /**
     * 附件
     */
    attachmentList?: {
      id?: number;
      /**
       * 附件OssId
       */
      fileId?: string;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 附件名称
       */
      name?: string;
      /**
       * 附件大小
       */
      size?: number;
    }[];
    /**
     * 所有实施计划
     */
    implementationPlans?: {
      uk?: string;
      fillOrderNo?: string;
      month?: number;
      monthDesc?: string;
      implementationPlan?: string;
      implementationProgress?: string;
      isPlanned?: number;
      executedAmount?: number;
      executedRate?: number;
      status?: number;
      statusDesc?: string;
      projectUk?: string;
    }[];
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [审核人-查询申报单详情↗](http://yapi.cai-inc.com/project/2991/interface/api/615090) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [预算绩效申报单管理↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54685)
 * @请求头 `GET /zlb/budget/perform/report/audit/detail`
 * @更新时间 `2024-02-04 09:55:01`
 * @项目ID 2991
 */
type ZlbBudgetPerformReportAuditDetailGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/perform/report/audit/detail',
    'data',
    string,
    'reportOrderNo',
    false
  >
>;

/**
 * 接口 [审核人-查询申报单详情↗](http://yapi.cai-inc.com/project/2991/interface/api/615090) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [预算绩效申报单管理↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54685)
 * @请求头 `GET /zlb/budget/perform/report/audit/detail`
 * @更新时间 `2024-02-04 09:55:01`
 * @项目ID 2991
 */
const zlbBudgetPerformReportAuditDetailGetRequestConfig: ZlbBudgetPerformReportAuditDetailGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_12,
    devUrl: devUrl_0_4_0_12,
    prodUrl: prodUrl_0_4_0_12,
    path: '/zlb/budget/perform/report/audit/detail',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_12,
    paramNames: [],
    queryNames: ['reportOrderNo'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbBudgetPerformReportAuditDetailGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [审核人-查询申报单详情↗](http://yapi.cai-inc.com/project/2991/interface/api/615090) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [预算绩效申报单管理↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54685)
 * @请求头 `GET /zlb/budget/perform/report/audit/detail`
 * @更新时间 `2024-02-04 09:55:01`
 * @项目ID 2991
 */
export const zlbBudgetPerformReportAuditDetailGet = /*#__PURE__*/ (
  requestData: ZlbBudgetPerformReportAuditDetailGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetPerformReportAuditDetailGetResponse>(
    prepare(zlbBudgetPerformReportAuditDetailGetRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetPerformReportAuditDetailGet.requestConfig =
  zlbBudgetPerformReportAuditDetailGetRequestConfig;

const mockUrl_0_4_0_13 = 'http://yapi.cai-inc.com/mock/2991' as any;
const devUrl_0_4_0_13 = '' as any;
const prodUrl_0_4_0_13 = '' as any;
const dataKey_0_4_0_13 = 'data' as any;

/**
 * 接口 [查询填报单详情↗](http://yapi.cai-inc.com/project/2991/interface/api/609714) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [预算绩效填报单↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54686)
 * @请求头 `GET /zlb/budget/perform/fill/detail`
 * @更新时间 `2024-02-27 15:06:50`
 * @项目ID 2991
 */
export interface ZlbBudgetPerformFillDetailGetRequest {
  /**
   * 填报单单号
   */
  fillOrderNo: string;
}

/**
 * 接口 [查询填报单详情↗](http://yapi.cai-inc.com/project/2991/interface/api/609714) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [预算绩效填报单↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54686)
 * @请求头 `GET /zlb/budget/perform/fill/detail`
 * @更新时间 `2024-02-27 15:06:50`
 * @项目ID 2991
 */
export interface ZlbBudgetPerformFillDetailGetResponse {
  /**
   * 必填 是否成功标识
   */
  success?: boolean;
  /**
   * 非必填 返回结果集
   */
  result?: {
    /**
     * 当前填报单的实施计划
     */
    currentFillImplementationPlans?: {
      uk?: string;
      fillOrderNo?: string;
      month?: number;
      monthDesc?: string;
      implementationPlan?: string;
      implementationProgress?: string;
      isPlanned?: number;
      executedAmount?: number;
      executedRate?: number;
      status?: number;
      statusDesc?: string;
      projectUk?: string;
    }[];
    /**
     * 申报单单号
     */
    reportOrderNo?: string;
    /**
     * 年份
     */
    year?: number;
    /**
     * 项目uk
     */
    projectUk?: string;
    /**
     * 项目编码
     */
    projectCode?: string;
    /**
     * 项目名称
     */
    projectName?: string;
    /**
     * 所属部门id
     */
    ownDepartmentId?: number;
    /**
     * 父级所属部门名称
     */
    parentOwnDepartmentName?: string;
    /**
     * 所属部门名称
     */
    ownDepartmentName?: string;
    /**
     * 负责人ID
     */
    ownId?: number;
    /**
     * 负责人名称
     */
    ownName?: string;
    /**
     * 预算金额
     */
    budgetAmount?: number;
    /**
     * 总体预算目标
     */
    totalPerformTarget?: string;
    operatorId?: number;
    orgId?: number;
    /**
     * 附件
     */
    attachmentList?: {
      id?: number;
      /**
       * 附件OssId
       */
      fileId?: string;
      /**
       * 附件类型
       */
      type?: string;
      /**
       * 附件名称
       */
      name?: string;
      /**
       * 附件大小
       */
      size?: number;
    }[];
    /**
     * 所有实施计划
     */
    implementationPlans?: {
      uk?: string;
      fillOrderNo?: string;
      month?: number;
      monthDesc?: string;
      implementationPlan?: string;
      implementationProgress?: string;
      isPlanned?: number;
      executedAmount?: number;
      executedRate?: number;
      status?: number;
      statusDesc?: string;
      projectUk?: string;
    }[];
    /**
     * 可选择的的部门信息
     */
    enableSelectedDepartments?: {
      /**
       * 部门id
       */
      id?: number;
      /**
       * 部门名称
       */
      name?: string;
    }[];
    /**
     * 申报单状态
     */
    status?: number;
    /**
     * 申报单状态描述
     */
    statusDesc?: string;
  };
  /**
   * 失败时必填 业务码/失败码 全局需唯一
   */
  code?: string;
  /**
   * 失败时必填 业务文案/失败文案提示
   */
  message?: string;
}

/**
 * 接口 [查询填报单详情↗](http://yapi.cai-inc.com/project/2991/interface/api/609714) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [预算绩效填报单↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54686)
 * @请求头 `GET /zlb/budget/perform/fill/detail`
 * @更新时间 `2024-02-27 15:06:50`
 * @项目ID 2991
 */
type ZlbBudgetPerformFillDetailGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/perform/fill/detail',
    'data',
    string,
    'fillOrderNo',
    false
  >
>;

/**
 * 接口 [查询填报单详情↗](http://yapi.cai-inc.com/project/2991/interface/api/609714) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [预算绩效填报单↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54686)
 * @请求头 `GET /zlb/budget/perform/fill/detail`
 * @更新时间 `2024-02-27 15:06:50`
 * @项目ID 2991
 */
const zlbBudgetPerformFillDetailGetRequestConfig: ZlbBudgetPerformFillDetailGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_13,
    devUrl: devUrl_0_4_0_13,
    prodUrl: prodUrl_0_4_0_13,
    path: '/zlb/budget/perform/fill/detail',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_13,
    paramNames: [],
    queryNames: ['fillOrderNo'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbBudgetPerformFillDetailGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [查询填报单详情↗](http://yapi.cai-inc.com/project/2991/interface/api/609714) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [预算绩效填报单↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54686)
 * @请求头 `GET /zlb/budget/perform/fill/detail`
 * @更新时间 `2024-02-27 15:06:50`
 * @项目ID 2991
 */
export const zlbBudgetPerformFillDetailGet = /*#__PURE__*/ (
  requestData: ZlbBudgetPerformFillDetailGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetPerformFillDetailGetResponse>(
    prepare(zlbBudgetPerformFillDetailGetRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetPerformFillDetailGet.requestConfig = zlbBudgetPerformFillDetailGetRequestConfig;

const mockUrl_0_4_0_14 = 'http://yapi.cai-inc.com/mock/2991' as any;
const devUrl_0_4_0_14 = '' as any;
const prodUrl_0_4_0_14 = '' as any;
const dataKey_0_4_0_14 = 'data' as any;

/**
 * 接口 [加签（添加审批人）↗](http://yapi.cai-inc.com/project/2991/interface/api/618498) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [预算绩效申报单工作流↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54810)
 * @请求头 `POST /zlb/budget/perform/report/workflow/addOperator`
 * @更新时间 `2024-02-22 17:09:53`
 * @项目ID 2991
 */
export interface ZlbBudgetPerformReportWorkflowAddOperatorPostRequest {
  /**
   * 必填，业务标识
   */
  bizId?: string;
  /**
   * 必填, 业务场景
   */
  bizType?: string;
  /**
   * 必填, 子类型
   */
  subType?: string;
  /**
   * 必填, 前加签 后加签
   */
  countersignType?: number;
  /**
   * 当前审批节点key
   */
  curTaskDefineKey?: string;
  /**
   * 加签人
   */
  operatorIds?: number[];
  /**
   * 备注
   */
  remark?: string;
  /**
   * 上下文
   */
  context?: string;
  /**
   * 操作人
   */
  operatorId?: number;
}

/**
 * 接口 [加签（添加审批人）↗](http://yapi.cai-inc.com/project/2991/interface/api/618498) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [预算绩效申报单工作流↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54810)
 * @请求头 `POST /zlb/budget/perform/report/workflow/addOperator`
 * @更新时间 `2024-02-22 17:09:53`
 * @项目ID 2991
 */
export interface ZlbBudgetPerformReportWorkflowAddOperatorPostResponse {
  success?: boolean;
  code?: string;
  message?: string;
  result?: {};
}

/**
 * 接口 [加签（添加审批人）↗](http://yapi.cai-inc.com/project/2991/interface/api/618498) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [预算绩效申报单工作流↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54810)
 * @请求头 `POST /zlb/budget/perform/report/workflow/addOperator`
 * @更新时间 `2024-02-22 17:09:53`
 * @项目ID 2991
 */
type ZlbBudgetPerformReportWorkflowAddOperatorPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/perform/report/workflow/addOperator',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [加签（添加审批人）↗](http://yapi.cai-inc.com/project/2991/interface/api/618498) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [预算绩效申报单工作流↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54810)
 * @请求头 `POST /zlb/budget/perform/report/workflow/addOperator`
 * @更新时间 `2024-02-22 17:09:53`
 * @项目ID 2991
 */
const zlbBudgetPerformReportWorkflowAddOperatorPostRequestConfig: ZlbBudgetPerformReportWorkflowAddOperatorPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_14,
    devUrl: devUrl_0_4_0_14,
    prodUrl: prodUrl_0_4_0_14,
    path: '/zlb/budget/perform/report/workflow/addOperator',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_14,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbBudgetPerformReportWorkflowAddOperatorPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [加签（添加审批人）↗](http://yapi.cai-inc.com/project/2991/interface/api/618498) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [预算绩效申报单工作流↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54810)
 * @请求头 `POST /zlb/budget/perform/report/workflow/addOperator`
 * @更新时间 `2024-02-22 17:09:53`
 * @项目ID 2991
 */
export const zlbBudgetPerformReportWorkflowAddOperatorPost = /*#__PURE__*/ (
  requestData: ZlbBudgetPerformReportWorkflowAddOperatorPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetPerformReportWorkflowAddOperatorPostResponse>(
    prepare(zlbBudgetPerformReportWorkflowAddOperatorPostRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetPerformReportWorkflowAddOperatorPost.requestConfig =
  zlbBudgetPerformReportWorkflowAddOperatorPostRequestConfig;

/**
 * 接口 [加签（添加审批节点）↗](http://yapi.cai-inc.com/project/2991/interface/api/618506) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [预算绩效申报单工作流↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54810)
 * @请求头 `POST /zlb/budget/perform/report/workflow/addNode`
 * @更新时间 `2024-02-22 17:09:53`
 * @项目ID 2991
 */
export interface ZlbBudgetPerformReportWorkflowAddNodePostRequest {
  /**
   * 必填，业务标识
   */
  bizId?: string;
  /**
   * 必填, 业务场景
   */
  bizType?: string;
  /**
   * 必填, 子类型
   */
  subType?: string;
  /**
   * 必填, 前加签 后加签
   */
  countersignType?: number;
  /**
   * 当前审批节点key
   */
  curTaskDefineKey?: string;
  /**
   * 加签人
   */
  operatorIds?: number[];
  /**
   * 备注
   */
  remark?: string;
  /**
   * 上下文
   */
  context?: string;
  /**
   * 操作人
   */
  operatorId?: number;
}

/**
 * 接口 [加签（添加审批节点）↗](http://yapi.cai-inc.com/project/2991/interface/api/618506) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [预算绩效申报单工作流↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54810)
 * @请求头 `POST /zlb/budget/perform/report/workflow/addNode`
 * @更新时间 `2024-02-22 17:09:53`
 * @项目ID 2991
 */
export interface ZlbBudgetPerformReportWorkflowAddNodePostResponse {
  success?: boolean;
  code?: string;
  message?: string;
  result?: {};
}

/**
 * 接口 [加签（添加审批节点）↗](http://yapi.cai-inc.com/project/2991/interface/api/618506) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [预算绩效申报单工作流↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54810)
 * @请求头 `POST /zlb/budget/perform/report/workflow/addNode`
 * @更新时间 `2024-02-22 17:09:53`
 * @项目ID 2991
 */
type ZlbBudgetPerformReportWorkflowAddNodePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/perform/report/workflow/addNode',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [加签（添加审批节点）↗](http://yapi.cai-inc.com/project/2991/interface/api/618506) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [预算绩效申报单工作流↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54810)
 * @请求头 `POST /zlb/budget/perform/report/workflow/addNode`
 * @更新时间 `2024-02-22 17:09:53`
 * @项目ID 2991
 */
const zlbBudgetPerformReportWorkflowAddNodePostRequestConfig: ZlbBudgetPerformReportWorkflowAddNodePostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_14,
    devUrl: devUrl_0_4_0_14,
    prodUrl: prodUrl_0_4_0_14,
    path: '/zlb/budget/perform/report/workflow/addNode',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_14,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbBudgetPerformReportWorkflowAddNodePost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [加签（添加审批节点）↗](http://yapi.cai-inc.com/project/2991/interface/api/618506) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [预算绩效申报单工作流↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54810)
 * @请求头 `POST /zlb/budget/perform/report/workflow/addNode`
 * @更新时间 `2024-02-22 17:09:53`
 * @项目ID 2991
 */
export const zlbBudgetPerformReportWorkflowAddNodePost = /*#__PURE__*/ (
  requestData: ZlbBudgetPerformReportWorkflowAddNodePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetPerformReportWorkflowAddNodePostResponse>(
    prepare(zlbBudgetPerformReportWorkflowAddNodePostRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetPerformReportWorkflowAddNodePost.requestConfig =
  zlbBudgetPerformReportWorkflowAddNodePostRequestConfig;

/**
 * 接口 [审批↗](http://yapi.cai-inc.com/project/2991/interface/api/618514) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [预算绩效申报单工作流↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54810)
 * @请求头 `POST /zlb/budget/perform/report/workflow/audit`
 * @更新时间 `2024-02-22 17:09:53`
 * @项目ID 2991
 */
export interface ZlbBudgetPerformReportWorkflowAuditPostRequest {
  /**
   * 业务单据编码
   */
  bizId?: string;
  /**
   * 业务类型
   */
  bizType?: string;
  /**
   * 业务子类型
   */
  subType?: string;
  /**
   * 审批备注
   */
  auditRemark?: string;
  /**
   * 审批类型
   */
  executeType?: number;
  /**
   * 工作流类型Key
   */
  processDefineKey?: string;
  /**
   * 当前节点key
   */
  currentNodeKey?: string;
  /**
   * 操作人
   */
  operatorId?: number;
  context?: string;
  /**
   * 事件类型：0-审批，1-审核，2-出纳
   */
  eventType?: number;
  /**
   * 签名相关
   */
  signAttachment?: {
    fileId?: string;
    type?: string;
    name?: string;
    size?: number;
    bizCode?: string;
    url?: string;
    sizeDesc?: string;
  };
}

/**
 * 接口 [审批↗](http://yapi.cai-inc.com/project/2991/interface/api/618514) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [预算绩效申报单工作流↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54810)
 * @请求头 `POST /zlb/budget/perform/report/workflow/audit`
 * @更新时间 `2024-02-22 17:09:53`
 * @项目ID 2991
 */
export interface ZlbBudgetPerformReportWorkflowAuditPostResponse {
  success?: boolean;
  code?: string;
  message?: string;
  result?: {};
}

/**
 * 接口 [审批↗](http://yapi.cai-inc.com/project/2991/interface/api/618514) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [预算绩效申报单工作流↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54810)
 * @请求头 `POST /zlb/budget/perform/report/workflow/audit`
 * @更新时间 `2024-02-22 17:09:53`
 * @项目ID 2991
 */
type ZlbBudgetPerformReportWorkflowAuditPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/perform/report/workflow/audit',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [审批↗](http://yapi.cai-inc.com/project/2991/interface/api/618514) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [预算绩效申报单工作流↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54810)
 * @请求头 `POST /zlb/budget/perform/report/workflow/audit`
 * @更新时间 `2024-02-22 17:09:53`
 * @项目ID 2991
 */
const zlbBudgetPerformReportWorkflowAuditPostRequestConfig: ZlbBudgetPerformReportWorkflowAuditPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_14,
    devUrl: devUrl_0_4_0_14,
    prodUrl: prodUrl_0_4_0_14,
    path: '/zlb/budget/perform/report/workflow/audit',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_14,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbBudgetPerformReportWorkflowAuditPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [审批↗](http://yapi.cai-inc.com/project/2991/interface/api/618514) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [预算绩效申报单工作流↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54810)
 * @请求头 `POST /zlb/budget/perform/report/workflow/audit`
 * @更新时间 `2024-02-22 17:09:53`
 * @项目ID 2991
 */
export const zlbBudgetPerformReportWorkflowAuditPost = /*#__PURE__*/ (
  requestData: ZlbBudgetPerformReportWorkflowAuditPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetPerformReportWorkflowAuditPostResponse>(
    prepare(zlbBudgetPerformReportWorkflowAuditPostRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetPerformReportWorkflowAuditPost.requestConfig =
  zlbBudgetPerformReportWorkflowAuditPostRequestConfig;

/**
 * 接口 [提交↗](http://yapi.cai-inc.com/project/2991/interface/api/618522) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [预算绩效申报单工作流↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54810)
 * @请求头 `POST /zlb/budget/perform/report/workflow/submit`
 * @更新时间 `2024-02-22 17:09:53`
 * @项目ID 2991
 */
export interface ZlbBudgetPerformReportWorkflowSubmitPostRequest {
  /**
   * 预算填报单
   */
  bizId?: string;
  /**
   * 必填, 单据类型
   */
  bizType?: string;
  /**
   * 必填, 子单据类型
   */
  subType?: string;
  /**
   * 必填, 工作流key
   */
  processDefineKey?: string;
  /**
   * 必填, 工作流ModelId
   */
  processModelId?: number;
  /**
   * 必填, 工作流版本
   */
  version?: number;
  /**
   * 审批节点
   */
  auditInfos?: {
    /**
     * 节点key
     */
    taskDefineKey: string;
    /**
     * 审批人
     */
    operatorIds: number[];
  }[];
  /**
   * {
   *    "year":2023 // 年度
   * }
   *
   *
   */
  context?: string;
  /**
   * 当前操作人Id
   */
  operatorId?: number;
}

/**
 * 接口 [提交↗](http://yapi.cai-inc.com/project/2991/interface/api/618522) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [预算绩效申报单工作流↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54810)
 * @请求头 `POST /zlb/budget/perform/report/workflow/submit`
 * @更新时间 `2024-02-22 17:09:53`
 * @项目ID 2991
 */
export interface ZlbBudgetPerformReportWorkflowSubmitPostResponse {
  success?: boolean;
  code?: string;
  message?: string;
  result?: {};
}

/**
 * 接口 [提交↗](http://yapi.cai-inc.com/project/2991/interface/api/618522) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [预算绩效申报单工作流↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54810)
 * @请求头 `POST /zlb/budget/perform/report/workflow/submit`
 * @更新时间 `2024-02-22 17:09:53`
 * @项目ID 2991
 */
type ZlbBudgetPerformReportWorkflowSubmitPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/perform/report/workflow/submit',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [提交↗](http://yapi.cai-inc.com/project/2991/interface/api/618522) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [预算绩效申报单工作流↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54810)
 * @请求头 `POST /zlb/budget/perform/report/workflow/submit`
 * @更新时间 `2024-02-22 17:09:53`
 * @项目ID 2991
 */
const zlbBudgetPerformReportWorkflowSubmitPostRequestConfig: ZlbBudgetPerformReportWorkflowSubmitPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_14,
    devUrl: devUrl_0_4_0_14,
    prodUrl: prodUrl_0_4_0_14,
    path: '/zlb/budget/perform/report/workflow/submit',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_14,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbBudgetPerformReportWorkflowSubmitPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [提交↗](http://yapi.cai-inc.com/project/2991/interface/api/618522) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [预算绩效申报单工作流↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54810)
 * @请求头 `POST /zlb/budget/perform/report/workflow/submit`
 * @更新时间 `2024-02-22 17:09:53`
 * @项目ID 2991
 */
export const zlbBudgetPerformReportWorkflowSubmitPost = /*#__PURE__*/ (
  requestData: ZlbBudgetPerformReportWorkflowSubmitPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetPerformReportWorkflowSubmitPostResponse>(
    prepare(zlbBudgetPerformReportWorkflowSubmitPostRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetPerformReportWorkflowSubmitPost.requestConfig =
  zlbBudgetPerformReportWorkflowSubmitPostRequestConfig;

/**
 * 接口 [撤销↗](http://yapi.cai-inc.com/project/2991/interface/api/618530) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [预算绩效申报单工作流↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54810)
 * @请求头 `POST /zlb/budget/perform/report/workflow/cancel`
 * @更新时间 `2024-02-22 17:09:53`
 * @项目ID 2991
 */
export interface ZlbBudgetPerformReportWorkflowCancelPostRequest {
  /**
   * 业务编码
   */
  bizId?: string;
  /**
   * 业务类型
   */
  bizType?: string;
  /**
   * 业务子类型
   */
  subType?: string;
  /**
   * 备注
   */
  remark?: string;
  /**
   * 操作人
   */
  operatorId?: number;
}

/**
 * 接口 [撤销↗](http://yapi.cai-inc.com/project/2991/interface/api/618530) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [预算绩效申报单工作流↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54810)
 * @请求头 `POST /zlb/budget/perform/report/workflow/cancel`
 * @更新时间 `2024-02-22 17:09:53`
 * @项目ID 2991
 */
export interface ZlbBudgetPerformReportWorkflowCancelPostResponse {
  success?: boolean;
  code?: string;
  message?: string;
  result?: {};
}

/**
 * 接口 [撤销↗](http://yapi.cai-inc.com/project/2991/interface/api/618530) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [预算绩效申报单工作流↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54810)
 * @请求头 `POST /zlb/budget/perform/report/workflow/cancel`
 * @更新时间 `2024-02-22 17:09:53`
 * @项目ID 2991
 */
type ZlbBudgetPerformReportWorkflowCancelPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/perform/report/workflow/cancel',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [撤销↗](http://yapi.cai-inc.com/project/2991/interface/api/618530) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [预算绩效申报单工作流↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54810)
 * @请求头 `POST /zlb/budget/perform/report/workflow/cancel`
 * @更新时间 `2024-02-22 17:09:53`
 * @项目ID 2991
 */
const zlbBudgetPerformReportWorkflowCancelPostRequestConfig: ZlbBudgetPerformReportWorkflowCancelPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_14,
    devUrl: devUrl_0_4_0_14,
    prodUrl: prodUrl_0_4_0_14,
    path: '/zlb/budget/perform/report/workflow/cancel',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_14,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbBudgetPerformReportWorkflowCancelPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [撤销↗](http://yapi.cai-inc.com/project/2991/interface/api/618530) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [预算绩效申报单工作流↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54810)
 * @请求头 `POST /zlb/budget/perform/report/workflow/cancel`
 * @更新时间 `2024-02-22 17:09:53`
 * @项目ID 2991
 */
export const zlbBudgetPerformReportWorkflowCancelPost = /*#__PURE__*/ (
  requestData: ZlbBudgetPerformReportWorkflowCancelPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetPerformReportWorkflowCancelPostResponse>(
    prepare(zlbBudgetPerformReportWorkflowCancelPostRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetPerformReportWorkflowCancelPost.requestConfig =
  zlbBudgetPerformReportWorkflowCancelPostRequestConfig;

/**
 * 接口 [获取工作流实例↗](http://yapi.cai-inc.com/project/2991/interface/api/618538) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [预算绩效申报单工作流↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54810)
 * @请求头 `POST /zlb/budget/perform/report/workflow/getInstance`
 * @更新时间 `2024-02-22 17:09:54`
 * @项目ID 2991
 */
export interface ZlbBudgetPerformReportWorkflowGetInstancePostRequest {
  /**
   * 流程key
   */
  processDefineKey: string;
  /**
   * 业务Id
   */
  bizId: string;
  /**
   * 业务类型
   */
  bizType: string;
  /**
   * 业务子类型
   */
  subType?: string;
  /**
   * 操作人
   */
  operatorId?: string;
  /**
   * 部门ID 查询部门主管需要
   */
  departmentId?: string;
  amount?: string;
  /**
   * 同行人
   */
  accompanyOperatorIds?: string;
}

/**
 * 接口 [获取工作流实例↗](http://yapi.cai-inc.com/project/2991/interface/api/618538) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [预算绩效申报单工作流↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54810)
 * @请求头 `POST /zlb/budget/perform/report/workflow/getInstance`
 * @更新时间 `2024-02-22 17:09:54`
 * @项目ID 2991
 */
export interface ZlbBudgetPerformReportWorkflowGetInstancePostResponse {
  success?: boolean;
  code?: string;
  message?: string;
  result?: {
    /**
     * 工作流key
     */
    workflowProcessKey?: string;
    /**
     * 工作流ModelId
     */
    workflowModelId?: number;
    /**
     * 工作流版本
     */
    workflowVersion?: number;
    /**
     * 申请人ID
     */
    applyOperatorId?: number;
    /**
     * 申请人姓名
     */
    applyOperatorName?: string;
    /**
     * 申请时间
     */
    applyTime?: string;
    /**
     * 申请说明
     */
    applyRemark?: string;
    /**
     * 是否能加签 0-否 1-是
     */
    isAddTaskAccess?: number;
    /**
     * 工作流是否开启签名：true-开启；false-未开启
     */
    isEnableSign?: boolean;
    /**
     * 签名配置：0-使用上次签名；1-每次重新签名；
     */
    signConfig?: number;
    /**
     * 审核节点列表
     */
    auditNodeList?: {
      /**
       * 审核用户类型：0-"按部门"；1-"按全机构";2-"全平台";3-"按岗位"
       */
      userRangeType?: number;
      userRangeTypeNew?: number;
      /**
       * 对应userRangeType的值
       */
      userRangeValues?: string[];
      userRangeValuesNew?: string[];
      /**
       * 审核人数(总人数)
       */
      personCount?: number;
      /**
       * 审核状态：0-待审批，1-已审批，2-审批驳回
       */
      auditStatus?: number;
      /**
       * 审核时间
       */
      auditTime?: string;
      /**
       * 审核描述
       */
      auditDesc?: string;
      /**
       * 审批类型：0-或签，1-会签，2-依次审批
       */
      auditType?: number;
      /**
       * 事件类型：0-审批，1-审核，2-出纳
       */
      eventType?: number;
      /**
       * 是否自选:0-指定，1-自选
       */
      nodeType?: number;
      /**
       * 节点key
       */
      nodeKey?: string;
      /**
       * 节点名称
       */
      nodeName?: string;
      /**
       * 审批策略：单人、多人会签、依次会签
       */
      checkStrategy?: number;
      /**
       * 部门id （为了获取部门主管）
       */
      departmentId?: number;
      /**
       * 审核人列表
       */
      auditOperatorList?: {
        /**
         * 审批意见
         */
        auditRemark?: string;
        /**
         * 审批状态：0-待审批，1-审批通过，2-审批驳回
         */
        auditStatus?: number;
        /**
         * 审核时间
         */
        auditTime?: string;
        /**
         * 签名附件
         */
        signAttachment?: {
          fileId?: string;
          type?: string;
          name?: string;
          size?: number;
          bizCode?: string;
          url?: string;
          sizeDesc?: string;
        };
        /**
         * 最新的个人历史签名附件
         */
        oneselfHistorySignAttachment?: {
          fileId?: string;
          type?: string;
          name?: string;
          size?: number;
          bizCode?: string;
          url?: string;
          sizeDesc?: string;
        };
        /**
         * 人员id
         */
        operatorId?: number;
        /**
         * 人员Name
         */
        operatorName?: string;
        /**
         * 机构ID
         */
        institutionId?: number;
        /**
         * 机构Name
         */
        institutionName?: string;
      }[];
      /**
       * 机构
       */
      institutionSelfDtos?: {
        /**
         * 机构编码
         */
        code?: string;
        /**
         * 机构Name
         */
        name?: string;
        /**
         * 人员类型
         */
        userType?: string;
        /**
         * 租户编码
         */
        tenantCode?: string;
        /**
         * 租户Name
         */
        tenantName?: string;
        /**
         * 唯一key
         */
        uniqueKey?: string;
        /**
         * 父机构
         */
        parentInstitution?: {
          parentCode?: number;
          parentName?: string;
        };
      }[];
      /**
       * 常用审核人列表
       */
      commonAuditorList?: {
        code?: string;
        name?: string;
        userType?: string;
        tenantCode?: string;
        tenantName?: string;
        uniqueKey?: string;
        parentInstitution?: {
          parentCode?: number;
          parentName?: string;
        };
      }[];
    }[];
  };
}

/**
 * 接口 [获取工作流实例↗](http://yapi.cai-inc.com/project/2991/interface/api/618538) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [预算绩效申报单工作流↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54810)
 * @请求头 `POST /zlb/budget/perform/report/workflow/getInstance`
 * @更新时间 `2024-02-22 17:09:54`
 * @项目ID 2991
 */
type ZlbBudgetPerformReportWorkflowGetInstancePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/perform/report/workflow/getInstance',
    'data',
    string,
    | 'processDefineKey'
    | 'bizId'
    | 'bizType'
    | 'subType'
    | 'operatorId'
    | 'departmentId'
    | 'amount'
    | 'accompanyOperatorIds',
    false
  >
>;

/**
 * 接口 [获取工作流实例↗](http://yapi.cai-inc.com/project/2991/interface/api/618538) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [预算绩效申报单工作流↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54810)
 * @请求头 `POST /zlb/budget/perform/report/workflow/getInstance`
 * @更新时间 `2024-02-22 17:09:54`
 * @项目ID 2991
 */
const zlbBudgetPerformReportWorkflowGetInstancePostRequestConfig: ZlbBudgetPerformReportWorkflowGetInstancePostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_14,
    devUrl: devUrl_0_4_0_14,
    prodUrl: prodUrl_0_4_0_14,
    path: '/zlb/budget/perform/report/workflow/getInstance',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_14,
    paramNames: [],
    queryNames: [
      'processDefineKey',
      'bizId',
      'bizType',
      'subType',
      'operatorId',
      'departmentId',
      'amount',
      'accompanyOperatorIds',
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbBudgetPerformReportWorkflowGetInstancePost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [获取工作流实例↗](http://yapi.cai-inc.com/project/2991/interface/api/618538) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [预算绩效申报单工作流↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54810)
 * @请求头 `POST /zlb/budget/perform/report/workflow/getInstance`
 * @更新时间 `2024-02-22 17:09:54`
 * @项目ID 2991
 */
export const zlbBudgetPerformReportWorkflowGetInstancePost = /*#__PURE__*/ (
  requestData: ZlbBudgetPerformReportWorkflowGetInstancePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetPerformReportWorkflowGetInstancePostResponse>(
    prepare(zlbBudgetPerformReportWorkflowGetInstancePostRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetPerformReportWorkflowGetInstancePost.requestConfig =
  zlbBudgetPerformReportWorkflowGetInstancePostRequestConfig;

/**
 * 接口 [获取工作流模板↗](http://yapi.cai-inc.com/project/2991/interface/api/618546) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [预算绩效申报单工作流↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54810)
 * @请求头 `POST /zlb/budget/perform/report/workflow/getTemplate`
 * @更新时间 `2024-02-22 17:09:54`
 * @项目ID 2991
 */
export interface ZlbBudgetPerformReportWorkflowGetTemplatePostRequest {
  /**
   * 流程key
   */
  processDefineKey: string;
  /**
   * 业务Id
   */
  bizId: string;
  /**
   * 业务类型
   */
  bizType: string;
  /**
   * 业务子类型
   */
  subType?: string;
  /**
   * 操作人
   */
  operatorId?: string;
  /**
   * 部门ID 查询部门主管需要
   */
  departmentId?: string;
  amount?: string;
  /**
   * 同行人
   */
  accompanyOperatorIds?: string;
}

/**
 * 接口 [获取工作流模板↗](http://yapi.cai-inc.com/project/2991/interface/api/618546) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [预算绩效申报单工作流↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54810)
 * @请求头 `POST /zlb/budget/perform/report/workflow/getTemplate`
 * @更新时间 `2024-02-22 17:09:54`
 * @项目ID 2991
 */
export interface ZlbBudgetPerformReportWorkflowGetTemplatePostResponse {
  success?: boolean;
  code?: string;
  message?: string;
  result?: {
    /**
     * 工作流key
     */
    workflowProcessKey?: string;
    /**
     * 工作流ModelId
     */
    workflowModelId?: number;
    /**
     * 工作流版本
     */
    workflowVersion?: number;
    /**
     * 审核节点列表
     */
    auditNodeList?: {
      /**
       * 审核用户类型：0-"按部门"；1-"按全机构";2-"全平台";3-"按岗位"
       */
      userRangeType?: number;
      userRangeTypeNew?: number;
      /**
       * 对应userRangeType的值
       */
      userRangeValues?: string[];
      userRangeValuesNew?: string[];
      /**
       * 审核人数(总人数)
       */
      personCount?: number;
      /**
       * 审核状态：0-待审批，1-已审批，2-审批驳回
       */
      auditStatus?: number;
      /**
       * 审核时间
       */
      auditTime?: string;
      /**
       * 审核描述
       */
      auditDesc?: string;
      /**
       * 审批类型：0-或签，1-会签，2-依次审批
       */
      auditType?: number;
      /**
       * 事件类型：0-审批，1-审核，2-出纳
       */
      eventType?: number;
      /**
       * 是否自选:0-指定，1-自选
       */
      nodeType?: number;
      /**
       * 节点key
       */
      nodeKey?: string;
      /**
       * 节点名称
       */
      nodeName?: string;
      /**
       * 审批策略：单人、多人会签、依次会签
       */
      checkStrategy?: number;
      /**
       * 部门id （为了获取部门主管）
       */
      departmentId?: number;
      /**
       * 审核人列表
       */
      auditOperatorList?: {
        /**
         * 审批意见
         */
        auditRemark?: string;
        /**
         * 审批状态：0-待审批，1-审批通过，2-审批驳回
         */
        auditStatus?: number;
        /**
         * 审核时间
         */
        auditTime?: string;
        /**
         * 签名附件
         */
        signAttachment?: {
          fileId?: string;
          type?: string;
          name?: string;
          size?: number;
          bizCode?: string;
          url?: string;
          sizeDesc?: string;
        };
        /**
         * 最新的个人历史签名附件
         */
        oneselfHistorySignAttachment?: {
          fileId?: string;
          type?: string;
          name?: string;
          size?: number;
          bizCode?: string;
          url?: string;
          sizeDesc?: string;
        };
        /**
         * 人员id
         */
        operatorId?: number;
        /**
         * 人员Name
         */
        operatorName?: string;
        /**
         * 机构ID
         */
        institutionId?: number;
        /**
         * 机构Name
         */
        institutionName?: string;
      }[];
      /**
       * 机构
       */
      institutionSelfDtos?: {
        /**
         * 机构编码
         */
        code?: string;
        /**
         * 机构Name
         */
        name?: string;
        /**
         * 人员类型
         */
        userType?: string;
        /**
         * 租户编码
         */
        tenantCode?: string;
        /**
         * 租户Name
         */
        tenantName?: string;
        /**
         * 唯一key
         */
        uniqueKey?: string;
        /**
         * 父机构
         */
        parentInstitution?: {
          parentCode?: number;
          parentName?: string;
        };
      }[];
      /**
       * 常用审核人列表
       */
      commonAuditorList?: {
        code?: string;
        name?: string;
        userType?: string;
        tenantCode?: string;
        tenantName?: string;
        uniqueKey?: string;
        parentInstitution?: {
          parentCode?: number;
          parentName?: string;
        };
      }[];
    }[];
  };
}

/**
 * 接口 [获取工作流模板↗](http://yapi.cai-inc.com/project/2991/interface/api/618546) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [预算绩效申报单工作流↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54810)
 * @请求头 `POST /zlb/budget/perform/report/workflow/getTemplate`
 * @更新时间 `2024-02-22 17:09:54`
 * @项目ID 2991
 */
type ZlbBudgetPerformReportWorkflowGetTemplatePostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/perform/report/workflow/getTemplate',
    'data',
    string,
    | 'processDefineKey'
    | 'bizId'
    | 'bizType'
    | 'subType'
    | 'operatorId'
    | 'departmentId'
    | 'amount'
    | 'accompanyOperatorIds',
    false
  >
>;

/**
 * 接口 [获取工作流模板↗](http://yapi.cai-inc.com/project/2991/interface/api/618546) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [预算绩效申报单工作流↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54810)
 * @请求头 `POST /zlb/budget/perform/report/workflow/getTemplate`
 * @更新时间 `2024-02-22 17:09:54`
 * @项目ID 2991
 */
const zlbBudgetPerformReportWorkflowGetTemplatePostRequestConfig: ZlbBudgetPerformReportWorkflowGetTemplatePostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_14,
    devUrl: devUrl_0_4_0_14,
    prodUrl: prodUrl_0_4_0_14,
    path: '/zlb/budget/perform/report/workflow/getTemplate',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_14,
    paramNames: [],
    queryNames: [
      'processDefineKey',
      'bizId',
      'bizType',
      'subType',
      'operatorId',
      'departmentId',
      'amount',
      'accompanyOperatorIds',
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbBudgetPerformReportWorkflowGetTemplatePost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [获取工作流模板↗](http://yapi.cai-inc.com/project/2991/interface/api/618546) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [预算绩效申报单工作流↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54810)
 * @请求头 `POST /zlb/budget/perform/report/workflow/getTemplate`
 * @更新时间 `2024-02-22 17:09:54`
 * @项目ID 2991
 */
export const zlbBudgetPerformReportWorkflowGetTemplatePost = /*#__PURE__*/ (
  requestData: ZlbBudgetPerformReportWorkflowGetTemplatePostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetPerformReportWorkflowGetTemplatePostResponse>(
    prepare(zlbBudgetPerformReportWorkflowGetTemplatePostRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetPerformReportWorkflowGetTemplatePost.requestConfig =
  zlbBudgetPerformReportWorkflowGetTemplatePostRequestConfig;

/**
 * 接口 [获取工作流实例_copy↗](http://yapi.cai-inc.com/project/2991/interface/api/619802) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [预算绩效申报单工作流↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54810)
 * @请求头 `POST /zlb/budget/perform/report/workflow/getInstance_1708592833069`
 * @更新时间 `2024-02-22 17:07:13`
 * @项目ID 2991
 */
export interface ZlbBudgetPerformReportWorkflowGetInstance_1708592833069PostRequest {
  /**
   * 流程key
   */
  processDefineKey: string;
  /**
   * 业务Id
   */
  bizId: string;
  /**
   * 业务类型
   */
  bizType: string;
  /**
   * 业务子类型
   */
  subType?: string;
  /**
   * 操作人
   */
  operatorId?: string;
  /**
   * 部门ID 查询部门主管需要
   */
  departmentId?: string;
  amount?: string;
  /**
   * 同行人
   */
  accompanyOperatorIds?: string;
}

/**
 * 接口 [获取工作流实例_copy↗](http://yapi.cai-inc.com/project/2991/interface/api/619802) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [预算绩效申报单工作流↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54810)
 * @请求头 `POST /zlb/budget/perform/report/workflow/getInstance_1708592833069`
 * @更新时间 `2024-02-22 17:07:13`
 * @项目ID 2991
 */
export interface ZlbBudgetPerformReportWorkflowGetInstance_1708592833069PostResponse {
  success?: boolean;
  code?: string;
  message?: string;
  result?: {
    /**
     * 工作流key
     */
    workflowProcessKey?: string;
    /**
     * 工作流ModelId
     */
    workflowModelId?: number;
    /**
     * 工作流版本
     */
    workflowVersion?: number;
    /**
     * 申请人ID
     */
    applyOperatorId?: number;
    /**
     * 申请人姓名
     */
    applyOperatorName?: string;
    /**
     * 申请时间
     */
    applyTime?: string;
    /**
     * 申请说明
     */
    applyRemark?: string;
    /**
     * 是否能加签 0-否 1-是
     */
    isAddTaskAccess?: number;
    /**
     * 工作流是否开启签名：true-开启；false-未开启
     */
    isEnableSign?: boolean;
    /**
     * 签名配置：0-使用上次签名；1-每次重新签名；
     */
    signConfig?: number;
    /**
     * 审核节点列表
     */
    auditNodeList?: {
      /**
       * 审核用户类型：0-"按部门"；1-"按全机构";2-"全平台";3-"按岗位"
       */
      userRangeType?: number;
      userRangeTypeNew?: number;
      /**
       * 对应userRangeType的值
       */
      userRangeValues?: string[];
      userRangeValuesNew?: string[];
      /**
       * 审核人数(总人数)
       */
      personCount?: number;
      /**
       * 审核状态：0-待审批，1-已审批，2-审批驳回
       */
      auditStatus?: number;
      /**
       * 审核时间
       */
      auditTime?: string;
      /**
       * 审核描述
       */
      auditDesc?: string;
      /**
       * 审批类型：0-或签，1-会签，2-依次审批
       */
      auditType?: number;
      /**
       * 事件类型：0-审批，1-审核，2-出纳
       */
      eventType?: number;
      /**
       * 是否自选:0-指定，1-自选
       */
      nodeType?: number;
      /**
       * 节点key
       */
      nodeKey?: string;
      /**
       * 节点名称
       */
      nodeName?: string;
      /**
       * 审批策略：单人、多人会签、依次会签
       */
      checkStrategy?: number;
      /**
       * 部门id （为了获取部门主管）
       */
      departmentId?: number;
      /**
       * 审核人列表
       */
      auditOperatorList?: {
        /**
         * 审批意见
         */
        auditRemark?: string;
        /**
         * 审批状态：0-待审批，1-审批通过，2-审批驳回
         */
        auditStatus?: number;
        /**
         * 审核时间
         */
        auditTime?: string;
        /**
         * 签名附件
         */
        signAttachment?: {
          fileId?: string;
          type?: string;
          name?: string;
          size?: number;
          bizCode?: string;
          url?: string;
          sizeDesc?: string;
        };
        /**
         * 最新的个人历史签名附件
         */
        oneselfHistorySignAttachment?: {
          fileId?: string;
          type?: string;
          name?: string;
          size?: number;
          bizCode?: string;
          url?: string;
          sizeDesc?: string;
        };
        /**
         * 人员id
         */
        operatorId?: number;
        /**
         * 人员Name
         */
        operatorName?: string;
        /**
         * 机构ID
         */
        institutionId?: number;
        /**
         * 机构Name
         */
        institutionName?: string;
      }[];
      /**
       * 机构
       */
      institutionSelfDtos?: {
        /**
         * 机构编码
         */
        code?: string;
        /**
         * 机构Name
         */
        name?: string;
        /**
         * 人员类型
         */
        userType?: string;
        /**
         * 租户编码
         */
        tenantCode?: string;
        /**
         * 租户Name
         */
        tenantName?: string;
        /**
         * 唯一key
         */
        uniqueKey?: string;
        /**
         * 父机构
         */
        parentInstitution?: {
          parentCode?: number;
          parentName?: string;
        };
      }[];
      /**
       * 常用审核人列表
       */
      commonAuditorList?: {
        code?: string;
        name?: string;
        userType?: string;
        tenantCode?: string;
        tenantName?: string;
        uniqueKey?: string;
        parentInstitution?: {
          parentCode?: number;
          parentName?: string;
        };
      }[];
    }[];
  };
}

/**
 * 接口 [获取工作流实例_copy↗](http://yapi.cai-inc.com/project/2991/interface/api/619802) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [预算绩效申报单工作流↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54810)
 * @请求头 `POST /zlb/budget/perform/report/workflow/getInstance_1708592833069`
 * @更新时间 `2024-02-22 17:07:13`
 * @项目ID 2991
 */
type ZlbBudgetPerformReportWorkflowGetInstance_1708592833069PostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/perform/report/workflow/getInstance_1708592833069',
    'data',
    string,
    | 'processDefineKey'
    | 'bizId'
    | 'bizType'
    | 'subType'
    | 'operatorId'
    | 'departmentId'
    | 'amount'
    | 'accompanyOperatorIds',
    false
  >
>;

/**
 * 接口 [获取工作流实例_copy↗](http://yapi.cai-inc.com/project/2991/interface/api/619802) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [预算绩效申报单工作流↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54810)
 * @请求头 `POST /zlb/budget/perform/report/workflow/getInstance_1708592833069`
 * @更新时间 `2024-02-22 17:07:13`
 * @项目ID 2991
 */
const zlbBudgetPerformReportWorkflowGetInstance_1708592833069PostRequestConfig: ZlbBudgetPerformReportWorkflowGetInstance_1708592833069PostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_14,
    devUrl: devUrl_0_4_0_14,
    prodUrl: prodUrl_0_4_0_14,
    path: '/zlb/budget/perform/report/workflow/getInstance_1708592833069',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_14,
    paramNames: [],
    queryNames: [
      'processDefineKey',
      'bizId',
      'bizType',
      'subType',
      'operatorId',
      'departmentId',
      'amount',
      'accompanyOperatorIds',
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbBudgetPerformReportWorkflowGetInstance_1708592833069Post',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [获取工作流实例_copy↗](http://yapi.cai-inc.com/project/2991/interface/api/619802) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [预算绩效申报单工作流↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_54810)
 * @请求头 `POST /zlb/budget/perform/report/workflow/getInstance_1708592833069`
 * @更新时间 `2024-02-22 17:07:13`
 * @项目ID 2991
 */
export const zlbBudgetPerformReportWorkflowGetInstance_1708592833069Post = /*#__PURE__*/ (
  requestData: ZlbBudgetPerformReportWorkflowGetInstance_1708592833069PostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetPerformReportWorkflowGetInstance_1708592833069PostResponse>(
    prepare(zlbBudgetPerformReportWorkflowGetInstance_1708592833069PostRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetPerformReportWorkflowGetInstance_1708592833069Post.requestConfig =
  zlbBudgetPerformReportWorkflowGetInstance_1708592833069PostRequestConfig;

const mockUrl_0_4_0_15 = 'http://yapi.cai-inc.com/mock/2991' as any;
const devUrl_0_4_0_15 = '' as any;
const prodUrl_0_4_0_15 = '' as any;
const dataKey_0_4_0_15 = 'data' as any;

/**
 * 接口 [编辑分解指标↗](http://yapi.cai-inc.com/project/2991/interface/api/362194) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [预算部门指标↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_55413)
 * @请求头 `POST /zlb/budget/info/edit-sub-budget`
 * @更新时间 `2024-12-10 17:40:39`
 * @项目ID 2991
 */
export interface ZlbBudgetInfoEditSubBudgetPostRequest {
  /**
   * 操作人id
   */
  operatorId?: number;
  /**
   * 用户id
   */
  userId?: number;
  /**
   * 用户名称
   */
  userName?: string;
  /**
   * 机构id
   */
  orgId?: number;
  /**
   * 年份 YYYY
   */
  year?: number;
  /**
   * 指标id
   */
  budgetId: number;
  /**
   * 指标金额
   */
  totalAmount?: number;
  /**
   * 是否下级部门可用（0:否，1:是）
   */
  isSubUse?: number;
  /**
   * 非浙里报已用金额
   */
  notZlbUsedAmount?: number;
}

/**
 * 接口 [编辑分解指标↗](http://yapi.cai-inc.com/project/2991/interface/api/362194) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [预算部门指标↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_55413)
 * @请求头 `POST /zlb/budget/info/edit-sub-budget`
 * @更新时间 `2024-12-10 17:40:39`
 * @项目ID 2991
 */
export interface ZlbBudgetInfoEditSubBudgetPostResponse {
  success?: boolean;
  result?: boolean;
  code?: string;
  message?: string;
}

/**
 * 接口 [编辑分解指标↗](http://yapi.cai-inc.com/project/2991/interface/api/362194) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [预算部门指标↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_55413)
 * @请求头 `POST /zlb/budget/info/edit-sub-budget`
 * @更新时间 `2024-12-10 17:40:39`
 * @项目ID 2991
 */
type ZlbBudgetInfoEditSubBudgetPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/info/edit-sub-budget',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [编辑分解指标↗](http://yapi.cai-inc.com/project/2991/interface/api/362194) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [预算部门指标↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_55413)
 * @请求头 `POST /zlb/budget/info/edit-sub-budget`
 * @更新时间 `2024-12-10 17:40:39`
 * @项目ID 2991
 */
const zlbBudgetInfoEditSubBudgetPostRequestConfig: ZlbBudgetInfoEditSubBudgetPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_15,
    devUrl: devUrl_0_4_0_15,
    prodUrl: prodUrl_0_4_0_15,
    path: '/zlb/budget/info/edit-sub-budget',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_15,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbBudgetInfoEditSubBudgetPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [编辑分解指标↗](http://yapi.cai-inc.com/project/2991/interface/api/362194) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [预算部门指标↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_55413)
 * @请求头 `POST /zlb/budget/info/edit-sub-budget`
 * @更新时间 `2024-12-10 17:40:39`
 * @项目ID 2991
 */
export const zlbBudgetInfoEditSubBudgetPost = /*#__PURE__*/ (
  requestData: ZlbBudgetInfoEditSubBudgetPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetInfoEditSubBudgetPostResponse>(
    prepare(zlbBudgetInfoEditSubBudgetPostRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetInfoEditSubBudgetPost.requestConfig = zlbBudgetInfoEditSubBudgetPostRequestConfig;

/**
 * 接口 [删除分解指标↗](http://yapi.cai-inc.com/project/2991/interface/api/362202) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [预算部门指标↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_55413)
 * @请求头 `POST /zlb/budget/info/delete-sub-budget`
 * @更新时间 `2024-12-10 17:40:39`
 * @项目ID 2991
 */
export interface ZlbBudgetInfoDeleteSubBudgetPostRequest {
  /**
   * 操作人id
   */
  operatorId?: number;
  /**
   * 用户id
   */
  userId?: number;
  /**
   * 用户名称
   */
  userName?: string;
  /**
   * 机构id
   */
  orgId?: number;
  /**
   * 年份 YYYY
   */
  year?: number;
  budgetId?: number;
}

/**
 * 接口 [删除分解指标↗](http://yapi.cai-inc.com/project/2991/interface/api/362202) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [预算部门指标↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_55413)
 * @请求头 `POST /zlb/budget/info/delete-sub-budget`
 * @更新时间 `2024-12-10 17:40:39`
 * @项目ID 2991
 */
export interface ZlbBudgetInfoDeleteSubBudgetPostResponse {
  success?: boolean;
  result?: boolean;
  code?: string;
  message?: string;
}

/**
 * 接口 [删除分解指标↗](http://yapi.cai-inc.com/project/2991/interface/api/362202) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [预算部门指标↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_55413)
 * @请求头 `POST /zlb/budget/info/delete-sub-budget`
 * @更新时间 `2024-12-10 17:40:39`
 * @项目ID 2991
 */
type ZlbBudgetInfoDeleteSubBudgetPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/info/delete-sub-budget',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [删除分解指标↗](http://yapi.cai-inc.com/project/2991/interface/api/362202) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [预算部门指标↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_55413)
 * @请求头 `POST /zlb/budget/info/delete-sub-budget`
 * @更新时间 `2024-12-10 17:40:39`
 * @项目ID 2991
 */
const zlbBudgetInfoDeleteSubBudgetPostRequestConfig: ZlbBudgetInfoDeleteSubBudgetPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_15,
    devUrl: devUrl_0_4_0_15,
    prodUrl: prodUrl_0_4_0_15,
    path: '/zlb/budget/info/delete-sub-budget',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_15,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbBudgetInfoDeleteSubBudgetPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [删除分解指标↗](http://yapi.cai-inc.com/project/2991/interface/api/362202) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [预算部门指标↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_55413)
 * @请求头 `POST /zlb/budget/info/delete-sub-budget`
 * @更新时间 `2024-12-10 17:40:39`
 * @项目ID 2991
 */
export const zlbBudgetInfoDeleteSubBudgetPost = /*#__PURE__*/ (
  requestData: ZlbBudgetInfoDeleteSubBudgetPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetInfoDeleteSubBudgetPostResponse>(
    prepare(zlbBudgetInfoDeleteSubBudgetPostRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetInfoDeleteSubBudgetPost.requestConfig = zlbBudgetInfoDeleteSubBudgetPostRequestConfig;

/**
 * 接口 [查询分解指标↗](http://yapi.cai-inc.com/project/2991/interface/api/381314) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [预算部门指标↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_55413)
 * @请求头 `POST /zlb/budget/info/query-sub-budget`
 * @更新时间 `2024-12-10 17:40:39`
 * @项目ID 2991
 */
export interface ZlbBudgetInfoQuerySubBudgetPostRequest {
  /**
   * 预算id
   */
  budgetId?: number;
  /**
   * 预算指标文号
   */
  budgetNo?: string;
  /**
   * 内网预算详情id
   */
  financialBudgetDetailId?: string;
  /**
   * 项目名称
   */
  projectName?: string;
  /**
   * 部门经济分类名称
   */
  depExpendEconomicClassifyName?: string;
  /**
   * 是否政府采购（0:否、1：是）
   */
  containsGovPurchaseBudget?: number;
  /**
   * 年份 默认当前年份
   */
  year?: number;
  /**
   * 机构ID
   */
  orgId?: number;
  /**
   * 报销类型id（字典表id）
   */
  scenesId?: number;
  /**
   * 当前页码，默认1
   */
  pageNo?: number;
  /**
   * 每页记录数，默认10
   */
  pageSize?: number;
  /**
   * 排序字段
   */
  sortField?: string;
  /**
   * 排序规则：DESC || ASC
   */
  sortBy?: string;
}

/**
 * 接口 [查询分解指标↗](http://yapi.cai-inc.com/project/2991/interface/api/381314) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [预算部门指标↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_55413)
 * @请求头 `POST /zlb/budget/info/query-sub-budget`
 * @更新时间 `2024-12-10 17:40:39`
 * @项目ID 2991
 */
export interface ZlbBudgetInfoQuerySubBudgetPostResponse {
  success?: boolean;
  result?: {
    /**
     * 总记录数
     */
    total?: number;
    /**
     * 结果集
     */
    data?: {
      /**
       * 预算id
       */
      budgetId?: number;
      /**
       * 部门名称
       */
      depName?: string;
      /**
       * 指标金额
       */
      totalAmount?: number;
      /**
       * 可用金额
       */
      availableAmount?: number;
      /**
       * 支出项
       */
      expenditureItem?: string;
    }[];
    pageNum?: number;
    pageSize?: number;
    /**
     * 总页数
     */
    pages?: number;
    /**
     * 第几页
     */
    size?: number;
  };
  code?: string;
  message?: string;
}

/**
 * 接口 [查询分解指标↗](http://yapi.cai-inc.com/project/2991/interface/api/381314) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [预算部门指标↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_55413)
 * @请求头 `POST /zlb/budget/info/query-sub-budget`
 * @更新时间 `2024-12-10 17:40:39`
 * @项目ID 2991
 */
type ZlbBudgetInfoQuerySubBudgetPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/info/query-sub-budget',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [查询分解指标↗](http://yapi.cai-inc.com/project/2991/interface/api/381314) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [预算部门指标↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_55413)
 * @请求头 `POST /zlb/budget/info/query-sub-budget`
 * @更新时间 `2024-12-10 17:40:39`
 * @项目ID 2991
 */
const zlbBudgetInfoQuerySubBudgetPostRequestConfig: ZlbBudgetInfoQuerySubBudgetPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_15,
    devUrl: devUrl_0_4_0_15,
    prodUrl: prodUrl_0_4_0_15,
    path: '/zlb/budget/info/query-sub-budget',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_15,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbBudgetInfoQuerySubBudgetPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [查询分解指标↗](http://yapi.cai-inc.com/project/2991/interface/api/381314) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [预算部门指标↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_55413)
 * @请求头 `POST /zlb/budget/info/query-sub-budget`
 * @更新时间 `2024-12-10 17:40:39`
 * @项目ID 2991
 */
export const zlbBudgetInfoQuerySubBudgetPost = /*#__PURE__*/ (
  requestData: ZlbBudgetInfoQuerySubBudgetPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetInfoQuerySubBudgetPostResponse>(
    prepare(zlbBudgetInfoQuerySubBudgetPostRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetInfoQuerySubBudgetPost.requestConfig = zlbBudgetInfoQuerySubBudgetPostRequestConfig;

/**
 * 接口 [保存分解指标↗](http://yapi.cai-inc.com/project/2991/interface/api/381322) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [预算部门指标↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_55413)
 * @请求头 `POST /zlb/budget/info/save-sub-budget`
 * @更新时间 `2024-12-10 17:40:39`
 * @项目ID 2991
 */
export interface ZlbBudgetInfoSaveSubBudgetPostRequest {
  /**
   * 操作人id
   */
  operatorId?: number;
  /**
   * 用户id
   */
  userId?: number;
  /**
   * 用户名称
   */
  userName?: string;
  /**
   * 机构id
   */
  orgId?: number;
  /**
   * 年份 YYYY
   */
  year?: number;
  /**
   * 指标id
   */
  budgetId: number;
  subBudgetList: {
    /**
     * 部门id
     */
    depId: number;
    /**
     * 部门名称
     */
    depName: string;
    /**
     * 指标金额
     */
    totalAmount: number;
    /**
     * 是否下级部门可用（0：否，1：是）默认否
     */
    isSubUse?: number;
    /**
     * 支出项
     */
    expenditureItem?: string;
    /**
     * 非浙里报已用金额
     */
    notZlbUsedAmount?: number;
  }[];
}

/**
 * 接口 [保存分解指标↗](http://yapi.cai-inc.com/project/2991/interface/api/381322) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [预算部门指标↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_55413)
 * @请求头 `POST /zlb/budget/info/save-sub-budget`
 * @更新时间 `2024-12-10 17:40:39`
 * @项目ID 2991
 */
export interface ZlbBudgetInfoSaveSubBudgetPostResponse {
  success?: boolean;
  result?: boolean;
  code?: string;
  message?: string;
}

/**
 * 接口 [保存分解指标↗](http://yapi.cai-inc.com/project/2991/interface/api/381322) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [预算部门指标↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_55413)
 * @请求头 `POST /zlb/budget/info/save-sub-budget`
 * @更新时间 `2024-12-10 17:40:39`
 * @项目ID 2991
 */
type ZlbBudgetInfoSaveSubBudgetPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/info/save-sub-budget',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [保存分解指标↗](http://yapi.cai-inc.com/project/2991/interface/api/381322) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [预算部门指标↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_55413)
 * @请求头 `POST /zlb/budget/info/save-sub-budget`
 * @更新时间 `2024-12-10 17:40:39`
 * @项目ID 2991
 */
const zlbBudgetInfoSaveSubBudgetPostRequestConfig: ZlbBudgetInfoSaveSubBudgetPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_15,
    devUrl: devUrl_0_4_0_15,
    prodUrl: prodUrl_0_4_0_15,
    path: '/zlb/budget/info/save-sub-budget',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_15,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbBudgetInfoSaveSubBudgetPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [保存分解指标↗](http://yapi.cai-inc.com/project/2991/interface/api/381322) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [预算部门指标↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_55413)
 * @请求头 `POST /zlb/budget/info/save-sub-budget`
 * @更新时间 `2024-12-10 17:40:39`
 * @项目ID 2991
 */
export const zlbBudgetInfoSaveSubBudgetPost = /*#__PURE__*/ (
  requestData: ZlbBudgetInfoSaveSubBudgetPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetInfoSaveSubBudgetPostResponse>(
    prepare(zlbBudgetInfoSaveSubBudgetPostRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetInfoSaveSubBudgetPost.requestConfig = zlbBudgetInfoSaveSubBudgetPostRequestConfig;

/**
 * 接口 [查询部门指标↗](http://yapi.cai-inc.com/project/2991/interface/api/458858) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [预算部门指标↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_55413)
 * @请求头 `POST /zlb/budget/info/query-budget`
 * @更新时间 `2024-12-10 17:40:38`
 * @项目ID 2991
 */
export interface ZlbBudgetInfoQueryBudgetPostRequest {
  /**
   * 操作人id
   */
  operatorId?: number;
  /**
   * 用户id
   */
  userId?: number;
  /**
   * 用户名称
   */
  userName?: string;
  /**
   * 机构id
   */
  orgId?: number;
  /**
   * 年份 YYYY
   */
  year?: number;
  /**
   * 内网预算详情id
   */
  financialBudgetDetailId?: string;
  /**
   * 部门经济分类名称
   */
  depExpendEconomicClassifyName?: string;
  /**
   * 项目名称
   */
  projectName?: string;
  /**
   * 预算指标文号
   */
  budgetNo?: string;
  /**
   * 部门id
   */
  depId?: number;
  /**
   * 部门名称
   */
  depName?: string;
  /**
   * 支出项
   */
  expenditureItem?: string;
  /**
   * 当前页码，默认1
   */
  pageNo?: number;
  /**
   * 每页记录数，默认10
   */
  pageSize?: number;
}

/**
 * 接口 [查询部门指标↗](http://yapi.cai-inc.com/project/2991/interface/api/458858) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [预算部门指标↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_55413)
 * @请求头 `POST /zlb/budget/info/query-budget`
 * @更新时间 `2024-12-10 17:40:38`
 * @项目ID 2991
 */
export interface ZlbBudgetInfoQueryBudgetPostResponse {
  success?: boolean;
  result?: {
    /**
     * 总记录数
     */
    total?: number;
    /**
     * 结果集
     */
    data?: {
      /**
       * 内网预算详情id
       */
      financialBudgetDetailId?: string;
      /**
       * 预算ID
       */
      budgetId?: number;
      /**
       * 指标文号
       */
      budgetNo?: string;
      /**
       * 项目名称
       */
      projectName?: string;
      /**
       * 父预算id
       */
      parentBudgetId?: number;
      /**
       * 部门经济科目名称
       */
      depExpendEconomicClassifyName?: string;
      /**
       * 项目类别代码（3：项目支出，其它数值为基本支出）
       */
      programCategoryCode?: string;
      /**
       * 是否包含政府采购预算，1:是、0：否
       */
      containsGovPurchaseBudget?: number;
      /**
       * 指标金额
       */
      totalAmount?: number;
      /**
       * 可用金额
       */
      availableAmount?: number;
      /**
       * 分解金额
       */
      spiltAmount?: number;
      /**
       * 使用金额
       */
      usedAmount?: number;
      /**
       * 冻结金额
       */
      frozenAmount?: number;
      /**
       * 支出进度
       */
      expenditurePercentage?: string;
      /**
       * 主指标总金额
       */
      mainTotalAmount?: number;
      /**
       * 年份
       */
      year?: number;
      /**
       * 部门名称
       */
      depName?: string;
      /**
       * 支出项
       */
      expenditureItem?: string;
      /**
       * 非浙里报已用金额
       */
      notZlbUsedAmount?: number;
    }[];
    pageNum?: number;
    pageSize?: number;
    /**
     * 总页数
     */
    pages?: number;
    /**
     * 第几页
     */
    size?: number;
  };
  code?: string;
  message?: string;
}

/**
 * 接口 [查询部门指标↗](http://yapi.cai-inc.com/project/2991/interface/api/458858) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [预算部门指标↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_55413)
 * @请求头 `POST /zlb/budget/info/query-budget`
 * @更新时间 `2024-12-10 17:40:38`
 * @项目ID 2991
 */
type ZlbBudgetInfoQueryBudgetPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/info/query-budget',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [查询部门指标↗](http://yapi.cai-inc.com/project/2991/interface/api/458858) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [预算部门指标↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_55413)
 * @请求头 `POST /zlb/budget/info/query-budget`
 * @更新时间 `2024-12-10 17:40:38`
 * @项目ID 2991
 */
const zlbBudgetInfoQueryBudgetPostRequestConfig: ZlbBudgetInfoQueryBudgetPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_15,
    devUrl: devUrl_0_4_0_15,
    prodUrl: prodUrl_0_4_0_15,
    path: '/zlb/budget/info/query-budget',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_15,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbBudgetInfoQueryBudgetPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [查询部门指标↗](http://yapi.cai-inc.com/project/2991/interface/api/458858) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [预算部门指标↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_55413)
 * @请求头 `POST /zlb/budget/info/query-budget`
 * @更新时间 `2024-12-10 17:40:38`
 * @项目ID 2991
 */
export const zlbBudgetInfoQueryBudgetPost = /*#__PURE__*/ (
  requestData: ZlbBudgetInfoQueryBudgetPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetInfoQueryBudgetPostResponse>(
    prepare(zlbBudgetInfoQueryBudgetPostRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetInfoQueryBudgetPost.requestConfig = zlbBudgetInfoQueryBudgetPostRequestConfig;

/**
 * 接口 [导出预算指标↗](http://yapi.cai-inc.com/project/2991/interface/api/653994) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [预算部门指标↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_55413)
 * @请求头 `POST /zlb/budget/info/export/dep/submit`
 * @更新时间 `2024-12-10 17:40:40`
 * @项目ID 2991
 */
export interface ZlbBudgetInfoExportDepSubmitPostRequest {
  /**
   * 操作人id
   */
  operatorId?: number;
  /**
   * 用户id
   */
  userId?: number;
  /**
   * 用户名称
   */
  userName?: string;
  /**
   * 机构id
   */
  orgId?: number;
  /**
   * 年份 YYYY
   */
  year?: number;
  /**
   * 内网预算详情id
   */
  financialBudgetDetailId?: string;
  /**
   * 部门经济分类名称
   */
  depExpendEconomicClassifyName?: string;
  /**
   * 项目名称
   */
  projectName?: string;
  /**
   * 预算指标文号
   */
  budgetNo?: string;
  /**
   * 部门id
   */
  depId?: number;
  /**
   * 部门名称
   */
  depName?: string;
  /**
   * 支出项
   */
  expenditureItem?: string;
  /**
   * 当前页码，默认1
   */
  pageNo?: number;
  /**
   * 每页记录数，默认10
   */
  pageSize?: number;
}

/**
 * 接口 [导出预算指标↗](http://yapi.cai-inc.com/project/2991/interface/api/653994) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [预算部门指标↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_55413)
 * @请求头 `POST /zlb/budget/info/export/dep/submit`
 * @更新时间 `2024-12-10 17:40:40`
 * @项目ID 2991
 */
export interface ZlbBudgetInfoExportDepSubmitPostResponse {
  success?: boolean;
  result?: string;
  code?: string;
  message?: string;
}

/**
 * 接口 [导出预算指标↗](http://yapi.cai-inc.com/project/2991/interface/api/653994) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [预算部门指标↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_55413)
 * @请求头 `POST /zlb/budget/info/export/dep/submit`
 * @更新时间 `2024-12-10 17:40:40`
 * @项目ID 2991
 */
type ZlbBudgetInfoExportDepSubmitPostRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/info/export/dep/submit',
    'data',
    string,
    string,
    false
  >
>;

/**
 * 接口 [导出预算指标↗](http://yapi.cai-inc.com/project/2991/interface/api/653994) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [预算部门指标↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_55413)
 * @请求头 `POST /zlb/budget/info/export/dep/submit`
 * @更新时间 `2024-12-10 17:40:40`
 * @项目ID 2991
 */
const zlbBudgetInfoExportDepSubmitPostRequestConfig: ZlbBudgetInfoExportDepSubmitPostRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_15,
    devUrl: devUrl_0_4_0_15,
    prodUrl: prodUrl_0_4_0_15,
    path: '/zlb/budget/info/export/dep/submit',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_15,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbBudgetInfoExportDepSubmitPost',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [导出预算指标↗](http://yapi.cai-inc.com/project/2991/interface/api/653994) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [预算部门指标↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_55413)
 * @请求头 `POST /zlb/budget/info/export/dep/submit`
 * @更新时间 `2024-12-10 17:40:40`
 * @项目ID 2991
 */
export const zlbBudgetInfoExportDepSubmitPost = /*#__PURE__*/ (
  requestData: ZlbBudgetInfoExportDepSubmitPostRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetInfoExportDepSubmitPostResponse>(
    prepare(zlbBudgetInfoExportDepSubmitPostRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetInfoExportDepSubmitPost.requestConfig = zlbBudgetInfoExportDepSubmitPostRequestConfig;

/**
 * 接口 [获取导出结果↗](http://yapi.cai-inc.com/project/2991/interface/api/654002) 的 **请求类型**
 *
 * @状态 已完成
 * @分类 [预算部门指标↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_55413)
 * @请求头 `GET /zlb/budget/info/export/dep/result`
 * @更新时间 `2024-12-10 17:40:40`
 * @项目ID 2991
 */
export interface ZlbBudgetInfoExportDepResultGetRequest {
  /**
   * 任务编码
   */
  serialCode: string;
}

/**
 * 接口 [获取导出结果↗](http://yapi.cai-inc.com/project/2991/interface/api/654002) 的 **返回类型**
 *
 * @状态 已完成
 * @分类 [预算部门指标↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_55413)
 * @请求头 `GET /zlb/budget/info/export/dep/result`
 * @更新时间 `2024-12-10 17:40:40`
 * @项目ID 2991
 */
export interface ZlbBudgetInfoExportDepResultGetResponse {
  success?: boolean;
  result?: {
    /**
     * 总数
     */
    totalNum?: number;
    /**
     * 成功数量
     */
    successNum?: number;
    /**
     * 失败数量
     */
    failNum?: number;
    /**
     * 成功FileId
     */
    successFileId?: string;
    /**
     * 任务状态
     */
    status?: number;
    /**
     * 任务编号
     */
    serialCode?: string;
    message?: string;
  };
  code?: string;
  message?: string;
}

/**
 * 接口 [获取导出结果↗](http://yapi.cai-inc.com/project/2991/interface/api/654002) 的 **请求配置的类型**
 *
 * @状态 已完成
 * @分类 [预算部门指标↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_55413)
 * @请求头 `GET /zlb/budget/info/export/dep/result`
 * @更新时间 `2024-12-10 17:40:40`
 * @项目ID 2991
 */
type ZlbBudgetInfoExportDepResultGetRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.cai-inc.com/mock/2991',
    '',
    '',
    '/zlb/budget/info/export/dep/result',
    'data',
    string,
    'serialCode',
    false
  >
>;

/**
 * 接口 [获取导出结果↗](http://yapi.cai-inc.com/project/2991/interface/api/654002) 的 **请求配置**
 *
 * @状态 已完成
 * @分类 [预算部门指标↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_55413)
 * @请求头 `GET /zlb/budget/info/export/dep/result`
 * @更新时间 `2024-12-10 17:40:40`
 * @项目ID 2991
 */
const zlbBudgetInfoExportDepResultGetRequestConfig: ZlbBudgetInfoExportDepResultGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_15,
    devUrl: devUrl_0_4_0_15,
    prodUrl: prodUrl_0_4_0_15,
    path: '/zlb/budget/info/export/dep/result',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_15,
    paramNames: [],
    queryNames: ['serialCode'],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'zlbBudgetInfoExportDepResultGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [获取导出结果↗](http://yapi.cai-inc.com/project/2991/interface/api/654002) 的 **请求函数**
 *
 * @状态 已完成
 * @分类 [预算部门指标↗](http://yapi.cai-inc.com/project/2991/interface/api/cat_55413)
 * @请求头 `GET /zlb/budget/info/export/dep/result`
 * @更新时间 `2024-12-10 17:40:40`
 * @项目ID 2991
 */
export const zlbBudgetInfoExportDepResultGet = /*#__PURE__*/ (
  requestData: ZlbBudgetInfoExportDepResultGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ZlbBudgetInfoExportDepResultGetResponse>(
    prepare(zlbBudgetInfoExportDepResultGetRequestConfig, requestData),
    ...args,
  );
};

zlbBudgetInfoExportDepResultGet.requestConfig = zlbBudgetInfoExportDepResultGetRequestConfig;

/* prettier-ignore-end */
